/* tslint:disable */
/* eslint-disable */
/**
 * Master da Web Public API
 * The Master da Web public API documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AccountInvoiceDto
 */
export interface AccountInvoiceDto {
    /**
     * 
     * @type {string}
     * @memberof AccountInvoiceDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AccountInvoiceDto
     */
    'provider': string;
    /**
     * Provider invoice id — for WHMCS, the id accepted by viewinvoice.php.
     * @type {string}
     * @memberof AccountInvoiceDto
     */
    'external_id': string;
    /**
     * Invoice total in BRL cents
     * @type {string}
     * @memberof AccountInvoiceDto
     */
    'amount_cents': string;
    /**
     * 
     * @type {string}
     * @memberof AccountInvoiceDto
     */
    'status': AccountInvoiceDtoStatusEnum;
    /**
     * What the invoice pays for. Always present.
     * @type {string}
     * @memberof AccountInvoiceDto
     */
    'purpose': AccountInvoiceDtoPurposeEnum;
    /**
     * CANCELLED because the subscription balance covered it in full — the obligation was met, not waived.
     * @type {boolean}
     * @memberof AccountInvoiceDto
     */
    'settled_by_credit': boolean;
    /**
     * 
     * @type {string}
     * @memberof AccountInvoiceDto
     */
    'settled_by_credit_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountInvoiceDto
     */
    'due_at': string;
    /**
     * 
     * @type {string}
     * @memberof AccountInvoiceDto
     */
    'paid_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountInvoiceDto
     */
    'created_at': string;
    /**
     * OPEN with due_at in the past
     * @type {boolean}
     * @memberof AccountInvoiceDto
     */
    'overdue': boolean;
    /**
     * 
     * @type {AccountInvoiceSubscriptionDto}
     * @memberof AccountInvoiceDto
     */
    'subscription': AccountInvoiceSubscriptionDto | null;
}

export const AccountInvoiceDtoStatusEnum = {
    Open: 'OPEN',
    Paid: 'PAID',
    Cancelled: 'CANCELLED',
    Refunded: 'REFUNDED'
} as const;

export type AccountInvoiceDtoStatusEnum = typeof AccountInvoiceDtoStatusEnum[keyof typeof AccountInvoiceDtoStatusEnum];
export const AccountInvoiceDtoPurposeEnum = {
    Topup: 'TOPUP',
    CycleClose: 'CYCLE_CLOSE',
    Debt: 'DEBT',
    Reschedule: 'RESCHEDULE',
    ResourceMove: 'RESOURCE_MOVE',
    AccountTransfer: 'ACCOUNT_TRANSFER',
    SubscriptionConversion: 'SUBSCRIPTION_CONVERSION',
    CheckoutAttach: 'CHECKOUT_ATTACH',
    CheckoutNew: 'CHECKOUT_NEW'
} as const;

export type AccountInvoiceDtoPurposeEnum = typeof AccountInvoiceDtoPurposeEnum[keyof typeof AccountInvoiceDtoPurposeEnum];

/**
 * 
 * @export
 * @interface AccountInvoiceSubscriptionDto
 */
export interface AccountInvoiceSubscriptionDto {
    /**
     * 
     * @type {string}
     * @memberof AccountInvoiceSubscriptionDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AccountInvoiceSubscriptionDto
     */
    'name': string | null;
}
/**
 * 
 * @export
 * @interface ActiveVmOperationDto
 */
export interface ActiveVmOperationDto {
    /**
     * What is holding the instance. `other` is a platform lock with no job row naming the work (e.g. a termination); `hypervisor` is a lock Proxmox itself reports.
     * @type {string}
     * @memberof ActiveVmOperationDto
     */
    'kind': ActiveVmOperationDtoKindEnum;
    /**
     * Where the evidence came from.
     * @type {string}
     * @memberof ActiveVmOperationDto
     */
    'source': ActiveVmOperationDtoSourceEnum;
    /**
     * When the operation was recorded as starting, if known.
     * @type {string}
     * @memberof ActiveVmOperationDto
     */
    'started_at'?: string | null;
    /**
     * The hypervisor lock name when `source` is `hypervisor`.
     * @type {string}
     * @memberof ActiveVmOperationDto
     */
    'hypervisor_lock'?: string | null;
    /**
     * Operator-readable sentence, English. Localize from `kind`.
     * @type {string}
     * @memberof ActiveVmOperationDto
     */
    'description': string;
}

export const ActiveVmOperationDtoKindEnum = {
    Deploy: 'deploy',
    Reinstall: 'reinstall',
    Clone: 'clone',
    Resize: 'resize',
    Backup: 'backup',
    Restore: 'restore',
    Vpc: 'vpc',
    Firewall: 'firewall',
    Hypervisor: 'hypervisor',
    Other: 'other'
} as const;

export type ActiveVmOperationDtoKindEnum = typeof ActiveVmOperationDtoKindEnum[keyof typeof ActiveVmOperationDtoKindEnum];
export const ActiveVmOperationDtoSourceEnum = {
    Lock: 'lock',
    Job: 'job',
    Hypervisor: 'hypervisor'
} as const;

export type ActiveVmOperationDtoSourceEnum = typeof ActiveVmOperationDtoSourceEnum[keyof typeof ActiveVmOperationDtoSourceEnum];

/**
 * 
 * @export
 * @interface AddClientDto
 */
export interface AddClientDto {
    /**
     * Client\'s first name
     * @type {string}
     * @memberof AddClientDto
     */
    'firstname': string;
    /**
     * Client\'s last name
     * @type {string}
     * @memberof AddClientDto
     */
    'lastname': string;
    /**
     * Client\'s email address
     * @type {string}
     * @memberof AddClientDto
     */
    'email': string;
    /**
     * Client\'s company name
     * @type {string}
     * @memberof AddClientDto
     */
    'companyname'?: string;
    /**
     * Client\'s address line 1
     * @type {string}
     * @memberof AddClientDto
     */
    'address1': string;
    /**
     * Client\'s address line 2
     * @type {string}
     * @memberof AddClientDto
     */
    'address2'?: string;
    /**
     * Client\'s city
     * @type {string}
     * @memberof AddClientDto
     */
    'city': string;
    /**
     * Client\'s state or region
     * @type {string}
     * @memberof AddClientDto
     */
    'state': string;
    /**
     * Client\'s postal code
     * @type {string}
     * @memberof AddClientDto
     */
    'postcode': string;
    /**
     * Client\'s country code (ISO 3166-1 alpha-2)
     * @type {string}
     * @memberof AddClientDto
     */
    'country': string;
    /**
     * Client\'s phone number
     * @type {string}
     * @memberof AddClientDto
     */
    'phonenumber'?: string;
    /**
     * Client\'s password. Minimum 8 characters with at least one uppercase letter, one lowercase letter, one number and one special character.
     * @type {string}
     * @memberof AddClientDto
     */
    'password2': string;
    /**
     * Client\'s IP address
     * @type {string}
     * @memberof AddClientDto
     */
    'clientip'?: string;
    /**
     * Stable per-browser identifier. When supplied, the response carries a session for the new account so the signup ends signed in.
     * @type {string}
     * @memberof AddClientDto
     */
    'deviceId'?: string;
    /**
     * Browser locale of the visitor (e.g. navigator.language, \'pt-BR\'). Used to set the WHMCS account language: Portuguese locales register as portuguese-br, anything else as english. When omitted, the Accept-Language request header is used; when neither is usable, the WHMCS default language applies.
     * @type {string}
     * @memberof AddClientDto
     */
    'language'?: string;
}
/**
 * 
 * @export
 * @interface AddClientResponseDto
 */
export interface AddClientResponseDto {
    /**
     * The result of the operation: success or error
     * @type {string}
     * @memberof AddClientResponseDto
     */
    'result': string;
    /**
     * The ID of the newly created client
     * @type {string}
     * @memberof AddClientResponseDto
     */
    'clientid': string;
    /**
     * The ID of the WHMCS user that owns the new client
     * @type {number}
     * @memberof AddClientResponseDto
     */
    'owner_id'?: number;
    /**
     * 
     * @type {ClientDetailsDto}
     * @memberof AddClientResponseDto
     */
    'client'?: ClientDetailsDto;
    /**
     * 
     * @type {TokenDto}
     * @memberof AddClientResponseDto
     */
    'token'?: TokenDto;
}
/**
 * 
 * @export
 * @interface AddFirewallRuleDto
 */
export interface AddFirewallRuleDto {
    /**
     * Rule type (direction)
     * @type {string}
     * @memberof AddFirewallRuleDto
     */
    'type': AddFirewallRuleDtoTypeEnum;
    /**
     * Rule action
     * @type {string}
     * @memberof AddFirewallRuleDto
     */
    'action': AddFirewallRuleDtoActionEnum;
    /**
     * Predefined macro (e.g., HTTP, HTTPS, SSH). If macro is provided, protocol, sport, and dport should not be set.
     * @type {string}
     * @memberof AddFirewallRuleDto
     */
    'macro'?: AddFirewallRuleDtoMacroEnum;
    /**
     * Lower-case protocol name as in /etc/protocols; omit to match any. Only tcp, udp, sctp, dccp and udplite carry ports — `rdp` here is IP protocol 27, not Remote Desktop. Required whenever a port is set; not allowed with a macro.
     * @type {string}
     * @memberof AddFirewallRuleDto
     */
    'proto'?: AddFirewallRuleDtoProtoEnum;
    /**
     * Source address, CIDR, `FROM-TO` range, or a comma-separated list. One address family per rule; a range cannot appear in a list.
     * @type {string}
     * @memberof AddFirewallRuleDto
     */
    'source'?: string;
    /**
     * Destination address, CIDR, `FROM-TO` range, or a comma-separated list. One address family per rule; a range cannot appear in a list.
     * @type {string}
     * @memberof AddFirewallRuleDto
     */
    'dest'?: string;
    /**
     * Source port, colon range or comma-separated list (e.g. `1024:65535`, `80,443`). A `FROM-TO` range is accepted and stored as `FROM:TO`. Requires `proto`; not allowed with a macro.
     * @type {string}
     * @memberof AddFirewallRuleDto
     */
    'sport'?: string;
    /**
     * Destination port, colon range or comma-separated list (e.g. `80`, `8000:8010`, `80,443`). A `FROM-TO` range is accepted and stored as `FROM:TO`. Requires `proto`; not allowed with a macro.
     * @type {string}
     * @memberof AddFirewallRuleDto
     */
    'dport'?: string;
    /**
     * Rule position in the list (0-based index)
     * @type {number}
     * @memberof AddFirewallRuleDto
     */
    'pos'?: number;
    /**
     * Rule comment
     * @type {string}
     * @memberof AddFirewallRuleDto
     */
    'comment'?: string;
    /**
     * Whether the rule should be active after commit. Defaults to true.
     * @type {boolean}
     * @memberof AddFirewallRuleDto
     */
    'enable'?: boolean;
}

export const AddFirewallRuleDtoTypeEnum = {
    In: 'in',
    Out: 'out'
} as const;

export type AddFirewallRuleDtoTypeEnum = typeof AddFirewallRuleDtoTypeEnum[keyof typeof AddFirewallRuleDtoTypeEnum];
export const AddFirewallRuleDtoActionEnum = {
    Accept: 'ACCEPT',
    Reject: 'REJECT',
    Drop: 'DROP'
} as const;

export type AddFirewallRuleDtoActionEnum = typeof AddFirewallRuleDtoActionEnum[keyof typeof AddFirewallRuleDtoActionEnum];
export const AddFirewallRuleDtoMacroEnum = {
    Amanda: 'Amanda',
    Auth: 'Auth',
    Bgp: 'BGP',
    BitTorrent: 'BitTorrent',
    BitTorrent32: 'BitTorrent32',
    Cvs: 'CVS',
    Ceph: 'Ceph',
    Citrix: 'Citrix',
    Daap: 'DAAP',
    Dcc: 'DCC',
    DhcPfwd: 'DHCPfwd',
    Dhcpv6: 'DHCPv6',
    Dns: 'DNS',
    Distcc: 'Distcc',
    Ftp: 'FTP',
    Finger: 'Finger',
    GnUnet: 'GNUnet',
    Gre: 'GRE',
    Git: 'Git',
    Hkp: 'HKP',
    Http: 'HTTP',
    Https: 'HTTPS',
    Icpv2: 'ICPV2',
    Icq: 'ICQ',
    Imap: 'IMAP',
    Imaps: 'IMAPS',
    Ipip: 'IPIP',
    IPsec: 'IPsec',
    IPsecah: 'IPsecah',
    IPsecnat: 'IPsecnat',
    Irc: 'IRC',
    Jetdirect: 'Jetdirect',
    L2Tp: 'L2TP',
    Ldap: 'LDAP',
    Ldaps: 'LDAPS',
    Mdns: 'MDNS',
    Msnp: 'MSNP',
    Mssql: 'MSSQL',
    Mail: 'Mail',
    Munin: 'Munin',
    MySql: 'MySQL',
    Nntp: 'NNTP',
    Nntps: 'NNTPS',
    Ntp: 'NTP',
    NeighborDiscovery: 'NeighborDiscovery',
    Ospf: 'OSPF',
    OpenVpn: 'OpenVPN',
    Pca: 'PCA',
    Pmg: 'PMG',
    Pop3: 'POP3',
    Pop3S: 'POP3S',
    PptP: 'PPtP',
    Ping: 'Ping',
    PostgreSql: 'PostgreSQL',
    Printer: 'Printer',
    Rdp: 'RDP',
    Rip: 'RIP',
    Rndc: 'RNDC',
    Razor: 'Razor',
    Rdate: 'Rdate',
    Rsync: 'Rsync',
    Sane: 'SANE',
    Smb: 'SMB',
    SmBswat: 'SMBswat',
    Smtp: 'SMTP',
    Smtps: 'SMTPS',
    Snmp: 'SNMP',
    Spamd: 'SPAMD',
    SpicEproxy: 'SPICEproxy',
    Ssh: 'SSH',
    Svn: 'SVN',
    SixXs: 'SixXS',
    Squid: 'Squid',
    Submission: 'Submission',
    Syslog: 'Syslog',
    Tftp: 'TFTP',
    Telnet: 'Telnet',
    Telnets: 'Telnets',
    Time: 'Time',
    Trcrt: 'Trcrt',
    Vnc: 'VNC',
    Vncl: 'VNCL',
    Web: 'Web',
    Webcache: 'Webcache',
    Webmin: 'Webmin',
    Whois: 'Whois'
} as const;

export type AddFirewallRuleDtoMacroEnum = typeof AddFirewallRuleDtoMacroEnum[keyof typeof AddFirewallRuleDtoMacroEnum];
export const AddFirewallRuleDtoProtoEnum = {
    Tcp: 'tcp',
    Udp: 'udp',
    Icmp: 'icmp',
    Igmp: 'igmp',
    Ggp: 'ggp',
    Ipencap: 'ipencap',
    St: 'st',
    Egp: 'egp',
    Igp: 'igp',
    Pup: 'pup',
    Hmp: 'hmp',
    XnsIdp: 'xns-idp',
    Rdp: 'rdp',
    IsoTp4: 'iso-tp4',
    Dccp: 'dccp',
    Xtp: 'xtp',
    Ddp: 'ddp',
    IdprCmtp: 'idpr-cmtp',
    Ipv6: 'ipv6',
    Ipv6Route: 'ipv6-route',
    Ipv6Frag: 'ipv6-frag',
    Idrp: 'idrp',
    Rsvp: 'rsvp',
    Gre: 'gre',
    Esp: 'esp',
    Ah: 'ah',
    Skip: 'skip',
    Ipv6Icmp: 'ipv6-icmp',
    Icmpv6: 'icmpv6',
    Ipv6Nonxt: 'ipv6-nonxt',
    Ipv6Opts: 'ipv6-opts',
    Vmtp: 'vmtp',
    Eigrp: 'eigrp',
    Ospf: 'ospf',
    Ax25: 'ax.25',
    Ipip: 'ipip',
    Etherip: 'etherip',
    Encap: 'encap',
    Pim: 'pim',
    Ipcomp: 'ipcomp',
    Vrrp: 'vrrp',
    L2tp: 'l2tp',
    Isis: 'isis',
    Sctp: 'sctp',
    Fc: 'fc',
    MobilityHeader: 'mobility-header',
    Udplite: 'udplite',
    MplsInIp: 'mpls-in-ip',
    Hip: 'hip',
    Shim6: 'shim6',
    Wesp: 'wesp',
    Rohc: 'rohc'
} as const;

export type AddFirewallRuleDtoProtoEnum = typeof AddFirewallRuleDtoProtoEnum[keyof typeof AddFirewallRuleDtoProtoEnum];

/**
 * 
 * @export
 * @interface AddVmToVpcDto
 */
export interface AddVmToVpcDto {
    /**
     * The ID of the VM
     * @type {string}
     * @memberof AddVmToVpcDto
     */
    'vm_id': string;
    /**
     * The ID of the VPC
     * @type {string}
     * @memberof AddVmToVpcDto
     */
    'vpc_id': string;
    /**
     * Whether to restart all VPC VMs after VPC refresh
     * @type {boolean}
     * @memberof AddVmToVpcDto
     */
    'restart'?: boolean;
}
/**
 * 
 * @export
 * @interface AddVpnUserDto
 */
export interface AddVpnUserDto {
    /**
     * Username (alphanumeric characters only)
     * @type {string}
     * @memberof AddVpnUserDto
     */
    'username': string;
    /**
     * Password
     * @type {string}
     * @memberof AddVpnUserDto
     */
    'password': string;
    /**
     * Email
     * @type {string}
     * @memberof AddVpnUserDto
     */
    'email': string;
    /**
     * Status
     * @type {string}
     * @memberof AddVpnUserDto
     */
    'status'?: AddVpnUserDtoStatusEnum;
    /**
     * Send credentials to user email
     * @type {boolean}
     * @memberof AddVpnUserDto
     */
    'sendCredentials'?: boolean;
}

export const AddVpnUserDtoStatusEnum = {
    Active: 'active',
    Inactive: 'inactive'
} as const;

export type AddVpnUserDtoStatusEnum = typeof AddVpnUserDtoStatusEnum[keyof typeof AddVpnUserDtoStatusEnum];

/**
 * 
 * @export
 * @interface AffiliateMeDto
 */
export interface AffiliateMeDto {
    /**
     * Opaque referral code for this account.
     * @type {string}
     * @memberof AffiliateMeDto
     */
    'referral_code': string;
    /**
     * Signed available balance in micro-cents.
     * @type {string}
     * @memberof AffiliateMeDto
     */
    'available_micro_cents': string;
    /**
     * Lifetime commission earned in micro-cents.
     * @type {string}
     * @memberof AffiliateMeDto
     */
    'lifetime_earned_micro_cents': string;
    /**
     * Count of active (commission-earning) referrals.
     * @type {number}
     * @memberof AffiliateMeDto
     */
    'active_referrals': number;
    /**
     * Minimum withdrawal amount in micro-cents.
     * @type {string}
     * @memberof AffiliateMeDto
     */
    'withdrawal_min_micro_cents': string;
    /**
     * Commission rate in basis points.
     * @type {number}
     * @memberof AffiliateMeDto
     */
    'commission_percent_bps': number;
}
/**
 * 
 * @export
 * @interface AffiliateReferralDto
 */
export interface AffiliateReferralDto {
    /**
     * 
     * @type {string}
     * @memberof AffiliateReferralDto
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof AffiliateReferralDto
     */
    'vm_id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AffiliateReferralDto
     */
    'status': AffiliateReferralDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AffiliateReferralDto
     */
    'source': AffiliateReferralDtoSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof AffiliateReferralDto
     */
    'created_at': string;
}

export const AffiliateReferralDtoStatusEnum = {
    Pending: 'PENDING',
    Active: 'ACTIVE',
    Ended: 'ENDED',
    Revoked: 'REVOKED'
} as const;

export type AffiliateReferralDtoStatusEnum = typeof AffiliateReferralDtoStatusEnum[keyof typeof AffiliateReferralDtoStatusEnum];
export const AffiliateReferralDtoSourceEnum = {
    CheckoutCookie: 'CHECKOUT_COOKIE',
    Migration: 'MIGRATION',
    Manual: 'MANUAL'
} as const;

export type AffiliateReferralDtoSourceEnum = typeof AffiliateReferralDtoSourceEnum[keyof typeof AffiliateReferralDtoSourceEnum];

/**
 * 
 * @export
 * @interface ApiScopeOptionDto
 */
export interface ApiScopeOptionDto {
    /**
     * 
     * @type {string}
     * @memberof ApiScopeOptionDto
     */
    'scope': ApiScopeOptionDtoScopeEnum;
    /**
     * 
     * @type {string}
     * @memberof ApiScopeOptionDto
     */
    'label': string;
    /**
     * True if the scope permits state mutations.
     * @type {boolean}
     * @memberof ApiScopeOptionDto
     */
    'write': boolean;
    /**
     * True if the scope can create a charge or consume account balance. Render these apart from ordinary writes.
     * @type {boolean}
     * @memberof ApiScopeOptionDto
     */
    'spend'?: boolean;
    /**
     * True if the scope permits irreversible destruction of customer data.
     * @type {boolean}
     * @memberof ApiScopeOptionDto
     */
    'destructive'?: boolean;
    /**
     * True if the in-console AI assistant is provisioned with this scope by default. Authoritative — clients must not hardcode their own list.
     * @type {boolean}
     * @memberof ApiScopeOptionDto
     */
    'assistantDefault'?: boolean;
}

export const ApiScopeOptionDtoScopeEnum = {
    Vmread: 'vm:read',
    Vmwrite: 'vm:write',
    Vmpower: 'vm:power',
    Billingread: 'billing:read',
    Dnsread: 'dns:read',
    Dnswrite: 'dns:write',
    Networkread: 'network:read',
    Networkwrite: 'network:write',
    Assistantread: 'assistant:read',
    Accountread: 'account:read',
    Imageread: 'image:read',
    Orderwrite: 'order:write',
    Billingwrite: 'billing:write',
    Vmdelete: 'vm:delete',
    Adminclientsread: 'admin:clients:read',
    Adminservicesread: 'admin:services:read',
    Adminserviceswrite: 'admin:services:write',
    Adminbillingread: 'admin:billing:read',
    Adminbillingwrite: 'admin:billing:write',
    Admindnsread: 'admin:dns:read',
    Admindnswrite: 'admin:dns:write',
    Adminoperationsread: 'admin:operations:read',
    Adminalertsread: 'admin:alerts:read',
    Admininfrastructureread: 'admin:infrastructure:read',
    Adminauditread: 'admin:audit:read'
} as const;

export type ApiScopeOptionDtoScopeEnum = typeof ApiScopeOptionDtoScopeEnum[keyof typeof ApiScopeOptionDtoScopeEnum];

/**
 * 
 * @export
 * @interface ApiTokenSummaryDto
 */
export interface ApiTokenSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof ApiTokenSummaryDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ApiTokenSummaryDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApiTokenSummaryDto
     */
    'tokenPrefix': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiTokenSummaryDto
     */
    'scopes': Array<ApiTokenSummaryDtoScopesEnum>;
    /**
     * 
     * @type {string}
     * @memberof ApiTokenSummaryDto
     */
    'createdVia': ApiTokenSummaryDtoCreatedViaEnum;
    /**
     * 
     * @type {string}
     * @memberof ApiTokenSummaryDto
     */
    'ownerKind': ApiTokenSummaryDtoOwnerKindEnum;
    /**
     * 
     * @type {number}
     * @memberof ApiTokenSummaryDto
     */
    'clientId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiTokenSummaryDto
     */
    'expiresAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiTokenSummaryDto
     */
    'lastUsedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiTokenSummaryDto
     */
    'revokedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiTokenSummaryDto
     */
    'createdAt': string;
}

export const ApiTokenSummaryDtoScopesEnum = {
    Vmread: 'vm:read',
    Vmwrite: 'vm:write',
    Vmpower: 'vm:power',
    Billingread: 'billing:read',
    Dnsread: 'dns:read',
    Dnswrite: 'dns:write',
    Networkread: 'network:read',
    Networkwrite: 'network:write',
    Assistantread: 'assistant:read',
    Accountread: 'account:read',
    Imageread: 'image:read',
    Orderwrite: 'order:write',
    Billingwrite: 'billing:write',
    Vmdelete: 'vm:delete',
    Adminclientsread: 'admin:clients:read',
    Adminservicesread: 'admin:services:read',
    Adminserviceswrite: 'admin:services:write',
    Adminbillingread: 'admin:billing:read',
    Adminbillingwrite: 'admin:billing:write',
    Admindnsread: 'admin:dns:read',
    Admindnswrite: 'admin:dns:write',
    Adminoperationsread: 'admin:operations:read',
    Adminalertsread: 'admin:alerts:read',
    Admininfrastructureread: 'admin:infrastructure:read',
    Adminauditread: 'admin:audit:read'
} as const;

export type ApiTokenSummaryDtoScopesEnum = typeof ApiTokenSummaryDtoScopesEnum[keyof typeof ApiTokenSummaryDtoScopesEnum];
export const ApiTokenSummaryDtoCreatedViaEnum = {
    Console: 'CONSOLE',
    SuperAdmin: 'SUPER_ADMIN',
    Oauth: 'OAUTH',
    TokenExchange: 'TOKEN_EXCHANGE'
} as const;

export type ApiTokenSummaryDtoCreatedViaEnum = typeof ApiTokenSummaryDtoCreatedViaEnum[keyof typeof ApiTokenSummaryDtoCreatedViaEnum];
export const ApiTokenSummaryDtoOwnerKindEnum = {
    User: 'USER',
    SuperAdmin: 'SUPER_ADMIN',
    Delegated: 'DELEGATED'
} as const;

export type ApiTokenSummaryDtoOwnerKindEnum = typeof ApiTokenSummaryDtoOwnerKindEnum[keyof typeof ApiTokenSummaryDtoOwnerKindEnum];

/**
 * 
 * @export
 * @interface ApplyChangesDto
 */
export interface ApplyChangesDto {
    /**
     * Whether to perform full reinstallation instead of just running deploy-vm-stage3
     * @type {boolean}
     * @memberof ApplyChangesDto
     */
    'fullReinstall'?: boolean;
}
/**
 * 
 * @export
 * @interface AssistantInstructionsDto
 */
export interface AssistantInstructionsDto {
    /**
     * Operator-authored instructions for the AI assistant (support channels, policies, notices). Empty string when none are configured.
     * @type {string}
     * @memberof AssistantInstructionsDto
     */
    'instructions': string;
}
/**
 * 
 * @export
 * @interface AttachTargetsDto
 */
export interface AttachTargetsDto {
    /**
     * 
     * @type {Array<ClientImageTargetDto>}
     * @memberof AttachTargetsDto
     */
    'targets': Array<ClientImageTargetDto>;
}
/**
 * 
 * @export
 * @interface BackupEntity
 */
export interface BackupEntity {
    /**
     * Backup ID
     * @type {number}
     * @memberof BackupEntity
     */
    'id': number;
    /**
     * VM ID
     * @type {number}
     * @memberof BackupEntity
     */
    'vm_id': number;
    /**
     * Storage ID
     * @type {number}
     * @memberof BackupEntity
     */
    'storage_id': number;
    /**
     * Creation timestamp
     * @type {string}
     * @memberof BackupEntity
     */
    'created_at': string;
    /**
     * Last update timestamp
     * @type {string}
     * @memberof BackupEntity
     */
    'updated_at': string;
}
/**
 * 
 * @export
 * @interface BackupScheduleEntity
 */
export interface BackupScheduleEntity {
    /**
     * Backup schedule ID
     * @type {number}
     * @memberof BackupScheduleEntity
     */
    'id': number;
    /**
     * VM ID
     * @type {number}
     * @memberof BackupScheduleEntity
     */
    'vm_id': number;
    /**
     * Run on Sunday
     * @type {boolean}
     * @memberof BackupScheduleEntity
     */
    'sun': boolean;
    /**
     * Run on Monday
     * @type {boolean}
     * @memberof BackupScheduleEntity
     */
    'mon': boolean;
    /**
     * Run on Tuesday
     * @type {boolean}
     * @memberof BackupScheduleEntity
     */
    'tue': boolean;
    /**
     * Run on Wednesday
     * @type {boolean}
     * @memberof BackupScheduleEntity
     */
    'wed': boolean;
    /**
     * Run on Thursday
     * @type {boolean}
     * @memberof BackupScheduleEntity
     */
    'thu': boolean;
    /**
     * Run on Friday
     * @type {boolean}
     * @memberof BackupScheduleEntity
     */
    'fri': boolean;
    /**
     * Run on Saturday
     * @type {boolean}
     * @memberof BackupScheduleEntity
     */
    'sat': boolean;
    /**
     * Time to run backup
     * @type {string}
     * @memberof BackupScheduleEntity
     */
    'time': string;
    /**
     * IANA timezone used to evaluate the scheduled time. Null means the server timezone is used.
     * @type {string}
     * @memberof BackupScheduleEntity
     */
    'timezone'?: string | null;
    /**
     * Last run timestamp (exact time the backup was last queued)
     * @type {string}
     * @memberof BackupScheduleEntity
     */
    'last_run_at'?: string;
    /**
     * Creation timestamp
     * @type {string}
     * @memberof BackupScheduleEntity
     */
    'created_at': string;
    /**
     * Last update timestamp
     * @type {string}
     * @memberof BackupScheduleEntity
     */
    'updated_at': string;
}
/**
 * 
 * @export
 * @interface BalanceBucketsDto
 */
export interface BalanceBucketsDto {
    /**
     * 
     * @type {string}
     * @memberof BalanceBucketsDto
     */
    'committed_micro_cents': string;
    /**
     * 
     * @type {string}
     * @memberof BalanceBucketsDto
     */
    'available_micro_cents': string;
    /**
     * 
     * @type {string}
     * @memberof BalanceBucketsDto
     */
    'temporary_micro_cents': string;
    /**
     * 
     * @type {string}
     * @memberof BalanceBucketsDto
     */
    'negative_micro_cents': string;
    /**
     * available + temporary - negative
     * @type {string}
     * @memberof BalanceBucketsDto
     */
    'usable_micro_cents': string;
}
/**
 * 
 * @export
 * @interface BandwidthDataPoint
 */
export interface BandwidthDataPoint {
    /**
     * Bucket start time (ISO 8601, UTC)
     * @type {string}
     * @memberof BandwidthDataPoint
     */
    'time': string;
    /**
     * Bytes received across all interfaces in this bucket
     * @type {number}
     * @memberof BandwidthDataPoint
     */
    'inbound_bytes': number;
    /**
     * Bytes sent across all interfaces in this bucket
     * @type {number}
     * @memberof BandwidthDataPoint
     */
    'outbound_bytes': number;
}
/**
 * 
 * @export
 * @interface BulkUpdateFirewallRulesDto
 */
export interface BulkUpdateFirewallRulesDto {
    /**
     * Collection of firewall rules to update
     * @type {Array<UpdateFirewallRuleItemDto>}
     * @memberof BulkUpdateFirewallRulesDto
     */
    'rules': Array<UpdateFirewallRuleItemDto>;
}
/**
 * 
 * @export
 * @interface CancellationRequestDto
 */
export interface CancellationRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CancellationRequestDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CancellationRequestDto
     */
    'subscription_id': string;
    /**
     * 
     * @type {string}
     * @memberof CancellationRequestDto
     */
    'status': CancellationRequestDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CancellationRequestDto
     */
    'reason': CancellationRequestDtoReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof CancellationRequestDto
     */
    'comment': string | null;
    /**
     * When the cancellation takes effect (the cycle end at request time). Null = ON_DEMAND subscription, effective immediately.
     * @type {string}
     * @memberof CancellationRequestDto
     */
    'effective_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof CancellationRequestDto
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof CancellationRequestDto
     */
    'withdrawn_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof CancellationRequestDto
     */
    'completed_at': string | null;
}

export const CancellationRequestDtoStatusEnum = {
    Pending: 'pending',
    Withdrawn: 'withdrawn',
    Completed: 'completed'
} as const;

export type CancellationRequestDtoStatusEnum = typeof CancellationRequestDtoStatusEnum[keyof typeof CancellationRequestDtoStatusEnum];
export const CancellationRequestDtoReasonEnum = {
    TooExpensive: 'TOO_EXPENSIVE',
    MissingFeatures: 'MISSING_FEATURES',
    TechnicalIssues: 'TECHNICAL_ISSUES',
    CustomerSupport: 'CUSTOMER_SUPPORT',
    SwitchingProvider: 'SWITCHING_PROVIDER',
    NoLongerNeeded: 'NO_LONGER_NEEDED',
    TemporaryProject: 'TEMPORARY_PROJECT',
    Other: 'OTHER'
} as const;

export type CancellationRequestDtoReasonEnum = typeof CancellationRequestDtoReasonEnum[keyof typeof CancellationRequestDtoReasonEnum];

/**
 * 
 * @export
 * @interface CancellationStateDto
 */
export interface CancellationStateDto {
    /**
     * The pending cancellation request, or null when none.
     * @type {CancellationRequestDto}
     * @memberof CancellationStateDto
     */
    'pending': CancellationRequestDto | null;
}
/**
 * 
 * @export
 * @interface CheckEmailDto
 */
export interface CheckEmailDto {
    /**
     * Email address to check for an existing account.
     * @type {string}
     * @memberof CheckEmailDto
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface CheckEmailResponseDto
 */
export interface CheckEmailResponseDto {
    /**
     * Whether registering this email would be refused — true when WHMCS holds it as a login OR as an account contact address. The two are different columns and either one blocks AddClient.
     * @type {boolean}
     * @memberof CheckEmailResponseDto
     */
    'exists': boolean;
    /**
     * Whether the address can actually SIGN IN, i.e. WHMCS holds it as a user. `exists: true` with `canSignIn: false` is an address that is only an account\'s contact address and has no login behind it — sending someone there to sign in is a dead end.
     * @type {boolean}
     * @memberof CheckEmailResponseDto
     */
    'canSignIn': boolean;
}
/**
 * 
 * @export
 * @interface CheckVmBackupEligibility200Response
 */
export interface CheckVmBackupEligibility200Response {
    /**
     * Whether the VM is eligible for backups
     * @type {boolean}
     * @memberof CheckVmBackupEligibility200Response
     */
    'eligible'?: boolean;
    /**
     * Number of backup slots allocated to the VM
     * @type {number}
     * @memberof CheckVmBackupEligibility200Response
     */
    'backupSlots'?: number;
    /**
     * Current number of backups for this VM
     * @type {number}
     * @memberof CheckVmBackupEligibility200Response
     */
    'currentBackupCount'?: number;
    /**
     * Number of available backup slots remaining
     * @type {number}
     * @memberof CheckVmBackupEligibility200Response
     */
    'availableSlots'?: number;
    /**
     * Reason if not eligible
     * @type {string}
     * @memberof CheckVmBackupEligibility200Response
     */
    'reason'?: string | null;
}
/**
 * 
 * @export
 * @interface CheckoutCouponPreviewBodyDto
 */
export interface CheckoutCouponPreviewBodyDto {
    /**
     * 
     * @type {string}
     * @memberof CheckoutCouponPreviewBodyDto
     */
    'coupon_code': string;
    /**
     * Gross cycle total of the service being ordered, in micro-cents, for the current checkout quote.
     * @type {string}
     * @memberof CheckoutCouponPreviewBodyDto
     */
    'service_total_micro_cents': string;
    /**
     * The existing subscription the service would be added to. A checkout coupon discounts a new subscription’s service only, so a preview naming one is refused.
     * @type {string}
     * @memberof CheckoutCouponPreviewBodyDto
     */
    'target_subscription_id'?: string;
}
/**
 * 
 * @export
 * @interface ClientActivityEntryDto
 */
export interface ClientActivityEntryDto {
    /**
     * 
     * @type {string}
     * @memberof ClientActivityEntryDto
     */
    'id': string;
    /**
     * When the action happened (UTC).
     * @type {string}
     * @memberof ClientActivityEntryDto
     */
    'createdAt': string;
    /**
     * Stable action key, e.g. `instance.delete`. Safe to switch on; the human label is derived from it by the console.
     * @type {string}
     * @memberof ClientActivityEntryDto
     */
    'action': string;
    /**
     * Area of the product this action belongs to.
     * @type {string}
     * @memberof ClientActivityEntryDto
     */
    'category'?: ClientActivityEntryDtoCategoryEnum;
    /**
     * True when the action destroys data or spends money. Rendered prominently in the console.
     * @type {boolean}
     * @memberof ClientActivityEntryDto
     */
    'significant': boolean;
    /**
     * False when the action key was derived from the route rather than declared, so the console can render a humanized fallback instead of a missing translation.
     * @type {boolean}
     * @memberof ClientActivityEntryDto
     */
    'labelled': boolean;
    /**
     * Which surface performed the action.
     * @type {string}
     * @memberof ClientActivityEntryDto
     */
    'actorKind': ClientActivityEntryDtoActorKindEnum;
    /**
     * Who performed it, as recorded at the time — a user email, an API token name, or `Support team` for actions taken by our staff on your behalf.
     * @type {string}
     * @memberof ClientActivityEntryDto
     */
    'actorLabel': string;
    /**
     * Source IP address of the request.
     * @type {string}
     * @memberof ClientActivityEntryDto
     */
    'ip'?: string;
    /**
     * User agent of the client that made the request.
     * @type {string}
     * @memberof ClientActivityEntryDto
     */
    'userAgent'?: string;
    /**
     * Kind of resource affected.
     * @type {string}
     * @memberof ClientActivityEntryDto
     */
    'targetType'?: string;
    /**
     * Id of the resource affected.
     * @type {string}
     * @memberof ClientActivityEntryDto
     */
    'targetId'?: string;
    /**
     * The resource\'s name at the time of the action. Retained after deletion — this is how a destroyed instance is still identifiable by name.
     * @type {string}
     * @memberof ClientActivityEntryDto
     */
    'targetLabel'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientActivityEntryDto
     */
    'outcome': ClientActivityEntryDtoOutcomeEnum;
    /**
     * HTTP status code the request returned.
     * @type {number}
     * @memberof ClientActivityEntryDto
     */
    'statusCode'?: number;
    /**
     * Why the action was refused. Only present for refusals (4xx); internal failures carry no detail.
     * @type {string}
     * @memberof ClientActivityEntryDto
     */
    'errorMessage'?: string;
    /**
     * HTTP method.
     * @type {string}
     * @memberof ClientActivityEntryDto
     */
    'method'?: string;
    /**
     * Request path, without the query string.
     * @type {string}
     * @memberof ClientActivityEntryDto
     */
    'path'?: string;
    /**
     * Correlation id, if the request carried one. Quote it in support tickets.
     * @type {string}
     * @memberof ClientActivityEntryDto
     */
    'requestId'?: string;
    /**
     * The submitted request detail, with credential-shaped fields masked. Large payloads are replaced by a byte count.
     * @type {{ [key: string]: any; }}
     * @memberof ClientActivityEntryDto
     */
    'metadata'?: { [key: string]: any; };
}

export const ClientActivityEntryDtoCategoryEnum = {
    Instance: 'instance',
    Network: 'network',
    Dns: 'dns',
    Storage: 'storage',
    Billing: 'billing',
    Security: 'security',
    Account: 'account'
} as const;

export type ClientActivityEntryDtoCategoryEnum = typeof ClientActivityEntryDtoCategoryEnum[keyof typeof ClientActivityEntryDtoCategoryEnum];
export const ClientActivityEntryDtoActorKindEnum = {
    Console: 'CONSOLE',
    ApiToken: 'API_TOKEN',
    Mcp: 'MCP',
    Support: 'SUPPORT',
    SupportBot: 'SUPPORT_BOT',
    System: 'SYSTEM'
} as const;

export type ClientActivityEntryDtoActorKindEnum = typeof ClientActivityEntryDtoActorKindEnum[keyof typeof ClientActivityEntryDtoActorKindEnum];
export const ClientActivityEntryDtoOutcomeEnum = {
    Success: 'success',
    Failure: 'failure',
    Denied: 'denied'
} as const;

export type ClientActivityEntryDtoOutcomeEnum = typeof ClientActivityEntryDtoOutcomeEnum[keyof typeof ClientActivityEntryDtoOutcomeEnum];

/**
 * 
 * @export
 * @interface ClientActivityListResponseDto
 */
export interface ClientActivityListResponseDto {
    /**
     * 
     * @type {Array<ClientActivityEntryDto>}
     * @memberof ClientActivityListResponseDto
     */
    'data': Array<ClientActivityEntryDto>;
    /**
     * Total entries matching the filters.
     * @type {number}
     * @memberof ClientActivityListResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof ClientActivityListResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof ClientActivityListResponseDto
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof ClientActivityListResponseDto
     */
    'totalPages': number;
    /**
     * How many days of history are retained. Entries older than this are permanently deleted.
     * @type {number}
     * @memberof ClientActivityListResponseDto
     */
    'retentionDays': number;
}
/**
 * 
 * @export
 * @interface ClientDetailsDto
 */
export interface ClientDetailsDto {
    /**
     * Client information
     * @type {object}
     * @memberof ClientDetailsDto
     */
    'client': object;
    /**
     * Users associated with the client
     * @type {object}
     * @memberof ClientDetailsDto
     */
    'users': object;
    /**
     * Statistics related to the client
     * @type {object}
     * @memberof ClientDetailsDto
     */
    'stats': object;
    /**
     * Locale the cloud platform resolved for this client (profile language when supported, the WHMCS default language for \"DEFAULT\" profiles, English otherwise). Frontends should use this instead of re-deriving a locale from the raw WHMCS language/country fields.
     * @type {string}
     * @memberof ClientDetailsDto
     */
    'platformLocale'?: ClientDetailsDtoPlatformLocaleEnum;
}

export const ClientDetailsDtoPlatformLocaleEnum = {
    Pt: 'pt',
    En: 'en'
} as const;

export type ClientDetailsDtoPlatformLocaleEnum = typeof ClientDetailsDtoPlatformLocaleEnum[keyof typeof ClientDetailsDtoPlatformLocaleEnum];

/**
 * 
 * @export
 * @interface ClientImageCloudInitDto
 */
export interface ClientImageCloudInitDto {
    /**
     * The user-data exactly as it will be handed to the guest. Null when the customer has written none, in which case the instance boots as the image was built.
     * @type {string}
     * @memberof ClientImageCloudInitDto
     */
    'user_data': string | null;
    /**
     * Which of cloud-init’s user-data formats this document is, decided from its first line: `cloud-config`, `shell-script`, `boothook`, `powershell`, `batch`, …
     * @type {string}
     * @memberof ClientImageCloudInitDto
     */
    'format': string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientImageCloudInitDto
     */
    'updated_at': string | null;
    /**
     * Size of the stored document in bytes.
     * @type {number}
     * @memberof ClientImageCloudInitDto
     */
    'size_bytes': number;
    /**
     * The largest document this image will accept.
     * @type {number}
     * @memberof ClientImageCloudInitDto
     */
    'max_bytes': number;
    /**
     * Which first-boot agent reads it, from the image’s OS type. Windows images run cloudbase-init, which accepts a different set of formats and implements only part of cloud-config.
     * @type {string}
     * @memberof ClientImageCloudInitDto
     */
    'family': ClientImageCloudInitDtoFamilyEnum;
    /**
     * The formats this image’s agent will actually execute.
     * @type {Array<string>}
     * @memberof ClientImageCloudInitDto
     */
    'accepted_formats': Array<string>;
    /**
     * Re-checked on every read, so a document saved before a rule existed is reported rather than silently accepted.
     * @type {Array<ClientImageCloudInitIssueDto>}
     * @memberof ClientImageCloudInitDto
     */
    'issues': Array<ClientImageCloudInitIssueDto>;
}

export const ClientImageCloudInitDtoFamilyEnum = {
    CloudInit: 'cloud-init',
    CloudbaseInit: 'cloudbase-init'
} as const;

export type ClientImageCloudInitDtoFamilyEnum = typeof ClientImageCloudInitDtoFamilyEnum[keyof typeof ClientImageCloudInitDtoFamilyEnum];

/**
 * 
 * @export
 * @interface ClientImageCloudInitIssueDto
 */
export interface ClientImageCloudInitIssueDto {
    /**
     * Machine-readable reason, e.g. `yaml_invalid`, `invalid_type`, `unknown_key`. Stable — the console keys its copy on it.
     * @type {string}
     * @memberof ClientImageCloudInitIssueDto
     */
    'code': string;
    /**
     * An error refuses the save; a warning is saved and shown. A warning always means \"this is legal and will do something you may not expect\".
     * @type {string}
     * @memberof ClientImageCloudInitIssueDto
     */
    'severity': ClientImageCloudInitIssueDtoSeverityEnum;
    /**
     * 
     * @type {string}
     * @memberof ClientImageCloudInitIssueDto
     */
    'message': string;
    /**
     * 1-based line the parser objected to, when it reported one.
     * @type {number}
     * @memberof ClientImageCloudInitIssueDto
     */
    'line'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ClientImageCloudInitIssueDto
     */
    'column'?: number | null;
    /**
     * Which key the issue is about, e.g. `write_files[0].path`.
     * @type {string}
     * @memberof ClientImageCloudInitIssueDto
     */
    'path'?: string | null;
}

export const ClientImageCloudInitIssueDtoSeverityEnum = {
    Error: 'error',
    Warning: 'warning'
} as const;

export type ClientImageCloudInitIssueDtoSeverityEnum = typeof ClientImageCloudInitIssueDtoSeverityEnum[keyof typeof ClientImageCloudInitIssueDtoSeverityEnum];

/**
 * 
 * @export
 * @interface ClientImageCloudInitValidationDto
 */
export interface ClientImageCloudInitValidationDto {
    /**
     * 
     * @type {string}
     * @memberof ClientImageCloudInitValidationDto
     */
    'format': string;
    /**
     * 
     * @type {number}
     * @memberof ClientImageCloudInitValidationDto
     */
    'size_bytes': number;
    /**
     * 
     * @type {number}
     * @memberof ClientImageCloudInitValidationDto
     */
    'max_bytes': number;
    /**
     * False when at least one issue is an error, so a save would be refused.
     * @type {boolean}
     * @memberof ClientImageCloudInitValidationDto
     */
    'ok': boolean;
    /**
     * 
     * @type {Array<ClientImageCloudInitIssueDto>}
     * @memberof ClientImageCloudInitValidationDto
     */
    'issues': Array<ClientImageCloudInitIssueDto>;
}
/**
 * 
 * @export
 * @interface ClientImageDto
 */
export interface ClientImageDto {
    /**
     * 
     * @type {string}
     * @memberof ClientImageDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ClientImageDto
     */
    'display_name': string;
    /**
     * 
     * @type {string}
     * @memberof ClientImageDto
     */
    'original_filename': string;
    /**
     * 
     * @type {string}
     * @memberof ClientImageDto
     */
    'kind': ClientImageDtoKindEnum;
    /**
     * 
     * @type {string}
     * @memberof ClientImageDto
     */
    'status': string;
    /**
     * Bytes stored. Null while an upload is still in progress.
     * @type {string}
     * @memberof ClientImageDto
     */
    'size_bytes'?: string | null;
    /**
     * What the guest sees once deployed, in bytes. Null for an ISO, and null for a disk image whose size could not be determined — which must never be read as \"fits\".
     * @type {string}
     * @memberof ClientImageDto
     */
    'virtual_size_bytes'?: string | null;
    /**
     * The smallest plan disk this image can be deployed onto, in GB.
     * @type {number}
     * @memberof ClientImageDto
     */
    'min_disk_gb'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ClientImageDto
     */
    'source_format'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientImageDto
     */
    'disk_format'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientImageDto
     */
    'sha256'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientImageDto
     */
    'ostype'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientImageDto
     */
    'disk_bus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientImageDto
     */
    'scsihw'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientImageDto
     */
    'machine'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientImageDto
     */
    'bios'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ClientImageDto
     */
    'requires_efi': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ClientImageDto
     */
    'requires_tpm': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ClientImageDto
     */
    'has_cloud_init': boolean;
    /**
     * 
     * @type {string}
     * @memberof ClientImageDto
     */
    'default_username'?: string | null;
    /**
     * Which format the customer’s own cloud-init user-data is in, or null if they have written none. A SUMMARY only — the document itself is read from `GET /images/{imageId}/cloud-init`, never from a list.
     * @type {string}
     * @memberof ClientImageDto
     */
    'cloud_init_user_data_format'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientImageDto
     */
    'cloud_init_user_data_updated_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientImageDto
     */
    'expires_at'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ClientImageDto
     */
    'renew_count': number;
    /**
     * 
     * @type {string}
     * @memberof ClientImageDto
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof ClientImageDto
     */
    'failure_reason'?: string | null;
    /**
     * Progress of the upload or processing, 0-100. Null when idle.
     * @type {number}
     * @memberof ClientImageDto
     */
    'progress'?: number | null;
    /**
     * 
     * @type {Array<ClientImagePlacementDto>}
     * @memberof ClientImageDto
     */
    'placements': Array<ClientImagePlacementDto>;
    /**
     * 
     * @type {Array<ClientImageMountDto>}
     * @memberof ClientImageDto
     */
    'mounts': Array<ClientImageMountDto>;
    /**
     * Instances built from this image.
     * @type {number}
     * @memberof ClientImageDto
     */
    'instance_count': number;
}

export const ClientImageDtoKindEnum = {
    DiskImage: 'disk_image',
    Iso: 'iso'
} as const;

export type ClientImageDtoKindEnum = typeof ClientImageDtoKindEnum[keyof typeof ClientImageDtoKindEnum];

/**
 * 
 * @export
 * @interface ClientImageMountDto
 */
export interface ClientImageMountDto {
    /**
     * 
     * @type {number}
     * @memberof ClientImageMountDto
     */
    'vm_id': number;
    /**
     * 
     * @type {string}
     * @memberof ClientImageMountDto
     */
    'mount_interface': string;
    /**
     * 
     * @type {string}
     * @memberof ClientImageMountDto
     */
    'auto_unmount_at': string;
}
/**
 * 
 * @export
 * @interface ClientImageOperationDto
 */
export interface ClientImageOperationDto {
    /**
     * 
     * @type {string}
     * @memberof ClientImageOperationDto
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof ClientImageOperationDto
     */
    'job_id'?: string;
}
/**
 * 
 * @export
 * @interface ClientImagePlacementDto
 */
export interface ClientImagePlacementDto {
    /**
     * 
     * @type {number}
     * @memberof ClientImagePlacementDto
     */
    'datacenter_id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ClientImagePlacementDto
     */
    'datacenter_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientImagePlacementDto
     */
    'state': ClientImagePlacementDtoStateEnum;
    /**
     * 
     * @type {string}
     * @memberof ClientImagePlacementDto
     */
    'size_bytes'?: string | null;
}

export const ClientImagePlacementDtoStateEnum = {
    Absent: 'absent',
    Copying: 'copying',
    Verifying: 'verifying',
    Ready: 'ready',
    Failed: 'failed'
} as const;

export type ClientImagePlacementDtoStateEnum = typeof ClientImagePlacementDtoStateEnum[keyof typeof ClientImagePlacementDtoStateEnum];

/**
 * 
 * @export
 * @interface ClientImageQuotaDto
 */
export interface ClientImageQuotaDto {
    /**
     * 
     * @type {number}
     * @memberof ClientImageQuotaDto
     */
    'artifacts': number;
    /**
     * 
     * @type {number}
     * @memberof ClientImageQuotaDto
     */
    'max_artifacts': number;
    /**
     * 
     * @type {string}
     * @memberof ClientImageQuotaDto
     */
    'total_bytes': string;
    /**
     * 
     * @type {string}
     * @memberof ClientImageQuotaDto
     */
    'max_total_bytes': string;
    /**
     * 
     * @type {string}
     * @memberof ClientImageQuotaDto
     */
    'max_file_bytes': string;
    /**
     * 
     * @type {number}
     * @memberof ClientImageQuotaDto
     */
    'retention_days': number;
    /**
     * 
     * @type {boolean}
     * @memberof ClientImageQuotaDto
     */
    'uploads_enabled': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientImageQuotaDto
     */
    'accepted_extensions': Array<string>;
}
/**
 * 
 * @export
 * @interface ClientImageTargetDto
 */
export interface ClientImageTargetDto {
    /**
     * 
     * @type {number}
     * @memberof ClientImageTargetDto
     */
    'vm_id': number;
    /**
     * 
     * @type {string}
     * @memberof ClientImageTargetDto
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof ClientImageTargetDto
     */
    'disk_gb'?: number | null;
    /**
     * False when the instance’s disk is smaller than the image needs. The customer must resize before deploying — a reinstall cannot grow a disk.
     * @type {boolean}
     * @memberof ClientImageTargetDto
     */
    'fits': boolean;
    /**
     * 
     * @type {number}
     * @memberof ClientImageTargetDto
     */
    'required_disk_gb'?: number | null;
}
/**
 * 
 * @export
 * @interface CloneBillingQuoteDto
 */
export interface CloneBillingQuoteDto {
    /**
     * COMMITTED | ON_DEMAND
     * @type {string}
     * @memberof CloneBillingQuoteDto
     */
    'commitment_type': string;
    /**
     * Destination billing subscription id
     * @type {string}
     * @memberof CloneBillingQuoteDto
     */
    'subscription_id': string;
    /**
     * Current hourly rate (micro-cents/h)
     * @type {string}
     * @memberof CloneBillingQuoteDto
     */
    'current_rate_micro_cents_per_hour': string;
    /**
     * Projected hourly rate after the clone (micro-cents/h)
     * @type {string}
     * @memberof CloneBillingQuoteDto
     */
    'projected_rate_micro_cents_per_hour': string;
    /**
     * Projected − current (micro-cents/h, may be negative)
     * @type {string}
     * @memberof CloneBillingQuoteDto
     */
    'delta_rate_micro_cents_per_hour': string;
    /**
     * Hours until the committed cycle renews (0 for on-demand)
     * @type {number}
     * @memberof CloneBillingQuoteDto
     */
    'hours_until_renewal': number;
    /**
     * COMMITTED upgrade prorata until renewal (micro-cents)
     * @type {string}
     * @memberof CloneBillingQuoteDto
     */
    'gross_impact_micro_cents': string;
    /**
     * Prorata after temporary-credit offset (micro-cents)
     * @type {string}
     * @memberof CloneBillingQuoteDto
     */
    'net_impact_micro_cents': string;
    /**
     * Top-up (cents) required before the clone can start; null when funded
     * @type {string}
     * @memberof CloneBillingQuoteDto
     */
    'required_topup_cents'?: string | null;
    /**
     * Temporary credit a committed rate DECREASE would preserve (micro-cents)
     * @type {string}
     * @memberof CloneBillingQuoteDto
     */
    'temporary_credit_on_downgrade_micro_cents': string;
    /**
     * False blocks the clone until the customer adds funds
     * @type {boolean}
     * @memberof CloneBillingQuoteDto
     */
    'funds_ok': boolean;
}
/**
 * 
 * @export
 * @interface CloneDiskChangesDto
 */
export interface CloneDiskChangesDto {
    /**
     * Destination main disk today (GB, billed spec)
     * @type {number}
     * @memberof CloneDiskChangesDto
     */
    'main_disk_before_gb': number;
    /**
     * Destination main disk after the clone (GB)
     * @type {number}
     * @memberof CloneDiskChangesDto
     */
    'main_disk_after_gb': number;
    /**
     * Sizes (GB) of the destination data disks that will be DESTROYED
     * @type {Array<number>}
     * @memberof CloneDiskChangesDto
     */
    'extra_disks_before_gb': Array<number>;
    /**
     * Sizes (GB) of the data disks the destination will have after the clone (copied from the origin)
     * @type {Array<number>}
     * @memberof CloneDiskChangesDto
     */
    'extra_disks_after_gb': Array<number>;
}
/**
 * 
 * @export
 * @interface CloneInitiatedResponseDto
 */
export interface CloneInitiatedResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof CloneInitiatedResponseDto
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof CloneInitiatedResponseDto
     */
    'message': string;
    /**
     * app_jobs id for progress tracking
     * @type {string}
     * @memberof CloneInitiatedResponseDto
     */
    'jobId': string;
}
/**
 * 
 * @export
 * @interface CloneValidationResponseDto
 */
export interface CloneValidationResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof CloneValidationResponseDto
     */
    'eligible': boolean;
    /**
     * 
     * @type {string}
     * @memberof CloneValidationResponseDto
     */
    'reason'?: string;
    /**
     * Origin VM main disk size in GB
     * @type {number}
     * @memberof CloneValidationResponseDto
     */
    'originDiskGb'?: number;
    /**
     * Destination VM main disk size in GB
     * @type {number}
     * @memberof CloneValidationResponseDto
     */
    'destinationDiskGb'?: number;
    /**
     * Selected clone source mode.
     * @type {string}
     * @memberof CloneValidationResponseDto
     */
    'sourceType'?: CloneValidationResponseDtoSourceTypeEnum;
    /**
     * Backup storage selected for clone input
     * @type {string}
     * @memberof CloneValidationResponseDto
     */
    'backupStorageName'?: string;
    /**
     * Destination VM storage selected for restore
     * @type {string}
     * @memberof CloneValidationResponseDto
     */
    'targetStorageName'?: string;
    /**
     * Whether the backup used by the clone will be deleted after completion.
     * @type {boolean}
     * @memberof CloneValidationResponseDto
     */
    'deleteTemporaryBackup'?: boolean;
    /**
     * 
     * @type {CloneDiskChangesDto}
     * @memberof CloneValidationResponseDto
     */
    'disk_changes'?: CloneDiskChangesDto;
    /**
     * Billing impact on the destination; null when it has no managed billing
     * @type {CloneBillingQuoteDto}
     * @memberof CloneValidationResponseDto
     */
    'billing'?: CloneBillingQuoteDto | null;
    /**
     * Non-blocking warnings the user must be shown before confirming
     * @type {Array<string>}
     * @memberof CloneValidationResponseDto
     */
    'warnings'?: Array<string>;
    /**
     * Blocking violations (eligible=false when non-empty)
     * @type {Array<CloneViolationDto>}
     * @memberof CloneValidationResponseDto
     */
    'violations'?: Array<CloneViolationDto>;
}

export const CloneValidationResponseDtoSourceTypeEnum = {
    CurrentState: 'current_state',
    ExistingBackup: 'existing_backup'
} as const;

export type CloneValidationResponseDtoSourceTypeEnum = typeof CloneValidationResponseDtoSourceTypeEnum[keyof typeof CloneValidationResponseDtoSourceTypeEnum];

/**
 * 
 * @export
 * @interface CloneViolationDto
 */
export interface CloneViolationDto {
    /**
     * 
     * @type {string}
     * @memberof CloneViolationDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof CloneViolationDto
     */
    'reason': string;
}
/**
 * 
 * @export
 * @interface ClusterEntity
 */
export interface ClusterEntity {
    /**
     * The unique identifier of the cluster
     * @type {number}
     * @memberof ClusterEntity
     */
    'id': number;
    /**
     * The name of the cluster
     * @type {string}
     * @memberof ClusterEntity
     */
    'name': string;
    /**
     * The datacenter ID this cluster belongs to
     * @type {number}
     * @memberof ClusterEntity
     */
    'datacenter_id': number;
    /**
     * The date and time when the cluster was created
     * @type {string}
     * @memberof ClusterEntity
     */
    'created_at': string;
    /**
     * The date and time when the cluster was last updated
     * @type {string}
     * @memberof ClusterEntity
     */
    'updated_at': string;
    /**
     * Indicates if the cluster can accomodate VPCs
     * @type {boolean}
     * @memberof ClusterEntity
     */
    'vpc': boolean;
    /**
     * The primary DNS for the VPC
     * @type {string}
     * @memberof ClusterEntity
     */
    'vpc_dns_1': string;
    /**
     * The secondary DNS for the VPC
     * @type {string}
     * @memberof ClusterEntity
     */
    'vpc_dns_2': string;
    /**
     * 
     * @type {DatacenterEntity}
     * @memberof ClusterEntity
     */
    'datacenters': DatacenterEntity;
}
/**
 * 
 * @export
 * @interface CommitFirewall201Response
 */
export interface CommitFirewall201Response {
    /**
     * Job ID for tracking the commit progress
     * @type {string}
     * @memberof CommitFirewall201Response
     */
    'job_id'?: string;
}
/**
 * 
 * @export
 * @interface CommitFirewallDto
 */
export interface CommitFirewallDto {
    /**
     * List of VM IDs to assign this firewall to
     * @type {Array<number>}
     * @memberof CommitFirewallDto
     */
    'vm_ids': Array<number>;
}
/**
 * 
 * @export
 * @interface CompleteSocialRegistrationDto
 */
export interface CompleteSocialRegistrationDto {
    /**
     * Single-use social registration ticket id.
     * @type {string}
     * @memberof CompleteSocialRegistrationDto
     */
    'ticketId': string;
    /**
     * Account password (also used to sign in to the billing portal directly). Minimum 8 characters with at least one uppercase letter, one lowercase letter, one number and one special character.
     * @type {string}
     * @memberof CompleteSocialRegistrationDto
     */
    'password': string;
    /**
     * Client\'s first name
     * @type {string}
     * @memberof CompleteSocialRegistrationDto
     */
    'firstname'?: string;
    /**
     * Client\'s last name
     * @type {string}
     * @memberof CompleteSocialRegistrationDto
     */
    'lastname'?: string;
    /**
     * Client\'s company name
     * @type {string}
     * @memberof CompleteSocialRegistrationDto
     */
    'companyname'?: string;
    /**
     * Client\'s address line 1
     * @type {string}
     * @memberof CompleteSocialRegistrationDto
     */
    'address1': string;
    /**
     * Client\'s address line 2
     * @type {string}
     * @memberof CompleteSocialRegistrationDto
     */
    'address2'?: string;
    /**
     * Client\'s city
     * @type {string}
     * @memberof CompleteSocialRegistrationDto
     */
    'city': string;
    /**
     * Client\'s state or region
     * @type {string}
     * @memberof CompleteSocialRegistrationDto
     */
    'state': string;
    /**
     * Client\'s postal code
     * @type {string}
     * @memberof CompleteSocialRegistrationDto
     */
    'postcode': string;
    /**
     * Client\'s country code (ISO 3166-1 alpha-2)
     * @type {string}
     * @memberof CompleteSocialRegistrationDto
     */
    'country': string;
    /**
     * Client\'s phone number
     * @type {string}
     * @memberof CompleteSocialRegistrationDto
     */
    'phonenumber': string;
    /**
     * Browser locale of the visitor (e.g. navigator.language, \'pt-BR\'). Sets the WHMCS account language: Portuguese locales register as portuguese-br, anything else as english. When omitted, the WHMCS default language applies.
     * @type {string}
     * @memberof CompleteSocialRegistrationDto
     */
    'language'?: string;
}
/**
 * 
 * @export
 * @interface CouponDto
 */
export interface CouponDto {
    /**
     * 
     * @type {string}
     * @memberof CouponDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CouponDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof CouponDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CouponDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CouponDto
     */
    'scope': CouponDtoScopeEnum;
    /**
     * 
     * @type {string}
     * @memberof CouponDto
     */
    'discount_type': CouponDtoDiscountTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof CouponDto
     */
    'percent_bps'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CouponDto
     */
    'amount_micro_cents'?: string | null;
    /**
     * COMMITMENT: the least a service\'s renewal share (rate × the term\'s hours) may be for the coupon to apply to it.
     * @type {string}
     * @memberof CouponDto
     */
    'min_service_total_micro_cents'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CouponDto
     */
    'min_topup_amount_micro_cents'?: string | null;
    /**
     * COMMITMENT: how many live services may hold this coupon at once; checkout reservations count.
     * @type {number}
     * @memberof CouponDto
     */
    'max_services'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CouponDto
     */
    'max_redemptions'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CouponDto
     */
    'assigned_accounts': number;
    /**
     * 
     * @type {number}
     * @memberof CouponDto
     */
    'redeemed_count': number;
    /**
     * 
     * @type {string}
     * @memberof CouponDto
     */
    'starts_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CouponDto
     */
    'expires_at'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CouponDto
     */
    'active': boolean;
    /**
     * Live services bound to this coupon.
     * @type {number}
     * @memberof CouponDto
     */
    'assigned_services': number;
    /**
     * 
     * @type {number}
     * @memberof CouponDto
     */
    'reserved_orders': number;
    /**
     * 
     * @type {string}
     * @memberof CouponDto
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof CouponDto
     */
    'updated_at': string;
}

export const CouponDtoScopeEnum = {
    Commitment: 'COMMITMENT',
    CreditTopup: 'CREDIT_TOPUP'
} as const;

export type CouponDtoScopeEnum = typeof CouponDtoScopeEnum[keyof typeof CouponDtoScopeEnum];
export const CouponDtoDiscountTypeEnum = {
    Percentage: 'PERCENTAGE',
    FixedAmount: 'FIXED_AMOUNT'
} as const;

export type CouponDtoDiscountTypeEnum = typeof CouponDtoDiscountTypeEnum[keyof typeof CouponDtoDiscountTypeEnum];

/**
 * 
 * @export
 * @interface CouponPreviewDto
 */
export interface CouponPreviewDto {
    /**
     * 
     * @type {boolean}
     * @memberof CouponPreviewDto
     */
    'valid': boolean;
    /**
     * 
     * @type {string}
     * @memberof CouponPreviewDto
     */
    'reason'?: string | null;
    /**
     * 
     * @type {CouponDto}
     * @memberof CouponPreviewDto
     */
    'coupon'?: CouponDto | null;
    /**
     * The service\'s share of one renewal at list price: rate × the term\'s hours.
     * @type {string}
     * @memberof CouponPreviewDto
     */
    'service_total_micro_cents': string;
    /**
     * 
     * @type {string}
     * @memberof CouponPreviewDto
     */
    'discount_micro_cents': string;
    /**
     * 
     * @type {string}
     * @memberof CouponPreviewDto
     */
    'payable_micro_cents': string;
    /**
     * 
     * @type {boolean}
     * @memberof CouponPreviewDto
     */
    'recurring': boolean;
    /**
     * 
     * @type {string}
     * @memberof CouponPreviewDto
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface CreateApiTokenDto
 */
export interface CreateApiTokenDto {
    /**
     * 
     * @type {string}
     * @memberof CreateApiTokenDto
     */
    'name': string;
    /**
     * Scopes to grant. Must be valid for the token owner kind.
     * @type {Array<string>}
     * @memberof CreateApiTokenDto
     */
    'scopes': Array<CreateApiTokenDtoScopesEnum>;
    /**
     * Optional absolute expiry (ISO 8601). Omit for a non-expiring token.
     * @type {string}
     * @memberof CreateApiTokenDto
     */
    'expiresAt'?: string;
}

export const CreateApiTokenDtoScopesEnum = {
    Vmread: 'vm:read',
    Vmwrite: 'vm:write',
    Vmpower: 'vm:power',
    Billingread: 'billing:read',
    Dnsread: 'dns:read',
    Dnswrite: 'dns:write',
    Networkread: 'network:read',
    Networkwrite: 'network:write',
    Assistantread: 'assistant:read',
    Accountread: 'account:read',
    Imageread: 'image:read',
    Orderwrite: 'order:write',
    Billingwrite: 'billing:write',
    Vmdelete: 'vm:delete',
    Adminclientsread: 'admin:clients:read',
    Adminservicesread: 'admin:services:read',
    Adminserviceswrite: 'admin:services:write',
    Adminbillingread: 'admin:billing:read',
    Adminbillingwrite: 'admin:billing:write',
    Admindnsread: 'admin:dns:read',
    Admindnswrite: 'admin:dns:write',
    Adminoperationsread: 'admin:operations:read',
    Adminalertsread: 'admin:alerts:read',
    Admininfrastructureread: 'admin:infrastructure:read',
    Adminauditread: 'admin:audit:read'
} as const;

export type CreateApiTokenDtoScopesEnum = typeof CreateApiTokenDtoScopesEnum[keyof typeof CreateApiTokenDtoScopesEnum];

/**
 * 
 * @export
 * @interface CreateBackupScheduleDto
 */
export interface CreateBackupScheduleDto {
    /**
     * VM ID to schedule backups for
     * @type {number}
     * @memberof CreateBackupScheduleDto
     */
    'vm_id': number;
    /**
     * Run backup on Sunday
     * @type {boolean}
     * @memberof CreateBackupScheduleDto
     */
    'sun': boolean;
    /**
     * Run backup on Monday
     * @type {boolean}
     * @memberof CreateBackupScheduleDto
     */
    'mon': boolean;
    /**
     * Run backup on Tuesday
     * @type {boolean}
     * @memberof CreateBackupScheduleDto
     */
    'tue': boolean;
    /**
     * Run backup on Wednesday
     * @type {boolean}
     * @memberof CreateBackupScheduleDto
     */
    'wed': boolean;
    /**
     * Run backup on Thursday
     * @type {boolean}
     * @memberof CreateBackupScheduleDto
     */
    'thu': boolean;
    /**
     * Run backup on Friday
     * @type {boolean}
     * @memberof CreateBackupScheduleDto
     */
    'fri': boolean;
    /**
     * Run backup on Saturday
     * @type {boolean}
     * @memberof CreateBackupScheduleDto
     */
    'sat': boolean;
    /**
     * Time to run backup (HH:MM:SS format)
     * @type {string}
     * @memberof CreateBackupScheduleDto
     */
    'time': string;
    /**
     * IANA timezone used to evaluate the scheduled time. When omitted, the server timezone is used.
     * @type {string}
     * @memberof CreateBackupScheduleDto
     */
    'timezone'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateFirewallDto
 */
export interface CreateFirewallDto {
    /**
     * Firewall name
     * @type {string}
     * @memberof CreateFirewallDto
     */
    'name': string;
    /**
     * Firewall description
     * @type {string}
     * @memberof CreateFirewallDto
     */
    'description'?: string;
    /**
     * Enable firewall
     * @type {boolean}
     * @memberof CreateFirewallDto
     */
    'enable'?: boolean;
    /**
     * Default policy for incoming traffic
     * @type {string}
     * @memberof CreateFirewallDto
     */
    'policy_in'?: CreateFirewallDtoPolicyInEnum;
    /**
     * Default policy for outgoing traffic
     * @type {string}
     * @memberof CreateFirewallDto
     */
    'policy_out'?: CreateFirewallDtoPolicyOutEnum;
}

export const CreateFirewallDtoPolicyInEnum = {
    Accept: 'ACCEPT',
    Reject: 'REJECT',
    Drop: 'DROP'
} as const;

export type CreateFirewallDtoPolicyInEnum = typeof CreateFirewallDtoPolicyInEnum[keyof typeof CreateFirewallDtoPolicyInEnum];
export const CreateFirewallDtoPolicyOutEnum = {
    Accept: 'ACCEPT',
    Reject: 'REJECT',
    Drop: 'DROP'
} as const;

export type CreateFirewallDtoPolicyOutEnum = typeof CreateFirewallDtoPolicyOutEnum[keyof typeof CreateFirewallDtoPolicyOutEnum];

/**
 * 
 * @export
 * @interface CreateOrderDto
 */
export interface CreateOrderDto {
    /**
     * Single-use trial offer code. Exclusive with subscription, coupon and prepaid credit.
     * @type {string}
     * @memberof CreateOrderDto
     */
    'trial_code'?: string;
    /**
     * Initial prepaid credit in cents for a new ON_DEMAND subscription only. Defaults to recharge_minimums.on_demand_initial_cents from the catalog, which covers the platform recharge minimum and the default tier resource minimum. The full amount becomes available credit on payment; usage is billed hourly.
     * @type {string}
     * @memberof CreateOrderDto
     */
    'initial_credit_cents'?: string;
    /**
     * VM access password for templates that require it. Letters, digits and these symbols only: !\"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~ (no spaces or accents).
     * @type {string}
     * @memberof CreateOrderDto
     */
    'vm_password'?: string;
    /**
     * Display name for the resource (e.g. VPN gateway name)
     * @type {string}
     * @memberof CreateOrderDto
     */
    'name'?: string;
    /**
     * Recurring subscription coupon code for a new committed subscription
     * @type {string}
     * @memberof CreateOrderDto
     */
    'coupon_code'?: string;
    /**
     * Affiliate referral code from the recommendation-link cookie
     * @type {string}
     * @memberof CreateOrderDto
     */
    'affiliate_ref'?: string;
    /**
     * 
     * @type {object}
     * @memberof CreateOrderDto
     */
    'marketing_attribution'?: object;
}
/**
 * 
 * @export
 * @interface CreateRecordDto
 */
export interface CreateRecordDto {
    /**
     * Record name (hostname or @)
     * @type {string}
     * @memberof CreateRecordDto
     */
    'name'?: string;
    /**
     * DNS record type
     * @type {string}
     * @memberof CreateRecordDto
     */
    'type': CreateRecordDtoTypeEnum;
    /**
     * Record content/value
     * @type {string}
     * @memberof CreateRecordDto
     */
    'content': string;
    /**
     * Time to live in seconds
     * @type {number}
     * @memberof CreateRecordDto
     */
    'ttl'?: number;
    /**
     * Optional comment for this record
     * @type {string}
     * @memberof CreateRecordDto
     */
    'comment'?: string;
}

export const CreateRecordDtoTypeEnum = {
    A: 'A',
    Aaaa: 'AAAA',
    Cname: 'CNAME',
    Mx: 'MX',
    Txt: 'TXT',
    Ns: 'NS',
    Caa: 'CAA',
    Srv: 'SRV',
    Ptr: 'PTR'
} as const;

export type CreateRecordDtoTypeEnum = typeof CreateRecordDtoTypeEnum[keyof typeof CreateRecordDtoTypeEnum];

/**
 * 
 * @export
 * @interface CreateSecurityExceptionDto
 */
export interface CreateSecurityExceptionDto {
    /**
     * 
     * @type {SecurityExceptionScope}
     * @memberof CreateSecurityExceptionDto
     */
    'scope': SecurityExceptionScope;
    /**
     * Required when scope is \"finding\".
     * @type {string}
     * @memberof CreateSecurityExceptionDto
     */
    'finding_id'?: string;
    /**
     * Required when scope is \"rule\".
     * @type {string}
     * @memberof CreateSecurityExceptionDto
     */
    'rule_id'?: string;
    /**
     * Required when scope is \"port\".
     * @type {number}
     * @memberof CreateSecurityExceptionDto
     */
    'port'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateSecurityExceptionDto
     */
    'protocol'?: string;
    /**
     * Limits the exception to one instance. Omit for account-wide.
     * @type {number}
     * @memberof CreateSecurityExceptionDto
     */
    'vm_id'?: number;
    /**
     * Why this risk is being accepted. Recorded against the account and visible to the provider.
     * @type {string}
     * @memberof CreateSecurityExceptionDto
     */
    'justification': string;
    /**
     * When the exception lapses. Required — there is no permanent exception. Clamped down to the platform and per-rule ceilings.
     * @type {string}
     * @memberof CreateSecurityExceptionDto
     */
    'expires_at': string;
}


/**
 * 
 * @export
 * @interface CreateSnapshotDto
 */
export interface CreateSnapshotDto {
    /**
     * Name for the snapshot
     * @type {string}
     * @memberof CreateSnapshotDto
     */
    'snapshot_name': string;
    /**
     * Optional description for the snapshot
     * @type {string}
     * @memberof CreateSnapshotDto
     */
    'description'?: string;
    /**
     * Include RAM state in the snapshot. If true, the VM RAM will be saved, allowing restoration to the exact running state. If false (default), only disk state is saved, resulting in faster snapshots and less storage usage.
     * @type {boolean}
     * @memberof CreateSnapshotDto
     */
    'include_ram'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateSsoDto
 */
export interface CreateSsoDto {
    /**
     * Result of the SSO creation process
     * @type {string}
     * @memberof CreateSsoDto
     */
    'result': string;
    /**
     * Access token for SSO
     * @type {string}
     * @memberof CreateSsoDto
     */
    'access_token': string;
    /**
     * Redirect URL for SSO
     * @type {string}
     * @memberof CreateSsoDto
     */
    'redirect_url': string;
}
/**
 * 
 * @export
 * @interface CreateVpnGatewayDto
 */
export interface CreateVpnGatewayDto {
    /**
     * VM ID
     * @type {number}
     * @memberof CreateVpnGatewayDto
     */
    'vmId': number;
    /**
     * The address pool handed to people connecting with the VPN app, as an IPv4 network. Chosen for you when omitted: 10.8.0.0/24 unless the private network covers it, then the first free candidate.
     * @type {string}
     * @memberof CreateVpnGatewayDto
     */
    'remoteAccessPool'?: string;
    /**
     * VPN Network (deprecated: send remoteAccessPool)
     * @type {string}
     * @memberof CreateVpnGatewayDto
     * @deprecated
     */
    'vpnNetwork'?: string;
    /**
     * VPN Netmask (deprecated: send remoteAccessPool)
     * @type {string}
     * @memberof CreateVpnGatewayDto
     * @deprecated
     */
    'vpnNetmask'?: string;
    /**
     * Push Route Network
     * @type {string}
     * @memberof CreateVpnGatewayDto
     */
    'pushRouteNetwork'?: string;
    /**
     * Push Route Netmask
     * @type {string}
     * @memberof CreateVpnGatewayDto
     */
    'pushRouteNetmask'?: string;
    /**
     * VPN Protocol
     * @type {string}
     * @memberof CreateVpnGatewayDto
     */
    'vpnProtocol'?: CreateVpnGatewayDtoVpnProtocolEnum;
}

export const CreateVpnGatewayDtoVpnProtocolEnum = {
    Tcp: 'tcp',
    Udp: 'udp'
} as const;

export type CreateVpnGatewayDtoVpnProtocolEnum = typeof CreateVpnGatewayDtoVpnProtocolEnum[keyof typeof CreateVpnGatewayDtoVpnProtocolEnum];

/**
 * 
 * @export
 * @interface CreateZoneDto
 */
export interface CreateZoneDto {
    /**
     * Domain name for the new DNS zone
     * @type {string}
     * @memberof CreateZoneDto
     */
    'domain': string;
}
/**
 * 
 * @export
 * @interface DashboardAttentionDto
 */
export interface DashboardAttentionDto {
    /**
     * Stable key, so the console can remember a dismissal.
     * @type {string}
     * @memberof DashboardAttentionDto
     */
    'id': string;
    /**
     * What kind of problem this is. The console maps it to translated copy and to the right destination; the API never sends prose.
     * @type {string}
     * @memberof DashboardAttentionDto
     */
    'kind': string;
    /**
     * critical | warning | info
     * @type {string}
     * @memberof DashboardAttentionDto
     */
    'severity': string;
    /**
     * Ordering weight, higher first. Combines severity with how close the thing is to actually happening, so \"4 hours of credit left\" outranks a stale backup.
     * @type {number}
     * @memberof DashboardAttentionDto
     */
    'rank': number;
    /**
     * Interpolation values for the console copy (counts, names, hours).
     * @type {{ [key: string]: any; }}
     * @memberof DashboardAttentionDto
     */
    'params': { [key: string]: any; };
    /**
     * 
     * @type {DashboardAttentionResourceDto}
     * @memberof DashboardAttentionDto
     */
    'resource'?: DashboardAttentionResourceDto | null;
}
/**
 * 
 * @export
 * @interface DashboardAttentionResourceDto
 */
export interface DashboardAttentionResourceDto {
    /**
     * vm | subscription | account
     * @type {string}
     * @memberof DashboardAttentionResourceDto
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof DashboardAttentionResourceDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DashboardAttentionResourceDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface DashboardCancellationDto
 */
export interface DashboardCancellationDto {
    /**
     * 
     * @type {string}
     * @memberof DashboardCancellationDto
     */
    'subscription_id': string;
    /**
     * 
     * @type {string}
     * @memberof DashboardCancellationDto
     */
    'subscription_name'?: string | null;
    /**
     * When the subscription stops.
     * @type {string}
     * @memberof DashboardCancellationDto
     */
    'effective_at': string;
    /**
     * Instances that go away with it.
     * @type {number}
     * @memberof DashboardCancellationDto
     */
    'instance_count': number;
}
/**
 * 
 * @export
 * @interface DashboardCoverageDto
 */
export interface DashboardCoverageDto {
    /**
     * 
     * @type {number}
     * @memberof DashboardCoverageDto
     */
    'measured': number;
    /**
     * 
     * @type {number}
     * @memberof DashboardCoverageDto
     */
    'total': number;
    /**
     * True while missing or old readings are being measured BEHIND this response — guest disk is never measured while the page waits. The console re-reads the overview shortly after, and is also told over the websocket (`fleetVitalsUpdated`) when something it shows has changed. False once everything is remembered, including \"this guest has no agent to ask\", so an agentless fleet does not re-read forever.
     * @type {boolean}
     * @memberof DashboardCoverageDto
     */
    'refreshing': boolean;
    /**
     * Every guest-disk reading remembered BEFORE this instant is in this response. `fleetVitalsUpdated` carries `at`, the instant AFTER the readings it announces were remembered — so an overview whose `as_of` is not older than a push\'s `at` already holds that change, and the console need not read again. Null when the fleet section could not be built.
     * @type {string}
     * @memberof DashboardCoverageDto
     */
    'as_of'?: string | null;
}
/**
 * 
 * @export
 * @interface DashboardFleetDto
 */
export interface DashboardFleetDto {
    /**
     * When the hypervisors behind this fleet were last listed — the OLDEST listing among them, since a fleet is only as current as the host listed longest ago. Power state and vitals are read from a snapshot refreshed every 30 seconds, never from a hypervisor during the request. Null when no host vouched for anything (every instance then reads `unknown`).
     * @type {string}
     * @memberof DashboardFleetDto
     */
    'observed_at'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardFleetDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof DashboardFleetDto
     */
    'running': number;
    /**
     * 
     * @type {number}
     * @memberof DashboardFleetDto
     */
    'stopped': number;
    /**
     * 
     * @type {number}
     * @memberof DashboardFleetDto
     */
    'suspended': number;
    /**
     * 
     * @type {number}
     * @memberof DashboardFleetDto
     */
    'deploying': number;
    /**
     * Sum of provisioned vCPU across every instance.
     * @type {number}
     * @memberof DashboardFleetDto
     */
    'vcpu': number;
    /**
     * 
     * @type {number}
     * @memberof DashboardFleetDto
     */
    'ram_mb': number;
    /**
     * 
     * @type {number}
     * @memberof DashboardFleetDto
     */
    'storage_gb': number;
    /**
     * Weighted mean CPU load across running instances, 0–100. Null when nothing was measured.
     * @type {number}
     * @memberof DashboardFleetDto
     */
    'avg_cpu_pct': number;
    /**
     * Weighted mean memory use across running instances.
     * @type {number}
     * @memberof DashboardFleetDto
     */
    'avg_mem_pct': number;
    /**
     * How many running instances answered with a guest-disk reading, out of how many were asked. Sent so the console can say \"9 of 15 measured\" instead of implying it looked everywhere.
     * @type {DashboardCoverageDto}
     * @memberof DashboardFleetDto
     */
    'disk_coverage': DashboardCoverageDto;
    /**
     * 
     * @type {Array<DashboardInstanceDto>}
     * @memberof DashboardFleetDto
     */
    'instances': Array<DashboardInstanceDto>;
}
/**
 * 
 * @export
 * @interface DashboardInstanceDto
 */
export interface DashboardInstanceDto {
    /**
     * 
     * @type {number}
     * @memberof DashboardInstanceDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof DashboardInstanceDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DashboardInstanceDto
     */
    'hostname'?: string | null;
    /**
     * running | stopped | suspended | deploying | unknown. `unknown` means the hypervisor did not answer for this instance — never rendered as healthy.
     * @type {string}
     * @memberof DashboardInstanceDto
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof DashboardInstanceDto
     */
    'os_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardInstanceDto
     */
    'os_family'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardInstanceDto
     */
    'datacenter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardInstanceDto
     */
    'primary_ip'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardInstanceDto
     */
    'vcpu': number;
    /**
     * 
     * @type {number}
     * @memberof DashboardInstanceDto
     */
    'ram_mb': number;
    /**
     * 
     * @type {number}
     * @memberof DashboardInstanceDto
     */
    'storage_gb': number;
    /**
     * Live CPU load 0–100, or null when there is no reading.
     * @type {number}
     * @memberof DashboardInstanceDto
     */
    'cpu_pct'?: number | null;
    /**
     * Live memory use 0–100.
     * @type {number}
     * @memberof DashboardInstanceDto
     */
    'mem_pct'?: number | null;
    /**
     * Busiest guest volume, 0–100. Null when the guest agent has not answered yet — the sweep is bounded, so a large fleet fills in over a few loads.
     * @type {number}
     * @memberof DashboardInstanceDto
     */
    'disk_pct'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardInstanceDto
     */
    'disk_mountpoint'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardInstanceDto
     */
    'uptime_seconds'?: number | null;
    /**
     * Worst of the three vitals as a 0–100 pressure figure, used to order and colour the fleet grid. Null when nothing was measured.
     * @type {number}
     * @memberof DashboardInstanceDto
     */
    'pressure_pct': number;
}
/**
 * 
 * @export
 * @interface DashboardMoneyDto
 */
export interface DashboardMoneyDto {
    /**
     * ISO 4217, from the platform. Always BRL today.
     * @type {string}
     * @memberof DashboardMoneyDto
     */
    'currency': string;
    /**
     * COMMITTED | ON_DEMAND | MIXED. Decides which story the console leads with: a committed account cares about its renewal, an on-demand one about how long its credit lasts. Leading with the wrong one puts a number on screen that is true and useless.
     * @type {string}
     * @memberof DashboardMoneyDto
     */
    'commitment_model': string;
    /**
     * Usable balance summed across every subscription.
     * @type {string}
     * @memberof DashboardMoneyDto
     */
    'usable_micro_cents': string;
    /**
     * Prepaid committed balance summed across subscriptions.
     * @type {string}
     * @memberof DashboardMoneyDto
     */
    'committed_micro_cents': string;
    /**
     * Observed burn per hour (flexible compute + billable bandwidth), summed. This is measured from posted usage, not quoted from the price list.
     * @type {string}
     * @memberof DashboardMoneyDto
     */
    'burn_hourly_micro_cents': string;
    /**
     * Everything metered since each subscription cycle opened.
     * @type {string}
     * @memberof DashboardMoneyDto
     */
    'cycle_to_date_micro_cents': string;
    /**
     * Sum of projected usable balance at close. Negative means the account ends the cycle owing money.
     * @type {string}
     * @memberof DashboardMoneyDto
     */
    'projected_at_close_micro_cents'?: string | null;
    /**
     * Shortest runway across subscriptions — the one that runs out first.
     * @type {number}
     * @memberof DashboardMoneyDto
     */
    'runway_hours'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardMoneyDto
     */
    'runway_subscription_id'?: string | null;
    /**
     * Earliest upcoming cycle close across subscriptions.
     * @type {string}
     * @memberof DashboardMoneyDto
     */
    'next_cycle_ends_at'?: string | null;
    /**
     * Any subscription projected to breach its tier threshold.
     * @type {boolean}
     * @memberof DashboardMoneyDto
     */
    'at_risk': boolean;
    /**
     * Hourly rate attributable to instances that are powered off. Proxmox does not stop the meter on a stopped instance — the customer is paying to keep it reserved, which is a legitimate choice but rarely a deliberate one.
     * @type {string}
     * @memberof DashboardMoneyDto
     */
    'idle_hourly_micro_cents': string;
    /**
     * 
     * @type {number}
     * @memberof DashboardMoneyDto
     */
    'idle_instance_count': number;
    /**
     * 
     * @type {number}
     * @memberof DashboardMoneyDto
     */
    'unpaid_invoice_count': number;
    /**
     * 
     * @type {number}
     * @memberof DashboardMoneyDto
     */
    'overdue_invoice_count': number;
    /**
     * Total of unpaid provider invoices, in cents.
     * @type {string}
     * @memberof DashboardMoneyDto
     */
    'unpaid_total_cents': string;
    /**
     * 
     * @type {DashboardRenewalDto}
     * @memberof DashboardMoneyDto
     */
    'renewal': DashboardRenewalDto;
    /**
     * Subscriptions the customer has scheduled to end. Invisible everywhere else on the home screen, and the instances on them stop on that date.
     * @type {Array<DashboardCancellationDto>}
     * @memberof DashboardMoneyDto
     */
    'cancellations': Array<DashboardCancellationDto>;
    /**
     * Bandwidth overage accrued but not yet on the balance. Draws on the flexible pool, so on a fully-prepaid account it is the one thing that can quietly push the balance negative.
     * @type {string}
     * @memberof DashboardMoneyDto
     */
    'bandwidth_pending_micro_cents': string;
    /**
     * 
     * @type {Array<DashboardSubscriptionDto>}
     * @memberof DashboardMoneyDto
     */
    'subscriptions': Array<DashboardSubscriptionDto>;
}
/**
 * 
 * @export
 * @interface DashboardOverviewDto
 */
export interface DashboardOverviewDto {
    /**
     * When this snapshot was assembled (UTC).
     * @type {string}
     * @memberof DashboardOverviewDto
     */
    'generated_at': string;
    /**
     * 
     * @type {DashboardFleetDto}
     * @memberof DashboardOverviewDto
     */
    'fleet': DashboardFleetDto;
    /**
     * Null when the client has no cloud account yet (pre-first-order).
     * @type {DashboardMoneyDto}
     * @memberof DashboardOverviewDto
     */
    'money'?: DashboardMoneyDto | null;
    /**
     * 
     * @type {DashboardProtectionDto}
     * @memberof DashboardOverviewDto
     */
    'protection': DashboardProtectionDto;
    /**
     * Null when scanning is off platform-wide or the read failed.
     * @type {DashboardSecurityDto}
     * @memberof DashboardOverviewDto
     */
    'security'?: DashboardSecurityDto | null;
    /**
     * Ranked, worst first. Empty means genuinely nothing to do.
     * @type {Array<DashboardAttentionDto>}
     * @memberof DashboardOverviewDto
     */
    'attention': Array<DashboardAttentionDto>;
    /**
     * Sections whose upstream read failed, by name (`fleet`, `money`, `protection`, `security`). A dashboard that silently renders a partial picture as a complete one is worse than one that admits the gap.
     * @type {Array<string>}
     * @memberof DashboardOverviewDto
     */
    'degraded': Array<string>;
}
/**
 * 
 * @export
 * @interface DashboardProtectionDto
 */
export interface DashboardProtectionDto {
    /**
     * Instances whose subscription carries at least one backup slot.
     * @type {number}
     * @memberof DashboardProtectionDto
     */
    'eligible': number;
    /**
     * Eligible instances with an active backup schedule.
     * @type {number}
     * @memberof DashboardProtectionDto
     */
    'scheduled': number;
    /**
     * Instances with no backup slot on their subscription.
     * @type {number}
     * @memberof DashboardProtectionDto
     */
    'without_slots': number;
    /**
     * Paying for slots, never scheduled a backup. The most expensive kind of gap: the customer already bought the protection and does not have it.
     * @type {Array<DashboardProtectionInstanceDto>}
     * @memberof DashboardProtectionDto
     */
    'paid_but_unscheduled': Array<DashboardProtectionInstanceDto>;
    /**
     * Scheduled, but the newest backup is older than the staleness window.
     * @type {Array<DashboardProtectionInstanceDto>}
     * @memberof DashboardProtectionDto
     */
    'stale': Array<DashboardProtectionInstanceDto>;
    /**
     * Days after which a backup counts as stale.
     * @type {number}
     * @memberof DashboardProtectionDto
     */
    'stale_after_days': number;
    /**
     * 
     * @type {string}
     * @memberof DashboardProtectionDto
     */
    'last_backup_at'?: string | null;
}
/**
 * 
 * @export
 * @interface DashboardProtectionInstanceDto
 */
export interface DashboardProtectionInstanceDto {
    /**
     * 
     * @type {number}
     * @memberof DashboardProtectionInstanceDto
     */
    'vm_id': number;
    /**
     * 
     * @type {string}
     * @memberof DashboardProtectionInstanceDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DashboardProtectionInstanceDto
     */
    'last_backup_at'?: string | null;
}
/**
 * 
 * @export
 * @interface DashboardRenewalDto
 */
export interface DashboardRenewalDto {
    /**
     * Earliest upcoming renewal date across subscriptions.
     * @type {string}
     * @memberof DashboardRenewalDto
     */
    'next_at'?: string | null;
    /**
     * Start of the cycle that ends at `next_at`. Sent so the console can show how far through the term the customer is, rather than only how many days are left — the same number with and without its denominator.
     * @type {string}
     * @memberof DashboardRenewalDto
     */
    'next_cycle_starts_at'?: string | null;
    /**
     * What the next close will bill, summed: Σ committed rates × term cap hours, less recurring coupons. Mirrors cycle-close exactly.
     * @type {string}
     * @memberof DashboardRenewalDto
     */
    'amount_micro_cents': string;
    /**
     * Balance that auto-nets against the renewal when the invoice is issued.
     * @type {string}
     * @memberof DashboardRenewalDto
     */
    'covered_micro_cents': string;
    /**
     * What the customer should expect to be invoiced: renewal + expected traffic − balance, floored at zero.
     * @type {string}
     * @memberof DashboardRenewalDto
     */
    'uncovered_micro_cents': string;
    /**
     * Traffic expected to settle at close. Settled from AVAILABLE before the renewal nets against it, so it eats into coverage.
     * @type {string}
     * @memberof DashboardRenewalDto
     */
    'bandwidth_expected_micro_cents': string;
    /**
     * Subscription whose renewal lands first — the one on the card.
     * @type {string}
     * @memberof DashboardRenewalDto
     */
    'next_subscription_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardRenewalDto
     */
    'next_subscription_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardRenewalDto
     */
    'term_kind'?: string | null;
    /**
     * Renewal invoices already issued and unpaid. When present, prepaying is pointless — paying this is the action, and not paying it ends in suspension.
     * @type {DashboardRenewalInvoiceDto}
     * @memberof DashboardRenewalDto
     */
    'open_invoice'?: DashboardRenewalInvoiceDto | null;
}
/**
 * 
 * @export
 * @interface DashboardRenewalInvoiceDto
 */
export interface DashboardRenewalInvoiceDto {
    /**
     * 
     * @type {number}
     * @memberof DashboardRenewalInvoiceDto
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof DashboardRenewalInvoiceDto
     */
    'total_cents': string;
    /**
     * Earliest due date across open renewal invoices.
     * @type {string}
     * @memberof DashboardRenewalInvoiceDto
     */
    'due_at': string;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardRenewalInvoiceDto
     */
    'overdue': boolean;
}
/**
 * 
 * @export
 * @interface DashboardSecurityDto
 */
export interface DashboardSecurityDto {
    /**
     * 
     * @type {number}
     * @memberof DashboardSecurityDto
     */
    'score'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardSecurityDto
     */
    'grade'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardSecurityDto
     */
    'critical': number;
    /**
     * 
     * @type {number}
     * @memberof DashboardSecurityDto
     */
    'high': number;
    /**
     * 
     * @type {number}
     * @memberof DashboardSecurityDto
     */
    'medium': number;
    /**
     * 
     * @type {number}
     * @memberof DashboardSecurityDto
     */
    'instances_total': number;
    /**
     * 
     * @type {number}
     * @memberof DashboardSecurityDto
     */
    'instances_awaiting_first_scan': number;
    /**
     * 
     * @type {string}
     * @memberof DashboardSecurityDto
     */
    'last_scan_at'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardSecurityDto
     */
    'scanning_enabled': boolean;
    /**
     * Highest-risk open rule, collapsed across instances — one fix that resolves every instance it counts.
     * @type {DashboardSecurityRuleDto}
     * @memberof DashboardSecurityDto
     */
    'top_rule'?: DashboardSecurityRuleDto | null;
}
/**
 * 
 * @export
 * @interface DashboardSecurityRuleDto
 */
export interface DashboardSecurityRuleDto {
    /**
     * 
     * @type {string}
     * @memberof DashboardSecurityRuleDto
     */
    'rule_id': string;
    /**
     * 
     * @type {string}
     * @memberof DashboardSecurityRuleDto
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof DashboardSecurityRuleDto
     */
    'severity': string;
    /**
     * 
     * @type {number}
     * @memberof DashboardSecurityRuleDto
     */
    'instances': number;
}
/**
 * 
 * @export
 * @interface DashboardSubscriptionDto
 */
export interface DashboardSubscriptionDto {
    /**
     * 
     * @type {string}
     * @memberof DashboardSubscriptionDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DashboardSubscriptionDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardSubscriptionDto
     */
    'status': string;
    /**
     * MONTHLY | QUARTERLY | … | ON_DEMAND
     * @type {string}
     * @memberof DashboardSubscriptionDto
     */
    'term_kind': string;
    /**
     * 
     * @type {string}
     * @memberof DashboardSubscriptionDto
     */
    'usable_micro_cents': string;
    /**
     * 
     * @type {string}
     * @memberof DashboardSubscriptionDto
     */
    'committed_micro_cents': string;
    /**
     * 
     * @type {string}
     * @memberof DashboardSubscriptionDto
     */
    'recurring_monthly_micro_cents': string;
    /**
     * 
     * @type {string}
     * @memberof DashboardSubscriptionDto
     */
    'current_cycle_ends_at'?: string | null;
    /**
     * Hours of usable balance left at the observed burn rate. Null when nothing is burning (a fully-prepaid committed subscription with no flexible usage).
     * @type {number}
     * @memberof DashboardSubscriptionDto
     */
    'runway_hours'?: number | null;
    /**
     * The projection says this subscription closes the cycle past its negative-credit threshold — i.e. it is heading for suspension, not just a low balance.
     * @type {boolean}
     * @memberof DashboardSubscriptionDto
     */
    'will_breach_tier': boolean;
    /**
     * 
     * @type {number}
     * @memberof DashboardSubscriptionDto
     */
    'instance_count': number;
}
/**
 * 
 * @export
 * @interface DatacenterEntity
 */
export interface DatacenterEntity {
    /**
     * 
     * @type {number}
     * @memberof DatacenterEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof DatacenterEntity
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DatacenterEntity
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof DatacenterEntity
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof DatacenterEntity
     */
    'image': string;
    /**
     * 
     * @type {boolean}
     * @memberof DatacenterEntity
     */
    'hidden': boolean;
    /**
     * 
     * @type {string}
     * @memberof DatacenterEntity
     */
    'region_name': string;
    /**
     * 
     * @type {Array<ClusterEntity>}
     * @memberof DatacenterEntity
     */
    'clusters': Array<ClusterEntity>;
    /**
     * Whether at least one hypervisor here can receive a new instance right now. False means an order placed against this datacenter cannot be provisioned — every host is out of service, paused for deployments, saturated or unwired. Present the datacenter as unavailable rather than letting the order through.
     * @type {boolean}
     * @memberof DatacenterEntity
     */
    'deployable': boolean;
}
/**
 * 
 * @export
 * @interface DatacenterInfoDto
 */
export interface DatacenterInfoDto {
    /**
     * Datacenter Name
     * @type {string}
     * @memberof DatacenterInfoDto
     */
    'name': string;
    /**
     * Region Name
     * @type {string}
     * @memberof DatacenterInfoDto
     */
    'region_name'?: string | null;
}
/**
 * 
 * @export
 * @interface DeleteBackup200Response
 */
export interface DeleteBackup200Response {
    /**
     * 
     * @type {string}
     * @memberof DeleteBackup200Response
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface DeleteFirewall201Response
 */
export interface DeleteFirewall201Response {
    /**
     * Job ID for tracking the delete progress
     * @type {string}
     * @memberof DeleteFirewall201Response
     */
    'job_id'?: string;
}
/**
 * 
 * @export
 * @interface DeleteRecordDto
 */
export interface DeleteRecordDto {
    /**
     * Record name (hostname or @)
     * @type {string}
     * @memberof DeleteRecordDto
     */
    'name'?: string;
    /**
     * DNS record type
     * @type {string}
     * @memberof DeleteRecordDto
     */
    'type': DeleteRecordDtoTypeEnum;
    /**
     * For TXT records: the specific entry to remove. Omit to delete the entire RRset.
     * @type {string}
     * @memberof DeleteRecordDto
     */
    'content'?: string;
}

export const DeleteRecordDtoTypeEnum = {
    A: 'A',
    Aaaa: 'AAAA',
    Cname: 'CNAME',
    Mx: 'MX',
    Txt: 'TXT',
    Ns: 'NS',
    Caa: 'CAA',
    Srv: 'SRV',
    Ptr: 'PTR'
} as const;

export type DeleteRecordDtoTypeEnum = typeof DeleteRecordDtoTypeEnum[keyof typeof DeleteRecordDtoTypeEnum];

/**
 * 
 * @export
 * @interface DeployVmDto
 */
export interface DeployVmDto {
    /**
     * Password for the VM. Letters, digits and these symbols only: !\"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~ (no spaces or accents).
     * @type {string}
     * @memberof DeployVmDto
     */
    'password'?: string;
}
/**
 * 
 * @export
 * @interface DeploymentPhaseDto
 */
export interface DeploymentPhaseDto {
    /**
     * Phase identifier
     * @type {string}
     * @memberof DeploymentPhaseDto
     */
    'phase': DeploymentPhaseDtoPhaseEnum;
    /**
     * Progress of this phase
     * @type {string}
     * @memberof DeploymentPhaseDto
     */
    'status': DeploymentPhaseDtoStatusEnum;
    /**
     * Completion of this phase, 0 to 1
     * @type {number}
     * @memberof DeploymentPhaseDto
     */
    'fraction': number;
    /**
     * Share of the overall progress bar, 0 to 1
     * @type {number}
     * @memberof DeploymentPhaseDto
     */
    'weight': number;
    /**
     * Extra detail for the active phase, e.g. image copy throughput
     * @type {string}
     * @memberof DeploymentPhaseDto
     */
    'detail'?: string;
}

export const DeploymentPhaseDtoPhaseEnum = {
    Prepare: 'prepare',
    Clone: 'clone',
    Configure: 'configure',
    CloudInit: 'cloud_init',
    Boot: 'boot',
    GuestSetup: 'guest_setup',
    PostInstall: 'post_install',
    Finalize: 'finalize'
} as const;

export type DeploymentPhaseDtoPhaseEnum = typeof DeploymentPhaseDtoPhaseEnum[keyof typeof DeploymentPhaseDtoPhaseEnum];
export const DeploymentPhaseDtoStatusEnum = {
    Pending: 'pending',
    Active: 'active',
    Done: 'done',
    Failed: 'failed',
    Skipped: 'skipped'
} as const;

export type DeploymentPhaseDtoStatusEnum = typeof DeploymentPhaseDtoStatusEnum[keyof typeof DeploymentPhaseDtoStatusEnum];

/**
 * 
 * @export
 * @interface DiscoveryCatalogDto
 */
export interface DiscoveryCatalogDto {
    /**
     * 
     * @type {Array<DiscoveryCatalogItemDto>}
     * @memberof DiscoveryCatalogDto
     */
    'items': Array<DiscoveryCatalogItemDto>;
}
/**
 * 
 * @export
 * @interface DiscoveryCatalogItemDto
 */
export interface DiscoveryCatalogItemDto {
    /**
     * Immutable tip code. The console owns the prose (`discovery.tips.<code>`) and the scene.
     * @type {string}
     * @memberof DiscoveryCatalogItemDto
     */
    'code': string;
    /**
     * A launch inside its announcement window.
     * @type {boolean}
     * @memberof DiscoveryCatalogItemDto
     */
    'is_new': boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscoveryCatalogItemDto
     */
    'announced_at'?: string | null;
    /**
     * Console route the call to action opens. Null when the console performs the action itself.
     * @type {string}
     * @memberof DiscoveryCatalogItemDto
     */
    'cta_route'?: string | null;
    /**
     * The account already uses this feature.
     * @type {boolean}
     * @memberof DiscoveryCatalogItemDto
     */
    'adopted': boolean;
    /**
     * Where this person stands with the tip; null when never shown.
     * @type {string}
     * @memberof DiscoveryCatalogItemDto
     */
    'state'?: DiscoveryCatalogItemDtoStateEnum | null;
}

export const DiscoveryCatalogItemDtoStateEnum = {
    Shown: 'shown',
    Snoozed: 'snoozed',
    Dismissed: 'dismissed',
    Acted: 'acted'
} as const;

export type DiscoveryCatalogItemDtoStateEnum = typeof DiscoveryCatalogItemDtoStateEnum[keyof typeof DiscoveryCatalogItemDtoStateEnum];

/**
 * 
 * @export
 * @interface DiscoveryDeckDto
 */
export interface DiscoveryDeckDto {
    /**
     * 
     * @type {Array<DiscoveryTipDto>}
     * @memberof DiscoveryDeckDto
     */
    'items': Array<DiscoveryTipDto>;
}
/**
 * 
 * @export
 * @interface DiscoveryEventDto
 */
export interface DiscoveryEventDto {
    /**
     * 
     * @type {string}
     * @memberof DiscoveryEventDto
     */
    'event': DiscoveryEventDtoEventEnum;
}

export const DiscoveryEventDtoEventEnum = {
    Shown: 'shown',
    Snoozed: 'snoozed',
    Dismissed: 'dismissed',
    Acted: 'acted'
} as const;

export type DiscoveryEventDtoEventEnum = typeof DiscoveryEventDtoEventEnum[keyof typeof DiscoveryEventDtoEventEnum];

/**
 * 
 * @export
 * @interface DiscoveryEventResultDto
 */
export interface DiscoveryEventResultDto {
    /**
     * False when nothing was recorded — a support session acting on the account never consumes the customer\'s tips.
     * @type {boolean}
     * @memberof DiscoveryEventResultDto
     */
    'recorded': boolean;
}
/**
 * 
 * @export
 * @interface DiscoveryTipDto
 */
export interface DiscoveryTipDto {
    /**
     * Immutable tip code. The console owns the prose (`discovery.tips.<code>`) and the scene.
     * @type {string}
     * @memberof DiscoveryTipDto
     */
    'code': string;
    /**
     * A launch inside its announcement window.
     * @type {boolean}
     * @memberof DiscoveryTipDto
     */
    'is_new': boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscoveryTipDto
     */
    'announced_at'?: string | null;
    /**
     * Console route the call to action opens. Null when the console performs the action itself.
     * @type {string}
     * @memberof DiscoveryTipDto
     */
    'cta_route'?: string | null;
}
/**
 * 
 * @export
 * @interface DnsCommentDto
 */
export interface DnsCommentDto {
    /**
     * 
     * @type {string}
     * @memberof DnsCommentDto
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof DnsCommentDto
     */
    'account': string;
    /**
     * 
     * @type {number}
     * @memberof DnsCommentDto
     */
    'modified_at': number;
}
/**
 * 
 * @export
 * @interface DnsHealthResponseDto
 */
export interface DnsHealthResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof DnsHealthResponseDto
     */
    'ok': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof DnsHealthResponseDto
     */
    'nsRecords': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DnsHealthResponseDto
     */
    'expectedNameservers': Array<string>;
}
/**
 * 
 * @export
 * @interface DnsRRsetDto
 */
export interface DnsRRsetDto {
    /**
     * 
     * @type {string}
     * @memberof DnsRRsetDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DnsRRsetDto
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof DnsRRsetDto
     */
    'ttl': number;
    /**
     * 
     * @type {Array<DnsRecordEntryDto>}
     * @memberof DnsRRsetDto
     */
    'records': Array<DnsRecordEntryDto>;
    /**
     * 
     * @type {Array<DnsCommentDto>}
     * @memberof DnsRRsetDto
     */
    'comments'?: Array<DnsCommentDto>;
}
/**
 * 
 * @export
 * @interface DnsRecordEntryDto
 */
export interface DnsRecordEntryDto {
    /**
     * 
     * @type {string}
     * @memberof DnsRecordEntryDto
     */
    'content': string;
    /**
     * 
     * @type {boolean}
     * @memberof DnsRecordEntryDto
     */
    'disabled': boolean;
}
/**
 * 
 * @export
 * @interface DnsZoneDto
 */
export interface DnsZoneDto {
    /**
     * 
     * @type {string}
     * @memberof DnsZoneDto
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof DnsZoneDto
     */
    'user_id': number;
    /**
     * 
     * @type {string}
     * @memberof DnsZoneDto
     */
    'domain': string;
    /**
     * 
     * @type {string}
     * @memberof DnsZoneDto
     */
    'created_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof DnsZoneDto
     */
    'updated_at': string | null;
}
/**
 * 
 * @export
 * @interface DownloadCodeConnectionProfileDto
 */
export interface DownloadCodeConnectionProfileDto {
    /**
     * OpenVPN connection profile content (.ovpn file)
     * @type {string}
     * @memberof DownloadCodeConnectionProfileDto
     */
    'profile': string;
    /**
     * VPN Gateway ID
     * @type {string}
     * @memberof DownloadCodeConnectionProfileDto
     */
    'vpn_gateway_id': string;
    /**
     * VM ID
     * @type {number}
     * @memberof DownloadCodeConnectionProfileDto
     */
    'vm_id': number;
    /**
     * Public IP address of the VPN server
     * @type {string}
     * @memberof DownloadCodeConnectionProfileDto
     */
    'public_ip'?: string;
    /**
     * Download code used to access this profile
     * @type {string}
     * @memberof DownloadCodeConnectionProfileDto
     */
    'download_code': string;
    /**
     * Download code expiration date
     * @type {string}
     * @memberof DownloadCodeConnectionProfileDto
     */
    'download_code_expiry': string;
}
/**
 * 
 * @export
 * @interface DownloadCodeDto
 */
export interface DownloadCodeDto {
    /**
     * Download code for accessing VPN connection profile
     * @type {string}
     * @memberof DownloadCodeDto
     */
    'download_code': string;
    /**
     * Download code expiration date
     * @type {string}
     * @memberof DownloadCodeDto
     */
    'download_code_expiry': string;
    /**
     * VPN Gateway ID
     * @type {string}
     * @memberof DownloadCodeDto
     */
    'vpn_gateway_id': string;
}
/**
 * 
 * @export
 * @interface EndedResourceDto
 */
export interface EndedResourceDto {
    /**
     * 
     * @type {string}
     * @memberof EndedResourceDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EndedResourceDto
     */
    'resource_type': EndedResourceDtoResourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof EndedResourceDto
     */
    'label'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EndedResourceDto
     */
    'resource_external_id'?: string | null;
    /**
     * The instance it billed, terminated or not; null when it is not one
     * @type {number}
     * @memberof EndedResourceDto
     */
    'vm_id'?: number | null;
    /**
     * When the instance was terminated. Null while it still exists — and for an instance this account no longer owns, which is neither named nor stated here.
     * @type {string}
     * @memberof EndedResourceDto
     */
    'instance_terminated_at'?: string | null;
    /**
     * The order was released before an instance existed — nothing ran and nothing was billed
     * @type {boolean}
     * @memberof EndedResourceDto
     */
    'never_provisioned': boolean;
    /**
     * 
     * @type {string}
     * @memberof EndedResourceDto
     */
    'commitment_pool': EndedResourceDtoCommitmentPoolEnum;
    /**
     * 
     * @type {number}
     * @memberof EndedResourceDto
     */
    'quantity': number;
    /**
     * 
     * @type {string}
     * @memberof EndedResourceDto
     */
    'rate_micro_cents_per_hour': string;
    /**
     * 
     * @type {string}
     * @memberof EndedResourceDto
     */
    'started_at': string;
    /**
     * 
     * @type {string}
     * @memberof EndedResourceDto
     */
    'ended_at': string;
    /**
     * Everything the meter billed it, over its whole life here
     * @type {string}
     * @memberof EndedResourceDto
     */
    'billed_total_micro_cents': string;
    /**
     * 
     * @type {number}
     * @memberof EndedResourceDto
     */
    'billed_seconds': number;
    /**
     * Unused commitment its removal returned as temporary credit, as the ledger recorded it; null when it returned none
     * @type {string}
     * @memberof EndedResourceDto
     */
    'removal_credit_micro_cents'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EndedResourceDto
     */
    'removal_credit_expires_at'?: string | null;
}

export const EndedResourceDtoResourceTypeEnum = {
    Vm: 'VM',
    DiskMain: 'DISK_MAIN',
    DiskExtra: 'DISK_EXTRA',
    ExtraIpv4: 'EXTRA_IPV4',
    ExtraIpv6: 'EXTRA_IPV6',
    WindowsLicense: 'WINDOWS_LICENSE',
    Cal: 'CAL',
    SnapshotSlot: 'SNAPSHOT_SLOT',
    BackupSlot: 'BACKUP_SLOT',
    VpnGateway: 'VPN_GATEWAY'
} as const;

export type EndedResourceDtoResourceTypeEnum = typeof EndedResourceDtoResourceTypeEnum[keyof typeof EndedResourceDtoResourceTypeEnum];
export const EndedResourceDtoCommitmentPoolEnum = {
    Committed: 'COMMITTED',
    Flexible: 'FLEXIBLE'
} as const;

export type EndedResourceDtoCommitmentPoolEnum = typeof EndedResourceDtoCommitmentPoolEnum[keyof typeof EndedResourceDtoCommitmentPoolEnum];

/**
 * 
 * @export
 * @interface EndedResourcesDto
 */
export interface EndedResourcesDto {
    /**
     * More ended services exist than are listed
     * @type {boolean}
     * @memberof EndedResourcesDto
     */
    'truncated': boolean;
    /**
     * 
     * @type {Array<EndedResourceDto>}
     * @memberof EndedResourcesDto
     */
    'items': Array<EndedResourceDto>;
}
/**
 * 
 * @export
 * @interface ExchangeSsoDto
 */
export interface ExchangeSsoDto {
    /**
     * The single-use SSO code issued via the admin endpoint.
     * @type {string}
     * @memberof ExchangeSsoDto
     */
    'code': string;
    /**
     * Client-provided device identifier. Used to scope the refresh token to a device.
     * @type {string}
     * @memberof ExchangeSsoDto
     */
    'deviceId': string;
    /**
     * Whether the generated refresh token should use the long-lived duration.
     * @type {boolean}
     * @memberof ExchangeSsoDto
     */
    'rememberMe'?: boolean;
}
/**
 * 
 * @export
 * @interface ExecuteBackup200Response
 */
export interface ExecuteBackup200Response {
    /**
     * 
     * @type {string}
     * @memberof ExecuteBackup200Response
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecuteBackup200Response
     */
    'vmId'?: number;
}
/**
 * 
 * @export
 * @interface FirewallEntity
 */
export interface FirewallEntity {
    /**
     * Firewall unique identifier
     * @type {string}
     * @memberof FirewallEntity
     */
    'id': string;
    /**
     * Firewall name
     * @type {string}
     * @memberof FirewallEntity
     */
    'name': string;
    /**
     * Firewall description
     * @type {string}
     * @memberof FirewallEntity
     */
    'description'?: string;
    /**
     * User ID who owns this firewall
     * @type {number}
     * @memberof FirewallEntity
     */
    'user_id': number;
    /**
     * Whether the firewall is enabled
     * @type {boolean}
     * @memberof FirewallEntity
     */
    'enable': boolean;
    /**
     * Indicates whether there are unapplied rule changes that require a commit.
     * @type {boolean}
     * @memberof FirewallEntity
     */
    'has_pending_changes': boolean;
    /**
     * Default policy for incoming traffic
     * @type {string}
     * @memberof FirewallEntity
     */
    'policy_in': string;
    /**
     * Default policy for outgoing traffic
     * @type {string}
     * @memberof FirewallEntity
     */
    'policy_out': string;
    /**
     * When the firewall was created
     * @type {string}
     * @memberof FirewallEntity
     */
    'created_at': string;
    /**
     * When the firewall was last updated
     * @type {string}
     * @memberof FirewallEntity
     */
    'updated_at': string;
    /**
     * Firewall rules
     * @type {Array<FirewallRuleEntity>}
     * @memberof FirewallEntity
     */
    'firewall_rules'?: Array<FirewallRuleEntity>;
    /**
     * Number of VMs using this firewall
     * @type {number}
     * @memberof FirewallEntity
     */
    'vm_count'?: number;
    /**
     * IDs of VMs assigned to this firewall
     * @type {Array<number>}
     * @memberof FirewallEntity
     */
    'vm_ids'?: Array<number>;
    /**
     * Number of rules in this firewall
     * @type {number}
     * @memberof FirewallEntity
     */
    'rule_count'?: number;
}
/**
 * 
 * @export
 * @interface FirewallMacroResponseDto
 */
export interface FirewallMacroResponseDto {
    /**
     * The firewall macro name
     * @type {string}
     * @memberof FirewallMacroResponseDto
     */
    'macro': FirewallMacroResponseDtoMacroEnum;
    /**
     * Description of what the macro allows
     * @type {string}
     * @memberof FirewallMacroResponseDto
     */
    'description': string;
}

export const FirewallMacroResponseDtoMacroEnum = {
    Amanda: 'Amanda',
    Auth: 'Auth',
    Bgp: 'BGP',
    BitTorrent: 'BitTorrent',
    BitTorrent32: 'BitTorrent32',
    Cvs: 'CVS',
    Ceph: 'Ceph',
    Citrix: 'Citrix',
    Daap: 'DAAP',
    Dcc: 'DCC',
    DhcPfwd: 'DHCPfwd',
    Dhcpv6: 'DHCPv6',
    Dns: 'DNS',
    Distcc: 'Distcc',
    Ftp: 'FTP',
    Finger: 'Finger',
    GnUnet: 'GNUnet',
    Gre: 'GRE',
    Git: 'Git',
    Hkp: 'HKP',
    Http: 'HTTP',
    Https: 'HTTPS',
    Icpv2: 'ICPV2',
    Icq: 'ICQ',
    Imap: 'IMAP',
    Imaps: 'IMAPS',
    Ipip: 'IPIP',
    IPsec: 'IPsec',
    IPsecah: 'IPsecah',
    IPsecnat: 'IPsecnat',
    Irc: 'IRC',
    Jetdirect: 'Jetdirect',
    L2Tp: 'L2TP',
    Ldap: 'LDAP',
    Ldaps: 'LDAPS',
    Mdns: 'MDNS',
    Msnp: 'MSNP',
    Mssql: 'MSSQL',
    Mail: 'Mail',
    Munin: 'Munin',
    MySql: 'MySQL',
    Nntp: 'NNTP',
    Nntps: 'NNTPS',
    Ntp: 'NTP',
    NeighborDiscovery: 'NeighborDiscovery',
    Ospf: 'OSPF',
    OpenVpn: 'OpenVPN',
    Pca: 'PCA',
    Pmg: 'PMG',
    Pop3: 'POP3',
    Pop3S: 'POP3S',
    PptP: 'PPtP',
    Ping: 'Ping',
    PostgreSql: 'PostgreSQL',
    Printer: 'Printer',
    Rdp: 'RDP',
    Rip: 'RIP',
    Rndc: 'RNDC',
    Razor: 'Razor',
    Rdate: 'Rdate',
    Rsync: 'Rsync',
    Sane: 'SANE',
    Smb: 'SMB',
    SmBswat: 'SMBswat',
    Smtp: 'SMTP',
    Smtps: 'SMTPS',
    Snmp: 'SNMP',
    Spamd: 'SPAMD',
    SpicEproxy: 'SPICEproxy',
    Ssh: 'SSH',
    Svn: 'SVN',
    SixXs: 'SixXS',
    Squid: 'Squid',
    Submission: 'Submission',
    Syslog: 'Syslog',
    Tftp: 'TFTP',
    Telnet: 'Telnet',
    Telnets: 'Telnets',
    Time: 'Time',
    Trcrt: 'Trcrt',
    Vnc: 'VNC',
    Vncl: 'VNCL',
    Web: 'Web',
    Webcache: 'Webcache',
    Webmin: 'Webmin',
    Whois: 'Whois'
} as const;

export type FirewallMacroResponseDtoMacroEnum = typeof FirewallMacroResponseDtoMacroEnum[keyof typeof FirewallMacroResponseDtoMacroEnum];

/**
 * 
 * @export
 * @interface FirewallRuleEntity
 */
export interface FirewallRuleEntity {
    /**
     * Rule unique identifier
     * @type {string}
     * @memberof FirewallRuleEntity
     */
    'id': string;
    /**
     * Firewall ID this rule belongs to
     * @type {string}
     * @memberof FirewallRuleEntity
     */
    'firewall_id': string;
    /**
     * Rule position in the list
     * @type {number}
     * @memberof FirewallRuleEntity
     */
    'pos': number;
    /**
     * Rule type (direction)
     * @type {string}
     * @memberof FirewallRuleEntity
     */
    'type': string;
    /**
     * Rule action
     * @type {string}
     * @memberof FirewallRuleEntity
     */
    'action': string;
    /**
     * Predefined macro
     * @type {string}
     * @memberof FirewallRuleEntity
     */
    'macro'?: string;
    /**
     * Protocol
     * @type {string}
     * @memberof FirewallRuleEntity
     */
    'proto'?: string;
    /**
     * Source IP address or range
     * @type {string}
     * @memberof FirewallRuleEntity
     */
    'source'?: string;
    /**
     * Destination IP address or range
     * @type {string}
     * @memberof FirewallRuleEntity
     */
    'dest'?: string;
    /**
     * Source port
     * @type {string}
     * @memberof FirewallRuleEntity
     */
    'sport'?: string;
    /**
     * Destination port
     * @type {string}
     * @memberof FirewallRuleEntity
     */
    'dport'?: string;
    /**
     * Rule comment
     * @type {string}
     * @memberof FirewallRuleEntity
     */
    'comment'?: string;
    /**
     * Whether the rule is enabled
     * @type {boolean}
     * @memberof FirewallRuleEntity
     */
    'enable': boolean;
    /**
     * When the rule was created
     * @type {string}
     * @memberof FirewallRuleEntity
     */
    'created_at': string;
    /**
     * When the rule was last updated
     * @type {string}
     * @memberof FirewallRuleEntity
     */
    'updated_at': string;
}
/**
 * 
 * @export
 * @interface GatewayClusterInfoDto
 */
export interface GatewayClusterInfoDto {
    /**
     * Cluster ID
     * @type {number}
     * @memberof GatewayClusterInfoDto
     */
    'id'?: number | null;
    /**
     * Cluster Name
     * @type {string}
     * @memberof GatewayClusterInfoDto
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface GatewayDatacenterInfoDto
 */
export interface GatewayDatacenterInfoDto {
    /**
     * Datacenter ID
     * @type {number}
     * @memberof GatewayDatacenterInfoDto
     */
    'id': number;
    /**
     * Datacenter Name
     * @type {string}
     * @memberof GatewayDatacenterInfoDto
     */
    'name': string;
    /**
     * Region Name
     * @type {string}
     * @memberof GatewayDatacenterInfoDto
     */
    'region_name': string;
}
/**
 * 
 * @export
 * @interface GatewayProductInfoDto
 */
export interface GatewayProductInfoDto {
    /**
     * Product ID
     * @type {number}
     * @memberof GatewayProductInfoDto
     */
    'id': number;
    /**
     * Product Name
     * @type {string}
     * @memberof GatewayProductInfoDto
     */
    'name': string;
    /**
     * Product Description
     * @type {string}
     * @memberof GatewayProductInfoDto
     */
    'description': string;
    /**
     * Category ID
     * @type {number}
     * @memberof GatewayProductInfoDto
     */
    'category_id': number;
    /**
     * Created At
     * @type {string}
     * @memberof GatewayProductInfoDto
     */
    'created_at': string;
    /**
     * Updated At
     * @type {string}
     * @memberof GatewayProductInfoDto
     */
    'updated_at': string;
}
/**
 * 
 * @export
 * @interface GatewayServerInfoDto
 */
export interface GatewayServerInfoDto {
    /**
     * Opaque host identifier — two gateways or instances with the same value share a host.
     * @type {number}
     * @memberof GatewayServerInfoDto
     */
    'id': number;
    /**
     * Datacenter Information
     * @type {GatewayDatacenterInfoDto}
     * @memberof GatewayServerInfoDto
     */
    'datacenter': GatewayDatacenterInfoDto;
    /**
     * Cluster Information
     * @type {GatewayClusterInfoDto}
     * @memberof GatewayServerInfoDto
     */
    'cluster'?: GatewayClusterInfoDto | null;
}
/**
 * 
 * @export
 * @interface GatewaySiteConnectionSummaryDto
 */
export interface GatewaySiteConnectionSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof GatewaySiteConnectionSummaryDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GatewaySiteConnectionSummaryDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GatewaySiteConnectionSummaryDto
     */
    'protocol': GatewaySiteConnectionSummaryDtoProtocolEnum;
    /**
     * pending_apply, applying, active, disabled, error or deleting
     * @type {string}
     * @memberof GatewaySiteConnectionSummaryDto
     */
    'status': string;
    /**
     * 
     * @type {boolean}
     * @memberof GatewaySiteConnectionSummaryDto
     */
    'enabled': boolean;
    /**
     * unknown, down, connecting or up
     * @type {string}
     * @memberof GatewaySiteConnectionSummaryDto
     */
    'tunnel_state': string;
    /**
     * 
     * @type {string}
     * @memberof GatewaySiteConnectionSummaryDto
     */
    'peer_address'?: string | null;
    /**
     * The networks behind the site
     * @type {Array<string>}
     * @memberof GatewaySiteConnectionSummaryDto
     */
    'remote_networks': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GatewaySiteConnectionSummaryDto
     */
    'last_handshake_at'?: string | null;
}

export const GatewaySiteConnectionSummaryDtoProtocolEnum = {
    IpsecIkev2: 'ipsec_ikev2',
    Wireguard: 'wireguard'
} as const;

export type GatewaySiteConnectionSummaryDtoProtocolEnum = typeof GatewaySiteConnectionSummaryDtoProtocolEnum[keyof typeof GatewaySiteConnectionSummaryDtoProtocolEnum];

/**
 * 
 * @export
 * @interface GatewaySiteToSiteDto
 */
export interface GatewaySiteToSiteDto {
    /**
     * 
     * @type {Array<GatewaySiteConnectionSummaryDto>}
     * @memberof GatewaySiteToSiteDto
     */
    'connections': Array<GatewaySiteConnectionSummaryDto>;
    /**
     * How many sites this gateway connects
     * @type {number}
     * @memberof GatewaySiteToSiteDto
     */
    'count': number;
    /**
     * How many its plan includes
     * @type {number}
     * @memberof GatewaySiteToSiteDto
     */
    'included': number;
}
/**
 * 
 * @export
 * @interface GatewayVmInfoDto
 */
export interface GatewayVmInfoDto {
    /**
     * VM ID
     * @type {number}
     * @memberof GatewayVmInfoDto
     */
    'id': number;
    /**
     * VM Name
     * @type {string}
     * @memberof GatewayVmInfoDto
     */
    'name'?: string | null;
    /**
     * VM Running Status
     * @type {boolean}
     * @memberof GatewayVmInfoDto
     */
    'running': boolean;
    /**
     * Virtual CPU Cores
     * @type {number}
     * @memberof GatewayVmInfoDto
     */
    'vcores': number;
    /**
     * RAM in MB
     * @type {number}
     * @memberof GatewayVmInfoDto
     */
    'ram': number;
    /**
     * Created At
     * @type {string}
     * @memberof GatewayVmInfoDto
     */
    'created_at': string;
    /**
     * Updated At
     * @type {string}
     * @memberof GatewayVmInfoDto
     */
    'updated_at': string;
    /**
     * Server Information
     * @type {GatewayServerInfoDto}
     * @memberof GatewayVmInfoDto
     */
    'server': GatewayServerInfoDto;
}
/**
 * 
 * @export
 * @interface GatewayVpcInfoDto
 */
export interface GatewayVpcInfoDto {
    /**
     * VPC ID
     * @type {number}
     * @memberof GatewayVpcInfoDto
     */
    'id': number;
    /**
     * VPC Name
     * @type {string}
     * @memberof GatewayVpcInfoDto
     */
    'name': string;
    /**
     * VPC Description
     * @type {string}
     * @memberof GatewayVpcInfoDto
     */
    'description'?: string | null;
    /**
     * DHCP Subnet
     * @type {string}
     * @memberof GatewayVpcInfoDto
     */
    'dhcp_subnet'?: string | null;
    /**
     * Default VPC Flag
     * @type {boolean}
     * @memberof GatewayVpcInfoDto
     */
    'default': boolean;
    /**
     * Created At
     * @type {string}
     * @memberof GatewayVpcInfoDto
     */
    'created_at': string;
    /**
     * Updated At
     * @type {string}
     * @memberof GatewayVpcInfoDto
     */
    'updated_at': string;
    /**
     * Cluster Information
     * @type {GatewayClusterInfoDto}
     * @memberof GatewayVpcInfoDto
     */
    'cluster'?: GatewayClusterInfoDto | null;
}
/**
 * 
 * @export
 * @interface GenerateDownloadCodeDto
 */
export interface GenerateDownloadCodeDto {
    /**
     * Hours until the download code expires
     * @type {number}
     * @memberof GenerateDownloadCodeDto
     */
    'expiryHours'?: number;
}
/**
 * 
 * @export
 * @interface GetEligibility200Response
 */
export interface GetEligibility200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GetEligibility200Response
     */
    'eligible'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetEligibility200Response
     */
    'maxSnapshots'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetEligibility200Response
     */
    'currentCount'?: number;
}
/**
 * 
 * @export
 * @interface GetVmHardwareConfig200Response
 */
export interface GetVmHardwareConfig200Response {
    /**
     * 
     * @type {string}
     * @memberof GetVmHardwareConfig200Response
     */
    'diskInterface'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetVmHardwareConfig200Response
     */
    'nicModel'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetVmHardwareConfig200Response
     */
    'osType'?: string;
}
/**
 * 
 * @export
 * @interface HardwareOption
 */
export interface HardwareOption {
    /**
     * 
     * @type {string}
     * @memberof HardwareOption
     */
    'value': string;
    /**
     * 
     * @type {string}
     * @memberof HardwareOption
     */
    'label': string;
}
/**
 * 
 * @export
 * @interface HardwareOptionsResponseDto
 */
export interface HardwareOptionsResponseDto {
    /**
     * 
     * @type {Array<HardwareOption>}
     * @memberof HardwareOptionsResponseDto
     */
    'diskInterfaces': Array<HardwareOption>;
    /**
     * 
     * @type {Array<HardwareOption>}
     * @memberof HardwareOptionsResponseDto
     */
    'nicModels': Array<HardwareOption>;
    /**
     * 
     * @type {Array<OsTypeGroup>}
     * @memberof HardwareOptionsResponseDto
     */
    'osTypes': Array<OsTypeGroup>;
}
/**
 * 
 * @export
 * @interface HostnameDomainEntity
 */
export interface HostnameDomainEntity {
    /**
     * 
     * @type {number}
     * @memberof HostnameDomainEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof HostnameDomainEntity
     */
    'domain': string;
    /**
     * 
     * @type {string}
     * @memberof HostnameDomainEntity
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof HostnameDomainEntity
     */
    'updated_at': string;
}
/**
 * 
 * @export
 * @interface InitiateCloneDto
 */
export interface InitiateCloneDto {
    /**
     * DB id of the origin (source) VM
     * @type {number}
     * @memberof InitiateCloneDto
     */
    'originVmId': number;
    /**
     * DB id of the destination VM
     * @type {number}
     * @memberof InitiateCloneDto
     */
    'destinationVmId': number;
    /**
     * Whether to clone the current VM state or restore from an existing backup.
     * @type {string}
     * @memberof InitiateCloneDto
     */
    'sourceType': InitiateCloneDtoSourceTypeEnum;
    /**
     * Existing backup ID to use when sourceType=existing_backup.
     * @type {number}
     * @memberof InitiateCloneDto
     */
    'backupId'?: number;
}

export const InitiateCloneDtoSourceTypeEnum = {
    CurrentState: 'current_state',
    ExistingBackup: 'existing_backup'
} as const;

export type InitiateCloneDtoSourceTypeEnum = typeof InitiateCloneDtoSourceTypeEnum[keyof typeof InitiateCloneDtoSourceTypeEnum];

/**
 * 
 * @export
 * @interface InvoiceDto
 */
export interface InvoiceDto {
    /**
     * 
     * @type {string}
     * @memberof InvoiceDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceDto
     */
    'provider': string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceDto
     */
    'external_id': string;
    /**
     * Invoice total in BRL cents
     * @type {string}
     * @memberof InvoiceDto
     */
    'amount_cents': string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceDto
     */
    'status': InvoiceDtoStatusEnum;
    /**
     * What the invoice pays for. Always present.
     * @type {string}
     * @memberof InvoiceDto
     */
    'purpose': InvoiceDtoPurposeEnum;
    /**
     * Unpaid renewal or usage obligation, including unpaid provider-voided invoices. Optional top-ups are never outstanding obligations.
     * @type {boolean}
     * @memberof InvoiceDto
     */
    'outstanding': boolean;
    /**
     * CANCELLED because the subscription balance covered it in full — the obligation was met, not waived. Rendered as \"settled from balance\", never as a plain cancellation.
     * @type {boolean}
     * @memberof InvoiceDto
     */
    'settled_by_credit': boolean;
    /**
     * 
     * @type {string}
     * @memberof InvoiceDto
     */
    'settled_by_credit_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceDto
     */
    'due_at': string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceDto
     */
    'paid_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceDto
     */
    'created_at': string;
    /**
     * 
     * @type {Array<InvoicePaymentEventDto>}
     * @memberof InvoiceDto
     */
    'payment_events': Array<InvoicePaymentEventDto>;
}

export const InvoiceDtoStatusEnum = {
    Open: 'OPEN',
    Paid: 'PAID',
    Cancelled: 'CANCELLED',
    Refunded: 'REFUNDED'
} as const;

export type InvoiceDtoStatusEnum = typeof InvoiceDtoStatusEnum[keyof typeof InvoiceDtoStatusEnum];
export const InvoiceDtoPurposeEnum = {
    Topup: 'TOPUP',
    CycleClose: 'CYCLE_CLOSE',
    Debt: 'DEBT',
    Reschedule: 'RESCHEDULE',
    ResourceMove: 'RESOURCE_MOVE',
    AccountTransfer: 'ACCOUNT_TRANSFER',
    SubscriptionConversion: 'SUBSCRIPTION_CONVERSION',
    CheckoutAttach: 'CHECKOUT_ATTACH',
    CheckoutNew: 'CHECKOUT_NEW'
} as const;

export type InvoiceDtoPurposeEnum = typeof InvoiceDtoPurposeEnum[keyof typeof InvoiceDtoPurposeEnum];

/**
 * 
 * @export
 * @interface InvoicePaymentEventDto
 */
export interface InvoicePaymentEventDto {
    /**
     * 
     * @type {string}
     * @memberof InvoicePaymentEventDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof InvoicePaymentEventDto
     */
    'event_type': InvoicePaymentEventDtoEventTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof InvoicePaymentEventDto
     */
    'source': InvoicePaymentEventDtoSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof InvoicePaymentEventDto
     */
    'received_at': string;
}

export const InvoicePaymentEventDtoEventTypeEnum = {
    Paid: 'paid',
    Cancelled: 'cancelled',
    Refunded: 'refunded'
} as const;

export type InvoicePaymentEventDtoEventTypeEnum = typeof InvoicePaymentEventDtoEventTypeEnum[keyof typeof InvoicePaymentEventDtoEventTypeEnum];
export const InvoicePaymentEventDtoSourceEnum = {
    Polling: 'polling',
    Webhook: 'webhook'
} as const;

export type InvoicePaymentEventDtoSourceEnum = typeof InvoicePaymentEventDtoSourceEnum[keyof typeof InvoicePaymentEventDtoSourceEnum];

/**
 * 
 * @export
 * @interface IpAvailabilityDto
 */
export interface IpAvailabilityDto {
    /**
     * Whether the datacenter can allocate public IPv4 addresses. Raw inventory counts are never exposed.
     * @type {boolean}
     * @memberof IpAvailabilityDto
     */
    'ipv4_available': boolean;
    /**
     * Whether the datacenter can allocate IPv6 addresses. Raw inventory counts are never exposed.
     * @type {boolean}
     * @memberof IpAvailabilityDto
     */
    'ipv6_available': boolean;
}
/**
 * 
 * @export
 * @interface IpEntity
 */
export interface IpEntity {
    /**
     * 
     * @type {number}
     * @memberof IpEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof IpEntity
     */
    'ip_address': string;
    /**
     * 
     * @type {string}
     * @memberof IpEntity
     */
    'mac_address': string;
    /**
     * 
     * @type {number}
     * @memberof IpEntity
     */
    'is_public': number;
    /**
     * 
     * @type {number}
     * @memberof IpEntity
     */
    'ip_pool_id': number;
    /**
     * 
     * @type {string}
     * @memberof IpEntity
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof IpEntity
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof IpEntity
     */
    'deleted_at': string | null;
    /**
     * 
     * @type {number}
     * @memberof IpEntity
     */
    'subnet_id': number;
    /**
     * 
     * @type {SubnetEntity}
     * @memberof IpEntity
     */
    'subnets'?: SubnetEntity;
}
/**
 * 
 * @export
 * @interface IpRdnsDto
 */
export interface IpRdnsDto {
    /**
     * Internal id of the underlying IP record.
     * @type {number}
     * @memberof IpRdnsDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof IpRdnsDto
     */
    'kind': IpRdnsDtoKindEnum;
    /**
     * 
     * @type {string}
     * @memberof IpRdnsDto
     */
    'ipAddress': string;
    /**
     * Identifier of the IP assignment this IP is attached to.
     * @type {string}
     * @memberof IpRdnsDto
     */
    'assignmentId': string;
    /**
     * Identifier of the VM this IP is attached to.
     * @type {number}
     * @memberof IpRdnsDto
     */
    'vmId': number;
    /**
     * Display name for the VM, when available.
     * @type {string}
     * @memberof IpRdnsDto
     */
    'vmName': string | null;
    /**
     * When the IP was assigned to the tenant (assignment assigned_at).
     * @type {string}
     * @memberof IpRdnsDto
     */
    'assignedAt': string | null;
    /**
     * Current PTR target for this IP. Null when no PTR is configured.
     * @type {string}
     * @memberof IpRdnsDto
     */
    'ptr': string | null;
    /**
     * Default PTR target generated from VM_HOSTNAME_DOMAIN. Resetting an IP returns the PTR to this value.
     * @type {string}
     * @memberof IpRdnsDto
     */
    'defaultPtr': string;
    /**
     * 
     * @type {RdnsEligibilityDto}
     * @memberof IpRdnsDto
     */
    'eligibility': RdnsEligibilityDto;
}

export const IpRdnsDtoKindEnum = {
    Ipv4: 'ipv4',
    Ipv6: 'ipv6'
} as const;

export type IpRdnsDtoKindEnum = typeof IpRdnsDtoKindEnum[keyof typeof IpRdnsDtoKindEnum];

/**
 * 
 * @export
 * @interface Ipv6Entity
 */
export interface Ipv6Entity {
    /**
     * 
     * @type {number}
     * @memberof Ipv6Entity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Ipv6Entity
     */
    'ipv6_address': string;
    /**
     * 
     * @type {number}
     * @memberof Ipv6Entity
     */
    'ipv6_subnet_id': number;
    /**
     * 
     * @type {string}
     * @memberof Ipv6Entity
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof Ipv6Entity
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof Ipv6Entity
     */
    'deleted_at': string;
    /**
     * 
     * @type {Ipv6SubnetEntity}
     * @memberof Ipv6Entity
     */
    'ipv6_subnets'?: Ipv6SubnetEntity;
}
/**
 * 
 * @export
 * @interface Ipv6SubnetEntity
 */
export interface Ipv6SubnetEntity {
    /**
     * 
     * @type {number}
     * @memberof Ipv6SubnetEntity
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof Ipv6SubnetEntity
     */
    'ip_pool_id': number;
    /**
     * 
     * @type {string}
     * @memberof Ipv6SubnetEntity
     */
    'gateway': string;
    /**
     * 
     * @type {string}
     * @memberof Ipv6SubnetEntity
     */
    'prefix_length': string;
    /**
     * 
     * @type {string}
     * @memberof Ipv6SubnetEntity
     */
    'dns1': string;
    /**
     * 
     * @type {string}
     * @memberof Ipv6SubnetEntity
     */
    'dns2': string;
    /**
     * 
     * @type {string}
     * @memberof Ipv6SubnetEntity
     */
    'cidr': string | null;
    /**
     * 
     * @type {string}
     * @memberof Ipv6SubnetEntity
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof Ipv6SubnetEntity
     */
    'updated_at': string;
}
/**
 * 
 * @export
 * @interface JobDto
 */
export interface JobDto {
    /**
     * Job ID
     * @type {string}
     * @memberof JobDto
     */
    'id': string;
    /**
     * 
     * @type {JobType}
     * @memberof JobDto
     */
    'type': JobType;
    /**
     * 
     * @type {JobResourceType}
     * @memberof JobDto
     */
    'resource_type': JobResourceType | null;
    /**
     * Associated resource ID
     * @type {string}
     * @memberof JobDto
     */
    'resource_id': string | null;
    /**
     * Human-readable name of the associated resource (VM hostname, firewall name, VPC name, ...)
     * @type {string}
     * @memberof JobDto
     */
    'resource_name'?: string | null;
    /**
     * 
     * @type {JobStatus}
     * @memberof JobDto
     */
    'status': JobStatus;
    /**
     * Completion percentage between 0 and 100. Null while the worker has not reported any progress yet.
     * @type {number}
     * @memberof JobDto
     */
    'progress': number | null;
    /**
     * Total units of work
     * @type {number}
     * @memberof JobDto
     */
    'total_units': number | null;
    /**
     * Processed units of work
     * @type {number}
     * @memberof JobDto
     */
    'processed_units': number | null;
    /**
     * Error message if failed
     * @type {string}
     * @memberof JobDto
     */
    'error_message': string | null;
    /**
     * 
     * @type {string}
     * @memberof JobDto
     */
    'started_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof JobDto
     */
    'completed_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof JobDto
     */
    'created_at': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const JobResourceType = {
    Firewall: 'firewall',
    Vm: 'vm',
    Vpc: 'vpc',
    Snapshot: 'snapshot',
    Backup: 'backup',
    CheckoutOrder: 'checkout_order',
    SecurityScan: 'security_scan',
    VpnGateway: 'vpn_gateway',
    System: 'system'
} as const;

export type JobResourceType = typeof JobResourceType[keyof typeof JobResourceType];


/**
 * 
 * @export
 * @enum {string}
 */

export const JobStatus = {
    Pending: 'pending',
    InProgress: 'in_progress',
    Completed: 'completed',
    Failed: 'failed',
    Cancelled: 'cancelled'
} as const;

export type JobStatus = typeof JobStatus[keyof typeof JobStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const JobType = {
    FirewallCommit: 'firewall_commit',
    VmDeploy: 'vm_deploy',
    VmClone: 'vm_clone',
    VmResizeApply: 'vm_resize_apply',
    SnapshotCreate: 'snapshot_create',
    BackupRun: 'backup_run',
    VpcRefresh: 'vpc_refresh',
    VpcDelete: 'vpc_delete',
    CheckoutFulfillment: 'checkout_fulfillment',
    SecurityScan: 'security_scan',
    VpnGatewayApply: 'vpn_gateway_apply',
    Generic: 'generic'
} as const;

export type JobType = typeof JobType[keyof typeof JobType];


/**
 * 
 * @export
 * @interface JobsPageDto
 */
export interface JobsPageDto {
    /**
     * Current page number (1-based)
     * @type {number}
     * @memberof JobsPageDto
     */
    'page': number;
    /**
     * Items per page
     * @type {number}
     * @memberof JobsPageDto
     */
    'page_size': number;
    /**
     * Total number of items
     * @type {number}
     * @memberof JobsPageDto
     */
    'total': number;
    /**
     * Total number of pages
     * @type {number}
     * @memberof JobsPageDto
     */
    'total_pages': number;
    /**
     * 
     * @type {Array<JobDto>}
     * @memberof JobsPageDto
     */
    'items': Array<JobDto>;
}
/**
 * 
 * @export
 * @interface LedgerEntryDetailDto
 */
export interface LedgerEntryDetailDto {
    /**
     * \'usage\' | \'bandwidth\' | \'adjustment\' | \'resource\' | \'invoice\' | \'migration\'. A reader must ignore a kind it does not know.
     * @type {string}
     * @memberof LedgerEntryDetailDto
     */
    'kind': string;
    /**
     * 
     * @type {string}
     * @memberof LedgerEntryDetailDto
     */
    'resource_label'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LedgerEntryDetailDto
     */
    'resource_type'?: string | null;
    /**
     * The instance behind the resource, when it is one
     * @type {number}
     * @memberof LedgerEntryDetailDto
     */
    'vm_id'?: number | null;
    /**
     * When the resource the entry is about stopped being billed; null while it is live
     * @type {string}
     * @memberof LedgerEntryDetailDto
     */
    'resource_ended_at'?: string | null;
    /**
     * The payment provider\'s invoice the money came from or went back to
     * @type {string}
     * @memberof LedgerEntryDetailDto
     */
    'invoice_external_id'?: string | null;
    /**
     * The service on the previous billing system a migrated entry came from
     * @type {string}
     * @memberof LedgerEntryDetailDto
     */
    'legacy_service_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LedgerEntryDetailDto
     */
    'usage_kind'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LedgerEntryDetailDto
     */
    'commitment_pool'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LedgerEntryDetailDto
     */
    'rate_micro_cents_per_hour'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LedgerEntryDetailDto
     */
    'seconds'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof LedgerEntryDetailDto
     */
    'cap_applied'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LedgerEntryDetailDto
     */
    'period_starts_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LedgerEntryDetailDto
     */
    'period_ends_at'?: string | null;
    /**
     * Public outbound bytes for the referenced hour or monthly window
     * @type {string}
     * @memberof LedgerEntryDetailDto
     */
    'public_outbound_bytes'?: string | null;
    /**
     * Included public outbound bytes per monthly window
     * @type {string}
     * @memberof LedgerEntryDetailDto
     */
    'included_bytes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LedgerEntryDetailDto
     */
    'price_micro_cents_per_gb'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LedgerEntryDetailDto
     */
    'late_usage_adjustment'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LedgerEntryDetailDto
     */
    'actor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LedgerEntryDetailDto
     */
    'note'?: string | null;
}
/**
 * 
 * @export
 * @interface LedgerEntryDto
 */
export interface LedgerEntryDto {
    /**
     * 
     * @type {string}
     * @memberof LedgerEntryDto
     */
    'id': string;
    /**
     * Signed micro-cents; negative = debit
     * @type {string}
     * @memberof LedgerEntryDto
     */
    'amount_micro_cents': string;
    /**
     * 
     * @type {boolean}
     * @memberof LedgerEntryDto
     */
    'is_credit': boolean;
    /**
     * 
     * @type {string}
     * @memberof LedgerEntryDto
     */
    'bucket': LedgerEntryDtoBucketEnum;
    /**
     * 
     * @type {string}
     * @memberof LedgerEntryDto
     */
    'reason': LedgerEntryDtoReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof LedgerEntryDto
     */
    'ref_type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LedgerEntryDto
     */
    'ref_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LedgerEntryDto
     */
    'expires_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LedgerEntryDto
     */
    'occurred_at': string;
    /**
     * Running usable balance the instant after this entry posted
     * @type {string}
     * @memberof LedgerEntryDto
     */
    'balance_after_usable_micro_cents'?: string | null;
    /**
     * 
     * @type {LedgerEntryDetailDto}
     * @memberof LedgerEntryDto
     */
    'detail'?: LedgerEntryDetailDto | null;
}

export const LedgerEntryDtoBucketEnum = {
    Committed: 'COMMITTED',
    Available: 'AVAILABLE',
    Temporary: 'TEMPORARY',
    Negative: 'NEGATIVE'
} as const;

export type LedgerEntryDtoBucketEnum = typeof LedgerEntryDtoBucketEnum[keyof typeof LedgerEntryDtoBucketEnum];
export const LedgerEntryDtoReasonEnum = {
    TrialGrant: 'TRIAL_GRANT',
    TrialWriteOff: 'TRIAL_WRITE_OFF',
    Usage: 'USAGE',
    Recharge: 'RECHARGE',
    InvoiceCarryover: 'INVOICE_CARRYOVER',
    Adjustment: 'ADJUSTMENT',
    Refund: 'REFUND',
    CommitmentPayment: 'COMMITMENT_PAYMENT',
    CouponDiscount: 'COUPON_DISCOUNT',
    TopupCouponCredit: 'TOPUP_COUPON_CREDIT',
    InternalTransferIn: 'INTERNAL_TRANSFER_IN',
    InternalTransferOut: 'INTERNAL_TRANSFER_OUT',
    TemporaryGrant: 'TEMPORARY_GRANT',
    TemporaryExpiry: 'TEMPORARY_EXPIRY',
    DebtSettlement: 'DEBT_SETTLEMENT',
    CommitmentExpiry: 'COMMITMENT_EXPIRY',
    RenewalCreditApplied: 'RENEWAL_CREDIT_APPLIED',
    PaymentReversal: 'PAYMENT_REVERSAL',
    CarryForward: 'CARRY_FORWARD',
    InternalCreditGrant: 'INTERNAL_CREDIT_GRANT'
} as const;

export type LedgerEntryDtoReasonEnum = typeof LedgerEntryDtoReasonEnum[keyof typeof LedgerEntryDtoReasonEnum];

/**
 * 
 * @export
 * @interface LedgerPageDto
 */
export interface LedgerPageDto {
    /**
     * 
     * @type {Array<LedgerEntryDto>}
     * @memberof LedgerPageDto
     */
    'entries': Array<LedgerEntryDto>;
    /**
     * Pass as ?cursor= for the next page
     * @type {string}
     * @memberof LedgerPageDto
     */
    'next_cursor'?: string | null;
}
/**
 * @type Login200Response
 * @export
 */
export type Login200Response = LoginAccountSelectionResponseDto | LoginResponseDto | TwoFactorRequiredResponseDto;

/**
 * 
 * @export
 * @interface LoginAccountOptionDto
 */
export interface LoginAccountOptionDto {
    /**
     * WHMCS client account ID
     * @type {number}
     * @memberof LoginAccountOptionDto
     */
    'clientId': number;
    /**
     * Display name for the WHMCS client account
     * @type {string}
     * @memberof LoginAccountOptionDto
     */
    'name': string;
    /**
     * Company name for the WHMCS client account
     * @type {string}
     * @memberof LoginAccountOptionDto
     */
    'companyName'?: string | null;
    /**
     * Account contact email address
     * @type {string}
     * @memberof LoginAccountOptionDto
     */
    'email': string;
    /**
     * Whether the WHMCS user owns this client account
     * @type {boolean}
     * @memberof LoginAccountOptionDto
     */
    'isOwner': boolean;
    /**
     * WHMCS permissions granted to this user for the client account
     * @type {Array<string>}
     * @memberof LoginAccountOptionDto
     */
    'permissions': Array<string>;
}
/**
 * 
 * @export
 * @interface LoginAccountSelectionResponseDto
 */
export interface LoginAccountSelectionResponseDto {
    /**
     * Signals that the user must choose a client account first.
     * @type {string}
     * @memberof LoginAccountSelectionResponseDto
     */
    'result': LoginAccountSelectionResponseDtoResultEnum;
    /**
     * 
     * @type {string}
     * @memberof LoginAccountSelectionResponseDto
     */
    'message': string;
    /**
     * 
     * @type {Array<LoginAccountOptionDto>}
     * @memberof LoginAccountSelectionResponseDto
     */
    'accounts': Array<LoginAccountOptionDto>;
}

export const LoginAccountSelectionResponseDtoResultEnum = {
    AccountSelectionRequired: 'account_selection_required'
} as const;

export type LoginAccountSelectionResponseDtoResultEnum = typeof LoginAccountSelectionResponseDtoResultEnum[keyof typeof LoginAccountSelectionResponseDtoResultEnum];

/**
 * 
 * @export
 * @interface LoginDto
 */
export interface LoginDto {
    /**
     * The email of the user
     * @type {string}
     * @memberof LoginDto
     */
    'email': string;
    /**
     * The password of the user
     * @type {string}
     * @memberof LoginDto
     */
    'password': string;
    /**
     * Device ID to login
     * @type {string}
     * @memberof LoginDto
     */
    'deviceId': string;
    /**
     * Remember me option
     * @type {boolean}
     * @memberof LoginDto
     */
    'rememberMe'?: boolean;
    /**
     * WHMCS client account ID to start a session for when the user can manage multiple accounts.
     * @type {number}
     * @memberof LoginDto
     */
    'clientId'?: number;
}
/**
 * 
 * @export
 * @interface LoginResponseDto
 */
export interface LoginResponseDto {
    /**
     * 
     * @type {ClientDetailsDto}
     * @memberof LoginResponseDto
     */
    'client': ClientDetailsDto;
    /**
     * 
     * @type {TokenDto}
     * @memberof LoginResponseDto
     */
    'token': TokenDto;
}
/**
 * 
 * @export
 * @interface LogoutDto
 */
export interface LogoutDto {
    /**
     * Device ID to logout
     * @type {string}
     * @memberof LogoutDto
     */
    'deviceId'?: string;
}
/**
 * 
 * @export
 * @interface MarkNotificationsReadDto
 */
export interface MarkNotificationsReadDto {
    /**
     * Array of notification IDs to mark as read
     * @type {Array<string>}
     * @memberof MarkNotificationsReadDto
     */
    'notificationIds': Array<string>;
}
/**
 * 
 * @export
 * @interface MarkNotificationsReadResponseDto
 */
export interface MarkNotificationsReadResponseDto {
    /**
     * Whether the update was applied
     * @type {boolean}
     * @memberof MarkNotificationsReadResponseDto
     */
    'success': boolean;
    /**
     * Number of notifications actually flipped to read
     * @type {number}
     * @memberof MarkNotificationsReadResponseDto
     */
    'updated': number;
    /**
     * Unread notifications left for the client after the update
     * @type {number}
     * @memberof MarkNotificationsReadResponseDto
     */
    'unreadCount': number;
}
/**
 * 
 * @export
 * @interface MetricsDataPoint
 */
export interface MetricsDataPoint {
    /**
     * Timestamp of the data point
     * @type {number}
     * @memberof MetricsDataPoint
     */
    'time': number;
    /**
     * CPU usage (0-1)
     * @type {number}
     * @memberof MetricsDataPoint
     */
    'cpu'?: number;
    /**
     * Memory usage in bytes
     * @type {number}
     * @memberof MetricsDataPoint
     */
    'mem'?: number;
    /**
     * Maximum memory in bytes
     * @type {number}
     * @memberof MetricsDataPoint
     */
    'maxmem'?: number;
    /**
     * Disk read in bytes/second
     * @type {number}
     * @memberof MetricsDataPoint
     */
    'diskread'?: number;
    /**
     * Disk write in bytes/second
     * @type {number}
     * @memberof MetricsDataPoint
     */
    'diskwrite'?: number;
    /**
     * Network input in bytes/second
     * @type {number}
     * @memberof MetricsDataPoint
     */
    'netin'?: number;
    /**
     * Network output in bytes/second
     * @type {number}
     * @memberof MetricsDataPoint
     */
    'netout'?: number;
}
/**
 * 
 * @export
 * @interface MintedApiTokenDto
 */
export interface MintedApiTokenDto {
    /**
     * The plaintext token. Shown exactly once — store it securely.
     * @type {string}
     * @memberof MintedApiTokenDto
     */
    'token': string;
    /**
     * 
     * @type {ApiTokenSummaryDto}
     * @memberof MintedApiTokenDto
     */
    'record': ApiTokenSummaryDto;
}
/**
 * 
 * @export
 * @interface NativeSocialExchangeDto
 */
export interface NativeSocialExchangeDto {
    /**
     * Single-use native callback code.
     * @type {string}
     * @memberof NativeSocialExchangeDto
     */
    'code': string;
    /**
     * Installation-held PKCE verifier for the S256 challenge at start.
     * @type {string}
     * @memberof NativeSocialExchangeDto
     */
    'codeVerifier': string;
}
/**
 * 
 * @export
 * @interface NativeSocialResultDto
 */
export interface NativeSocialResultDto {
    /**
     * 
     * @type {string}
     * @memberof NativeSocialResultDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof NativeSocialResultDto
     */
    'register'?: string;
    /**
     * 
     * @type {string}
     * @memberof NativeSocialResultDto
     */
    'selection'?: string;
    /**
     * 
     * @type {string}
     * @memberof NativeSocialResultDto
     */
    'error'?: string;
    /**
     * 
     * @type {string}
     * @memberof NativeSocialResultDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof NativeSocialResultDto
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof NativeSocialResultDto
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof NativeSocialResultDto
     */
    'redirect'?: string;
}
/**
 * 
 * @export
 * @interface NotificationEntity
 */
export interface NotificationEntity {
    /**
     * The unique identifier of the notification
     * @type {string}
     * @memberof NotificationEntity
     */
    'id': string;
    /**
     * The ID of the client associated with the notification
     * @type {number}
     * @memberof NotificationEntity
     */
    'client_id': number;
    /**
     * The message content of the notification
     * @type {string}
     * @memberof NotificationEntity
     */
    'message': string;
    /**
     * The type of the notification
     * @type {string}
     * @memberof NotificationEntity
     */
    'notification_type': NotificationEntityNotificationTypeEnum;
    /**
     * Indicates whether the notification has been read
     * @type {boolean}
     * @memberof NotificationEntity
     */
    'is_read': boolean;
    /**
     * An optional link associated with the notification
     * @type {string}
     * @memberof NotificationEntity
     */
    'link': string;
    /**
     * Additional data associated with the notification in JSON format
     * @type {{ [key: string]: any; }}
     * @memberof NotificationEntity
     */
    'extra_data': { [key: string]: any; };
    /**
     * The date and time when the notification was created
     * @type {string}
     * @memberof NotificationEntity
     */
    'created_at': string;
    /**
     * The date and time when the notification was last updated
     * @type {string}
     * @memberof NotificationEntity
     */
    'updated_at': string;
}

export const NotificationEntityNotificationTypeEnum = {
    TrialOffered: 'trial_offered',
    TrialEndingSoon: 'trial_ending_soon',
    TrialEnded: 'trial_ended',
    Info: 'info',
    Warning: 'warning',
    Error: 'error',
    VpcCreated: 'vpc_created',
    VpcDeleted: 'vpc_deleted',
    VpcUpdated: 'vpc_updated',
    BackupInitiated: 'backup_initiated',
    BackupComplete: 'backup_complete',
    BackupFailed: 'backup_failed',
    RestoreInitiated: 'restore_initiated',
    RestoreComplete: 'restore_complete',
    RestoreFailed: 'restore_failed',
    SnapshotCreated: 'snapshot_created',
    SnapshotRestored: 'snapshot_restored',
    SnapshotDeleted: 'snapshot_deleted',
    TopupUpgradeReady: 'topup_upgrade_ready',
    TopupOpenRenewal: 'topup_open_renewal',
    RenewalCreditSettled: 'renewal_credit_settled',
    AttachOrderCredited: 'attach_order_credited',
    SubscriptionSuspensionRisk: 'subscription_suspension_risk',
    SecurityScanComplete: 'security_scan_complete',
    SecurityNewCriticalFinding: 'security_new_critical_finding',
    SecurityScoreDropped: 'security_score_dropped'
} as const;

export type NotificationEntityNotificationTypeEnum = typeof NotificationEntityNotificationTypeEnum[keyof typeof NotificationEntityNotificationTypeEnum];

/**
 * 
 * @export
 * @interface NotificationsResponseDto
 */
export interface NotificationsResponseDto {
    /**
     * Array of notifications
     * @type {Array<NotificationEntity>}
     * @memberof NotificationsResponseDto
     */
    'data': Array<NotificationEntity>;
    /**
     * Current page number
     * @type {number}
     * @memberof NotificationsResponseDto
     */
    'page': number;
    /**
     * Number of items per page
     * @type {number}
     * @memberof NotificationsResponseDto
     */
    'limit': number;
    /**
     * Total number of notifications
     * @type {number}
     * @memberof NotificationsResponseDto
     */
    'total': number;
    /**
     * Total number of pages
     * @type {number}
     * @memberof NotificationsResponseDto
     */
    'totalPages': number;
    /**
     * Total number of unread notifications
     * @type {number}
     * @memberof NotificationsResponseDto
     */
    'unreadCount': number;
}
/**
 * 
 * @export
 * @interface OrderPaymentInvoiceDto
 */
export interface OrderPaymentInvoiceDto {
    /**
     * Provider invoice id — for WHMCS, the id viewinvoice.php takes.
     * @type {string}
     * @memberof OrderPaymentInvoiceDto
     */
    'external_id': string;
    /**
     * 
     * @type {string}
     * @memberof OrderPaymentInvoiceDto
     */
    'status': OrderPaymentInvoiceDtoStatusEnum;
    /**
     * Invoice total in BRL cents (string).
     * @type {string}
     * @memberof OrderPaymentInvoiceDto
     */
    'amount_cents': string;
    /**
     * 
     * @type {string}
     * @memberof OrderPaymentInvoiceDto
     */
    'due_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderPaymentInvoiceDto
     */
    'paid_at'?: string | null;
}

export const OrderPaymentInvoiceDtoStatusEnum = {
    Open: 'OPEN',
    Paid: 'PAID',
    Cancelled: 'CANCELLED',
    Refunded: 'REFUNDED'
} as const;

export type OrderPaymentInvoiceDtoStatusEnum = typeof OrderPaymentInvoiceDtoStatusEnum[keyof typeof OrderPaymentInvoiceDtoStatusEnum];

/**
 * 
 * @export
 * @interface OrderPaymentStateDto
 */
export interface OrderPaymentStateDto {
    /**
     * 
     * @type {string}
     * @memberof OrderPaymentStateDto
     */
    'order_id': string;
    /**
     * 
     * @type {string}
     * @memberof OrderPaymentStateDto
     */
    'status': OrderPaymentStateDtoStatusEnum;
    /**
     * The money is in — the order left pending_payment other than by cancellation. Provisioning may still be running.
     * @type {boolean}
     * @memberof OrderPaymentStateDto
     */
    'paid': boolean;
    /**
     * Order finished and its resources exist.
     * @type {boolean}
     * @memberof OrderPaymentStateDto
     */
    'provisioned': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderPaymentStateDto
     */
    'failed': boolean;
    /**
     * When an unpaid order stops being payable.
     * @type {string}
     * @memberof OrderPaymentStateDto
     */
    'expires_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderPaymentStateDto
     */
    'subscription_id'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderPaymentStateDto
     */
    'resource_ids': Array<string>;
    /**
     * 
     * @type {OrderPaymentInvoiceDto}
     * @memberof OrderPaymentStateDto
     */
    'invoice'?: OrderPaymentInvoiceDto | null;
    /**
     * Subscription balance netted against the invoice of a full-term add-to-existing order, in cents — invoice.amount_cents is the term price minus this. Null when nothing was netted.
     * @type {string}
     * @memberof OrderPaymentStateDto
     */
    'balance_applied_cents'?: string | null;
    /**
     * What the minimum recharge added to the invoice above the net charge (the prorata minus balance_applied_cents), in cents. Paid with the rest, it stays on the subscription as available credit. Null when the net charge met the minimum.
     * @type {string}
     * @memberof OrderPaymentStateDto
     */
    'minimum_recharge_credit_cents'?: string | null;
    /**
     * Initial prepaid credit purchased by a new ON_DEMAND order, in cents. The full amount becomes available credit on payment. Null for other orders.
     * @type {string}
     * @memberof OrderPaymentStateDto
     */
    'initial_credit_cents'?: string | null;
    /**
     * False when refresh=true was asked for but the per-invoice cooldown blocked the provider call — the state below still holds, it just came from our own record.
     * @type {boolean}
     * @memberof OrderPaymentStateDto
     */
    'checked_provider': boolean;
}

export const OrderPaymentStateDtoStatusEnum = {
    PendingPayment: 'pending_payment',
    Paid: 'paid',
    Provisioning: 'provisioning',
    Provisioned: 'provisioned',
    Failed: 'failed',
    Cancelled: 'cancelled'
} as const;

export type OrderPaymentStateDtoStatusEnum = typeof OrderPaymentStateDtoStatusEnum[keyof typeof OrderPaymentStateDtoStatusEnum];

/**
 * 
 * @export
 * @interface OsTypeGroup
 */
export interface OsTypeGroup {
    /**
     * 
     * @type {string}
     * @memberof OsTypeGroup
     */
    'value': string;
    /**
     * 
     * @type {string}
     * @memberof OsTypeGroup
     */
    'label': string;
    /**
     * 
     * @type {Array<OsTypeVersion>}
     * @memberof OsTypeGroup
     */
    'versions': Array<OsTypeVersion>;
}
/**
 * 
 * @export
 * @interface OsTypeVersion
 */
export interface OsTypeVersion {
    /**
     * 
     * @type {string}
     * @memberof OsTypeVersion
     */
    'value': string;
    /**
     * 
     * @type {string}
     * @memberof OsTypeVersion
     */
    'label': string;
}
/**
 * 
 * @export
 * @interface PaymentHoldStateDto
 */
export interface PaymentHoldStateDto {
    /**
     * 
     * @type {string}
     * @memberof PaymentHoldStateDto
     */
    'holds_until': string;
    /**
     * The last day covered, YYYY-MM-DD in the platform time zone. Render this rather than holds_until: the instant ends a few hours into the next UTC day and formats as the wrong date in most browsers.
     * @type {string}
     * @memberof PaymentHoldStateDto
     */
    'holds_until_date': string;
    /**
     * Whole days remaining, floored at 0. Rendered rather than recomputed in the browser so the customer and the operator agree on the deadline.
     * @type {number}
     * @memberof PaymentHoldStateDto
     */
    'days_remaining': number;
    /**
     * True when the extension switched suspended services back on, rather than only deferring a suspension that had not happened yet.
     * @type {boolean}
     * @memberof PaymentHoldStateDto
     */
    'lifted_suspension': boolean;
}
/**
 * 
 * @export
 * @interface PendingCancellationDto
 */
export interface PendingCancellationDto {
    /**
     * 
     * @type {string}
     * @memberof PendingCancellationDto
     */
    'requested_at': string;
    /**
     * When the cancellation takes effect (cycle end). Null = ON_DEMAND, effective immediately.
     * @type {string}
     * @memberof PendingCancellationDto
     */
    'effective_at': string | null;
}
/**
 * 
 * @export
 * @interface ProductInfoDto
 */
export interface ProductInfoDto {
    /**
     * Product ID
     * @type {number}
     * @memberof ProductInfoDto
     */
    'id': number;
    /**
     * Product Name
     * @type {string}
     * @memberof ProductInfoDto
     */
    'name': string;
    /**
     * Product Description
     * @type {string}
     * @memberof ProductInfoDto
     */
    'description': string;
    /**
     * Category ID
     * @type {number}
     * @memberof ProductInfoDto
     */
    'category_id': number;
    /**
     * Created At
     * @type {string}
     * @memberof ProductInfoDto
     */
    'created_at'?: string;
    /**
     * Updated At
     * @type {string}
     * @memberof ProductInfoDto
     */
    'updated_at'?: string;
}
/**
 * 
 * @export
 * @interface ProjectionDto
 */
export interface ProjectionDto {
    /**
     * 
     * @type {string}
     * @memberof ProjectionDto
     */
    'forecast_as_of': string;
    /**
     * Forecast horizon: seven days for on-demand, remaining cycle for committed. An estimate, never an invoice deadline.
     * @type {number}
     * @memberof ProjectionDto
     */
    'forecast_horizon_hours': number | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectionDto
     */
    'projected_balance_micro_cents': string | null;
    /**
     * Only ON_DEMAND is subject to a balance limit. COMMITTED usage is payable through invoices.
     * @type {boolean}
     * @memberof ProjectionDto
     */
    'balance_threshold_applies': boolean;
    /**
     * 
     * @type {string}
     * @memberof ProjectionDto
     */
    'bandwidth_window_ends_at': string;
    /**
     * Additional estimated bandwidth charges until the next monthly allowance reset; excludes usage already accrued.
     * @type {string}
     * @memberof ProjectionDto
     */
    'bandwidth_projected_until_window_end_micro_cents': string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectionDto
     */
    'usable_micro_cents': string;
    /**
     * Observed average hourly USABLE-balance compute burn (FLEXIBLE only): current cycle for committed, up to the last 24 hours for on-demand.
     * @type {string}
     * @memberof ProjectionDto
     */
    'avg_hourly_burn_micro_cents': string;
    /**
     * 
     * @type {number}
     * @memberof ProjectionDto
     */
    'hours_until_close'?: number | null;
    /**
     * Projected usable balance at close, including pending and forecasted bandwidth. Excludes COMMITTED-pool compute (prepaid).
     * @type {string}
     * @memberof ProjectionDto
     */
    'projected_at_close_micro_cents'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectionDto
     */
    'tier_negative_credit_threshold_micro_cents': string;
    /**
     * Forecast balance-limit breach for ON_DEMAND only. False for COMMITTED; says nothing about invoice delinquency or an active payment hold.
     * @type {boolean}
     * @memberof ProjectionDto
     */
    'will_breach_tier': boolean;
    /**
     * Estimated hours to the ON_DEMAND balance limit. Null for COMMITTED. Not a suspension deadline.
     * @type {number}
     * @memberof ProjectionDto
     */
    'runway_hours'?: number | null;
    /**
     * Current prepaid committed-bucket balance
     * @type {string}
     * @memberof ProjectionDto
     */
    'committed_balance_micro_cents': string;
    /**
     * Projected COMMITTED-pool compute spend until close, capped per resource at the remaining commitment capacity. Null when there is no close (on-demand).
     * @type {string}
     * @memberof ProjectionDto
     */
    'committed_projected_spend_until_close_micro_cents'?: string | null;
    /**
     * committed_balance − committed_projected_spend: what remains of the prepaid balance at close (negative = committed spend not fully funded; settled at cycle close). Null when there is no close.
     * @type {string}
     * @memberof ProjectionDto
     */
    'committed_projected_at_close_micro_cents'?: string | null;
    /**
     * Platform bandwidth billing mode
     * @type {string}
     * @memberof ProjectionDto
     */
    'bandwidth_mode': ProjectionDtoBandwidthModeEnum;
    /**
     * False when bandwidth is never billed (unlimited mode)
     * @type {boolean}
     * @memberof ProjectionDto
     */
    'bandwidth_billable': boolean;
    /**
     * Billable bandwidth metered in the observation period: current cycle for committed, up to the last 24 hours for on-demand.
     * @type {string}
     * @memberof ProjectionDto
     */
    'bandwidth_burn_to_date_micro_cents': string;
    /**
     * COMMITTED bandwidth overage accrued in the open franchise window — owed but not yet reflected in the usable balance
     * @type {string}
     * @memberof ProjectionDto
     */
    'bandwidth_pending_micro_cents': string;
    /**
     * Average billable bandwidth per hour in the observation period
     * @type {string}
     * @memberof ProjectionDto
     */
    'bandwidth_avg_hourly_micro_cents': string;
    /**
     * Run-rate forecast of billable bandwidth until cycle close (franchise-aware). Null for on-demand (no close).
     * @type {string}
     * @memberof ProjectionDto
     */
    'bandwidth_projected_until_close_micro_cents'?: string | null;
}

export const ProjectionDtoBandwidthModeEnum = {
    Unlimited: 'unlimited',
    FairUsage: 'fair_usage',
    AlwaysCharged: 'always_charged'
} as const;

export type ProjectionDtoBandwidthModeEnum = typeof ProjectionDtoBandwidthModeEnum[keyof typeof ProjectionDtoBandwidthModeEnum];

/**
 * 
 * @export
 * @interface PublicLocationDto
 */
export interface PublicLocationDto {
    /**
     * Datacenter id, as used by `datacenter_id` everywhere else.
     * @type {number}
     * @memberof PublicLocationDto
     */
    'id': number;
    /**
     * Customer-facing location name.
     * @type {string}
     * @memberof PublicLocationDto
     */
    'name': string;
    /**
     * Region this location belongs to, when recorded.
     * @type {string}
     * @memberof PublicLocationDto
     */
    'region_name': string | null;
    /**
     * Flag/badge filename recorded on the location. The console derives the ISO country code — and from it the country name and flag — from this value.
     * @type {string}
     * @memberof PublicLocationDto
     */
    'image': string | null;
    /**
     * Whether a new instance can be placed here right now. Advisory: the list is not filtered by it, so a location with no capacity is shown as temporarily unavailable rather than silently missing.
     * @type {boolean}
     * @memberof PublicLocationDto
     */
    'deployable': boolean;
    /**
     * Whether public IPv4 can be allocated here. Inventory counts are never exposed.
     * @type {boolean}
     * @memberof PublicLocationDto
     */
    'ipv4_available': boolean;
    /**
     * Whether IPv6 can be allocated here. Inventory counts are never exposed.
     * @type {boolean}
     * @memberof PublicLocationDto
     */
    'ipv6_available': boolean;
}
/**
 * 
 * @export
 * @interface PublicTrialDto
 */
export interface PublicTrialDto {
    /**
     * 
     * @type {string}
     * @memberof PublicTrialDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof PublicTrialDto
     */
    'state': PublicTrialDtoStateEnum;
    /**
     * 
     * @type {Array<TrialPlanDto>}
     * @memberof PublicTrialDto
     */
    'plans': Array<TrialPlanDto>;
    /**
     * 
     * @type {number}
     * @memberof PublicTrialDto
     */
    'trial_days': number;
    /**
     * 
     * @type {number}
     * @memberof PublicTrialDto
     */
    'grace_hours': number;
    /**
     * 
     * @type {string}
     * @memberof PublicTrialDto
     */
    'term': PublicTrialDtoTermEnum;
    /**
     * 
     * @type {string}
     * @memberof PublicTrialDto
     */
    'budget_micro_cents': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PublicTrialDto
     */
    'allowed_addon_types': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PublicTrialDto
     */
    'offer_expires_at': string;
    /**
     * 
     * @type {string}
     * @memberof PublicTrialDto
     */
    'trial_ends_at': string;
    /**
     * 
     * @type {boolean}
     * @memberof PublicTrialDto
     */
    'pinned_to_email': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PublicTrialDto
     */
    'bound': boolean;
    /**
     * 
     * @type {string}
     * @memberof PublicTrialDto
     */
    'terms_version': string;
    /**
     * 
     * @type {boolean}
     * @memberof PublicTrialDto
     */
    'has_renewal_coupon': boolean;
}

export const PublicTrialDtoStateEnum = {
    Open: 'open',
    Redeemed: 'redeemed',
    Expired: 'expired',
    Revoked: 'revoked'
} as const;

export type PublicTrialDtoStateEnum = typeof PublicTrialDtoStateEnum[keyof typeof PublicTrialDtoStateEnum];
export const PublicTrialDtoTermEnum = {
    Monthly: 'MONTHLY',
    Quarterly: 'QUARTERLY',
    SemiAnnual: 'SEMI_ANNUAL',
    Annual: 'ANNUAL',
    OnDemand: 'ON_DEMAND'
} as const;

export type PublicTrialDtoTermEnum = typeof PublicTrialDtoTermEnum[keyof typeof PublicTrialDtoTermEnum];

/**
 * 
 * @export
 * @interface QemuAgentResetPasswordRequestDto
 */
export interface QemuAgentResetPasswordRequestDto {
    /**
     * The username for which to reset the password
     * @type {string}
     * @memberof QemuAgentResetPasswordRequestDto
     */
    'username': string;
    /**
     * The new password to set for the user. Letters, digits and these symbols only: !\"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~ (no spaces or accents).
     * @type {string}
     * @memberof QemuAgentResetPasswordRequestDto
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface QemuAgentResetPasswordResponseDto
 */
export interface QemuAgentResetPasswordResponseDto {
    /**
     * Indicates if the password reset was successful
     * @type {boolean}
     * @memberof QemuAgentResetPasswordResponseDto
     */
    'success': boolean;
    /**
     * A message describing the result of the operation
     * @type {string}
     * @memberof QemuAgentResetPasswordResponseDto
     */
    'message': string;
    /**
     * VM ID from database
     * @type {number}
     * @memberof QemuAgentResetPasswordResponseDto
     */
    'vm_id': number;
    /**
     * Username for which the password was reset
     * @type {string}
     * @memberof QemuAgentResetPasswordResponseDto
     */
    'username': string;
}
/**
 * 
 * @export
 * @interface QemuAgentStatusResponseDto
 */
export interface QemuAgentStatusResponseDto {
    /**
     * Indicates if the QEMU guest agent is running
     * @type {boolean}
     * @memberof QemuAgentStatusResponseDto
     */
    'is_running': boolean;
    /**
     * A message describing the agent status
     * @type {string}
     * @memberof QemuAgentStatusResponseDto
     */
    'message': string;
    /**
     * VM ID from database
     * @type {number}
     * @memberof QemuAgentStatusResponseDto
     */
    'vm_id': number;
}
/**
 * 
 * @export
 * @interface RdnsEligibilityDto
 */
export interface RdnsEligibilityDto {
    /**
     * Whether the IP is currently eligible to have its rDNS modified by the tenant.
     * @type {boolean}
     * @memberof RdnsEligibilityDto
     */
    'eligible': boolean;
    /**
     * When true, rDNS modifications are globally disabled by the platform.
     * @type {boolean}
     * @memberof RdnsEligibilityDto
     */
    'restricted': boolean;
    /**
     * Number of days the IP has been held by the tenant (based on the assignment assigned_at).
     * @type {number}
     * @memberof RdnsEligibilityDto
     */
    'daysHeld': number;
    /**
     * Minimum number of days the IP must be held before rDNS can be changed. Zero means no hold restriction.
     * @type {number}
     * @memberof RdnsEligibilityDto
     */
    'requiredHoldDays': number;
    /**
     * ISO timestamp after which the IP becomes eligible. Null when already eligible or restricted.
     * @type {string}
     * @memberof RdnsEligibilityDto
     */
    'eligibleAt': string | null;
}
/**
 * 
 * @export
 * @interface RegisterDeviceDto
 */
export interface RegisterDeviceDto {
    /**
     * FCM registration token of the device
     * @type {string}
     * @memberof RegisterDeviceDto
     */
    'registration_token': string;
    /**
     * Operating system of the device
     * @type {string}
     * @memberof RegisterDeviceDto
     */
    'operating_system': RegisterDeviceDtoOperatingSystemEnum;
}

export const RegisterDeviceDtoOperatingSystemEnum = {
    Android: 'android',
    Ios: 'ios'
} as const;

export type RegisterDeviceDtoOperatingSystemEnum = typeof RegisterDeviceDtoOperatingSystemEnum[keyof typeof RegisterDeviceDtoOperatingSystemEnum];

/**
 * 
 * @export
 * @interface RegisterDeviceResponseDto
 */
export interface RegisterDeviceResponseDto {
    /**
     * Confirmation message
     * @type {string}
     * @memberof RegisterDeviceResponseDto
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface RenewalCreditSettleResultDto
 */
export interface RenewalCreditSettleResultDto {
    /**
     * 
     * @type {string}
     * @memberof RenewalCreditSettleResultDto
     */
    'status': RenewalCreditSettleResultDtoStatusEnum;
    /**
     * Why nothing was settled. insufficient_balance: top up shortfall_cents and it settles automatically. remote_not_open: the provider already reports the invoice paid — the reconciler credits that payment. lock_busy / order_in_flight / provider_unavailable: transient; the hourly sweep retries.
     * @type {string}
     * @memberof RenewalCreditSettleResultDto
     */
    'reason'?: RenewalCreditSettleResultDtoReasonEnum;
    /**
     * The oldest open renewal invoice this was measured against.
     * @type {string}
     * @memberof RenewalCreditSettleResultDto
     */
    'invoice_external_id'?: string;
    /**
     * What the customer still has to add (cents) for the balance to settle the open invoice.
     * @type {string}
     * @memberof RenewalCreditSettleResultDto
     */
    'shortfall_cents'?: string;
    /**
     * 
     * @type {Array<RenewalCreditSettledInvoiceDto>}
     * @memberof RenewalCreditSettleResultDto
     */
    'settled_invoices': Array<RenewalCreditSettledInvoiceDto>;
}

export const RenewalCreditSettleResultDtoStatusEnum = {
    Settled: 'settled',
    Noop: 'noop'
} as const;

export type RenewalCreditSettleResultDtoStatusEnum = typeof RenewalCreditSettleResultDtoStatusEnum[keyof typeof RenewalCreditSettleResultDtoStatusEnum];
export const RenewalCreditSettleResultDtoReasonEnum = {
    Disabled: 'disabled',
    NoOpenRenewal: 'no_open_renewal',
    InsufficientBalance: 'insufficient_balance',
    LockBusy: 'lock_busy',
    OrderInFlight: 'order_in_flight',
    RemoteNotOpen: 'remote_not_open',
    ProviderUnavailable: 'provider_unavailable'
} as const;

export type RenewalCreditSettleResultDtoReasonEnum = typeof RenewalCreditSettleResultDtoReasonEnum[keyof typeof RenewalCreditSettleResultDtoReasonEnum];

/**
 * 
 * @export
 * @interface RenewalCreditSettledInvoiceDto
 */
export interface RenewalCreditSettledInvoiceDto {
    /**
     * Provider invoice id (WHMCS viewinvoice.php id)
     * @type {string}
     * @memberof RenewalCreditSettledInvoiceDto
     */
    'external_id': string;
    /**
     * Balance moved into the commitment for this invoice (cents)
     * @type {string}
     * @memberof RenewalCreditSettledInvoiceDto
     */
    'applied_cents': string;
}
/**
 * 
 * @export
 * @interface RenewalPreviewDto
 */
export interface RenewalPreviewDto {
    /**
     * 
     * @type {string}
     * @memberof RenewalPreviewDto
     */
    'cycle_ends_at': string | null;
    /**
     * The term the NEXT cycle bills at. When a plan change is scheduled for the cycle end this is the NEW term, and every renewal figure below is already priced at it.
     * @type {string}
     * @memberof RenewalPreviewDto
     */
    'term_kind': string | null;
    /**
     * A plan change scheduled for the cycle end (set by support at the customer\'s request). The renewal issued at that date covers the full first cycle of the new term.
     * @type {ScheduledPlanChangeDto}
     * @memberof RenewalPreviewDto
     */
    'scheduled_plan_change': ScheduledPlanChangeDto | null;
    /**
     * Next renewal, gross (µ¢), before recurring coupon
     * @type {string}
     * @memberof RenewalPreviewDto
     */
    'renewal_micro_cents': string;
    /**
     * Recurring coupon discount on the renewal (µ¢)
     * @type {string}
     * @memberof RenewalPreviewDto
     */
    'renewal_discount_micro_cents': string;
    /**
     * What the customer would pay for one renewal (µ¢)
     * @type {string}
     * @memberof RenewalPreviewDto
     */
    'renewal_net_micro_cents': string;
    /**
     * Current balance_available (µ¢) — auto-applied at renewal
     * @type {string}
     * @memberof RenewalPreviewDto
     */
    'available_micro_cents': string;
    /**
     * Bandwidth expected to hit the close (µ¢): overage accrued so far + run-rate forecast until close. Settled from available balance BEFORE the renewal netting, so the suggested amounts already include it. 0 on unlimited mode.
     * @type {string}
     * @memberof RenewalPreviewDto
     */
    'bandwidth_expected_micro_cents': string;
    /**
     * Suggested top-up (cents) to fully cover the NEXT renewal (incl. expected bandwidth) after the current available balance nets against it. 0 = already covered.
     * @type {string}
     * @memberof RenewalPreviewDto
     */
    'suggested_topup_cents_one_cycle': string;
    /**
     * Suggested top-up (cents) to cover the next TWO renewals.
     * @type {string}
     * @memberof RenewalPreviewDto
     */
    'suggested_topup_cents_two_cycles': string;
    /**
     * Open CYCLE_CLOSE invoice, if the renewal was already issued. Balance that covers it IN FULL settles it automatically (the invoice is cancelled, never paid twice); shortfall_cents says how much more is needed. Partial balance is never applied.
     * @type {RenewalPreviewOpenInvoiceDto}
     * @memberof RenewalPreviewDto
     */
    'open_renewal_invoice': RenewalPreviewOpenInvoiceDto | null;
}
/**
 * 
 * @export
 * @interface RenewalPreviewOpenInvoiceDto
 */
export interface RenewalPreviewOpenInvoiceDto {
    /**
     * Provider invoice id (WHMCS viewinvoice.php id)
     * @type {string}
     * @memberof RenewalPreviewOpenInvoiceDto
     */
    'external_id': string;
    /**
     * Invoice total in BRL cents
     * @type {string}
     * @memberof RenewalPreviewOpenInvoiceDto
     */
    'amount_cents': string;
    /**
     * 
     * @type {string}
     * @memberof RenewalPreviewOpenInvoiceDto
     */
    'due_at': string;
    /**
     * What the customer still has to add (cents) for the balance to settle this invoice automatically. 0 = the balance already covers it: the next hourly sweep settles it, or POST renewal-invoice/settle-from-balance does so now.
     * @type {string}
     * @memberof RenewalPreviewOpenInvoiceDto
     */
    'shortfall_cents': string;
    /**
     * The cycle end this invoice renews. Pass it as intent_cycle_ends_at on a RENEWAL_PREPAY top-up for the shortfall, so that top-up is voided if the invoice is paid in cash instead.
     * @type {string}
     * @memberof RenewalPreviewOpenInvoiceDto
     */
    'cycle_ends_at': string | null;
}
/**
 * 
 * @export
 * @interface RequestCancellationBodyDto
 */
export interface RequestCancellationBodyDto {
    /**
     * Primary reason selected in the cancellation survey.
     * @type {string}
     * @memberof RequestCancellationBodyDto
     */
    'reason': RequestCancellationBodyDtoReasonEnum;
    /**
     * Free-text answer to the survey follow-up question, required. Trimmed; whitespace alone is refused.
     * @type {string}
     * @memberof RequestCancellationBodyDto
     */
    'comment': string;
}

export const RequestCancellationBodyDtoReasonEnum = {
    TooExpensive: 'TOO_EXPENSIVE',
    MissingFeatures: 'MISSING_FEATURES',
    TechnicalIssues: 'TECHNICAL_ISSUES',
    CustomerSupport: 'CUSTOMER_SUPPORT',
    SwitchingProvider: 'SWITCHING_PROVIDER',
    NoLongerNeeded: 'NO_LONGER_NEEDED',
    TemporaryProject: 'TEMPORARY_PROJECT',
    Other: 'OTHER'
} as const;

export type RequestCancellationBodyDtoReasonEnum = typeof RequestCancellationBodyDtoReasonEnum[keyof typeof RequestCancellationBodyDtoReasonEnum];

/**
 * 
 * @export
 * @interface RequestWithdrawalDto
 */
export interface RequestWithdrawalDto {
    /**
     * Amount to withdraw in micro-cents.
     * @type {number}
     * @memberof RequestWithdrawalDto
     */
    'amount_micro_cents': number;
    /**
     * Free-form payout details (e.g. PIX key / bank) shown to admin.
     * @type {object}
     * @memberof RequestWithdrawalDto
     */
    'payout_details': object;
}
/**
 * 
 * @export
 * @interface ResendTwoFactorDto
 */
export interface ResendTwoFactorDto {
    /**
     * The challenge ID from the two_factor_required response
     * @type {string}
     * @memberof ResendTwoFactorDto
     */
    'challengeId': string;
}
/**
 * 
 * @export
 * @interface ResetPasswordRequestDto
 */
export interface ResetPasswordRequestDto {
    /**
     * Email address of the account to reset.
     * @type {string}
     * @memberof ResetPasswordRequestDto
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface ResetPasswordResponseDto
 */
export interface ResetPasswordResponseDto {
    /**
     * Always true — a generic response is returned regardless of whether the email exists, to avoid account enumeration.
     * @type {boolean}
     * @memberof ResetPasswordResponseDto
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface ResizeAddonDto
 */
export interface ResizeAddonDto {
    /**
     * catalog_addons.code
     * @type {string}
     * @memberof ResizeAddonDto
     */
    'addon_code': string;
    /**
     * Desired quantity
     * @type {number}
     * @memberof ResizeAddonDto
     */
    'quantity'?: number;
}
/**
 * 
 * @export
 * @interface ResizeApplyResultDto
 */
export interface ResizeApplyResultDto {
    /**
     * \'applied\' (billing committed; hypervisor changes queued as an async job) | \'requires_topup\'.
     * @type {string}
     * @memberof ResizeApplyResultDto
     */
    'status': string;
    /**
     * 
     * @type {number}
     * @memberof ResizeApplyResultDto
     */
    'vm_id': number;
    /**
     * 
     * @type {string}
     * @memberof ResizeApplyResultDto
     */
    'subscription_id': string;
    /**
     * 
     * @type {string}
     * @memberof ResizeApplyResultDto
     */
    'new_rate_micro_cents_per_hour': string | null;
    /**
     * 
     * @type {string}
     * @memberof ResizeApplyResultDto
     */
    'temporary_credit_granted_micro_cents': string;
    /**
     * 
     * @type {string}
     * @memberof ResizeApplyResultDto
     */
    'required_topup_cents': string | null;
    /**
     * 
     * @type {string}
     * @memberof ResizeApplyResultDto
     */
    'reason': string | null;
    /**
     * app_jobs id of the async hypervisor-apply job (track it in the tasks feed). Null on requires_topup.
     * @type {string}
     * @memberof ResizeApplyResultDto
     */
    'job_id': string | null;
    /**
     * 
     * @type {ResizePlannedChangesDto}
     * @memberof ResizeApplyResultDto
     */
    'planned': ResizePlannedChangesDto | null;
}
/**
 * 
 * @export
 * @interface ResizeBalanceDto
 */
export interface ResizeBalanceDto {
    /**
     * 
     * @type {string}
     * @memberof ResizeBalanceDto
     */
    'committed_micro_cents': string;
    /**
     * 
     * @type {string}
     * @memberof ResizeBalanceDto
     */
    'available_micro_cents': string;
    /**
     * 
     * @type {string}
     * @memberof ResizeBalanceDto
     */
    'temporary_micro_cents': string;
    /**
     * 
     * @type {string}
     * @memberof ResizeBalanceDto
     */
    'negative_micro_cents': string;
    /**
     * 
     * @type {string}
     * @memberof ResizeBalanceDto
     */
    'usable_micro_cents': string;
}
/**
 * 
 * @export
 * @interface ResizeCapabilitiesDto
 */
export interface ResizeCapabilitiesDto {
    /**
     * Whether this offering kind sells customer-chosen addons (licences, snapshot/backup slots, anti-DDoS). False for managed appliances such as VPN gateways, where `addons` is returned empty and any addon change is rejected.
     * @type {boolean}
     * @memberof ResizeCapabilitiesDto
     */
    'addons': boolean;
    /**
     * Whether public addresses may be added or released. False for managed appliances: the plan includes exactly the addresses the service answers on.
     * @type {boolean}
     * @memberof ResizeCapabilitiesDto
     */
    'extra_ips': boolean;
    /**
     * Whether the main disk may grow and extra data disks may be attached or removed. False for managed appliances, whose storage is part of the plan.
     * @type {boolean}
     * @memberof ResizeCapabilitiesDto
     */
    'storage': boolean;
}
/**
 * 
 * @export
 * @interface ResizeContextAddonDto
 */
export interface ResizeContextAddonDto {
    /**
     * 
     * @type {string}
     * @memberof ResizeContextAddonDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ResizeContextAddonDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ResizeContextAddonDto
     */
    'addon_type': string;
    /**
     * 
     * @type {boolean}
     * @memberof ResizeContextAddonDto
     */
    'resizable_after_purchase': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResizeContextAddonDto
     */
    'removable_after_purchase': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResizeContextAddonDto
     */
    'quantity_enabled': boolean;
    /**
     * 
     * @type {number}
     * @memberof ResizeContextAddonDto
     */
    'min_quantity': number;
    /**
     * 
     * @type {number}
     * @memberof ResizeContextAddonDto
     */
    'max_quantity': number | null;
    /**
     * 
     * @type {number}
     * @memberof ResizeContextAddonDto
     */
    'quantity_step': number;
    /**
     * Quantity is derived from the target offering vCPU count, not chosen by the customer, and rate_micro_cents_per_hour is the price PER vCPU. Render as on/off priced at rate × vCPU — never a stepper.
     * @type {boolean}
     * @memberof ResizeContextAddonDto
     */
    'quantity_follows_vcpu': boolean;
    /**
     * Live quantity configured on this instance (0 = not present). When removable_after_purchase is false the customer may only raise this, never lower it.
     * @type {number}
     * @memberof ResizeContextAddonDto
     */
    'current_quantity': number;
    /**
     * Hourly rate for the subscription term, micro-cents.
     * @type {string}
     * @memberof ResizeContextAddonDto
     */
    'rate_micro_cents_per_hour': string;
}
/**
 * 
 * @export
 * @interface ResizeContextDiskDto
 */
export interface ResizeContextDiskDto {
    /**
     * 
     * @type {number}
     * @memberof ResizeContextDiskDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ResizeContextDiskDto
     */
    'label': string;
}
/**
 * 
 * @export
 * @interface ResizeContextDto
 */
export interface ResizeContextDto {
    /**
     * 
     * @type {number}
     * @memberof ResizeContextDto
     */
    'vm_id': number;
    /**
     * 
     * @type {string}
     * @memberof ResizeContextDto
     */
    'vm_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof ResizeContextDto
     */
    'subscription_id': string;
    /**
     * 
     * @type {string}
     * @memberof ResizeContextDto
     */
    'commitment_type': string;
    /**
     * 
     * @type {string}
     * @memberof ResizeContextDto
     */
    'term_kind': string | null;
    /**
     * 
     * @type {string}
     * @memberof ResizeContextDto
     */
    'current_cycle_ends_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof ResizeContextDto
     */
    'offering_kind': string;
    /**
     * What this offering kind lets the customer change. A false flag means the wizard must not render that section: the corresponding lists come back empty and the API rejects any change to that dimension.
     * @type {ResizeCapabilitiesDto}
     * @memberof ResizeContextDto
     */
    'capabilities': ResizeCapabilitiesDto;
    /**
     * 
     * @type {string}
     * @memberof ResizeContextDto
     */
    'current_offering_code': string;
    /**
     * True when the instance\'s plan is no longer sold — every migrated service sits on a hidden `legacy-*` placeholder, and a retired plan keeps its customers. It stays available as a target (keeping it is what preserves the contracted price), but it is NOT a plan anyone can pick, so the wizard must present it as the current configuration rather than as one option among the plans on sale.
     * @type {boolean}
     * @memberof ResizeContextDto
     */
    'current_offering_is_purchasable': boolean;
    /**
     * True when the instance\'s real shape was never recorded: it sits on a placeholder plan with no per-VM override, so `current_vcpu` / `current_ram_mb` / `current_main_disk_total_gb` are the PLACEHOLDER\'s numbers, not the machine\'s. Show them as unknown rather than as fact — they will not match what the customer sees inside their server. The resize is refused while this is true.
     * @type {boolean}
     * @memberof ResizeContextDto
     */
    'current_specs_are_unknown': boolean;
    /**
     * 
     * @type {string}
     * @memberof ResizeContextDto
     */
    'current_rate_micro_cents_per_hour': string;
    /**
     * Global minimum recharge for this subscription in BRL cents (0 = no minimum).
     * @type {string}
     * @memberof ResizeContextDto
     */
    'min_recharge_cents': string;
    /**
     * Current effective MAIN disk total in GB (offering base or per-VM override). The main disk can never shrink: for any target plan the minimum expansion is max(0, this − target base).
     * @type {number}
     * @memberof ResizeContextDto
     */
    'current_main_disk_total_gb': number;
    /**
     * Current effective vCPU (per-VM override or plan). Migrated instances sit on a placeholder plan whose own specs are meaningless — display these.
     * @type {number}
     * @memberof ResizeContextDto
     */
    'current_vcpu': number;
    /**
     * Current effective RAM in MB (per-VM override or plan).
     * @type {number}
     * @memberof ResizeContextDto
     */
    'current_ram_mb': number;
    /**
     * True when the instance\'s contracted hourly rate is not what the current price list would quote for this exact configuration (migrated service, or contracted before a price change). Show the contracted rate on the current plan row, and expect a plan change to re-quote at the list.
     * @type {boolean}
     * @memberof ResizeContextDto
     */
    'current_rate_is_grandfathered': boolean;
    /**
     * 
     * @type {number}
     * @memberof ResizeContextDto
     */
    'current_extra_ipv4_count': number;
    /**
     * 
     * @type {number}
     * @memberof ResizeContextDto
     */
    'current_extra_ipv6_count': number;
    /**
     * Whether at least one IPv4 can be added on this instance host. Inventory counts are never exposed.
     * @type {boolean}
     * @memberof ResizeContextDto
     */
    'can_add_ipv4': boolean;
    /**
     * Whether at least one IPv6 can be added on this instance host. Inventory counts are never exposed.
     * @type {boolean}
     * @memberof ResizeContextDto
     */
    'can_add_ipv6': boolean;
    /**
     * Hard ceiling of IPv4 addresses per instance (product limit).
     * @type {number}
     * @memberof ResizeContextDto
     */
    'max_ipv4_per_instance': number;
    /**
     * Hard ceiling of IPv6 addresses per instance (product limit).
     * @type {number}
     * @memberof ResizeContextDto
     */
    'max_ipv6_per_instance': number;
    /**
     * 
     * @type {Array<ResizeContextIpDto>}
     * @memberof ResizeContextDto
     */
    'ip_assignments': Array<ResizeContextIpDto>;
    /**
     * 
     * @type {Array<ResizeContextDiskDto>}
     * @memberof ResizeContextDto
     */
    'extra_disks': Array<ResizeContextDiskDto>;
    /**
     * 
     * @type {Array<ResizeContextOfferingDto>}
     * @memberof ResizeContextDto
     */
    'available_offerings': Array<ResizeContextOfferingDto>;
    /**
     * 
     * @type {Array<ResizeContextAddonDto>}
     * @memberof ResizeContextDto
     */
    'addons': Array<ResizeContextAddonDto>;
    /**
     * 
     * @type {ResizeBalanceDto}
     * @memberof ResizeContextDto
     */
    'balance': ResizeBalanceDto;
}
/**
 * 
 * @export
 * @interface ResizeContextIpDto
 */
export interface ResizeContextIpDto {
    /**
     * 
     * @type {string}
     * @memberof ResizeContextIpDto
     */
    'assignment_id': string;
    /**
     * 
     * @type {string}
     * @memberof ResizeContextIpDto
     */
    'ip_version': string;
    /**
     * 
     * @type {string}
     * @memberof ResizeContextIpDto
     */
    'address': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResizeContextIpDto
     */
    'primary': boolean;
}
/**
 * 
 * @export
 * @interface ResizeContextOfferingDto
 */
export interface ResizeContextOfferingDto {
    /**
     * 
     * @type {string}
     * @memberof ResizeContextOfferingDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ResizeContextOfferingDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ResizeContextOfferingDto
     */
    'offering_kind': string;
    /**
     * 
     * @type {number}
     * @memberof ResizeContextOfferingDto
     */
    'vcpu': number;
    /**
     * 
     * @type {number}
     * @memberof ResizeContextOfferingDto
     */
    'ram_mb': number;
    /**
     * 
     * @type {number}
     * @memberof ResizeContextOfferingDto
     */
    'main_disk_base_gb': number;
    /**
     * 
     * @type {number}
     * @memberof ResizeContextOfferingDto
     */
    'included_ipv4_per_vm': number;
    /**
     * 
     * @type {number}
     * @memberof ResizeContextOfferingDto
     */
    'included_ipv6_per_vm': number;
    /**
     * Hourly rate for the subscription term, micro-cents.
     * @type {string}
     * @memberof ResizeContextOfferingDto
     */
    'rate_micro_cents_per_hour': string;
    /**
     * Whether this is the instance current offering.
     * @type {boolean}
     * @memberof ResizeContextOfferingDto
     */
    'is_current': boolean;
    /**
     * True for a plan that is off sale and only listed because the instance runs on it (migrated services). Its rate is a catalog placeholder — show the contracted rate instead.
     * @type {boolean}
     * @memberof ResizeContextOfferingDto
     */
    'rate_is_placeholder': boolean;
}
/**
 * 
 * @export
 * @interface ResizeExtraDiskDto
 */
export interface ResizeExtraDiskDto {
    /**
     * Disk size in GB (multiple of the disk addon step)
     * @type {number}
     * @memberof ResizeExtraDiskDto
     */
    'size_gb': number;
}
/**
 * 
 * @export
 * @interface ResizeFlagViolationDto
 */
export interface ResizeFlagViolationDto {
    /**
     * What the violation is about: the check itself, or the catalog code of the addon it concerns. Not a translation key — two refusals about one addon share it.
     * @type {string}
     * @memberof ResizeFlagViolationDto
     */
    'code': string;
    /**
     * English prose — the fallback for `message_code`.
     * @type {string}
     * @memberof ResizeFlagViolationDto
     */
    'reason': string;
    /**
     * Stable identifier the console localizes on.
     * @type {string}
     * @memberof ResizeFlagViolationDto
     */
    'message_code': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ResizeFlagViolationDto
     */
    'params': { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface ResizeImpactDto
 */
export interface ResizeImpactDto {
    /**
     * 
     * @type {number}
     * @memberof ResizeImpactDto
     */
    'hours_until_renewal': number;
    /**
     * 
     * @type {string}
     * @memberof ResizeImpactDto
     */
    'gross_impact_micro_cents': string;
    /**
     * 
     * @type {string}
     * @memberof ResizeImpactDto
     */
    'applied_temporary_micro_cents': string;
    /**
     * 
     * @type {string}
     * @memberof ResizeImpactDto
     */
    'net_impact_micro_cents': string;
    /**
     * 
     * @type {string}
     * @memberof ResizeImpactDto
     */
    'required_recharge_micro_cents': string;
    /**
     * 
     * @type {boolean}
     * @memberof ResizeImpactDto
     */
    'can_proceed_now': boolean;
}
/**
 * 
 * @export
 * @interface ResizeLineItemDto
 */
export interface ResizeLineItemDto {
    /**
     * 
     * @type {string}
     * @memberof ResizeLineItemDto
     */
    'kind': string;
    /**
     * 
     * @type {string}
     * @memberof ResizeLineItemDto
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof ResizeLineItemDto
     */
    'rate_micro_cents_per_hour': string;
    /**
     * 
     * @type {number}
     * @memberof ResizeLineItemDto
     */
    'quantity': number;
    /**
     * 
     * @type {string}
     * @memberof ResizeLineItemDto
     */
    'hourly_subtotal_micro_cents': string;
}
/**
 * 
 * @export
 * @interface ResizeMessageDto
 */
export interface ResizeMessageDto {
    /**
     * Stable identifier the console localizes on. A code with no translation renders `message`.
     * @type {string}
     * @memberof ResizeMessageDto
     */
    'code': string;
    /**
     * Values the sentence interpolates, so a translation can reorder them.
     * @type {{ [key: string]: any; }}
     * @memberof ResizeMessageDto
     */
    'params': { [key: string]: any; } | null;
    /**
     * English prose — the fallback, always a complete sentence.
     * @type {string}
     * @memberof ResizeMessageDto
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface ResizePlannedChangesDto
 */
export interface ResizePlannedChangesDto {
    /**
     * True when this resize includes hardware changes: the async job will forcefully power the instance off, apply them and power it back on.
     * @type {boolean}
     * @memberof ResizePlannedChangesDto
     */
    'requires_shutdown': boolean;
    /**
     * GB the MAIN disk will grow. The guest partition/filesystem must be expanded manually afterwards.
     * @type {number}
     * @memberof ResizePlannedChangesDto
     */
    'main_disk_grow_gb': number;
    /**
     * 
     * @type {number}
     * @memberof ResizePlannedChangesDto
     */
    'disks_added': number;
    /**
     * 
     * @type {number}
     * @memberof ResizePlannedChangesDto
     */
    'disks_removed': number;
    /**
     * 
     * @type {number}
     * @memberof ResizePlannedChangesDto
     */
    'ipv4_added': number;
    /**
     * 
     * @type {number}
     * @memberof ResizePlannedChangesDto
     */
    'ipv4_removed': number;
    /**
     * 
     * @type {number}
     * @memberof ResizePlannedChangesDto
     */
    'ipv6_added': number;
    /**
     * 
     * @type {number}
     * @memberof ResizePlannedChangesDto
     */
    'ipv6_removed': number;
    /**
     * Whether a reboot (or DHCP lease renew) is required for the guest to pick up a changed MAIN IPv4 (only when no power cycle happens — a power cycle re-DHCPs on its own).
     * @type {boolean}
     * @memberof ResizePlannedChangesDto
     */
    'reboot_required': boolean;
}
/**
 * 
 * @export
 * @interface ResizeQuoteDto
 */
export interface ResizeQuoteDto {
    /**
     * 
     * @type {string}
     * @memberof ResizeQuoteDto
     */
    'commitment_type': string;
    /**
     * 
     * @type {string}
     * @memberof ResizeQuoteDto
     */
    'current_rate_micro_cents_per_hour': string;
    /**
     * 
     * @type {string}
     * @memberof ResizeQuoteDto
     */
    'target_rate_micro_cents_per_hour': string;
    /**
     * 
     * @type {string}
     * @memberof ResizeQuoteDto
     */
    'delta_rate_micro_cents_per_hour': string;
    /**
     * 
     * @type {string}
     * @memberof ResizeQuoteDto
     */
    'target_cycle_micro_cents': string | null;
    /**
     * 
     * @type {Array<ResizeLineItemDto>}
     * @memberof ResizeQuoteDto
     */
    'target_line_items': Array<ResizeLineItemDto>;
    /**
     * 
     * @type {ResizeImpactDto}
     * @memberof ResizeQuoteDto
     */
    'impact': ResizeImpactDto;
    /**
     * Estimated balance_temporary that a committed downgrade would generate (0 for upgrades / on-demand).
     * @type {string}
     * @memberof ResizeQuoteDto
     */
    'temporary_credit_on_downgrade_micro_cents': string;
    /**
     * 
     * @type {Array<ResizeRemovedItemDto>}
     * @memberof ResizeQuoteDto
     */
    'removed_items': Array<ResizeRemovedItemDto>;
    /**
     * Address of the IPv4 that will be the main (primary) one after the resize. Null when the main IP will be a newly allocated address.
     * @type {string}
     * @memberof ResizeQuoteDto
     */
    'resulting_main_ipv4_address': string | null;
    /**
     * 
     * @type {Array<ResizeFlagViolationDto>}
     * @memberof ResizeQuoteDto
     */
    'flag_violations': Array<ResizeFlagViolationDto>;
    /**
     * 
     * @type {Array<ResizeMessageDto>}
     * @memberof ResizeQuoteDto
     */
    'warnings': Array<ResizeMessageDto>;
    /**
     * True when the resize can be applied with current balance.
     * @type {boolean}
     * @memberof ResizeQuoteDto
     */
    'funds_ok': boolean;
    /**
     * Shortfall in BRL cents that must be topped up before applying (committed only).
     * @type {string}
     * @memberof ResizeQuoteDto
     */
    'required_topup_cents': string | null;
    /**
     * False when the target is identical to the current configuration — apply would be rejected, the wizard must keep the button disabled.
     * @type {boolean}
     * @memberof ResizeQuoteDto
     */
    'has_changes': boolean;
    /**
     * True when the resize includes hardware changes (CPU/RAM/disk) that require the instance to be powered off: apply will shut it down and start it again automatically.
     * @type {boolean}
     * @memberof ResizeQuoteDto
     */
    'requires_shutdown': boolean;
}
/**
 * 
 * @export
 * @interface ResizeRemovedItemDto
 */
export interface ResizeRemovedItemDto {
    /**
     * One of \'ipv4\' | \'ipv6\' | \'extra_disk\'.
     * @type {string}
     * @memberof ResizeRemovedItemDto
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof ResizeRemovedItemDto
     */
    'label': string;
    /**
     * English prose — the fallback for `warning_code`.
     * @type {string}
     * @memberof ResizeRemovedItemDto
     */
    'warning': string;
    /**
     * Stable identifier the console localizes on.
     * @type {string}
     * @memberof ResizeRemovedItemDto
     */
    'warning_code': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ResizeRemovedItemDto
     */
    'params': { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface ResizeTargetDto
 */
export interface ResizeTargetDto {
    /**
     * Target offering (plan) code. Must be a visible offering of the same offering_kind as the current instance.
     * @type {string}
     * @memberof ResizeTargetDto
     */
    'offering_code': string;
    /**
     * Additional GB on the MAIN disk beyond the offering base (multiple of the disk addon step). Main disk can only grow, never shrink.
     * @type {number}
     * @memberof ResizeTargetDto
     */
    'main_disk_extra_gb'?: number;
    /**
     * Desired full set of EXTRA data disks. OMIT the field to keep the current disks unchanged; when an array is sent (even an empty one) it is the full desired set — disks present today but absent from it are removed (data loss).
     * @type {Array<ResizeExtraDiskDto>}
     * @memberof ResizeTargetDto
     */
    'extra_disks'?: Array<ResizeExtraDiskDto>;
    /**
     * Number of NEW IPv4 addresses to allocate.
     * @type {number}
     * @memberof ResizeTargetDto
     */
    'ipv4_add_count'?: number;
    /**
     * Assignment ids of existing IPv4 addresses to release (remove).
     * @type {Array<string>}
     * @memberof ResizeTargetDto
     */
    'ipv4_remove_assignment_ids'?: Array<string>;
    /**
     * Assignment id of the IPv4 that must become the MAIN (primary) address. Exactly one IPv4 is always the main one; its address is what the instance gets by default. Must be a kept (not removed) IPv4.
     * @type {string}
     * @memberof ResizeTargetDto
     */
    'ipv4_primary_assignment_id'?: string;
    /**
     * Number of NEW IPv6 addresses to allocate.
     * @type {number}
     * @memberof ResizeTargetDto
     */
    'ipv6_add_count'?: number;
    /**
     * Assignment ids of existing IPv6 addresses to release (remove).
     * @type {Array<string>}
     * @memberof ResizeTargetDto
     */
    'ipv6_remove_assignment_ids'?: Array<string>;
    /**
     * Other addons (snapshot/backup slots, licenses, etc.) with desired quantities.
     * @type {Array<ResizeAddonDto>}
     * @memberof ResizeTargetDto
     */
    'addons'?: Array<ResizeAddonDto>;
}
/**
 * 
 * @export
 * @interface ResourceUsageDto
 */
export interface ResourceUsageDto {
    /**
     * 
     * @type {string}
     * @memberof ResourceUsageDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ResourceUsageDto
     */
    'resource_type': ResourceUsageDtoResourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ResourceUsageDto
     */
    'label'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResourceUsageDto
     */
    'resource_external_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResourceUsageDto
     */
    'commitment_pool': ResourceUsageDtoCommitmentPoolEnum;
    /**
     * 
     * @type {number}
     * @memberof ResourceUsageDto
     */
    'quantity': number;
    /**
     * 
     * @type {string}
     * @memberof ResourceUsageDto
     */
    'rate_micro_cents_per_hour': string;
    /**
     * 
     * @type {number}
     * @memberof ResourceUsageDto
     */
    'billed_seconds_in_cycle': number;
    /**
     * 
     * @type {string}
     * @memberof ResourceUsageDto
     */
    'consumed_this_cycle_micro_cents': string;
    /**
     * 
     * @type {string}
     * @memberof ResourceUsageDto
     */
    'commitment_cap_micro_cents'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResourceUsageDto
     */
    'cap_reached': boolean;
    /**
     * 
     * @type {string}
     * @memberof ResourceUsageDto
     */
    'started_at': string;
}

export const ResourceUsageDtoResourceTypeEnum = {
    Vm: 'VM',
    DiskMain: 'DISK_MAIN',
    DiskExtra: 'DISK_EXTRA',
    ExtraIpv4: 'EXTRA_IPV4',
    ExtraIpv6: 'EXTRA_IPV6',
    WindowsLicense: 'WINDOWS_LICENSE',
    Cal: 'CAL',
    SnapshotSlot: 'SNAPSHOT_SLOT',
    BackupSlot: 'BACKUP_SLOT',
    VpnGateway: 'VPN_GATEWAY'
} as const;

export type ResourceUsageDtoResourceTypeEnum = typeof ResourceUsageDtoResourceTypeEnum[keyof typeof ResourceUsageDtoResourceTypeEnum];
export const ResourceUsageDtoCommitmentPoolEnum = {
    Committed: 'COMMITTED',
    Flexible: 'FLEXIBLE'
} as const;

export type ResourceUsageDtoCommitmentPoolEnum = typeof ResourceUsageDtoCommitmentPoolEnum[keyof typeof ResourceUsageDtoCommitmentPoolEnum];

/**
 * 
 * @export
 * @interface RestoreBackupResponseDto
 */
export interface RestoreBackupResponseDto {
    /**
     * Success message
     * @type {string}
     * @memberof RestoreBackupResponseDto
     */
    'message': string;
    /**
     * Opaque handle for the restore task. Progress arrives over the websocket; the hypervisor task id is never returned.
     * @type {string}
     * @memberof RestoreBackupResponseDto
     */
    'taskId': string;
    /**
     * VM ID
     * @type {number}
     * @memberof RestoreBackupResponseDto
     */
    'vmId': number;
    /**
     * Backup ID used for restoration
     * @type {number}
     * @memberof RestoreBackupResponseDto
     */
    'backupId': number;
}
/**
 * 
 * @export
 * @interface RestoreSnapshotDto
 */
export interface RestoreSnapshotDto {
    /**
     * Name of the snapshot to restore
     * @type {string}
     * @memberof RestoreSnapshotDto
     */
    'snapshot_name': string;
}
/**
 * 
 * @export
 * @interface ResumeTicketDto
 */
export interface ResumeTicketDto {
    /**
     * 
     * @type {string}
     * @memberof ResumeTicketDto
     */
    'image_id': string;
    /**
     * 
     * @type {number}
     * @memberof ResumeTicketDto
     */
    'part_bytes': number;
    /**
     * 
     * @type {number}
     * @memberof ResumeTicketDto
     */
    'part_count': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof ResumeTicketDto
     */
    'missing_parts': Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResumeTicketDto
     */
    'part_urls': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ResumeTicketDto
     */
    'uploaded_bytes': number;
}
/**
 * 
 * @export
 * @interface RuleActionDto
 */
export interface RuleActionDto {
    /**
     * 
     * @type {string}
     * @memberof RuleActionDto
     */
    'kind': string;
    /**
     * 
     * @type {string}
     * @memberof RuleActionDto
     */
    'label': string;
    /**
     * Console path that takes the customer to the fix.
     * @type {string}
     * @memberof RuleActionDto
     */
    'href': string;
}
/**
 * 
 * @export
 * @interface RuleReferenceDto
 */
export interface RuleReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof RuleReferenceDto
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof RuleReferenceDto
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface ScheduledPlanChangeDto
 */
export interface ScheduledPlanChangeDto {
    /**
     * The cycle end the change takes effect at.
     * @type {string}
     * @memberof ScheduledPlanChangeDto
     */
    'effective_at': string;
    /**
     * 
     * @type {string}
     * @memberof ScheduledPlanChangeDto
     */
    'new_commitment_type': ScheduledPlanChangeDtoNewCommitmentTypeEnum;
    /**
     * The term the subscription bills at from that date.
     * @type {string}
     * @memberof ScheduledPlanChangeDto
     */
    'new_term_kind': string;
}

export const ScheduledPlanChangeDtoNewCommitmentTypeEnum = {
    Committed: 'COMMITTED',
    OnDemand: 'ON_DEMAND'
} as const;

export type ScheduledPlanChangeDtoNewCommitmentTypeEnum = typeof ScheduledPlanChangeDtoNewCommitmentTypeEnum[keyof typeof ScheduledPlanChangeDtoNewCommitmentTypeEnum];

/**
 * 
 * @export
 * @interface SecurityDiscoveredServiceDto
 */
export interface SecurityDiscoveredServiceDto {
    /**
     * 
     * @type {string}
     * @memberof SecurityDiscoveredServiceDto
     */
    'ip_address': string;
    /**
     * 
     * @type {string}
     * @memberof SecurityDiscoveredServiceDto
     */
    'protocol': string;
    /**
     * 
     * @type {number}
     * @memberof SecurityDiscoveredServiceDto
     */
    'port': number;
    /**
     * open, or open|filtered when the probe got no answer at all — the latter is not evidence of exposure.
     * @type {string}
     * @memberof SecurityDiscoveredServiceDto
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof SecurityDiscoveredServiceDto
     */
    'service_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityDiscoveredServiceDto
     */
    'product': string | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityDiscoveredServiceDto
     */
    'version': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SecurityDiscoveredServiceDto
     */
    'tls': boolean;
    /**
     * Cross-reference against the instance firewall: no_firewall | open_to_world | scoped | drift | blocked.
     * @type {string}
     * @memberof SecurityDiscoveredServiceDto
     */
    'firewall_verdict': string | null;
}
/**
 * 
 * @export
 * @interface SecurityEngineScoreDto
 */
export interface SecurityEngineScoreDto {
    /**
     * 
     * @type {string}
     * @memberof SecurityEngineScoreDto
     */
    'engine': SecurityEngineScoreDtoEngineEnum;
    /**
     * Null when this engine has never completed for the scope — never 100. An engine that has not run finds nothing, which would otherwise read as clean.
     * @type {number}
     * @memberof SecurityEngineScoreDto
     */
    'score': number | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityEngineScoreDto
     */
    'grade': string | null;
    /**
     * When THIS engine last completed. Engines run on different cadences — exposure weekly, CVEs monthly — so a single scan date would misstate how current half the score is.
     * @type {string}
     * @memberof SecurityEngineScoreDto
     */
    'last_scan_at': string | null;
    /**
     * 
     * @type {number}
     * @memberof SecurityEngineScoreDto
     */
    'findings': number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof SecurityEngineScoreDto
     */
    'counts': { [key: string]: number; };
}

export const SecurityEngineScoreDtoEngineEnum = {
    Nmap: 'nmap',
    Sslyze: 'sslyze',
    Nuclei: 'nuclei',
    Openvas: 'openvas'
} as const;

export type SecurityEngineScoreDtoEngineEnum = typeof SecurityEngineScoreDtoEngineEnum[keyof typeof SecurityEngineScoreDtoEngineEnum];

/**
 * 
 * @export
 * @interface SecurityExceptionCreatedDto
 */
export interface SecurityExceptionCreatedDto {
    /**
     * 
     * @type {SecurityExceptionDto}
     * @memberof SecurityExceptionCreatedDto
     */
    'exception': SecurityExceptionDto;
    /**
     * Ceiling that applied, in days. The requested expiry is clamped to it rather than rejected.
     * @type {number}
     * @memberof SecurityExceptionCreatedDto
     */
    'applied_max_days': number;
}
/**
 * 
 * @export
 * @interface SecurityExceptionDto
 */
export interface SecurityExceptionDto {
    /**
     * 
     * @type {string}
     * @memberof SecurityExceptionDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SecurityExceptionDto
     */
    'scope': string;
    /**
     * 
     * @type {number}
     * @memberof SecurityExceptionDto
     */
    'vm_id': number | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityExceptionDto
     */
    'rule_id': string | null;
    /**
     * 
     * @type {number}
     * @memberof SecurityExceptionDto
     */
    'port': number | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityExceptionDto
     */
    'protocol': string | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityExceptionDto
     */
    'justification': string;
    /**
     * `active` while it is silencing findings, then `expired` or `revoked`. Acceptance is immediate at every severity, so a new exception is always created `active`; `pending_review` and `rejected` appear only on rows predating the retired approval step.
     * @type {string}
     * @memberof SecurityExceptionDto
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof SecurityExceptionDto
     */
    'starts_at': string;
    /**
     * 
     * @type {string}
     * @memberof SecurityExceptionDto
     */
    'expires_at': string;
    /**
     * 
     * @type {string}
     * @memberof SecurityExceptionDto
     */
    'reviewed_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityExceptionDto
     */
    'review_note': string | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityExceptionDto
     */
    'revoked_at': string | null;
}
/**
 * 
 * @export
 * @interface SecurityExceptionListDto
 */
export interface SecurityExceptionListDto {
    /**
     * 
     * @type {Array<SecurityExceptionDto>}
     * @memberof SecurityExceptionListDto
     */
    'rows': Array<SecurityExceptionDto>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SecurityExceptionScope = {
    Finding: 'finding',
    Rule: 'rule',
    Port: 'port'
} as const;

export type SecurityExceptionScope = typeof SecurityExceptionScope[keyof typeof SecurityExceptionScope];


/**
 * 
 * @export
 * @enum {string}
 */

export const SecurityFindingCategory = {
    ExposedService: 'EXPOSED_SERVICE',
    AmplificationVector: 'AMPLIFICATION_VECTOR',
    VulnerableSoftware: 'VULNERABLE_SOFTWARE',
    WeakEncryption: 'WEAK_ENCRYPTION',
    Certificate: 'CERTIFICATE',
    Misconfiguration: 'MISCONFIGURATION',
    InformationDisclosure: 'INFORMATION_DISCLOSURE',
    DefaultCredentials: 'DEFAULT_CREDENTIALS',
    AccessControl: 'ACCESS_CONTROL',
    NetworkPolicy: 'NETWORK_POLICY'
} as const;

export type SecurityFindingCategory = typeof SecurityFindingCategory[keyof typeof SecurityFindingCategory];


/**
 * 
 * @export
 * @interface SecurityFindingDetailDto
 */
export interface SecurityFindingDetailDto {
    /**
     * 
     * @type {string}
     * @memberof SecurityFindingDetailDto
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof SecurityFindingDetailDto
     */
    'vm_id': number;
    /**
     * Instance name, so a list spanning many instances can say WHICH one. Null only when the instance has no name; fall back to the id then.
     * @type {string}
     * @memberof SecurityFindingDetailDto
     */
    'vm_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityFindingDetailDto
     */
    'rule_id': string;
    /**
     * 
     * @type {SecurityFindingCategory}
     * @memberof SecurityFindingDetailDto
     */
    'category': SecurityFindingCategory;
    /**
     * 
     * @type {SecuritySeverity}
     * @memberof SecurityFindingDetailDto
     */
    'severity': SecuritySeverity;
    /**
     * 
     * @type {SecurityFindingStatus}
     * @memberof SecurityFindingDetailDto
     */
    'status': SecurityFindingStatus;
    /**
     * Prioritization score 0-1000. Sort by this, not by severity: it folds in reachability, known exploitation and instance context.
     * @type {number}
     * @memberof SecurityFindingDetailDto
     */
    'risk_score': number;
    /**
     * 
     * @type {string}
     * @memberof SecurityFindingDetailDto
     */
    'ip_address': string | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityFindingDetailDto
     */
    'protocol': string | null;
    /**
     * 
     * @type {number}
     * @memberof SecurityFindingDetailDto
     */
    'port': number | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityFindingDetailDto
     */
    'service_name': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SecurityFindingDetailDto
     */
    'cve_ids': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof SecurityFindingDetailDto
     */
    'cvss_score': number | null;
    /**
     * 
     * @type {number}
     * @memberof SecurityFindingDetailDto
     */
    'epss_score': number | null;
    /**
     * Listed in the CISA Known Exploited Vulnerabilities catalog.
     * @type {boolean}
     * @memberof SecurityFindingDetailDto
     */
    'kev': boolean;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof SecurityFindingDetailDto
     */
    'evidence': { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof SecurityFindingDetailDto
     */
    'first_seen_at': string;
    /**
     * 
     * @type {string}
     * @memberof SecurityFindingDetailDto
     */
    'last_seen_at': string;
    /**
     * Last scan in which the engine that owns this rule completed. Render this rather than implying continuous monitoring.
     * @type {string}
     * @memberof SecurityFindingDetailDto
     */
    'last_verified_at': string;
    /**
     * 
     * @type {string}
     * @memberof SecurityFindingDetailDto
     */
    'resolved_at': string | null;
    /**
     * 
     * @type {number}
     * @memberof SecurityFindingDetailDto
     */
    'occurrence_count': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof SecurityFindingDetailDto
     */
    'engines': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SecurityFindingDetailDto
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof SecurityFindingDetailDto
     */
    'description': string;
    /**
     * Why this matters, in the customer\'s language.
     * @type {string}
     * @memberof SecurityFindingDetailDto
     */
    'impact': string;
    /**
     * What to actually do about it.
     * @type {string}
     * @memberof SecurityFindingDetailDto
     */
    'recommendation': string;
    /**
     * 
     * @type {Array<RuleReferenceDto>}
     * @memberof SecurityFindingDetailDto
     */
    'references': Array<RuleReferenceDto>;
    /**
     * 
     * @type {Array<RuleActionDto>}
     * @memberof SecurityFindingDetailDto
     */
    'actions': Array<RuleActionDto>;
    /**
     * Where description/impact/recommendation came from. \"catalog\" is our own rule, written and translated by us. \"engine\" means at least one block is the scan engine\'s own wording, verbatim and IN ENGLISH — label it in the UI rather than presenting it as ours. \"category\" is the generic advice for the category, translated, used when neither had anything specific.
     * @type {SecurityRuleTextSource}
     * @memberof SecurityFindingDetailDto
     */
    'text_source': SecurityRuleTextSource;
    /**
     * 
     * @type {Array<SecurityFindingEventDto>}
     * @memberof SecurityFindingDetailDto
     */
    'events': Array<SecurityFindingEventDto>;
}


/**
 * 
 * @export
 * @interface SecurityFindingDto
 */
export interface SecurityFindingDto {
    /**
     * 
     * @type {string}
     * @memberof SecurityFindingDto
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof SecurityFindingDto
     */
    'vm_id': number;
    /**
     * Instance name, so a list spanning many instances can say WHICH one. Null only when the instance has no name; fall back to the id then.
     * @type {string}
     * @memberof SecurityFindingDto
     */
    'vm_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityFindingDto
     */
    'rule_id': string;
    /**
     * 
     * @type {SecurityFindingCategory}
     * @memberof SecurityFindingDto
     */
    'category': SecurityFindingCategory;
    /**
     * 
     * @type {SecuritySeverity}
     * @memberof SecurityFindingDto
     */
    'severity': SecuritySeverity;
    /**
     * 
     * @type {SecurityFindingStatus}
     * @memberof SecurityFindingDto
     */
    'status': SecurityFindingStatus;
    /**
     * Prioritization score 0-1000. Sort by this, not by severity: it folds in reachability, known exploitation and instance context.
     * @type {number}
     * @memberof SecurityFindingDto
     */
    'risk_score': number;
    /**
     * 
     * @type {string}
     * @memberof SecurityFindingDto
     */
    'ip_address': string | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityFindingDto
     */
    'protocol': string | null;
    /**
     * 
     * @type {number}
     * @memberof SecurityFindingDto
     */
    'port': number | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityFindingDto
     */
    'service_name': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SecurityFindingDto
     */
    'cve_ids': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof SecurityFindingDto
     */
    'cvss_score': number | null;
    /**
     * 
     * @type {number}
     * @memberof SecurityFindingDto
     */
    'epss_score': number | null;
    /**
     * Listed in the CISA Known Exploited Vulnerabilities catalog.
     * @type {boolean}
     * @memberof SecurityFindingDto
     */
    'kev': boolean;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof SecurityFindingDto
     */
    'evidence': { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof SecurityFindingDto
     */
    'first_seen_at': string;
    /**
     * 
     * @type {string}
     * @memberof SecurityFindingDto
     */
    'last_seen_at': string;
    /**
     * Last scan in which the engine that owns this rule completed. Render this rather than implying continuous monitoring.
     * @type {string}
     * @memberof SecurityFindingDto
     */
    'last_verified_at': string;
    /**
     * 
     * @type {string}
     * @memberof SecurityFindingDto
     */
    'resolved_at': string | null;
    /**
     * 
     * @type {number}
     * @memberof SecurityFindingDto
     */
    'occurrence_count': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof SecurityFindingDto
     */
    'engines': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SecurityFindingDto
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof SecurityFindingDto
     */
    'description': string;
    /**
     * Why this matters, in the customer\'s language.
     * @type {string}
     * @memberof SecurityFindingDto
     */
    'impact': string;
    /**
     * What to actually do about it.
     * @type {string}
     * @memberof SecurityFindingDto
     */
    'recommendation': string;
    /**
     * 
     * @type {Array<RuleReferenceDto>}
     * @memberof SecurityFindingDto
     */
    'references': Array<RuleReferenceDto>;
    /**
     * 
     * @type {Array<RuleActionDto>}
     * @memberof SecurityFindingDto
     */
    'actions': Array<RuleActionDto>;
    /**
     * Where description/impact/recommendation came from. \"catalog\" is our own rule, written and translated by us. \"engine\" means at least one block is the scan engine\'s own wording, verbatim and IN ENGLISH — label it in the UI rather than presenting it as ours. \"category\" is the generic advice for the category, translated, used when neither had anything specific.
     * @type {SecurityRuleTextSource}
     * @memberof SecurityFindingDto
     */
    'text_source': SecurityRuleTextSource;
}


/**
 * 
 * @export
 * @interface SecurityFindingEventDto
 */
export interface SecurityFindingEventDto {
    /**
     * 
     * @type {string}
     * @memberof SecurityFindingEventDto
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof SecurityFindingEventDto
     */
    'from_severity': string | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityFindingEventDto
     */
    'to_severity': string | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityFindingEventDto
     */
    'note': string | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityFindingEventDto
     */
    'occurred_at': string;
}
/**
 * 
 * @export
 * @interface SecurityFindingListDto
 */
export interface SecurityFindingListDto {
    /**
     * 
     * @type {Array<SecurityFindingDto>}
     * @memberof SecurityFindingListDto
     */
    'rows': Array<SecurityFindingDto>;
    /**
     * 
     * @type {number}
     * @memberof SecurityFindingListDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof SecurityFindingListDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof SecurityFindingListDto
     */
    'page_size': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SecurityFindingStatus = {
    Open: 'open',
    Resolved: 'resolved',
    Excepted: 'excepted',
    FalsePositive: 'false_positive'
} as const;

export type SecurityFindingStatus = typeof SecurityFindingStatus[keyof typeof SecurityFindingStatus];


/**
 * 
 * @export
 * @interface SecurityOverviewDto
 */
export interface SecurityOverviewDto {
    /**
     * Average across instances that have actually been scanned. Null when none have — never 0 and never 100 for an unassessed account.
     * @type {number}
     * @memberof SecurityOverviewDto
     */
    'score': number | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityOverviewDto
     */
    'grade': string | null;
    /**
     * Most recent scan across the account. Null until something has been scanned — the score has no meaning without knowing how fresh it is.
     * @type {string}
     * @memberof SecurityOverviewDto
     */
    'last_scan_at': string | null;
    /**
     * The parts the headline score is made of, each with its own freshness.
     * @type {Array<SecurityEngineScoreDto>}
     * @memberof SecurityOverviewDto
     */
    'engines': Array<SecurityEngineScoreDto>;
    /**
     * 
     * @type {number}
     * @memberof SecurityOverviewDto
     */
    'instances_total': number;
    /**
     * 
     * @type {number}
     * @memberof SecurityOverviewDto
     */
    'instances_assessed': number;
    /**
     * 
     * @type {number}
     * @memberof SecurityOverviewDto
     */
    'instances_awaiting_first_scan': number;
    /**
     * 
     * @type {number}
     * @memberof SecurityOverviewDto
     */
    'instances_excluded': number;
    /**
     * 
     * @type {number}
     * @memberof SecurityOverviewDto
     */
    'instances_opted_out': number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof SecurityOverviewDto
     */
    'excluded_reasons': { [key: string]: number; };
    /**
     * 
     * @type {SeverityCountsDto}
     * @memberof SecurityOverviewDto
     */
    'counts': SeverityCountsDto;
    /**
     * 
     * @type {Array<WorstInstanceDto>}
     * @memberof SecurityOverviewDto
     */
    'worst_instances': Array<WorstInstanceDto>;
    /**
     * 
     * @type {boolean}
     * @memberof SecurityOverviewDto
     */
    'scanning_enabled_globally': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof SecurityOverviewDto
     */
    'known_exclusion_reasons': Array<string>;
}
/**
 * 
 * @export
 * @interface SecurityRuleGroupDto
 */
export interface SecurityRuleGroupDto {
    /**
     * 
     * @type {string}
     * @memberof SecurityRuleGroupDto
     */
    'rule_id': string;
    /**
     * 
     * @type {SecuritySeverity}
     * @memberof SecurityRuleGroupDto
     */
    'severity': SecuritySeverity;
    /**
     * 
     * @type {SecurityFindingCategory}
     * @memberof SecurityRuleGroupDto
     */
    'category': SecurityFindingCategory;
    /**
     * Localized rule title — the label for the whole group.
     * @type {string}
     * @memberof SecurityRuleGroupDto
     */
    'title': string;
    /**
     * What to do about it. One fix resolves every instance in the group.
     * @type {string}
     * @memberof SecurityRuleGroupDto
     */
    'recommendation': string;
    /**
     * See SecurityFindingDto.text_source. \"engine\" means the text is in English.
     * @type {SecurityRuleTextSource}
     * @memberof SecurityRuleGroupDto
     */
    'text_source': SecurityRuleTextSource;
    /**
     * How many instances this rule is open on.
     * @type {number}
     * @memberof SecurityRuleGroupDto
     */
    'instances': number;
    /**
     * Highest risk score in the group. The list sorts by this.
     * @type {number}
     * @memberof SecurityRuleGroupDto
     */
    'risk_score': number;
    /**
     * 
     * @type {string}
     * @memberof SecurityRuleGroupDto
     */
    'last_seen_at': string | null;
    /**
     * Up to six affected instance ids — enough to preview, not the full set.
     * @type {Array<number>}
     * @memberof SecurityRuleGroupDto
     */
    'sample_vm_ids': Array<number>;
}


/**
 * See SecurityFindingDto.text_source. \"engine\" means the text is in English.
 * @export
 * @enum {string}
 */

export const SecurityRuleTextSource = {
    Catalog: 'catalog',
    Engine: 'engine',
    Category: 'category'
} as const;

export type SecurityRuleTextSource = typeof SecurityRuleTextSource[keyof typeof SecurityRuleTextSource];


/**
 * 
 * @export
 * @interface SecurityScanDto
 */
export interface SecurityScanDto {
    /**
     * 
     * @type {string}
     * @memberof SecurityScanDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SecurityScanDto
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof SecurityScanDto
     */
    'trigger': string;
    /**
     * 
     * @type {string}
     * @memberof SecurityScanDto
     */
    'queued_at': string;
    /**
     * 
     * @type {string}
     * @memberof SecurityScanDto
     */
    'started_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityScanDto
     */
    'finished_at': string | null;
    /**
     * 
     * @type {number}
     * @memberof SecurityScanDto
     */
    'duration_ms': number | null;
    /**
     * 
     * @type {number}
     * @memberof SecurityScanDto
     */
    'score': number | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityScanDto
     */
    'grade': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SecurityScanDto
     */
    'engines_requested': Array<string>;
    /**
     * Engines that actually completed. A short list means the scan was partial and nothing its missing engines own was resolved.
     * @type {Array<string>}
     * @memberof SecurityScanDto
     */
    'engines_completed': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof SecurityScanDto
     */
    'findings_new': number;
    /**
     * 
     * @type {number}
     * @memberof SecurityScanDto
     */
    'findings_resolved': number;
    /**
     * 
     * @type {number}
     * @memberof SecurityScanDto
     */
    'findings_reopened': number;
    /**
     * Ports opened/closed since the previous scan. Null on a first scan or when discovery did not run.
     * @type {{ [key: string]: any; }}
     * @memberof SecurityScanDto
     */
    'surface_diff': { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityScanDto
     */
    'error_message': string | null;
    /**
     * Where the probes originated from.
     * @type {string}
     * @memberof SecurityScanDto
     */
    'vantage_point': string;
}
/**
 * 
 * @export
 * @interface SecurityScanListDto
 */
export interface SecurityScanListDto {
    /**
     * 
     * @type {Array<SecurityScanDto>}
     * @memberof SecurityScanListDto
     */
    'rows': Array<SecurityScanDto>;
}
/**
 * 
 * @export
 * @interface SecurityScanStartedDto
 */
export interface SecurityScanStartedDto {
    /**
     * 
     * @type {boolean}
     * @memberof SecurityScanStartedDto
     */
    'started': boolean;
    /**
     * 
     * @type {string}
     * @memberof SecurityScanStartedDto
     */
    'scan_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityScanStartedDto
     */
    'job_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityScanStartedDto
     */
    'reason': string | null;
}
/**
 * 
 * @export
 * @interface SecurityScoreHistoryDto
 */
export interface SecurityScoreHistoryDto {
    /**
     * 
     * @type {Array<SecurityScorePointDto>}
     * @memberof SecurityScoreHistoryDto
     */
    'points': Array<SecurityScorePointDto>;
}
/**
 * 
 * @export
 * @interface SecurityScorePointDto
 */
export interface SecurityScorePointDto {
    /**
     * 
     * @type {string}
     * @memberof SecurityScorePointDto
     */
    'captured_on': string;
    /**
     * 
     * @type {number}
     * @memberof SecurityScorePointDto
     */
    'vm_id': number | null;
    /**
     * 
     * @type {number}
     * @memberof SecurityScorePointDto
     */
    'score': number;
    /**
     * 
     * @type {string}
     * @memberof SecurityScorePointDto
     */
    'grade': string;
    /**
     * Scoring weights version. Break the trend line when it changes rather than comparing incomparable numbers.
     * @type {number}
     * @memberof SecurityScorePointDto
     */
    'algorithm_version': number;
    /**
     * 
     * @type {number}
     * @memberof SecurityScorePointDto
     */
    'open_critical': number;
    /**
     * 
     * @type {number}
     * @memberof SecurityScorePointDto
     */
    'open_high': number;
    /**
     * 
     * @type {number}
     * @memberof SecurityScorePointDto
     */
    'open_medium': number;
    /**
     * 
     * @type {number}
     * @memberof SecurityScorePointDto
     */
    'open_low': number;
}
/**
 * 
 * @export
 * @interface SecurityServiceListDto
 */
export interface SecurityServiceListDto {
    /**
     * 
     * @type {string}
     * @memberof SecurityServiceListDto
     */
    'observed_at': string | null;
    /**
     * 
     * @type {Array<SecurityDiscoveredServiceDto>}
     * @memberof SecurityServiceListDto
     */
    'services': Array<SecurityDiscoveredServiceDto>;
}
/**
 * 
 * @export
 * @interface SecuritySettingsDto
 */
export interface SecuritySettingsDto {
    /**
     * Master switch for this account. When false NO scan is dispatched — scheduled or on-demand — and existing findings stop being refreshed.
     * @type {boolean}
     * @memberof SecuritySettingsDto
     */
    'enabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof SecuritySettingsDto
     */
    'default_frequency': SecuritySettingsDtoDefaultFrequencyEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SecuritySettingsDto
     */
    'notify_on_new_critical': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SecuritySettingsDto
     */
    'notify_on_score_drop': boolean;
}

export const SecuritySettingsDtoDefaultFrequencyEnum = {
    Daily: 'daily',
    Weekly: 'weekly',
    Monthly: 'monthly'
} as const;

export type SecuritySettingsDtoDefaultFrequencyEnum = typeof SecuritySettingsDtoDefaultFrequencyEnum[keyof typeof SecuritySettingsDtoDefaultFrequencyEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const SecuritySeverity = {
    Critical: 'critical',
    High: 'high',
    Medium: 'medium',
    Low: 'low',
    Info: 'info'
} as const;

export type SecuritySeverity = typeof SecuritySeverity[keyof typeof SecuritySeverity];


/**
 * 
 * @export
 * @interface SelectSocialAccountDto
 */
export interface SelectSocialAccountDto {
    /**
     * Single-use account-selection continuation token.
     * @type {string}
     * @memberof SelectSocialAccountDto
     */
    'token': string;
    /**
     * WHMCS client id chosen by the user.
     * @type {number}
     * @memberof SelectSocialAccountDto
     */
    'clientId': number;
}
/**
 * 
 * @export
 * @interface ServerEntity
 */
export interface ServerEntity {
    /**
     * Opaque host identifier — two of your instances with the same value share a host.
     * @type {number}
     * @memberof ServerEntity
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof ServerEntity
     */
    'datacenter_id': number;
    /**
     * 
     * @type {number}
     * @memberof ServerEntity
     */
    'cluster_id': number | null;
    /**
     * 
     * @type {DatacenterEntity}
     * @memberof ServerEntity
     */
    'datacenters': DatacenterEntity;
}
/**
 * 
 * @export
 * @interface ServerInfoDto
 */
export interface ServerInfoDto {
    /**
     * Server ID
     * @type {number}
     * @memberof ServerInfoDto
     */
    'id': number;
    /**
     * Datacenter Information
     * @type {DatacenterInfoDto}
     * @memberof ServerInfoDto
     */
    'datacenters': DatacenterInfoDto;
}
/**
 * 
 * @export
 * @interface SeverityCountsDto
 */
export interface SeverityCountsDto {
    /**
     * 
     * @type {number}
     * @memberof SeverityCountsDto
     */
    'critical': number;
    /**
     * 
     * @type {number}
     * @memberof SeverityCountsDto
     */
    'high': number;
    /**
     * 
     * @type {number}
     * @memberof SeverityCountsDto
     */
    'medium': number;
    /**
     * 
     * @type {number}
     * @memberof SeverityCountsDto
     */
    'low': number;
    /**
     * 
     * @type {number}
     * @memberof SeverityCountsDto
     */
    'info': number;
}
/**
 * 
 * @export
 * @interface SiteConnectionDetailDto
 */
export interface SiteConnectionDetailDto {
    /**
     * 
     * @type {SiteConnectionDto}
     * @memberof SiteConnectionDetailDto
     */
    'connection': SiteConnectionDto;
    /**
     * 
     * @type {SiteConnectionSetupDto}
     * @memberof SiteConnectionDetailDto
     */
    'setup': SiteConnectionSetupDto;
    /**
     * 
     * @type {SiteConnectionRouteHintDto}
     * @memberof SiteConnectionDetailDto
     */
    'instance_route_hint'?: SiteConnectionRouteHintDto;
    /**
     * 
     * @type {Array<VendorConfigOptionDto>}
     * @memberof SiteConnectionDetailDto
     */
    'config_options': Array<VendorConfigOptionDto>;
}
/**
 * 
 * @export
 * @interface SiteConnectionDto
 */
export interface SiteConnectionDto {
    /**
     * 
     * @type {string}
     * @memberof SiteConnectionDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SiteConnectionDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SiteConnectionDto
     */
    'protocol': SiteConnectionDtoProtocolEnum;
    /**
     * 
     * @type {string}
     * @memberof SiteConnectionDto
     */
    'status': string;
    /**
     * 
     * @type {boolean}
     * @memberof SiteConnectionDto
     */
    'enabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof SiteConnectionDto
     */
    'peer_vendor': SiteConnectionDtoPeerVendorEnum;
    /**
     * 
     * @type {string}
     * @memberof SiteConnectionDto
     */
    'peer_address'?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteConnectionDto
     */
    'peer_id'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SiteConnectionDto
     */
    'remote_networks': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof SiteConnectionDto
     */
    'policy_based_peer': boolean;
    /**
     * 
     * @type {string}
     * @memberof SiteConnectionDto
     */
    'ike_preset': SiteConnectionDtoIkePresetEnum;
    /**
     * 
     * @type {number}
     * @memberof SiteConnectionDto
     */
    'mtu': number;
    /**
     * 
     * @type {string}
     * @memberof SiteConnectionDto
     */
    'wg_peer_public_key'?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteConnectionDto
     */
    'tunnel_state': SiteConnectionDtoTunnelStateEnum;
    /**
     * 
     * @type {string}
     * @memberof SiteConnectionDto
     */
    'error_class': SiteConnectionDtoErrorClassEnum;
    /**
     * 
     * @type {string}
     * @memberof SiteConnectionDto
     */
    'error_detail'?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteConnectionDto
     */
    'last_status_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteConnectionDto
     */
    'last_handshake_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteConnectionDto
     */
    'last_up_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteConnectionDto
     */
    'bytes_in': string;
    /**
     * 
     * @type {string}
     * @memberof SiteConnectionDto
     */
    'bytes_out': string;
    /**
     * 
     * @type {string}
     * @memberof SiteConnectionDto
     */
    'applied_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteConnectionDto
     */
    'apply_error'?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteConnectionDto
     */
    'created_at': string;
}

export const SiteConnectionDtoProtocolEnum = {
    IpsecIkev2: 'ipsec_ikev2',
    Wireguard: 'wireguard'
} as const;

export type SiteConnectionDtoProtocolEnum = typeof SiteConnectionDtoProtocolEnum[keyof typeof SiteConnectionDtoProtocolEnum];
export const SiteConnectionDtoPeerVendorEnum = {
    Mikrotik: 'mikrotik',
    Pfsense: 'pfsense',
    Opnsense: 'opnsense',
    Fortigate: 'fortigate',
    CiscoIos: 'cisco_ios',
    Ubiquiti: 'ubiquiti',
    Aws: 'aws',
    Azure: 'azure',
    Linux: 'linux',
    WireguardGeneric: 'wireguard_generic',
    Other: 'other'
} as const;

export type SiteConnectionDtoPeerVendorEnum = typeof SiteConnectionDtoPeerVendorEnum[keyof typeof SiteConnectionDtoPeerVendorEnum];
export const SiteConnectionDtoIkePresetEnum = {
    Recommended: 'recommended',
    Compatible: 'compatible',
    Custom: 'custom'
} as const;

export type SiteConnectionDtoIkePresetEnum = typeof SiteConnectionDtoIkePresetEnum[keyof typeof SiteConnectionDtoIkePresetEnum];
export const SiteConnectionDtoTunnelStateEnum = {
    Unknown: 'unknown',
    Down: 'down',
    Connecting: 'connecting',
    Up: 'up'
} as const;

export type SiteConnectionDtoTunnelStateEnum = typeof SiteConnectionDtoTunnelStateEnum[keyof typeof SiteConnectionDtoTunnelStateEnum];
export const SiteConnectionDtoErrorClassEnum = {
    None: 'none',
    NoAttempt: 'no_attempt',
    PeerUnreachable: 'peer_unreachable',
    AuthFailed: 'auth_failed',
    IdentityMismatch: 'identity_mismatch',
    ProposalMismatch: 'proposal_mismatch',
    TsMismatch: 'ts_mismatch',
    NoHandshake: 'no_handshake',
    HandshakeStale: 'handshake_stale',
    PeerLost: 'peer_lost',
    GatewayStopped: 'gateway_stopped',
    ApplyFailed: 'apply_failed'
} as const;

export type SiteConnectionDtoErrorClassEnum = typeof SiteConnectionDtoErrorClassEnum[keyof typeof SiteConnectionDtoErrorClassEnum];

/**
 * 
 * @export
 * @interface SiteConnectionEnabledRequestDto
 */
export interface SiteConnectionEnabledRequestDto {
    /**
     * False disconnects the site without deleting it
     * @type {boolean}
     * @memberof SiteConnectionEnabledRequestDto
     */
    'enabled': boolean;
}
/**
 * 
 * @export
 * @interface SiteConnectionEventDto
 */
export interface SiteConnectionEventDto {
    /**
     * 
     * @type {string}
     * @memberof SiteConnectionEventDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SiteConnectionEventDto
     */
    'kind': string;
    /**
     * 
     * @type {string}
     * @memberof SiteConnectionEventDto
     */
    'from_state'?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteConnectionEventDto
     */
    'to_state'?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteConnectionEventDto
     */
    'error_class'?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteConnectionEventDto
     */
    'detail'?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteConnectionEventDto
     */
    'created_at': string;
}
/**
 * 
 * @export
 * @interface SiteConnectionListDto
 */
export interface SiteConnectionListDto {
    /**
     * 
     * @type {Array<SiteConnectionDto>}
     * @memberof SiteConnectionListDto
     */
    'connections': Array<SiteConnectionDto>;
    /**
     * 
     * @type {SiteQuotaDto}
     * @memberof SiteConnectionListDto
     */
    'quota': SiteQuotaDto;
    /**
     * Whether customers may create connections at all
     * @type {boolean}
     * @memberof SiteConnectionListDto
     */
    'feature_enabled': boolean;
    /**
     * Whether this platform can install the appliance agent at all yet. When false, no gateway here can carry a site connection, and rebuilding one would reinstall the same previous-generation container.
     * @type {boolean}
     * @memberof SiteConnectionListDto
     */
    'platform_installs_agent': boolean;
    /**
     * legacy or appliance
     * @type {string}
     * @memberof SiteConnectionListDto
     */
    'generation': string;
    /**
     * Whether the gateway is currently reporting
     * @type {boolean}
     * @memberof SiteConnectionListDto
     */
    'agent_online': boolean;
    /**
     * The gateway\'s own private network
     * @type {string}
     * @memberof SiteConnectionListDto
     */
    'vpc_cidr'?: string;
    /**
     * The address inside it that carries the tunnels
     * @type {string}
     * @memberof SiteConnectionListDto
     */
    'vpc_gateway_ip'?: string;
    /**
     * The addresses people on the VPN app are given, e.g. 10.8.0.0/24. A site network may not overlap it.
     * @type {string}
     * @memberof SiteConnectionListDto
     */
    'remote_access_pool'?: string;
}
/**
 * 
 * @export
 * @interface SiteConnectionMutationDto
 */
export interface SiteConnectionMutationDto {
    /**
     * 
     * @type {SiteConnectionDto}
     * @memberof SiteConnectionMutationDto
     */
    'connection': SiteConnectionDto;
    /**
     * 
     * @type {Array<SiteMessageDto>}
     * @memberof SiteConnectionMutationDto
     */
    'warnings': Array<SiteMessageDto>;
    /**
     * The apply job carrying this change to the gateway
     * @type {string}
     * @memberof SiteConnectionMutationDto
     */
    'job_id': string;
}
/**
 * 
 * @export
 * @interface SiteConnectionRemovedDto
 */
export interface SiteConnectionRemovedDto {
    /**
     * 
     * @type {boolean}
     * @memberof SiteConnectionRemovedDto
     */
    'removed': boolean;
    /**
     * The apply job that removes it from the gateway
     * @type {string}
     * @memberof SiteConnectionRemovedDto
     */
    'job_id': string;
}
/**
 * 
 * @export
 * @interface SiteConnectionRequestDto
 */
export interface SiteConnectionRequestDto {
    /**
     * A short name for this site, lowercase with hyphens
     * @type {string}
     * @memberof SiteConnectionRequestDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SiteConnectionRequestDto
     */
    'protocol': SiteConnectionRequestDtoProtocolEnum;
    /**
     * What is on the other end
     * @type {string}
     * @memberof SiteConnectionRequestDto
     */
    'peer_vendor'?: SiteConnectionRequestDtoPeerVendorEnum;
    /**
     * The other end\'s public address. Leave it out when it changes: the gateway then waits to be called.
     * @type {string}
     * @memberof SiteConnectionRequestDto
     */
    'peer_address'?: string;
    /**
     * The networks behind the other end
     * @type {Array<string>}
     * @memberof SiteConnectionRequestDto
     */
    'remote_networks': Array<string>;
    /**
     * Whether the other end negotiates one pair of networks at a time. Set from the device by default.
     * @type {boolean}
     * @memberof SiteConnectionRequestDto
     */
    'policy_based_peer'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SiteConnectionRequestDto
     */
    'ike_preset'?: SiteConnectionRequestDtoIkePresetEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof SiteConnectionRequestDto
     */
    'ike_proposals'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SiteConnectionRequestDto
     */
    'esp_proposals'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof SiteConnectionRequestDto
     */
    'mtu'?: number;
    /**
     * 
     * @type {number}
     * @memberof SiteConnectionRequestDto
     */
    'ike_lifetime_seconds'?: number;
    /**
     * 
     * @type {number}
     * @memberof SiteConnectionRequestDto
     */
    'child_lifetime_seconds'?: number;
    /**
     * 
     * @type {number}
     * @memberof SiteConnectionRequestDto
     */
    'dpd_delay_seconds'?: number;
    /**
     * Your device\'s WireGuard public key. Left out, we generate one for you.
     * @type {string}
     * @memberof SiteConnectionRequestDto
     */
    'wg_peer_public_key'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SiteConnectionRequestDto
     */
    'enabled'?: boolean;
}

export const SiteConnectionRequestDtoProtocolEnum = {
    IpsecIkev2: 'ipsec_ikev2',
    Wireguard: 'wireguard'
} as const;

export type SiteConnectionRequestDtoProtocolEnum = typeof SiteConnectionRequestDtoProtocolEnum[keyof typeof SiteConnectionRequestDtoProtocolEnum];
export const SiteConnectionRequestDtoPeerVendorEnum = {
    Mikrotik: 'mikrotik',
    Pfsense: 'pfsense',
    Opnsense: 'opnsense',
    Fortigate: 'fortigate',
    CiscoIos: 'cisco_ios',
    Ubiquiti: 'ubiquiti',
    Aws: 'aws',
    Azure: 'azure',
    Linux: 'linux',
    WireguardGeneric: 'wireguard_generic',
    Other: 'other'
} as const;

export type SiteConnectionRequestDtoPeerVendorEnum = typeof SiteConnectionRequestDtoPeerVendorEnum[keyof typeof SiteConnectionRequestDtoPeerVendorEnum];
export const SiteConnectionRequestDtoIkePresetEnum = {
    Recommended: 'recommended',
    Compatible: 'compatible',
    Custom: 'custom'
} as const;

export type SiteConnectionRequestDtoIkePresetEnum = typeof SiteConnectionRequestDtoIkePresetEnum[keyof typeof SiteConnectionRequestDtoIkePresetEnum];

/**
 * 
 * @export
 * @interface SiteConnectionRouteHintDto
 */
export interface SiteConnectionRouteHintDto {
    /**
     * 
     * @type {string}
     * @memberof SiteConnectionRouteHintDto
     */
    'next_hop': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SiteConnectionRouteHintDto
     */
    'networks': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SiteConnectionRouteHintDto
     */
    'linux': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SiteConnectionRouteHintDto
     */
    'windows': Array<string>;
}
/**
 * 
 * @export
 * @interface SiteConnectionSetupDto
 */
export interface SiteConnectionSetupDto {
    /**
     * The address the other end connects to
     * @type {string}
     * @memberof SiteConnectionSetupDto
     */
    'our_public_address'?: string;
    /**
     * The network the other end will reach
     * @type {string}
     * @memberof SiteConnectionSetupDto
     */
    'our_private_network'?: string;
    /**
     * The addresses people on the VPN app are given, e.g. 10.8.0.0/24
     * @type {string}
     * @memberof SiteConnectionSetupDto
     */
    'remote_access_pool'?: string;
    /**
     * The address VPN app users appear as at the other end (the gateway\'s own private address); their device needs no route for the pool
     * @type {string}
     * @memberof SiteConnectionSetupDto
     */
    'vpn_users_reach_as'?: string;
    /**
     * What must be open towards us
     * @type {Array<string>}
     * @memberof SiteConnectionSetupDto
     */
    'required_ports': Array<string>;
    /**
     * Which end starts the tunnel: both, or your device
     * @type {string}
     * @memberof SiteConnectionSetupDto
     */
    'initiates': string;
}
/**
 * 
 * @export
 * @interface SiteMessageDto
 */
export interface SiteMessageDto {
    /**
     * 
     * @type {string}
     * @memberof SiteMessageDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof SiteMessageDto
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof SiteMessageDto
     */
    'severity': string;
    /**
     * 
     * @type {object}
     * @memberof SiteMessageDto
     */
    'params'?: object;
    /**
     * 
     * @type {string}
     * @memberof SiteMessageDto
     */
    'field'?: string;
}
/**
 * 
 * @export
 * @interface SiteQuotaDto
 */
export interface SiteQuotaDto {
    /**
     * 
     * @type {number}
     * @memberof SiteQuotaDto
     */
    'included': number;
    /**
     * 
     * @type {number}
     * @memberof SiteQuotaDto
     */
    'used': number;
    /**
     * 
     * @type {number}
     * @memberof SiteQuotaDto
     */
    'hard_cap': number;
    /**
     * 
     * @type {string}
     * @memberof SiteQuotaDto
     */
    'plan_code': string;
    /**
     * 
     * @type {string}
     * @memberof SiteQuotaDto
     */
    'plan_name': string;
}
/**
 * 
 * @export
 * @interface SiteSecretDto
 */
export interface SiteSecretDto {
    /**
     * 
     * @type {string}
     * @memberof SiteSecretDto
     */
    'psk'?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteSecretDto
     */
    'wg_private_key'?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteSecretDto
     */
    'wg_preshared_key'?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteSecretDto
     */
    'wg_public_key'?: string;
}
/**
 * 
 * @export
 * @interface SiteValidationDto
 */
export interface SiteValidationDto {
    /**
     * 
     * @type {boolean}
     * @memberof SiteValidationDto
     */
    'ok': boolean;
    /**
     * 
     * @type {Array<SiteMessageDto>}
     * @memberof SiteValidationDto
     */
    'errors': Array<SiteMessageDto>;
    /**
     * 
     * @type {Array<SiteMessageDto>}
     * @memberof SiteValidationDto
     */
    'warnings': Array<SiteMessageDto>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SiteValidationDto
     */
    'normalized_networks': Array<string>;
}
/**
 * 
 * @export
 * @interface SnapshotListResponseDto
 */
export interface SnapshotListResponseDto {
    /**
     * 
     * @type {Array<SnapshotResponseDto>}
     * @memberof SnapshotListResponseDto
     */
    'snapshots': Array<SnapshotResponseDto>;
    /**
     * Total number of snapshots
     * @type {number}
     * @memberof SnapshotListResponseDto
     */
    'total': number;
    /**
     * Maximum allowed snapshots
     * @type {number}
     * @memberof SnapshotListResponseDto
     */
    'max_snapshots': number;
    /**
     * Remaining snapshot slots
     * @type {number}
     * @memberof SnapshotListResponseDto
     */
    'remaining': number;
}
/**
 * 
 * @export
 * @interface SnapshotOperationResponseDto
 */
export interface SnapshotOperationResponseDto {
    /**
     * Success status
     * @type {boolean}
     * @memberof SnapshotOperationResponseDto
     */
    'success': boolean;
    /**
     * Response message
     * @type {string}
     * @memberof SnapshotOperationResponseDto
     */
    'message': string;
    /**
     * Snapshot data
     * @type {SnapshotResponseDto}
     * @memberof SnapshotOperationResponseDto
     */
    'snapshot'?: SnapshotResponseDto;
}
/**
 * 
 * @export
 * @interface SnapshotResponseDto
 */
export interface SnapshotResponseDto {
    /**
     * Snapshot ID
     * @type {string}
     * @memberof SnapshotResponseDto
     */
    'id': string;
    /**
     * VM ID
     * @type {number}
     * @memberof SnapshotResponseDto
     */
    'vm_id': number;
    /**
     * Snapshot name
     * @type {string}
     * @memberof SnapshotResponseDto
     */
    'snapshot_name': string;
    /**
     * Snapshot description
     * @type {string}
     * @memberof SnapshotResponseDto
     */
    'description'?: string;
    /**
     * Creation date (ISO 8601)
     * @type {string}
     * @memberof SnapshotResponseDto
     */
    'created_at': string;
    /**
     * Expiration date (ISO 8601)
     * @type {string}
     * @memberof SnapshotResponseDto
     */
    'expires_at': string;
    /**
     * Unix timestamp of snapshot creation
     * @type {number}
     * @memberof SnapshotResponseDto
     */
    'snaptime'?: number;
    /**
     * Whether RAM state is included in the snapshot
     * @type {boolean}
     * @memberof SnapshotResponseDto
     */
    'include_ram': boolean;
}
/**
 * 
 * @export
 * @interface SocialHandoffExchangeDto
 */
export interface SocialHandoffExchangeDto {
    /**
     * Single-use handoff code issued by the social callback redirect.
     * @type {string}
     * @memberof SocialHandoffExchangeDto
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface StartClientImageUploadDto
 */
export interface StartClientImageUploadDto {
    /**
     * The file name, including its extension.
     * @type {string}
     * @memberof StartClientImageUploadDto
     */
    'filename': string;
    /**
     * A label for the library. Defaults to the file name.
     * @type {string}
     * @memberof StartClientImageUploadDto
     */
    'display_name'?: string;
    /**
     * File size in bytes.
     * @type {number}
     * @memberof StartClientImageUploadDto
     */
    'size_bytes': number;
}
/**
 * 
 * @export
 * @interface StatementReasonTotalDto
 */
export interface StatementReasonTotalDto {
    /**
     * 
     * @type {string}
     * @memberof StatementReasonTotalDto
     */
    'reason': StatementReasonTotalDtoReasonEnum;
    /**
     * Signed micro-cents EFFECT on the total balance for this reason in the window (NEGATIVE-bucket debt increases count as decreases). Σ by_reason = closing_total − opening_total.
     * @type {string}
     * @memberof StatementReasonTotalDto
     */
    'amount_micro_cents': string;
}

export const StatementReasonTotalDtoReasonEnum = {
    TrialGrant: 'TRIAL_GRANT',
    TrialWriteOff: 'TRIAL_WRITE_OFF',
    Usage: 'USAGE',
    Recharge: 'RECHARGE',
    InvoiceCarryover: 'INVOICE_CARRYOVER',
    Adjustment: 'ADJUSTMENT',
    Refund: 'REFUND',
    CommitmentPayment: 'COMMITMENT_PAYMENT',
    CouponDiscount: 'COUPON_DISCOUNT',
    TopupCouponCredit: 'TOPUP_COUPON_CREDIT',
    InternalTransferIn: 'INTERNAL_TRANSFER_IN',
    InternalTransferOut: 'INTERNAL_TRANSFER_OUT',
    TemporaryGrant: 'TEMPORARY_GRANT',
    TemporaryExpiry: 'TEMPORARY_EXPIRY',
    DebtSettlement: 'DEBT_SETTLEMENT',
    CommitmentExpiry: 'COMMITMENT_EXPIRY',
    RenewalCreditApplied: 'RENEWAL_CREDIT_APPLIED',
    PaymentReversal: 'PAYMENT_REVERSAL',
    CarryForward: 'CARRY_FORWARD',
    InternalCreditGrant: 'INTERNAL_CREDIT_GRANT'
} as const;

export type StatementReasonTotalDtoReasonEnum = typeof StatementReasonTotalDtoReasonEnum[keyof typeof StatementReasonTotalDtoReasonEnum];

/**
 * 
 * @export
 * @interface StatementSummaryDto
 */
export interface StatementSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof StatementSummaryDto
     */
    'from': string;
    /**
     * 
     * @type {string}
     * @memberof StatementSummaryDto
     */
    'to': string;
    /**
     * Total balance (available + temporary + committed − negative) at window start
     * @type {string}
     * @memberof StatementSummaryDto
     */
    'opening_total_micro_cents': string;
    /**
     * Total balance at window end
     * @type {string}
     * @memberof StatementSummaryDto
     */
    'closing_total_micro_cents': string;
    /**
     * closing_total − opening_total
     * @type {string}
     * @memberof StatementSummaryDto
     */
    'net_change_total_micro_cents': string;
    /**
     * Usable balance (available + temporary − negative) at window start
     * @type {string}
     * @memberof StatementSummaryDto
     */
    'opening_usable_micro_cents': string;
    /**
     * 
     * @type {string}
     * @memberof StatementSummaryDto
     */
    'closing_usable_micro_cents': string;
    /**
     * closing_usable − opening_usable
     * @type {string}
     * @memberof StatementSummaryDto
     */
    'net_change_micro_cents': string;
    /**
     * 
     * @type {Array<StatementReasonTotalDto>}
     * @memberof StatementSummaryDto
     */
    'by_reason': Array<StatementReasonTotalDto>;
}
/**
 * 
 * @export
 * @interface SubmitFeedbackDto
 */
export interface SubmitFeedbackDto {
    /**
     * 
     * @type {string}
     * @memberof SubmitFeedbackDto
     */
    'surface': SubmitFeedbackDtoSurfaceEnum;
    /**
     * 
     * @type {string}
     * @memberof SubmitFeedbackDto
     */
    'ratingKind': SubmitFeedbackDtoRatingKindEnum;
    /**
     * Normalized numeric rating: thumbs +1/-1, stars 1-5, NPS 0-10, CSAT 1-5.
     * @type {number}
     * @memberof SubmitFeedbackDto
     */
    'rating': number;
    /**
     * Optional free-text comment.
     * @type {string}
     * @memberof SubmitFeedbackDto
     */
    'comment'?: string;
    /**
     * Optional reason tags (e.g. inaccurate, unhelpful, incomplete).
     * @type {Array<string>}
     * @memberof SubmitFeedbackDto
     */
    'reasons'?: Array<string>;
    /**
     * Polymorphic subject kind being rated (e.g. AI_MESSAGE).
     * @type {string}
     * @memberof SubmitFeedbackDto
     */
    'subjectType'?: string;
    /**
     * Stable id of the rated subject (e.g. the assistant message id).
     * @type {string}
     * @memberof SubmitFeedbackDto
     */
    'subjectId'?: string;
    /**
     * Context snapshot. For the AI Assistant this is the conversation thread + model/screen so quality can be assessed later.
     * @type {{ [key: string]: any; }}
     * @memberof SubmitFeedbackDto
     */
    'snapshot'?: { [key: string]: any; };
    /**
     * Lightweight metadata (route, locale, app version, etc.).
     * @type {{ [key: string]: any; }}
     * @memberof SubmitFeedbackDto
     */
    'metadata'?: { [key: string]: any; };
}

export const SubmitFeedbackDtoSurfaceEnum = {
    AiAssistant: 'AI_ASSISTANT',
    Csat: 'CSAT',
    Nps: 'NPS',
    Feature: 'FEATURE'
} as const;

export type SubmitFeedbackDtoSurfaceEnum = typeof SubmitFeedbackDtoSurfaceEnum[keyof typeof SubmitFeedbackDtoSurfaceEnum];
export const SubmitFeedbackDtoRatingKindEnum = {
    Thumbs: 'THUMBS',
    Stars: 'STARS',
    Nps: 'NPS',
    Csat: 'CSAT'
} as const;

export type SubmitFeedbackDtoRatingKindEnum = typeof SubmitFeedbackDtoRatingKindEnum[keyof typeof SubmitFeedbackDtoRatingKindEnum];

/**
 * 
 * @export
 * @interface SubmitFeedbackResultDto
 */
export interface SubmitFeedbackResultDto {
    /**
     * 
     * @type {string}
     * @memberof SubmitFeedbackResultDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitFeedbackResultDto
     */
    'sentiment': SubmitFeedbackResultDtoSentimentEnum;
    /**
     * True when an existing rating was updated in place.
     * @type {boolean}
     * @memberof SubmitFeedbackResultDto
     */
    'updated': boolean;
}

export const SubmitFeedbackResultDtoSentimentEnum = {
    Positive: 'POSITIVE',
    Negative: 'NEGATIVE',
    Neutral: 'NEUTRAL'
} as const;

export type SubmitFeedbackResultDtoSentimentEnum = typeof SubmitFeedbackResultDtoSentimentEnum[keyof typeof SubmitFeedbackResultDtoSentimentEnum];

/**
 * 
 * @export
 * @interface SubnetEntity
 */
export interface SubnetEntity {
    /**
     * 
     * @type {number}
     * @memberof SubnetEntity
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof SubnetEntity
     */
    'ip_pool_id': number;
    /**
     * 
     * @type {string}
     * @memberof SubnetEntity
     */
    'gateway': string;
    /**
     * 
     * @type {string}
     * @memberof SubnetEntity
     */
    'mask': string;
    /**
     * 
     * @type {string}
     * @memberof SubnetEntity
     */
    'dns1': string;
    /**
     * 
     * @type {string}
     * @memberof SubnetEntity
     */
    'dns2': string;
    /**
     * 
     * @type {string}
     * @memberof SubnetEntity
     */
    'cidr': string | null;
    /**
     * 
     * @type {string}
     * @memberof SubnetEntity
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof SubnetEntity
     */
    'updated_at': string;
}
/**
 * 
 * @export
 * @interface SubscriptionListCycleDto
 */
export interface SubscriptionListCycleDto {
    /**
     * Whole days until current_cycle_ends_at. Null on ON_DEMAND.
     * @type {number}
     * @memberof SubscriptionListCycleDto
     */
    'days_remaining': number | null;
    /**
     * Metered spend so far in the current cycle.
     * @type {string}
     * @memberof SubscriptionListCycleDto
     */
    'consumed_micro_cents': string;
    /**
     * Ceiling the committed resources may bill in this cycle — the denominator of the consumption bar. Null on ON_DEMAND.
     * @type {string}
     * @memberof SubscriptionListCycleDto
     */
    'commitment_cap_micro_cents': string | null;
}
/**
 * 
 * @export
 * @interface SubscriptionListInvoicesDto
 */
export interface SubscriptionListInvoicesDto {
    /**
     * Open payment requests plus unpaid provider-voided obligations. Includes optional top-ups.
     * @type {number}
     * @memberof SubscriptionListInvoicesDto
     */
    'open_count': number;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionListInvoicesDto
     */
    'next_due_at': string | null;
    /**
     * An outstanding renewal or usage obligation is past its due date. Optional top-ups are never overdue service obligations.
     * @type {boolean}
     * @memberof SubscriptionListInvoicesDto
     */
    'overdue': boolean;
}
/**
 * 
 * @export
 * @interface SubscriptionListItemDto
 */
export interface SubscriptionListItemDto {
    /**
     * 
     * @type {TrialSubscriptionDto}
     * @memberof SubscriptionListItemDto
     */
    'trial': TrialSubscriptionDto | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionListItemDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionListItemDto
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionListItemDto
     */
    'status': string;
    /**
     * COMMITTED | ON_DEMAND
     * @type {string}
     * @memberof SubscriptionListItemDto
     */
    'commitment_type': string;
    /**
     * 
     * @type {SubscriptionListTermDto}
     * @memberof SubscriptionListItemDto
     */
    'term': SubscriptionListTermDto | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionListItemDto
     */
    'current_cycle_starts_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionListItemDto
     */
    'current_cycle_ends_at': string | null;
    /**
     * 
     * @type {BalanceBucketsDto}
     * @memberof SubscriptionListItemDto
     */
    'balance': BalanceBucketsDto | null;
    /**
     * 
     * @type {SubscriptionListResourcesDto}
     * @memberof SubscriptionListItemDto
     */
    'resources': SubscriptionListResourcesDto;
    /**
     * 
     * @type {SubscriptionListRecurringDto}
     * @memberof SubscriptionListItemDto
     */
    'recurring': SubscriptionListRecurringDto;
    /**
     * 
     * @type {SubscriptionListCycleDto}
     * @memberof SubscriptionListItemDto
     */
    'cycle': SubscriptionListCycleDto;
    /**
     * 
     * @type {SubscriptionListInvoicesDto}
     * @memberof SubscriptionListItemDto
     */
    'invoices': SubscriptionListInvoicesDto;
    /**
     * Set when the client scheduled this subscription for cancellation at the end of the current cycle.
     * @type {PendingCancellationDto}
     * @memberof SubscriptionListItemDto
     */
    'pending_cancellation': PendingCancellationDto | null;
    /**
     * Set when an operator has given this account extra time to pay. While it is in force nothing here is suspended for an overdue invoice or a breached credit limit. The money is unchanged — invoices keep their due dates and usage keeps being billed.
     * @type {PaymentHoldStateDto}
     * @memberof SubscriptionListItemDto
     */
    'payment_hold': PaymentHoldStateDto | null;
}
/**
 * 
 * @export
 * @interface SubscriptionListRecurringDto
 */
export interface SubscriptionListRecurringDto {
    /**
     * Sum of resource rates over the 672h monthly base. Stays a monthly figure on quarterly and annual terms.
     * @type {string}
     * @memberof SubscriptionListRecurringDto
     */
    'monthly_micro_cents': string;
    /**
     * Amount charged at renewal: the sum of the committed resources\' per-cycle caps. Null on ON_DEMAND.
     * @type {string}
     * @memberof SubscriptionListRecurringDto
     */
    'term_micro_cents': string | null;
}
/**
 * 
 * @export
 * @interface SubscriptionListResourcesDto
 */
export interface SubscriptionListResourcesDto {
    /**
     * Live billed resources, summed by quantity
     * @type {number}
     * @memberof SubscriptionListResourcesDto
     */
    'total': number;
    /**
     * Live resources of type \'VM\'
     * @type {number}
     * @memberof SubscriptionListResourcesDto
     */
    'instance_count': number;
    /**
     * Up to 3 VM display names, for a \"web-01, db-02, +5\" style summary.
     * @type {Array<string>}
     * @memberof SubscriptionListResourcesDto
     */
    'labels': Array<string>;
    /**
     * Live resource quantity keyed by resource type.
     * @type {{ [key: string]: number; }}
     * @memberof SubscriptionListResourcesDto
     */
    'counts_by_type': { [key: string]: number; };
}
/**
 * 
 * @export
 * @interface SubscriptionListTermDto
 */
export interface SubscriptionListTermDto {
    /**
     * MONTHLY | QUARTERLY | SEMI_ANNUAL | ANNUAL | ON_DEMAND
     * @type {string}
     * @memberof SubscriptionListTermDto
     */
    'kind': string;
}
/**
 * 
 * @export
 * @interface SuspensionDto
 */
export interface SuspensionDto {
    /**
     * 
     * @type {string}
     * @memberof SuspensionDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SuspensionDto
     */
    'reason': SuspensionDtoReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof SuspensionDto
     */
    'suspended_at': string;
    /**
     * 
     * @type {string}
     * @memberof SuspensionDto
     */
    'resumed_at'?: string | null;
    /**
     * Why an operator suspended it, in the words written for the customer (the same text the suspension email carries). Null for an automatic suspension, which `reason` explains.
     * @type {string}
     * @memberof SuspensionDto
     */
    'customer_reason'?: string | null;
}

export const SuspensionDtoReasonEnum = {
    TierThreshold: 'tier_threshold',
    Manual: 'manual',
    PaymentFailed: 'payment_failed',
    InvoiceOverdue: 'invoice_overdue'
} as const;

export type SuspensionDtoReasonEnum = typeof SuspensionDtoReasonEnum[keyof typeof SuspensionDtoReasonEnum];

/**
 * 
 * @export
 * @interface TaskStatusResponseDto
 */
export interface TaskStatusResponseDto {
    /**
     * Task ID
     * @type {string}
     * @memberof TaskStatusResponseDto
     */
    'task_id': string;
    /**
     * Current status of the task
     * @type {string}
     * @memberof TaskStatusResponseDto
     */
    'status': TaskStatusResponseDtoStatusEnum;
    /**
     * Task type
     * @type {string}
     * @memberof TaskStatusResponseDto
     */
    'type'?: string;
    /**
     * Task start time (Unix timestamp)
     * @type {number}
     * @memberof TaskStatusResponseDto
     */
    'starttime'?: number;
    /**
     * Task end time (Unix timestamp)
     * @type {number}
     * @memberof TaskStatusResponseDto
     */
    'endtime'?: number;
    /**
     * Task progress (0-1)
     * @type {number}
     * @memberof TaskStatusResponseDto
     */
    'progress'?: number;
    /**
     * Exit status of the task
     * @type {string}
     * @memberof TaskStatusResponseDto
     */
    'exitstatus'?: string;
}

export const TaskStatusResponseDtoStatusEnum = {
    Running: 'running',
    Stopped: 'stopped',
    Ok: 'OK'
} as const;

export type TaskStatusResponseDtoStatusEnum = typeof TaskStatusResponseDtoStatusEnum[keyof typeof TaskStatusResponseDtoStatusEnum];

/**
 * 
 * @export
 * @interface TemplateDto
 */
export interface TemplateDto {
    /**
     * Template ID
     * @type {number}
     * @memberof TemplateDto
     */
    'id': number;
    /**
     * Template display name
     * @type {string}
     * @memberof TemplateDto
     */
    'display_name': string;
    /**
     * Template real name
     * @type {string}
     * @memberof TemplateDto
     */
    'real_name'?: string;
    /**
     * Template icon URL
     * @type {string}
     * @memberof TemplateDto
     */
    'icon_url'?: string;
    /**
     * Whether password can be chosen
     * @type {number}
     * @memberof TemplateDto
     */
    'choose_password': number;
    /**
     * Minimum disk (GB) this OS requires, or null for no minimum
     * @type {number}
     * @memberof TemplateDto
     */
    'min_disk_gb'?: number | null;
    /**
     * Minimum RAM (MB) this OS requires, or null for no minimum
     * @type {number}
     * @memberof TemplateDto
     */
    'min_ram_mb'?: number | null;
    /**
     * Minimum vCPU this OS requires, or null for no minimum
     * @type {number}
     * @memberof TemplateDto
     */
    'min_vcpu'?: number | null;
    /**
     * Immutable catalog slug. Checkout and provisioning resolve a template by it.
     * @type {string}
     * @memberof TemplateDto
     */
    'code'?: string | null;
    /**
     * Distribution / product this version belongs to (\"Ubuntu\", \"Windows Server\").
     * @type {string}
     * @memberof TemplateDto
     */
    'category'?: string | null;
    /**
     * Whether this is an operating system or a marketplace app.
     * @type {string}
     * @memberof TemplateDto
     */
    'template_type'?: TemplateDtoTemplateTypeEnum | null;
    /**
     * OS family, used to filter OS-gated addons and licences.
     * @type {string}
     * @memberof TemplateDto
     */
    'os_family'?: TemplateDtoOsFamilyEnum | null;
    /**
     * Short in-picker name for this version (\"22.04 LTS\"). Always present — derived from the display name when staff have not curated one.
     * @type {string}
     * @memberof TemplateDto
     */
    'version_label': string;
    /**
     * The vendor calls this a long-term-support release
     * @type {boolean}
     * @memberof TemplateDto
     */
    'is_lts': boolean;
    /**
     * The version a customer with no preference should take
     * @type {boolean}
     * @memberof TemplateDto
     */
    'is_recommended': boolean;
    /**
     * Day security support ends (YYYY-MM-DD), or null when the platform makes no claim. Null must render as silence, never as \"supported\".
     * @type {string}
     * @memberof TemplateDto
     */
    'eol_at'?: string | null;
    /**
     * How the support window reads today. Null exactly when eol_at is null.
     * @type {string}
     * @memberof TemplateDto
     */
    'support_status'?: TemplateDtoSupportStatusEnum | null;
    /**
     * Template creation date
     * @type {string}
     * @memberof TemplateDto
     */
    'created_at': string;
    /**
     * Template last update date
     * @type {string}
     * @memberof TemplateDto
     */
    'updated_at': string;
}

export const TemplateDtoTemplateTypeEnum = {
    OperatingSystem: 'OPERATING_SYSTEM',
    MarketplaceApp: 'MARKETPLACE_APP'
} as const;

export type TemplateDtoTemplateTypeEnum = typeof TemplateDtoTemplateTypeEnum[keyof typeof TemplateDtoTemplateTypeEnum];
export const TemplateDtoOsFamilyEnum = {
    Linux: 'linux',
    Windows: 'windows',
    Other: 'other'
} as const;

export type TemplateDtoOsFamilyEnum = typeof TemplateDtoOsFamilyEnum[keyof typeof TemplateDtoOsFamilyEnum];
export const TemplateDtoSupportStatusEnum = {
    Supported: 'supported',
    EndingSoon: 'ending_soon',
    Ended: 'ended'
} as const;

export type TemplateDtoSupportStatusEnum = typeof TemplateDtoSupportStatusEnum[keyof typeof TemplateDtoSupportStatusEnum];

/**
 * 
 * @export
 * @interface TerminateServiceDataDto
 */
export interface TerminateServiceDataDto {
    /**
     * The ID of the VM in the database
     * @type {number}
     * @memberof TerminateServiceDataDto
     */
    'vm_id': number;
    /**
     * The WHMCS client ID
     * @type {number}
     * @memberof TerminateServiceDataDto
     */
    'client_id': number;
}
/**
 * 
 * @export
 * @interface TerminateServiceResponseDto
 */
export interface TerminateServiceResponseDto {
    /**
     * Indicates if the operation was successful
     * @type {boolean}
     * @memberof TerminateServiceResponseDto
     */
    'success': boolean;
    /**
     * A message describing the result of the operation
     * @type {string}
     * @memberof TerminateServiceResponseDto
     */
    'message': string;
    /**
     * Data about the terminated service
     * @type {TerminateServiceDataDto}
     * @memberof TerminateServiceResponseDto
     */
    'data': TerminateServiceDataDto;
}
/**
 * 
 * @export
 * @interface TokenDto
 */
export interface TokenDto {
    /**
     * Access token
     * @type {string}
     * @memberof TokenDto
     */
    'accessToken': string;
    /**
     * Access token expiry time in seconds
     * @type {number}
     * @memberof TokenDto
     */
    'accessTokenExpiry': number;
    /**
     * Refresh token
     * @type {string}
     * @memberof TokenDto
     */
    'refreshToken': string;
    /**
     * Refresh token expiry time in seconds
     * @type {number}
     * @memberof TokenDto
     */
    'refreshTokenExpiry': number;
}
/**
 * 
 * @export
 * @interface TopupBodyDto
 */
export interface TopupBodyDto {
    /**
     * Amount in BRL cents to top up (e.g. 5000 = R$ 50,00)
     * @type {number}
     * @memberof TopupBodyDto
     */
    'amount_cents': number;
    /**
     * Optional CREDIT_TOPUP coupon code for this recharge.
     * @type {string}
     * @memberof TopupBodyDto
     */
    'coupon_code'?: string;
    /**
     * What this top-up is FOR. Funds always land in balance_available. UPGRADE: on payment the customer is deep-linked back to the pending resize. RENEWAL_PREPAY: the top-up prepays the renewal ending at intent_cycle_ends_at — the invoice line says so, and it is voided automatically once the renewal invoice for that cycle exists, so the customer never holds two demands for the same money.
     * @type {string}
     * @memberof TopupBodyDto
     */
    'intent_kind'?: TopupBodyDtoIntentKindEnum;
    /**
     * With intent_kind=RENEWAL_PREPAY: the cycle end (from renewal-preview.cycle_ends_at) this top-up prepays.
     * @type {string}
     * @memberof TopupBodyDto
     */
    'intent_cycle_ends_at'?: string;
    /**
     * VM id the intent refers to (deep-link target).
     * @type {number}
     * @memberof TopupBodyDto
     */
    'intent_vm_id'?: number;
}

export const TopupBodyDtoIntentKindEnum = {
    Upgrade: 'UPGRADE',
    RenewalPrepay: 'RENEWAL_PREPAY'
} as const;

export type TopupBodyDtoIntentKindEnum = typeof TopupBodyDtoIntentKindEnum[keyof typeof TopupBodyDtoIntentKindEnum];

/**
 * 
 * @export
 * @interface TopupCouponPreviewBodyDto
 */
export interface TopupCouponPreviewBodyDto {
    /**
     * 
     * @type {string}
     * @memberof TopupCouponPreviewBodyDto
     */
    'coupon_code': string;
    /**
     * Gross top-up credit amount in micro-cents.
     * @type {string}
     * @memberof TopupCouponPreviewBodyDto
     */
    'topup_amount_micro_cents': string;
}
/**
 * 
 * @export
 * @interface TopupCouponPreviewDto
 */
export interface TopupCouponPreviewDto {
    /**
     * 
     * @type {boolean}
     * @memberof TopupCouponPreviewDto
     */
    'valid': boolean;
    /**
     * 
     * @type {string}
     * @memberof TopupCouponPreviewDto
     */
    'reason'?: string | null;
    /**
     * 
     * @type {CouponDto}
     * @memberof TopupCouponPreviewDto
     */
    'coupon'?: CouponDto | null;
    /**
     * 
     * @type {string}
     * @memberof TopupCouponPreviewDto
     */
    'topup_amount_micro_cents': string;
    /**
     * 
     * @type {string}
     * @memberof TopupCouponPreviewDto
     */
    'promotional_credit_micro_cents': string;
    /**
     * 
     * @type {string}
     * @memberof TopupCouponPreviewDto
     */
    'payable_micro_cents': string;
    /**
     * 
     * @type {string}
     * @memberof TopupCouponPreviewDto
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface TrialAllowanceDto
 */
export interface TrialAllowanceDto {
    /**
     * 
     * @type {string}
     * @memberof TrialAllowanceDto
     */
    'budget': string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialAllowanceDto
     */
    'used': string;
    /**
     * 
     * @type {string}
     * @memberof TrialAllowanceDto
     */
    'remaining': string | null;
}
/**
 * 
 * @export
 * @interface TrialPlanDto
 */
export interface TrialPlanDto {
    /**
     * 
     * @type {string}
     * @memberof TrialPlanDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TrialPlanDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof TrialPlanDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TrialPlanDto
     */
    'trial_cost_micro_cents': string;
    /**
     * 
     * @type {string}
     * @memberof TrialPlanDto
     */
    'renewal_micro_cents': string;
}
/**
 * 
 * @export
 * @interface TrialRenewalDto
 */
export interface TrialRenewalDto {
    /**
     * 
     * @type {string}
     * @memberof TrialRenewalDto
     */
    'gross_micro_cents': string;
    /**
     * 
     * @type {string}
     * @memberof TrialRenewalDto
     */
    'discount_micro_cents': string;
    /**
     * 
     * @type {string}
     * @memberof TrialRenewalDto
     */
    'net_micro_cents': string;
}
/**
 * 
 * @export
 * @interface TrialSubscriptionDto
 */
export interface TrialSubscriptionDto {
    /**
     * 
     * @type {string}
     * @memberof TrialSubscriptionDto
     */
    'offer_id': string;
    /**
     * 
     * @type {string}
     * @memberof TrialSubscriptionDto
     */
    'trial_ends_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialSubscriptionDto
     */
    'converted_at': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TrialSubscriptionDto
     */
    'ended': boolean;
    /**
     * 
     * @type {string}
     * @memberof TrialSubscriptionDto
     */
    'renewal_due_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialSubscriptionDto
     */
    'scheduled_switch_off_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialSubscriptionDto
     */
    'scheduled_deletion_at': string | null;
}
/**
 * 
 * @export
 * @interface TwoFactorRequiredResponseDto
 */
export interface TwoFactorRequiredResponseDto {
    /**
     * Signals that two-factor authentication is required to complete login.
     * @type {string}
     * @memberof TwoFactorRequiredResponseDto
     */
    'result': TwoFactorRequiredResponseDtoResultEnum;
    /**
     * Opaque challenge ID to be passed to the verify-two-factor endpoint.
     * @type {string}
     * @memberof TwoFactorRequiredResponseDto
     */
    'challengeId': string;
}

export const TwoFactorRequiredResponseDtoResultEnum = {
    TwoFactorRequired: 'two_factor_required'
} as const;

export type TwoFactorRequiredResponseDtoResultEnum = typeof TwoFactorRequiredResponseDtoResultEnum[keyof typeof TwoFactorRequiredResponseDtoResultEnum];

/**
 * 
 * @export
 * @interface UpdateClientImageCloudInitDto
 */
export interface UpdateClientImageCloudInitDto {
    /**
     * The user-data to store, or null to remove it. Line endings are normalised and a byte-order mark stripped before it is saved.
     * @type {string}
     * @memberof UpdateClientImageCloudInitDto
     */
    'user_data': string | null;
}
/**
 * 
 * @export
 * @interface UpdateClientImageDto
 */
export interface UpdateClientImageDto {
    /**
     * Rename the image in the library.
     * @type {string}
     * @memberof UpdateClientImageDto
     */
    'display_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateClientImageDto
     */
    'ostype'?: UpdateClientImageDtoOstypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateClientImageDto
     */
    'disk_bus'?: UpdateClientImageDtoDiskBusEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateClientImageDto
     */
    'scsihw'?: UpdateClientImageDtoScsihwEnum;
    /**
     * QEMU machine type. Null means \"let the hypervisor choose\", which is usually right — an image states nothing about the machine it expects.
     * @type {string}
     * @memberof UpdateClientImageDto
     */
    'machine'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateClientImageDto
     */
    'bios'?: UpdateClientImageDtoBiosEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateClientImageDto
     */
    'requires_efi'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateClientImageDto
     */
    'requires_tpm'?: boolean;
    /**
     * Whether the image has cloud-init (Linux) or cloudbase-init (Windows) installed. Without it the instance cannot be given its network settings or password automatically and must be configured through the console.
     * @type {boolean}
     * @memberof UpdateClientImageDto
     */
    'has_cloud_init'?: boolean;
    /**
     * The login the image ships with, if any.
     * @type {string}
     * @memberof UpdateClientImageDto
     */
    'default_username'?: string;
}

export const UpdateClientImageDtoOstypeEnum = {
    Other: 'other',
    Wxp: 'wxp',
    W2k: 'w2k',
    W2k3: 'w2k3',
    W2k8: 'w2k8',
    Wvista: 'wvista',
    Win7: 'win7',
    Win8: 'win8',
    Win10: 'win10',
    Win11: 'win11',
    L24: 'l24',
    L26: 'l26',
    Solaris: 'solaris'
} as const;

export type UpdateClientImageDtoOstypeEnum = typeof UpdateClientImageDtoOstypeEnum[keyof typeof UpdateClientImageDtoOstypeEnum];
export const UpdateClientImageDtoDiskBusEnum = {
    Ide0: 'ide0',
    Ide1: 'ide1',
    Ide2: 'ide2',
    Ide3: 'ide3',
    Sata0: 'sata0',
    Sata1: 'sata1',
    Sata2: 'sata2',
    Sata3: 'sata3',
    Sata4: 'sata4',
    Sata5: 'sata5',
    Scsi0: 'scsi0',
    Scsi1: 'scsi1',
    Scsi2: 'scsi2',
    Scsi3: 'scsi3',
    Scsi4: 'scsi4',
    Scsi5: 'scsi5',
    Scsi6: 'scsi6',
    Scsi7: 'scsi7',
    Scsi8: 'scsi8',
    Scsi9: 'scsi9',
    Scsi10: 'scsi10',
    Scsi11: 'scsi11',
    Scsi12: 'scsi12',
    Scsi13: 'scsi13',
    Scsi14: 'scsi14',
    Scsi15: 'scsi15',
    Scsi16: 'scsi16',
    Scsi17: 'scsi17',
    Scsi18: 'scsi18',
    Scsi19: 'scsi19',
    Scsi20: 'scsi20',
    Scsi21: 'scsi21',
    Scsi22: 'scsi22',
    Scsi23: 'scsi23',
    Scsi24: 'scsi24',
    Scsi25: 'scsi25',
    Scsi26: 'scsi26',
    Scsi27: 'scsi27',
    Scsi28: 'scsi28',
    Scsi29: 'scsi29',
    Scsi30: 'scsi30',
    Virtio0: 'virtio0',
    Virtio1: 'virtio1',
    Virtio2: 'virtio2',
    Virtio3: 'virtio3',
    Virtio4: 'virtio4',
    Virtio5: 'virtio5',
    Virtio6: 'virtio6',
    Virtio7: 'virtio7',
    Virtio8: 'virtio8',
    Virtio9: 'virtio9',
    Virtio10: 'virtio10',
    Virtio11: 'virtio11',
    Virtio12: 'virtio12',
    Virtio13: 'virtio13',
    Virtio14: 'virtio14',
    Virtio15: 'virtio15'
} as const;

export type UpdateClientImageDtoDiskBusEnum = typeof UpdateClientImageDtoDiskBusEnum[keyof typeof UpdateClientImageDtoDiskBusEnum];
export const UpdateClientImageDtoScsihwEnum = {
    Lsi: 'lsi',
    Lsi53c810: 'lsi53c810',
    VirtioScsiPci: 'virtio-scsi-pci',
    VirtioScsiSingle: 'virtio-scsi-single',
    Megasas: 'megasas',
    Pvscsi: 'pvscsi'
} as const;

export type UpdateClientImageDtoScsihwEnum = typeof UpdateClientImageDtoScsihwEnum[keyof typeof UpdateClientImageDtoScsihwEnum];
export const UpdateClientImageDtoBiosEnum = {
    Seabios: 'seabios',
    Ovmf: 'ovmf'
} as const;

export type UpdateClientImageDtoBiosEnum = typeof UpdateClientImageDtoBiosEnum[keyof typeof UpdateClientImageDtoBiosEnum];

/**
 * 
 * @export
 * @interface UpdateFirewallDto
 */
export interface UpdateFirewallDto {
    /**
     * Firewall name
     * @type {string}
     * @memberof UpdateFirewallDto
     */
    'name'?: string;
    /**
     * Firewall description
     * @type {string}
     * @memberof UpdateFirewallDto
     */
    'description'?: string;
    /**
     * Enable firewall
     * @type {boolean}
     * @memberof UpdateFirewallDto
     */
    'enable'?: boolean;
    /**
     * Default policy for incoming traffic
     * @type {string}
     * @memberof UpdateFirewallDto
     */
    'policy_in'?: UpdateFirewallDtoPolicyInEnum;
    /**
     * Default policy for outgoing traffic
     * @type {string}
     * @memberof UpdateFirewallDto
     */
    'policy_out'?: UpdateFirewallDtoPolicyOutEnum;
}

export const UpdateFirewallDtoPolicyInEnum = {
    Accept: 'ACCEPT',
    Reject: 'REJECT',
    Drop: 'DROP'
} as const;

export type UpdateFirewallDtoPolicyInEnum = typeof UpdateFirewallDtoPolicyInEnum[keyof typeof UpdateFirewallDtoPolicyInEnum];
export const UpdateFirewallDtoPolicyOutEnum = {
    Accept: 'ACCEPT',
    Reject: 'REJECT',
    Drop: 'DROP'
} as const;

export type UpdateFirewallDtoPolicyOutEnum = typeof UpdateFirewallDtoPolicyOutEnum[keyof typeof UpdateFirewallDtoPolicyOutEnum];

/**
 * 
 * @export
 * @interface UpdateFirewallRuleDto
 */
export interface UpdateFirewallRuleDto {
    /**
     * Rule type (direction)
     * @type {string}
     * @memberof UpdateFirewallRuleDto
     */
    'type'?: UpdateFirewallRuleDtoTypeEnum;
    /**
     * Rule action
     * @type {string}
     * @memberof UpdateFirewallRuleDto
     */
    'action'?: UpdateFirewallRuleDtoActionEnum;
    /**
     * Predefined macro (e.g., HTTP, HTTPS, SSH). If macro is provided, protocol, sport, and dport should not be set.
     * @type {string}
     * @memberof UpdateFirewallRuleDto
     */
    'macro'?: UpdateFirewallRuleDtoMacroEnum;
    /**
     * Lower-case protocol name as in /etc/protocols; omit to match any. Only tcp, udp, sctp, dccp and udplite carry ports — `rdp` here is IP protocol 27, not Remote Desktop. Required whenever a port is set; not allowed with a macro.
     * @type {string}
     * @memberof UpdateFirewallRuleDto
     */
    'proto'?: UpdateFirewallRuleDtoProtoEnum;
    /**
     * Source address, CIDR, `FROM-TO` range, or a comma-separated list. One address family per rule; a range cannot appear in a list.
     * @type {string}
     * @memberof UpdateFirewallRuleDto
     */
    'source'?: string;
    /**
     * Destination address, CIDR, `FROM-TO` range, or a comma-separated list. One address family per rule; a range cannot appear in a list.
     * @type {string}
     * @memberof UpdateFirewallRuleDto
     */
    'dest'?: string;
    /**
     * Source port, colon range or comma-separated list (e.g. `1024:65535`, `80,443`). A `FROM-TO` range is accepted and stored as `FROM:TO`. Requires `proto`; not allowed with a macro.
     * @type {string}
     * @memberof UpdateFirewallRuleDto
     */
    'sport'?: string;
    /**
     * Destination port, colon range or comma-separated list (e.g. `80`, `8000:8010`, `80,443`). A `FROM-TO` range is accepted and stored as `FROM:TO`. Requires `proto`; not allowed with a macro.
     * @type {string}
     * @memberof UpdateFirewallRuleDto
     */
    'dport'?: string;
    /**
     * Rule position in the list (0-based index)
     * @type {number}
     * @memberof UpdateFirewallRuleDto
     */
    'pos'?: number;
    /**
     * Rule comment
     * @type {string}
     * @memberof UpdateFirewallRuleDto
     */
    'comment'?: string;
    /**
     * Whether the rule should be active after commit. Defaults to true when omitted during creation.
     * @type {boolean}
     * @memberof UpdateFirewallRuleDto
     */
    'enable'?: boolean;
}

export const UpdateFirewallRuleDtoTypeEnum = {
    In: 'in',
    Out: 'out'
} as const;

export type UpdateFirewallRuleDtoTypeEnum = typeof UpdateFirewallRuleDtoTypeEnum[keyof typeof UpdateFirewallRuleDtoTypeEnum];
export const UpdateFirewallRuleDtoActionEnum = {
    Accept: 'ACCEPT',
    Reject: 'REJECT',
    Drop: 'DROP'
} as const;

export type UpdateFirewallRuleDtoActionEnum = typeof UpdateFirewallRuleDtoActionEnum[keyof typeof UpdateFirewallRuleDtoActionEnum];
export const UpdateFirewallRuleDtoMacroEnum = {
    Amanda: 'Amanda',
    Auth: 'Auth',
    Bgp: 'BGP',
    BitTorrent: 'BitTorrent',
    BitTorrent32: 'BitTorrent32',
    Cvs: 'CVS',
    Ceph: 'Ceph',
    Citrix: 'Citrix',
    Daap: 'DAAP',
    Dcc: 'DCC',
    DhcPfwd: 'DHCPfwd',
    Dhcpv6: 'DHCPv6',
    Dns: 'DNS',
    Distcc: 'Distcc',
    Ftp: 'FTP',
    Finger: 'Finger',
    GnUnet: 'GNUnet',
    Gre: 'GRE',
    Git: 'Git',
    Hkp: 'HKP',
    Http: 'HTTP',
    Https: 'HTTPS',
    Icpv2: 'ICPV2',
    Icq: 'ICQ',
    Imap: 'IMAP',
    Imaps: 'IMAPS',
    Ipip: 'IPIP',
    IPsec: 'IPsec',
    IPsecah: 'IPsecah',
    IPsecnat: 'IPsecnat',
    Irc: 'IRC',
    Jetdirect: 'Jetdirect',
    L2Tp: 'L2TP',
    Ldap: 'LDAP',
    Ldaps: 'LDAPS',
    Mdns: 'MDNS',
    Msnp: 'MSNP',
    Mssql: 'MSSQL',
    Mail: 'Mail',
    Munin: 'Munin',
    MySql: 'MySQL',
    Nntp: 'NNTP',
    Nntps: 'NNTPS',
    Ntp: 'NTP',
    NeighborDiscovery: 'NeighborDiscovery',
    Ospf: 'OSPF',
    OpenVpn: 'OpenVPN',
    Pca: 'PCA',
    Pmg: 'PMG',
    Pop3: 'POP3',
    Pop3S: 'POP3S',
    PptP: 'PPtP',
    Ping: 'Ping',
    PostgreSql: 'PostgreSQL',
    Printer: 'Printer',
    Rdp: 'RDP',
    Rip: 'RIP',
    Rndc: 'RNDC',
    Razor: 'Razor',
    Rdate: 'Rdate',
    Rsync: 'Rsync',
    Sane: 'SANE',
    Smb: 'SMB',
    SmBswat: 'SMBswat',
    Smtp: 'SMTP',
    Smtps: 'SMTPS',
    Snmp: 'SNMP',
    Spamd: 'SPAMD',
    SpicEproxy: 'SPICEproxy',
    Ssh: 'SSH',
    Svn: 'SVN',
    SixXs: 'SixXS',
    Squid: 'Squid',
    Submission: 'Submission',
    Syslog: 'Syslog',
    Tftp: 'TFTP',
    Telnet: 'Telnet',
    Telnets: 'Telnets',
    Time: 'Time',
    Trcrt: 'Trcrt',
    Vnc: 'VNC',
    Vncl: 'VNCL',
    Web: 'Web',
    Webcache: 'Webcache',
    Webmin: 'Webmin',
    Whois: 'Whois'
} as const;

export type UpdateFirewallRuleDtoMacroEnum = typeof UpdateFirewallRuleDtoMacroEnum[keyof typeof UpdateFirewallRuleDtoMacroEnum];
export const UpdateFirewallRuleDtoProtoEnum = {
    Tcp: 'tcp',
    Udp: 'udp',
    Icmp: 'icmp',
    Igmp: 'igmp',
    Ggp: 'ggp',
    Ipencap: 'ipencap',
    St: 'st',
    Egp: 'egp',
    Igp: 'igp',
    Pup: 'pup',
    Hmp: 'hmp',
    XnsIdp: 'xns-idp',
    Rdp: 'rdp',
    IsoTp4: 'iso-tp4',
    Dccp: 'dccp',
    Xtp: 'xtp',
    Ddp: 'ddp',
    IdprCmtp: 'idpr-cmtp',
    Ipv6: 'ipv6',
    Ipv6Route: 'ipv6-route',
    Ipv6Frag: 'ipv6-frag',
    Idrp: 'idrp',
    Rsvp: 'rsvp',
    Gre: 'gre',
    Esp: 'esp',
    Ah: 'ah',
    Skip: 'skip',
    Ipv6Icmp: 'ipv6-icmp',
    Icmpv6: 'icmpv6',
    Ipv6Nonxt: 'ipv6-nonxt',
    Ipv6Opts: 'ipv6-opts',
    Vmtp: 'vmtp',
    Eigrp: 'eigrp',
    Ospf: 'ospf',
    Ax25: 'ax.25',
    Ipip: 'ipip',
    Etherip: 'etherip',
    Encap: 'encap',
    Pim: 'pim',
    Ipcomp: 'ipcomp',
    Vrrp: 'vrrp',
    L2tp: 'l2tp',
    Isis: 'isis',
    Sctp: 'sctp',
    Fc: 'fc',
    MobilityHeader: 'mobility-header',
    Udplite: 'udplite',
    MplsInIp: 'mpls-in-ip',
    Hip: 'hip',
    Shim6: 'shim6',
    Wesp: 'wesp',
    Rohc: 'rohc'
} as const;

export type UpdateFirewallRuleDtoProtoEnum = typeof UpdateFirewallRuleDtoProtoEnum[keyof typeof UpdateFirewallRuleDtoProtoEnum];

/**
 * 
 * @export
 * @interface UpdateFirewallRuleItemDto
 */
export interface UpdateFirewallRuleItemDto {
    /**
     * Rule type (direction)
     * @type {string}
     * @memberof UpdateFirewallRuleItemDto
     */
    'type'?: UpdateFirewallRuleItemDtoTypeEnum;
    /**
     * Rule action
     * @type {string}
     * @memberof UpdateFirewallRuleItemDto
     */
    'action'?: UpdateFirewallRuleItemDtoActionEnum;
    /**
     * Predefined macro (e.g., HTTP, HTTPS, SSH). If macro is provided, protocol, sport, and dport should not be set.
     * @type {string}
     * @memberof UpdateFirewallRuleItemDto
     */
    'macro'?: UpdateFirewallRuleItemDtoMacroEnum;
    /**
     * Lower-case protocol name as in /etc/protocols; omit to match any. Only tcp, udp, sctp, dccp and udplite carry ports — `rdp` here is IP protocol 27, not Remote Desktop. Required whenever a port is set; not allowed with a macro.
     * @type {string}
     * @memberof UpdateFirewallRuleItemDto
     */
    'proto'?: UpdateFirewallRuleItemDtoProtoEnum;
    /**
     * Source address, CIDR, `FROM-TO` range, or a comma-separated list. One address family per rule; a range cannot appear in a list.
     * @type {string}
     * @memberof UpdateFirewallRuleItemDto
     */
    'source'?: string;
    /**
     * Destination address, CIDR, `FROM-TO` range, or a comma-separated list. One address family per rule; a range cannot appear in a list.
     * @type {string}
     * @memberof UpdateFirewallRuleItemDto
     */
    'dest'?: string;
    /**
     * Source port, colon range or comma-separated list (e.g. `1024:65535`, `80,443`). A `FROM-TO` range is accepted and stored as `FROM:TO`. Requires `proto`; not allowed with a macro.
     * @type {string}
     * @memberof UpdateFirewallRuleItemDto
     */
    'sport'?: string;
    /**
     * Destination port, colon range or comma-separated list (e.g. `80`, `8000:8010`, `80,443`). A `FROM-TO` range is accepted and stored as `FROM:TO`. Requires `proto`; not allowed with a macro.
     * @type {string}
     * @memberof UpdateFirewallRuleItemDto
     */
    'dport'?: string;
    /**
     * Rule position in the list (0-based index)
     * @type {number}
     * @memberof UpdateFirewallRuleItemDto
     */
    'pos'?: number;
    /**
     * Rule comment
     * @type {string}
     * @memberof UpdateFirewallRuleItemDto
     */
    'comment'?: string;
    /**
     * Whether the rule should be active after commit. Defaults to true when omitted during creation.
     * @type {boolean}
     * @memberof UpdateFirewallRuleItemDto
     */
    'enable'?: boolean;
    /**
     * Unique identifier of the rule to update
     * @type {string}
     * @memberof UpdateFirewallRuleItemDto
     */
    'rule_id': string;
}

export const UpdateFirewallRuleItemDtoTypeEnum = {
    In: 'in',
    Out: 'out'
} as const;

export type UpdateFirewallRuleItemDtoTypeEnum = typeof UpdateFirewallRuleItemDtoTypeEnum[keyof typeof UpdateFirewallRuleItemDtoTypeEnum];
export const UpdateFirewallRuleItemDtoActionEnum = {
    Accept: 'ACCEPT',
    Reject: 'REJECT',
    Drop: 'DROP'
} as const;

export type UpdateFirewallRuleItemDtoActionEnum = typeof UpdateFirewallRuleItemDtoActionEnum[keyof typeof UpdateFirewallRuleItemDtoActionEnum];
export const UpdateFirewallRuleItemDtoMacroEnum = {
    Amanda: 'Amanda',
    Auth: 'Auth',
    Bgp: 'BGP',
    BitTorrent: 'BitTorrent',
    BitTorrent32: 'BitTorrent32',
    Cvs: 'CVS',
    Ceph: 'Ceph',
    Citrix: 'Citrix',
    Daap: 'DAAP',
    Dcc: 'DCC',
    DhcPfwd: 'DHCPfwd',
    Dhcpv6: 'DHCPv6',
    Dns: 'DNS',
    Distcc: 'Distcc',
    Ftp: 'FTP',
    Finger: 'Finger',
    GnUnet: 'GNUnet',
    Gre: 'GRE',
    Git: 'Git',
    Hkp: 'HKP',
    Http: 'HTTP',
    Https: 'HTTPS',
    Icpv2: 'ICPV2',
    Icq: 'ICQ',
    Imap: 'IMAP',
    Imaps: 'IMAPS',
    Ipip: 'IPIP',
    IPsec: 'IPsec',
    IPsecah: 'IPsecah',
    IPsecnat: 'IPsecnat',
    Irc: 'IRC',
    Jetdirect: 'Jetdirect',
    L2Tp: 'L2TP',
    Ldap: 'LDAP',
    Ldaps: 'LDAPS',
    Mdns: 'MDNS',
    Msnp: 'MSNP',
    Mssql: 'MSSQL',
    Mail: 'Mail',
    Munin: 'Munin',
    MySql: 'MySQL',
    Nntp: 'NNTP',
    Nntps: 'NNTPS',
    Ntp: 'NTP',
    NeighborDiscovery: 'NeighborDiscovery',
    Ospf: 'OSPF',
    OpenVpn: 'OpenVPN',
    Pca: 'PCA',
    Pmg: 'PMG',
    Pop3: 'POP3',
    Pop3S: 'POP3S',
    PptP: 'PPtP',
    Ping: 'Ping',
    PostgreSql: 'PostgreSQL',
    Printer: 'Printer',
    Rdp: 'RDP',
    Rip: 'RIP',
    Rndc: 'RNDC',
    Razor: 'Razor',
    Rdate: 'Rdate',
    Rsync: 'Rsync',
    Sane: 'SANE',
    Smb: 'SMB',
    SmBswat: 'SMBswat',
    Smtp: 'SMTP',
    Smtps: 'SMTPS',
    Snmp: 'SNMP',
    Spamd: 'SPAMD',
    SpicEproxy: 'SPICEproxy',
    Ssh: 'SSH',
    Svn: 'SVN',
    SixXs: 'SixXS',
    Squid: 'Squid',
    Submission: 'Submission',
    Syslog: 'Syslog',
    Tftp: 'TFTP',
    Telnet: 'Telnet',
    Telnets: 'Telnets',
    Time: 'Time',
    Trcrt: 'Trcrt',
    Vnc: 'VNC',
    Vncl: 'VNCL',
    Web: 'Web',
    Webcache: 'Webcache',
    Webmin: 'Webmin',
    Whois: 'Whois'
} as const;

export type UpdateFirewallRuleItemDtoMacroEnum = typeof UpdateFirewallRuleItemDtoMacroEnum[keyof typeof UpdateFirewallRuleItemDtoMacroEnum];
export const UpdateFirewallRuleItemDtoProtoEnum = {
    Tcp: 'tcp',
    Udp: 'udp',
    Icmp: 'icmp',
    Igmp: 'igmp',
    Ggp: 'ggp',
    Ipencap: 'ipencap',
    St: 'st',
    Egp: 'egp',
    Igp: 'igp',
    Pup: 'pup',
    Hmp: 'hmp',
    XnsIdp: 'xns-idp',
    Rdp: 'rdp',
    IsoTp4: 'iso-tp4',
    Dccp: 'dccp',
    Xtp: 'xtp',
    Ddp: 'ddp',
    IdprCmtp: 'idpr-cmtp',
    Ipv6: 'ipv6',
    Ipv6Route: 'ipv6-route',
    Ipv6Frag: 'ipv6-frag',
    Idrp: 'idrp',
    Rsvp: 'rsvp',
    Gre: 'gre',
    Esp: 'esp',
    Ah: 'ah',
    Skip: 'skip',
    Ipv6Icmp: 'ipv6-icmp',
    Icmpv6: 'icmpv6',
    Ipv6Nonxt: 'ipv6-nonxt',
    Ipv6Opts: 'ipv6-opts',
    Vmtp: 'vmtp',
    Eigrp: 'eigrp',
    Ospf: 'ospf',
    Ax25: 'ax.25',
    Ipip: 'ipip',
    Etherip: 'etherip',
    Encap: 'encap',
    Pim: 'pim',
    Ipcomp: 'ipcomp',
    Vrrp: 'vrrp',
    L2tp: 'l2tp',
    Isis: 'isis',
    Sctp: 'sctp',
    Fc: 'fc',
    MobilityHeader: 'mobility-header',
    Udplite: 'udplite',
    MplsInIp: 'mpls-in-ip',
    Hip: 'hip',
    Shim6: 'shim6',
    Wesp: 'wesp',
    Rohc: 'rohc'
} as const;

export type UpdateFirewallRuleItemDtoProtoEnum = typeof UpdateFirewallRuleItemDtoProtoEnum[keyof typeof UpdateFirewallRuleItemDtoProtoEnum];

/**
 * 
 * @export
 * @interface UpdateRdnsDto
 */
export interface UpdateRdnsDto {
    /**
     * Fully-qualified hostname to use as the PTR target (e.g. \"mail.example.com\"). A trailing dot is optional and will be normalized server-side.
     * @type {string}
     * @memberof UpdateRdnsDto
     */
    'ptr': string;
}
/**
 * 
 * @export
 * @interface UpdateSecuritySettingsDto
 */
export interface UpdateSecuritySettingsDto {
    /**
     * Turn scanning off for the whole account. Existing findings are kept and stay visible; they simply stop being re-checked.
     * @type {boolean}
     * @memberof UpdateSecuritySettingsDto
     */
    'enabled'?: boolean;
    /**
     * How often this account\'s instances are scanned. `daily` is not customer-selectable — see CUSTOMER_SCAN_FREQUENCIES.
     * @type {string}
     * @memberof UpdateSecuritySettingsDto
     */
    'default_frequency'?: UpdateSecuritySettingsDtoDefaultFrequencyEnum;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSecuritySettingsDto
     */
    'notify_on_new_critical'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSecuritySettingsDto
     */
    'notify_on_score_drop'?: boolean;
}

export const UpdateSecuritySettingsDtoDefaultFrequencyEnum = {
    Weekly: 'weekly',
    Monthly: 'monthly'
} as const;

export type UpdateSecuritySettingsDtoDefaultFrequencyEnum = typeof UpdateSecuritySettingsDtoDefaultFrequencyEnum[keyof typeof UpdateSecuritySettingsDtoDefaultFrequencyEnum];

/**
 * 
 * @export
 * @interface UpdateSubscriptionDto
 */
export interface UpdateSubscriptionDto {
    /**
     * User-facing display name for the subscription. Send an empty string or null to clear it.
     * @type {string}
     * @memberof UpdateSubscriptionDto
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateVmDto
 */
export interface UpdateVmDto {
    /**
     * VM name
     * @type {string}
     * @memberof UpdateVmDto
     */
    'name'?: string;
    /**
     * VM description
     * @type {string}
     * @memberof UpdateVmDto
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface UpdateVmHardware200Response
 */
export interface UpdateVmHardware200Response {
    /**
     * 
     * @type {string}
     * @memberof UpdateVmHardware200Response
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface UpdateVmHardwareDto
 */
export interface UpdateVmHardwareDto {
    /**
     * New disk interface type. Applied to ALL disks on the VM. Requires detach + re-attach — VM must be stopped.
     * @type {string}
     * @memberof UpdateVmHardwareDto
     */
    'diskInterface': UpdateVmHardwareDtoDiskInterfaceEnum;
    /**
     * New network interface model. Applied to ALL NICs on the VM.
     * @type {string}
     * @memberof UpdateVmHardwareDto
     */
    'nicModel': UpdateVmHardwareDtoNicModelEnum;
    /**
     * OS type value as defined by the hypervisor (e.g. \"l26\", \"win11\").
     * @type {string}
     * @memberof UpdateVmHardwareDto
     */
    'osType'?: UpdateVmHardwareDtoOsTypeEnum;
}

export const UpdateVmHardwareDtoDiskInterfaceEnum = {
    Virtio: 'virtio',
    Scsi: 'scsi',
    Sata: 'sata',
    Ide: 'ide'
} as const;

export type UpdateVmHardwareDtoDiskInterfaceEnum = typeof UpdateVmHardwareDtoDiskInterfaceEnum[keyof typeof UpdateVmHardwareDtoDiskInterfaceEnum];
export const UpdateVmHardwareDtoNicModelEnum = {
    Virtio: 'virtio',
    E1000: 'e1000',
    E1000e: 'e1000e',
    Rtl8139: 'rtl8139',
    Vmxnet3: 'vmxnet3'
} as const;

export type UpdateVmHardwareDtoNicModelEnum = typeof UpdateVmHardwareDtoNicModelEnum[keyof typeof UpdateVmHardwareDtoNicModelEnum];
export const UpdateVmHardwareDtoOsTypeEnum = {
    L26: 'l26',
    L24: 'l24',
    Win11: 'win11',
    Win10: 'win10',
    Win8: 'win8',
    Win7: 'win7',
    Wvista: 'wvista',
    Wxp: 'wxp',
    W2k: 'w2k',
    Solaris: 'solaris',
    Other: 'other'
} as const;

export type UpdateVmHardwareDtoOsTypeEnum = typeof UpdateVmHardwareDtoOsTypeEnum[keyof typeof UpdateVmHardwareDtoOsTypeEnum];

/**
 * 
 * @export
 * @interface UpdateVmSecuritySettingsDto
 */
export interface UpdateVmSecuritySettingsDto {
    /**
     * Turn scanning off for this instance only.
     * @type {boolean}
     * @memberof UpdateVmSecuritySettingsDto
     */
    'enabled'?: boolean;
    /**
     * How often this instance is scanned. `daily` is not customer-selectable.
     * @type {string}
     * @memberof UpdateVmSecuritySettingsDto
     */
    'schedule_frequency'?: UpdateVmSecuritySettingsDtoScheduleFrequencyEnum;
}

export const UpdateVmSecuritySettingsDtoScheduleFrequencyEnum = {
    Weekly: 'weekly',
    Monthly: 'monthly'
} as const;

export type UpdateVmSecuritySettingsDtoScheduleFrequencyEnum = typeof UpdateVmSecuritySettingsDtoScheduleFrequencyEnum[keyof typeof UpdateVmSecuritySettingsDtoScheduleFrequencyEnum];

/**
 * 
 * @export
 * @interface UpdateVpcVmsDto
 */
export interface UpdateVpcVmsDto {
    /**
     * Array of VM IDs. Empty array means remove all VMs from the VPC.
     * @type {Array<number>}
     * @memberof UpdateVpcVmsDto
     */
    'vm_id': Array<number>;
    /**
     * VPC ID
     * @type {number}
     * @memberof UpdateVpcVmsDto
     */
    'vpc_id': number;
    /**
     * Whether to restart all VPC VMs after VPC update/refresh
     * @type {boolean}
     * @memberof UpdateVpcVmsDto
     */
    'restart'?: boolean;
    /**
     * Optional private IP mappings per VM. If not provided for a VM, IP is auto-assigned.
     * @type {Array<VmPrivateIpDto>}
     * @memberof UpdateVpcVmsDto
     */
    'vm_private_ips'?: Array<VmPrivateIpDto>;
}
/**
 * 
 * @export
 * @interface UpdateVpnGatewayDto
 */
export interface UpdateVpnGatewayDto {
    /**
     * VPN Gateway Name (updates VM name)
     * @type {string}
     * @memberof UpdateVpnGatewayDto
     */
    'name'?: string;
    /**
     * VPN Protocol
     * @type {string}
     * @memberof UpdateVpnGatewayDto
     */
    'vpnProtocol'?: UpdateVpnGatewayDtoVpnProtocolEnum;
    /**
     * Default Gateway
     * @type {boolean}
     * @memberof UpdateVpnGatewayDto
     */
    'defaultGateway'?: boolean;
    /**
     * The address pool handed to people connecting with the VPN app, as an IPv4 network (e.g. 10.8.0.0/24). Must not overlap the private network or a connected site; changing it restarts the VPN server and renumbers connected clients.
     * @type {string}
     * @memberof UpdateVpnGatewayDto
     */
    'remoteAccessPool'?: string;
    /**
     * Allow duplicate common names (multiple clients/devices connecting with the same user)
     * @type {boolean}
     * @memberof UpdateVpnGatewayDto
     */
    'duplicateCn'?: boolean;
    /**
     * TUN interface MTU size (default 1420 for CGNAT/ISP compatibility)
     * @type {number}
     * @memberof UpdateVpnGatewayDto
     */
    'tunMtu'?: number;
}

export const UpdateVpnGatewayDtoVpnProtocolEnum = {
    Tcp: 'tcp',
    Udp: 'udp'
} as const;

export type UpdateVpnGatewayDtoVpnProtocolEnum = typeof UpdateVpnGatewayDtoVpnProtocolEnum[keyof typeof UpdateVpnGatewayDtoVpnProtocolEnum];

/**
 * 
 * @export
 * @interface UpdateVpnUserDto
 */
export interface UpdateVpnUserDto {
    /**
     * Username (alphanumeric characters only)
     * @type {string}
     * @memberof UpdateVpnUserDto
     */
    'username'?: string;
    /**
     * Password (leave blank to keep current password)
     * @type {string}
     * @memberof UpdateVpnUserDto
     */
    'password'?: string;
    /**
     * Email
     * @type {string}
     * @memberof UpdateVpnUserDto
     */
    'email'?: string;
    /**
     * Status
     * @type {string}
     * @memberof UpdateVpnUserDto
     */
    'status'?: UpdateVpnUserDtoStatusEnum;
    /**
     * Send credentials to user email
     * @type {boolean}
     * @memberof UpdateVpnUserDto
     */
    'sendCredentials'?: boolean;
}

export const UpdateVpnUserDtoStatusEnum = {
    Active: 'active',
    Inactive: 'inactive'
} as const;

export type UpdateVpnUserDtoStatusEnum = typeof UpdateVpnUserDtoStatusEnum[keyof typeof UpdateVpnUserDtoStatusEnum];

/**
 * 
 * @export
 * @interface UploadTicketDto
 */
export interface UploadTicketDto {
    /**
     * 
     * @type {string}
     * @memberof UploadTicketDto
     */
    'image_id': string;
    /**
     * 
     * @type {string}
     * @memberof UploadTicketDto
     */
    'upload_id': string;
    /**
     * 
     * @type {number}
     * @memberof UploadTicketDto
     */
    'part_bytes': number;
    /**
     * 
     * @type {number}
     * @memberof UploadTicketDto
     */
    'part_count': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof UploadTicketDto
     */
    'part_urls': Array<string>;
}
/**
 * 
 * @export
 * @interface UsageByKindDto
 */
export interface UsageByKindDto {
    /**
     * 
     * @type {string}
     * @memberof UsageByKindDto
     */
    'kind': UsageByKindDtoKindEnum;
    /**
     * 
     * @type {string}
     * @memberof UsageByKindDto
     */
    'total_micro_cents': string;
    /**
     * 
     * @type {number}
     * @memberof UsageByKindDto
     */
    'seconds': number;
}

export const UsageByKindDtoKindEnum = {
    Compute: 'compute',
    Storage: 'storage',
    Addon: 'addon',
    Ip: 'ip',
    License: 'license',
    Bandwidth: 'bandwidth'
} as const;

export type UsageByKindDtoKindEnum = typeof UsageByKindDtoKindEnum[keyof typeof UsageByKindDtoKindEnum];

/**
 * 
 * @export
 * @interface UsageDailyPointDto
 */
export interface UsageDailyPointDto {
    /**
     * 
     * @type {string}
     * @memberof UsageDailyPointDto
     */
    'day': string;
    /**
     * 
     * @type {string}
     * @memberof UsageDailyPointDto
     */
    'total_micro_cents': string;
    /**
     * 
     * @type {number}
     * @memberof UsageDailyPointDto
     */
    'seconds': number;
}
/**
 * 
 * @export
 * @interface UsageHourItemDto
 */
export interface UsageHourItemDto {
    /**
     * 
     * @type {string}
     * @memberof UsageHourItemDto
     */
    'resource_label'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UsageHourItemDto
     */
    'resource_type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UsageHourItemDto
     */
    'kind': UsageHourItemDtoKindEnum;
    /**
     * 
     * @type {string}
     * @memberof UsageHourItemDto
     */
    'commitment_pool': UsageHourItemDtoCommitmentPoolEnum;
    /**
     * 
     * @type {string}
     * @memberof UsageHourItemDto
     */
    'rate_micro_cents_per_hour': string;
    /**
     * 
     * @type {number}
     * @memberof UsageHourItemDto
     */
    'seconds': number;
    /**
     * 
     * @type {string}
     * @memberof UsageHourItemDto
     */
    'total_micro_cents': string;
    /**
     * 
     * @type {boolean}
     * @memberof UsageHourItemDto
     */
    'cap_applied': boolean;
}

export const UsageHourItemDtoKindEnum = {
    Compute: 'compute',
    Storage: 'storage',
    Addon: 'addon',
    Ip: 'ip',
    License: 'license',
    Bandwidth: 'bandwidth'
} as const;

export type UsageHourItemDtoKindEnum = typeof UsageHourItemDtoKindEnum[keyof typeof UsageHourItemDtoKindEnum];
export const UsageHourItemDtoCommitmentPoolEnum = {
    Committed: 'COMMITTED',
    Flexible: 'FLEXIBLE'
} as const;

export type UsageHourItemDtoCommitmentPoolEnum = typeof UsageHourItemDtoCommitmentPoolEnum[keyof typeof UsageHourItemDtoCommitmentPoolEnum];

/**
 * 
 * @export
 * @interface UsageHourPointDto
 */
export interface UsageHourPointDto {
    /**
     * 
     * @type {string}
     * @memberof UsageHourPointDto
     */
    'hour': string;
    /**
     * 
     * @type {string}
     * @memberof UsageHourPointDto
     */
    'total_micro_cents': string;
    /**
     * 
     * @type {number}
     * @memberof UsageHourPointDto
     */
    'seconds': number;
    /**
     * 
     * @type {Array<UsageHourItemDto>}
     * @memberof UsageHourPointDto
     */
    'items': Array<UsageHourItemDto>;
}
/**
 * 
 * @export
 * @interface UsageHourlyReportDto
 */
export interface UsageHourlyReportDto {
    /**
     * 
     * @type {string}
     * @memberof UsageHourlyReportDto
     */
    'from': string;
    /**
     * 
     * @type {string}
     * @memberof UsageHourlyReportDto
     */
    'to': string;
    /**
     * True when the window holds more hours than the response carries — `hours` is then the newest `limit_hours` of them
     * @type {boolean}
     * @memberof UsageHourlyReportDto
     */
    'truncated': boolean;
    /**
     * 
     * @type {number}
     * @memberof UsageHourlyReportDto
     */
    'limit_hours': number;
    /**
     * 
     * @type {Array<UsageHourPointDto>}
     * @memberof UsageHourlyReportDto
     */
    'hours': Array<UsageHourPointDto>;
}
/**
 * 
 * @export
 * @interface UsageReportDto
 */
export interface UsageReportDto {
    /**
     * 
     * @type {string}
     * @memberof UsageReportDto
     */
    'from': string;
    /**
     * 
     * @type {string}
     * @memberof UsageReportDto
     */
    'to': string;
    /**
     * 
     * @type {string}
     * @memberof UsageReportDto
     */
    'total_micro_cents': string;
    /**
     * 
     * @type {Array<UsageDailyPointDto>}
     * @memberof UsageReportDto
     */
    'daily': Array<UsageDailyPointDto>;
    /**
     * 
     * @type {Array<UsageByKindDto>}
     * @memberof UsageReportDto
     */
    'by_kind': Array<UsageByKindDto>;
}
/**
 * 
 * @export
 * @interface ValidateClientImageCloudInitDto
 */
export interface ValidateClientImageCloudInitDto {
    /**
     * The document to check. Nothing is stored.
     * @type {string}
     * @memberof ValidateClientImageCloudInitDto
     */
    'user_data': string;
    /**
     * Check against this agent instead of the image’s own. Only useful before the OS type has been set correctly.
     * @type {string}
     * @memberof ValidateClientImageCloudInitDto
     */
    'family'?: ValidateClientImageCloudInitDtoFamilyEnum;
}

export const ValidateClientImageCloudInitDtoFamilyEnum = {
    CloudInit: 'cloud-init',
    CloudbaseInit: 'cloudbase-init'
} as const;

export type ValidateClientImageCloudInitDtoFamilyEnum = typeof ValidateClientImageCloudInitDtoFamilyEnum[keyof typeof ValidateClientImageCloudInitDtoFamilyEnum];

/**
 * 
 * @export
 * @interface VendorConfigDto
 */
export interface VendorConfigDto {
    /**
     * 
     * @type {string}
     * @memberof VendorConfigDto
     */
    'filename': string;
    /**
     * 
     * @type {string}
     * @memberof VendorConfigDto
     */
    'content_type': string;
    /**
     * 
     * @type {string}
     * @memberof VendorConfigDto
     */
    'content': string;
    /**
     * 
     * @type {Array<VendorNoteDto>}
     * @memberof VendorConfigDto
     */
    'notes': Array<VendorNoteDto>;
}
/**
 * 
 * @export
 * @interface VendorConfigOptionDto
 */
export interface VendorConfigOptionDto {
    /**
     * 
     * @type {string}
     * @memberof VendorConfigOptionDto
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof VendorConfigOptionDto
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof VendorConfigOptionDto
     */
    'label_code': VendorConfigOptionDtoLabelCodeEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof VendorConfigOptionDto
     */
    'recommended': boolean;
}

export const VendorConfigOptionDtoLabelCodeEnum = {
    SettingsSheet: 'settings_sheet'
} as const;

export type VendorConfigOptionDtoLabelCodeEnum = typeof VendorConfigOptionDtoLabelCodeEnum[keyof typeof VendorConfigOptionDtoLabelCodeEnum];

/**
 * 
 * @export
 * @interface VendorNoteDto
 */
export interface VendorNoteDto {
    /**
     * 
     * @type {string}
     * @memberof VendorNoteDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof VendorNoteDto
     */
    'message': string;
    /**
     * 
     * @type {object}
     * @memberof VendorNoteDto
     */
    'params'?: object;
}
/**
 * 
 * @export
 * @interface VerifyTwoFactorDto
 */
export interface VerifyTwoFactorDto {
    /**
     * Challenge ID returned by the login endpoint.
     * @type {string}
     * @memberof VerifyTwoFactorDto
     */
    'challengeId': string;
    /**
     * Six-digit verification code sent to the account email. Omit when resubmitting after account_selection_required.
     * @type {string}
     * @memberof VerifyTwoFactorDto
     */
    'code'?: string;
    /**
     * Device ID
     * @type {string}
     * @memberof VerifyTwoFactorDto
     */
    'deviceId': string;
    /**
     * Remember me option
     * @type {boolean}
     * @memberof VerifyTwoFactorDto
     */
    'rememberMe'?: boolean;
    /**
     * WHMCS client account ID to start a session for (when the user manages multiple accounts).
     * @type {number}
     * @memberof VerifyTwoFactorDto
     */
    'clientId'?: number;
}
/**
 * 
 * @export
 * @interface VmBandwidthCycleDto
 */
export interface VmBandwidthCycleDto {
    /**
     * Start of the current billing window
     * @type {string}
     * @memberof VmBandwidthCycleDto
     */
    'starts_at': string;
    /**
     * End of the current billing window
     * @type {string}
     * @memberof VmBandwidthCycleDto
     */
    'ends_at': string;
    /**
     * Public outbound traffic included in the plan for this window, in GB (0 = no franchise configured)
     * @type {number}
     * @memberof VmBandwidthCycleDto
     */
    'included_gb': number;
    /**
     * Public outbound bytes transferred in this window
     * @type {number}
     * @memberof VmBandwidthCycleDto
     */
    'public_outbound_bytes': number;
}
/**
 * 
 * @export
 * @interface VmBandwidthResponseDto
 */
export interface VmBandwidthResponseDto {
    /**
     * VM ID from database
     * @type {number}
     * @memberof VmBandwidthResponseDto
     */
    'vm_id': number;
    /**
     * Requested period
     * @type {string}
     * @memberof VmBandwidthResponseDto
     */
    'period': VmBandwidthResponseDtoPeriodEnum;
    /**
     * Bucket size of each series point
     * @type {string}
     * @memberof VmBandwidthResponseDto
     */
    'bucket': VmBandwidthResponseDtoBucketEnum;
    /**
     * Start of the reported range (ISO 8601)
     * @type {string}
     * @memberof VmBandwidthResponseDto
     */
    'starts_at': string;
    /**
     * End of the reported range (ISO 8601)
     * @type {string}
     * @memberof VmBandwidthResponseDto
     */
    'ends_at': string;
    /**
     * Transferred volume per time bucket (zero-filled)
     * @type {Array<BandwidthDataPoint>}
     * @memberof VmBandwidthResponseDto
     */
    'series': Array<BandwidthDataPoint>;
    /**
     * Total bytes received in the period
     * @type {number}
     * @memberof VmBandwidthResponseDto
     */
    'total_inbound_bytes': number;
    /**
     * Total bytes sent in the period
     * @type {number}
     * @memberof VmBandwidthResponseDto
     */
    'total_outbound_bytes': number;
    /**
     * Current billing-cycle public outbound usage. Only present for period=current_cycle when the VM has an active billing subscription.
     * @type {VmBandwidthCycleDto}
     * @memberof VmBandwidthResponseDto
     */
    'cycle'?: VmBandwidthCycleDto | null;
}

export const VmBandwidthResponseDtoPeriodEnum = {
    CurrentCycle: 'current_cycle',
    Day: 'day',
    Week: 'week',
    Month: 'month',
    Year: 'year'
} as const;

export type VmBandwidthResponseDtoPeriodEnum = typeof VmBandwidthResponseDtoPeriodEnum[keyof typeof VmBandwidthResponseDtoPeriodEnum];
export const VmBandwidthResponseDtoBucketEnum = {
    Hour: 'hour',
    Day: 'day',
    Month: 'month'
} as const;

export type VmBandwidthResponseDtoBucketEnum = typeof VmBandwidthResponseDtoBucketEnum[keyof typeof VmBandwidthResponseDtoBucketEnum];

/**
 * 
 * @export
 * @interface VmEntity
 */
export interface VmEntity {
    /**
     * 
     * @type {number}
     * @memberof VmEntity
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof VmEntity
     */
    'user_id': number;
    /**
     * 
     * @type {number}
     * @memberof VmEntity
     */
    'offering_id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof VmEntity
     */
    'username'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VmEntity
     */
    'server_id': number;
    /**
     * 
     * @type {number}
     * @memberof VmEntity
     */
    'template_id': number;
    /**
     * 
     * @type {number}
     * @memberof VmEntity
     */
    'vcores': number;
    /**
     * 
     * @type {number}
     * @memberof VmEntity
     */
    'ram': number;
    /**
     * 
     * @type {boolean}
     * @memberof VmEntity
     */
    'running': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VmEntity
     */
    'suspended': boolean;
    /**
     * Start of the current suspension in effective time — backdated by any time already served under a suspension a payment hold lifted (null when not suspended).
     * @type {string}
     * @memberof VmEntity
     */
    'suspended_at'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VmEntity
     */
    'port': number;
    /**
     * 
     * @type {string}
     * @memberof VmEntity
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof VmEntity
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof VmEntity
     */
    'deleted_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof VmEntity
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof VmEntity
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof VmEntity
     */
    'project_id': number;
    /**
     * 
     * @type {number}
     * @memberof VmEntity
     */
    'account_id': number;
    /**
     * 
     * @type {ServerEntity}
     * @memberof VmEntity
     */
    'servers': ServerEntity;
    /**
     * 
     * @type {VmHostnameEntity}
     * @memberof VmEntity
     */
    'vm_hostnames': VmHostnameEntity;
    /**
     * 
     * @type {Array<VmIpAssignmentEntity>}
     * @memberof VmEntity
     */
    'ip_assignments': Array<VmIpAssignmentEntity>;
    /**
     * 
     * @type {VpcVmsEntity}
     * @memberof VmEntity
     */
    'vpc_vms': VpcVmsEntity;
    /**
     * 
     * @type {number}
     * @memberof VmEntity
     */
    'storage_gb'?: number | null;
    /**
     * 
     * @type {VmOfferingEntity}
     * @memberof VmEntity
     */
    'offering'?: VmOfferingEntity | null;
    /**
     * UUID of the billing subscription this VM belongs to, if any.
     * @type {string}
     * @memberof VmEntity
     */
    'subscription_id'?: string | null;
    /**
     * Display name of the billing subscription this VM belongs to.
     * @type {string}
     * @memberof VmEntity
     */
    'subscription_name'?: string | null;
    /**
     * 
     * @type {VmTemplateEntity}
     * @memberof VmEntity
     */
    'template'?: VmTemplateEntity | null;
}
/**
 * 
 * @export
 * @interface VmGuestFilesystemDto
 */
export interface VmGuestFilesystemDto {
    /**
     * Mount point, e.g. `/`, `/boot`, `C:\\`.
     * @type {string}
     * @memberof VmGuestFilesystemDto
     */
    'mountpoint': string;
    /**
     * Bytes used on this filesystem.
     * @type {number}
     * @memberof VmGuestFilesystemDto
     */
    'used_bytes': number;
    /**
     * Capacity of this filesystem in bytes.
     * @type {number}
     * @memberof VmGuestFilesystemDto
     */
    'total_bytes': number;
}
/**
 * 
 * @export
 * @interface VmHostnameEntity
 */
export interface VmHostnameEntity {
    /**
     * 
     * @type {number}
     * @memberof VmHostnameEntity
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof VmHostnameEntity
     */
    'vm_id': number;
    /**
     * 
     * @type {number}
     * @memberof VmHostnameEntity
     */
    'hostname_domain_id': number;
    /**
     * 
     * @type {string}
     * @memberof VmHostnameEntity
     */
    'hostname': string;
    /**
     * 
     * @type {string}
     * @memberof VmHostnameEntity
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof VmHostnameEntity
     */
    'updated_at': string;
    /**
     * 
     * @type {HostnameDomainEntity}
     * @memberof VmHostnameEntity
     */
    'hostname_domains': HostnameDomainEntity;
}
/**
 * 
 * @export
 * @interface VmInfoDto
 */
export interface VmInfoDto {
    /**
     * VM ID
     * @type {number}
     * @memberof VmInfoDto
     */
    'id': number;
    /**
     * VM Name
     * @type {string}
     * @memberof VmInfoDto
     */
    'name'?: string | null;
    /**
     * VM Running Status
     * @type {boolean}
     * @memberof VmInfoDto
     */
    'running': boolean;
    /**
     * Created At
     * @type {string}
     * @memberof VmInfoDto
     */
    'created_at'?: string;
    /**
     * Updated At
     * @type {string}
     * @memberof VmInfoDto
     */
    'updated_at'?: string;
    /**
     * Server Information
     * @type {ServerInfoDto}
     * @memberof VmInfoDto
     */
    'servers': ServerInfoDto;
}
/**
 * 
 * @export
 * @interface VmIpAssignmentEntity
 */
export interface VmIpAssignmentEntity {
    /**
     * 
     * @type {string}
     * @memberof VmIpAssignmentEntity
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof VmIpAssignmentEntity
     */
    'vm_id': number;
    /**
     * 
     * @type {number}
     * @memberof VmIpAssignmentEntity
     */
    'account_id': number | null;
    /**
     * 
     * @type {string}
     * @memberof VmIpAssignmentEntity
     */
    'ip_version': VmIpAssignmentEntityIpVersionEnum;
    /**
     * 
     * @type {number}
     * @memberof VmIpAssignmentEntity
     */
    'ip_id': number | null;
    /**
     * 
     * @type {number}
     * @memberof VmIpAssignmentEntity
     */
    'ipv6_id': number | null;
    /**
     * 
     * @type {number}
     * @memberof VmIpAssignmentEntity
     */
    'rate_limit': number;
    /**
     * 
     * @type {string}
     * @memberof VmIpAssignmentEntity
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof VmIpAssignmentEntity
     */
    'mode': VmIpAssignmentEntityModeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof VmIpAssignmentEntity
     */
    'primary': boolean;
    /**
     * 
     * @type {string}
     * @memberof VmIpAssignmentEntity
     */
    'assigned_at': string;
    /**
     * 
     * @type {string}
     * @memberof VmIpAssignmentEntity
     */
    'released_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof VmIpAssignmentEntity
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof VmIpAssignmentEntity
     */
    'updated_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof VmIpAssignmentEntity
     */
    'deleted_at': string | null;
    /**
     * 
     * @type {IpEntity}
     * @memberof VmIpAssignmentEntity
     */
    'ips': IpEntity | null;
    /**
     * 
     * @type {Ipv6Entity}
     * @memberof VmIpAssignmentEntity
     */
    'ipv6': Ipv6Entity | null;
}

export const VmIpAssignmentEntityIpVersionEnum = {
    V4: 'v4',
    V6: 'v6'
} as const;

export type VmIpAssignmentEntityIpVersionEnum = typeof VmIpAssignmentEntityIpVersionEnum[keyof typeof VmIpAssignmentEntityIpVersionEnum];
export const VmIpAssignmentEntityModeEnum = {
    Fixed: 'fixed',
    Floating: 'floating'
} as const;

export type VmIpAssignmentEntityModeEnum = typeof VmIpAssignmentEntityModeEnum[keyof typeof VmIpAssignmentEntityModeEnum];

/**
 * 
 * @export
 * @interface VmMetricsResponseDto
 */
export interface VmMetricsResponseDto {
    /**
     * VM ID from database
     * @type {number}
     * @memberof VmMetricsResponseDto
     */
    'vm_id': number;
    /**
     * Timeframe of the metrics data
     * @type {string}
     * @memberof VmMetricsResponseDto
     */
    'timeframe': string;
    /**
     * Array of metrics data points
     * @type {Array<MetricsDataPoint>}
     * @memberof VmMetricsResponseDto
     */
    'data': Array<MetricsDataPoint>;
    /**
     * Whether data was retrieved from cache
     * @type {boolean}
     * @memberof VmMetricsResponseDto
     */
    'cached': boolean;
    /**
     * Cache expiration timestamp
     * @type {string}
     * @memberof VmMetricsResponseDto
     */
    'cache_expires_at'?: string;
}
/**
 * 
 * @export
 * @interface VmOfferingEntity
 */
export interface VmOfferingEntity {
    /**
     * 
     * @type {string}
     * @memberof VmOfferingEntity
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof VmOfferingEntity
     */
    'name': string;
    /**
     * COMPUTE | VPN_GATEWAY
     * @type {string}
     * @memberof VmOfferingEntity
     */
    'offering_kind': string;
    /**
     * 
     * @type {number}
     * @memberof VmOfferingEntity
     */
    'vcpu': number;
    /**
     * 
     * @type {number}
     * @memberof VmOfferingEntity
     */
    'ram_mb': number;
    /**
     * 
     * @type {number}
     * @memberof VmOfferingEntity
     */
    'main_disk_base_gb': number;
}
/**
 * 
 * @export
 * @interface VmOperationRequestDto
 */
export interface VmOperationRequestDto {
    /**
     * The operation to perform on the VM
     * @type {string}
     * @memberof VmOperationRequestDto
     */
    'operation': VmOperationRequestDtoOperationEnum;
}

export const VmOperationRequestDtoOperationEnum = {
    Start: 'start',
    Stop: 'stop',
    Reboot: 'reboot'
} as const;

export type VmOperationRequestDtoOperationEnum = typeof VmOperationRequestDtoOperationEnum[keyof typeof VmOperationRequestDtoOperationEnum];

/**
 * 
 * @export
 * @interface VmOperationResponseDto
 */
export interface VmOperationResponseDto {
    /**
     * Indicates if the operation was successful
     * @type {boolean}
     * @memberof VmOperationResponseDto
     */
    'success': boolean;
    /**
     * A message describing the result of the operation
     * @type {string}
     * @memberof VmOperationResponseDto
     */
    'message': string;
    /**
     * Task ID for tracking the operation progress
     * @type {string}
     * @memberof VmOperationResponseDto
     */
    'task_id': string;
    /**
     * VM ID from database
     * @type {number}
     * @memberof VmOperationResponseDto
     */
    'vm_id': number;
    /**
     * The operation that was performed
     * @type {string}
     * @memberof VmOperationResponseDto
     */
    'operation': VmOperationResponseDtoOperationEnum;
}

export const VmOperationResponseDtoOperationEnum = {
    Start: 'start',
    Stop: 'stop',
    Reboot: 'reboot'
} as const;

export type VmOperationResponseDtoOperationEnum = typeof VmOperationResponseDtoOperationEnum[keyof typeof VmOperationResponseDtoOperationEnum];

/**
 * 
 * @export
 * @interface VmPrivateIpDto
 */
export interface VmPrivateIpDto {
    /**
     * VM ID
     * @type {number}
     * @memberof VmPrivateIpDto
     */
    'vm_id': number;
    /**
     * Private IP to assign to this VM within the VPC subnet
     * @type {string}
     * @memberof VmPrivateIpDto
     */
    'private_ip'?: string;
}
/**
 * 
 * @export
 * @interface VmRemovalPreviewBalanceDto
 */
export interface VmRemovalPreviewBalanceDto {
    /**
     * The COMMITTED pool as it stands: what this cycle\'s renewal funded minus what the meter has drawn. Negative when the cycle is being consumed without its renewal paid.
     * @type {string}
     * @memberof VmRemovalPreviewBalanceDto
     */
    'committed_micro_cents': string;
    /**
     * 
     * @type {string}
     * @memberof VmRemovalPreviewBalanceDto
     */
    'available_micro_cents': string;
    /**
     * 
     * @type {string}
     * @memberof VmRemovalPreviewBalanceDto
     */
    'temporary_micro_cents': string;
    /**
     * 
     * @type {string}
     * @memberof VmRemovalPreviewBalanceDto
     */
    'negative_micro_cents': string;
    /**
     * available + temporary − negative as it stands now, before the removal.
     * @type {string}
     * @memberof VmRemovalPreviewBalanceDto
     */
    'usable_now_micro_cents': string;
    /**
     * usable_now plus the removal credit: what the subscription will hold for new instances once this one is gone.
     * @type {string}
     * @memberof VmRemovalPreviewBalanceDto
     */
    'usable_after_micro_cents': string;
}
/**
 * 
 * @export
 * @interface VmRemovalPreviewCreditDto
 */
export interface VmRemovalPreviewCreditDto {
    /**
     * Temporary credit the removal returns to the subscription, in micro-cents. Zero when `none_reason` is set.
     * @type {string}
     * @memberof VmRemovalPreviewCreditDto
     */
    'amount_micro_cents': string;
    /**
     * Hours of the commitment the instance has used this cycle, counting the hour in progress (the meter bills it in full).
     * @type {number}
     * @memberof VmRemovalPreviewCreditDto
     */
    'hours_charged': number;
    /**
     * Hours of the commitment that come back as credit.
     * @type {number}
     * @memberof VmRemovalPreviewCreditDto
     */
    'billable_hours_remaining': number;
    /**
     * Commitment hours in the cycle (term cap plus any paid extension).
     * @type {number}
     * @memberof VmRemovalPreviewCreditDto
     */
    'cap_hours': number;
    /**
     * True when the credit is less than the unused hours are worth because only part of this cycle\'s renewal was paid (the rest is on an open invoice): what comes back is what was paid for, not the hours.
     * @type {boolean}
     * @memberof VmRemovalPreviewCreditDto
     */
    'limited_by_balance': boolean;
    /**
     * When the credit expires if unspent — the end of the current cycle.
     * @type {string}
     * @memberof VmRemovalPreviewCreditDto
     */
    'expires_at': string | null;
    /**
     * Why nothing comes back: `cap_reached` (the commitment is fully used this cycle), `cycle_ended` (the cycle is over and awaiting renewal) or `trial` (platform-sponsored credit is not refundable), or `unfunded` (the renewal invoice of this cycle has not been paid, so there is no prepaid commitment to return; the invoice stays due). Null when credit is returned.
     * @type {string}
     * @memberof VmRemovalPreviewCreditDto
     */
    'none_reason': string | null;
}
/**
 * 
 * @export
 * @interface VmRemovalPreviewDto
 */
export interface VmRemovalPreviewDto {
    /**
     * `committed`: the instance is billed under a commitment and its unused part returns as temporary credit. `on_demand`: billed by the hour, billing simply stops. `unbilled`: no live billing resource is linked to the instance, so deleting it changes nothing on any balance.
     * @type {string}
     * @memberof VmRemovalPreviewDto
     */
    'billing': string;
    /**
     * 
     * @type {VmRemovalPreviewSubscriptionDto}
     * @memberof VmRemovalPreviewDto
     */
    'subscription': VmRemovalPreviewSubscriptionDto | null;
    /**
     * Combined hourly rate of the live billing resources linked to the instance, in micro-cents.
     * @type {string}
     * @memberof VmRemovalPreviewDto
     */
    'hourly_rate_micro_cents': string | null;
    /**
     * Set only when `billing` is `committed`.
     * @type {VmRemovalPreviewCreditDto}
     * @memberof VmRemovalPreviewDto
     */
    'credit': VmRemovalPreviewCreditDto | null;
    /**
     * 
     * @type {VmRemovalPreviewBalanceDto}
     * @memberof VmRemovalPreviewDto
     */
    'balance': VmRemovalPreviewBalanceDto | null;
    /**
     * True when this instance is the last live service on its subscription. The subscription is then parked as `inactive` (its balance stays and it remains selectable at checkout) until a new instance is added to it.
     * @type {boolean}
     * @memberof VmRemovalPreviewDto
     */
    'last_service': boolean;
    /**
     * True when the subscription is scheduled for cancellation at the end of the current cycle; credit returned by the removal would be settled with it.
     * @type {boolean}
     * @memberof VmRemovalPreviewDto
     */
    'pending_cancellation': boolean;
    /**
     * Reasons the deletion will be refused as it stands: a billing resource locked by a pending move (`pending_move`) or account transfer (`pending_transfer`), or a pending subscription conversion (`pending_conversion`). Empty when the deletion can proceed.
     * @type {Array<string>}
     * @memberof VmRemovalPreviewDto
     */
    'blockers': Array<string>;
}
/**
 * 
 * @export
 * @interface VmRemovalPreviewSubscriptionDto
 */
export interface VmRemovalPreviewSubscriptionDto {
    /**
     * 
     * @type {string}
     * @memberof VmRemovalPreviewSubscriptionDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof VmRemovalPreviewSubscriptionDto
     */
    'name': string | null;
    /**
     * active | suspended | inactive | cancelled
     * @type {string}
     * @memberof VmRemovalPreviewSubscriptionDto
     */
    'status': string;
    /**
     * COMMITTED | ON_DEMAND
     * @type {string}
     * @memberof VmRemovalPreviewSubscriptionDto
     */
    'commitment_type': string;
    /**
     * MONTHLY | QUARTERLY | SEMI_ANNUAL | ANNUAL | ON_DEMAND
     * @type {string}
     * @memberof VmRemovalPreviewSubscriptionDto
     */
    'term_kind': string | null;
    /**
     * 
     * @type {string}
     * @memberof VmRemovalPreviewSubscriptionDto
     */
    'current_cycle_ends_at': string | null;
}
/**
 * 
 * @export
 * @interface VmSecurityPostureDto
 */
export interface VmSecurityPostureDto {
    /**
     * 
     * @type {number}
     * @memberof VmSecurityPostureDto
     */
    'vm_id': number;
    /**
     * Why there is or is not a score. Render the state, not a placeholder number.
     * @type {VmSecurityPostureState}
     * @memberof VmSecurityPostureDto
     */
    'state': VmSecurityPostureState;
    /**
     * 
     * @type {string}
     * @memberof VmSecurityPostureDto
     */
    'excluded_reason': string | null;
    /**
     * 
     * @type {number}
     * @memberof VmSecurityPostureDto
     */
    'score': number | null;
    /**
     * 
     * @type {string}
     * @memberof VmSecurityPostureDto
     */
    'grade': string | null;
    /**
     * 
     * @type {string}
     * @memberof VmSecurityPostureDto
     */
    'last_scan_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof VmSecurityPostureDto
     */
    'next_scan_due_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof VmSecurityPostureDto
     */
    'schedule_frequency': string | null;
    /**
     * Per-engine score and freshness for this instance.
     * @type {Array<SecurityEngineScoreDto>}
     * @memberof VmSecurityPostureDto
     */
    'engines'?: Array<SecurityEngineScoreDto>;
    /**
     * 
     * @type {SeverityCountsDto}
     * @memberof VmSecurityPostureDto
     */
    'counts': SeverityCountsDto;
    /**
     * 
     * @type {boolean}
     * @memberof VmSecurityPostureDto
     */
    'scanning_enabled_globally': boolean;
}


/**
 * Why there is or is not a score. Render the state, not a placeholder number.
 * @export
 * @enum {string}
 */

export const VmSecurityPostureState = {
    Assessed: 'assessed',
    NotYetScanned: 'not_yet_scanned',
    Excluded: 'excluded',
    OptedOut: 'opted_out',
    AccountOptedOut: 'account_opted_out',
    NoTarget: 'no_target'
} as const;

export type VmSecurityPostureState = typeof VmSecurityPostureState[keyof typeof VmSecurityPostureState];


/**
 * 
 * @export
 * @interface VmStatusResponseDto
 */
export interface VmStatusResponseDto {
    /**
     * VM ID from database
     * @type {number}
     * @memberof VmStatusResponseDto
     */
    'vm_id': number;
    /**
     * Current VM status
     * @type {string}
     * @memberof VmStatusResponseDto
     */
    'status': string;
    /**
     * Whether the VM is administratively suspended
     * @type {boolean}
     * @memberof VmStatusResponseDto
     */
    'suspended': boolean;
    /**
     * VM uptime in seconds
     * @type {number}
     * @memberof VmStatusResponseDto
     */
    'uptime'?: number;
    /**
     * CPU usage (0-1)
     * @type {number}
     * @memberof VmStatusResponseDto
     */
    'cpu'?: number;
    /**
     * Number of CPUs
     * @type {number}
     * @memberof VmStatusResponseDto
     */
    'cpus'?: number;
    /**
     * Memory usage in bytes
     * @type {number}
     * @memberof VmStatusResponseDto
     */
    'mem'?: number;
    /**
     * Maximum memory in bytes
     * @type {number}
     * @memberof VmStatusResponseDto
     */
    'maxmem'?: number;
    /**
     * Hypervisor disk usage in bytes. Always 0 for VMs — use guest_disk_used.
     * @type {number}
     * @memberof VmStatusResponseDto
     * @deprecated
     */
    'disk'?: number;
    /**
     * Provisioned disk size in bytes
     * @type {number}
     * @memberof VmStatusResponseDto
     */
    'maxdisk'?: number;
    /**
     * Whether real in-guest disk usage could be read: `ok` (figures below are present), `stopped` (instance is off), or `agent_unavailable` (no QEMU guest agent answering).
     * @type {string}
     * @memberof VmStatusResponseDto
     */
    'guest_disk_state'?: VmStatusResponseDtoGuestDiskStateEnum;
    /**
     * Bytes used across the guest\'s real filesystems, via the QEMU guest agent. Only present when guest_disk_state is `ok`.
     * @type {number}
     * @memberof VmStatusResponseDto
     */
    'guest_disk_used'?: number;
    /**
     * Total bytes across the guest\'s real filesystems, via the QEMU guest agent. Only present when guest_disk_state is `ok`.
     * @type {number}
     * @memberof VmStatusResponseDto
     */
    'guest_disk_total'?: number;
    /**
     * Every real filesystem the guest reports, busiest first. A guest almost always mounts more than one (`/` and `/boot` at minimum), and the aggregate above hides a volume that is nearly full — read this to show per-volume usage. Only present when guest_disk_state is `ok`.
     * @type {Array<VmGuestFilesystemDto>}
     * @memberof VmStatusResponseDto
     */
    'guest_filesystems'?: Array<VmGuestFilesystemDto>;
    /**
     * Disk read in bytes
     * @type {number}
     * @memberof VmStatusResponseDto
     */
    'diskread'?: number;
    /**
     * Disk write in bytes
     * @type {number}
     * @memberof VmStatusResponseDto
     */
    'diskwrite'?: number;
    /**
     * Network input in bytes
     * @type {number}
     * @memberof VmStatusResponseDto
     */
    'netin'?: number;
    /**
     * Network output in bytes
     * @type {number}
     * @memberof VmStatusResponseDto
     */
    'netout'?: number;
    /**
     * VM name as reported by the hypervisor
     * @type {string}
     * @memberof VmStatusResponseDto
     */
    'name'?: string;
    /**
     * QMP status
     * @type {string}
     * @memberof VmStatusResponseDto
     */
    'qmpstatus'?: string;
    /**
     * Process ID
     * @type {number}
     * @memberof VmStatusResponseDto
     */
    'pid'?: number;
    /**
     * CPU shares
     * @type {number}
     * @memberof VmStatusResponseDto
     */
    'shares'?: number;
    /**
     * HA status
     * @type {object}
     * @memberof VmStatusResponseDto
     */
    'ha'?: object;
    /**
     * Lock status
     * @type {string}
     * @memberof VmStatusResponseDto
     */
    'lock'?: string;
    /**
     * Running machine type
     * @type {string}
     * @memberof VmStatusResponseDto
     */
    'running_machine'?: string;
    /**
     * Running QEMU version
     * @type {string}
     * @memberof VmStatusResponseDto
     */
    'running_qemu'?: string;
    /**
     * VM tags
     * @type {string}
     * @memberof VmStatusResponseDto
     */
    'tags'?: string;
    /**
     * Balloon memory info
     * @type {object}
     * @memberof VmStatusResponseDto
     */
    'ballooninfo'?: object;
    /**
     * Whether VM is currently being deployed
     * @type {boolean}
     * @memberof VmStatusResponseDto
     */
    'is_deploying': boolean;
    /**
     * Whether VM is currently being backed up
     * @type {boolean}
     * @memberof VmStatusResponseDto
     */
    'is_backing_up': boolean;
    /**
     * Whether VM is currently being restored
     * @type {boolean}
     * @memberof VmStatusResponseDto
     */
    'is_restoring': boolean;
    /**
     * The operation currently holding the instance, or null when idle. Any write the API would refuse with 409 VM_OPERATION_IN_PROGRESS is refused for this; the console disables the matching controls on it.
     * @type {ActiveVmOperationDto}
     * @memberof VmStatusResponseDto
     */
    'active_operation'?: ActiveVmOperationDto | null;
    /**
     * Deployment progress percentage (0-100)
     * @type {number}
     * @memberof VmStatusResponseDto
     */
    'deployment_progress'?: number;
    /**
     * Deployment status from app_jobs
     * @type {string}
     * @memberof VmStatusResponseDto
     */
    'deployment_status'?: VmStatusResponseDtoDeploymentStatusEnum;
    /**
     * When the deployment reached a terminal state. Present for a recently failed or cancelled deployment so the console can show the outcome and then stop showing it.
     * @type {string}
     * @memberof VmStatusResponseDto
     */
    'deployment_ended_at'?: string | null;
    /**
     * Last deployment stage marked complete. Superseded by deployment_phase for progress display; kept for compatibility.
     * @type {string}
     * @memberof VmStatusResponseDto
     */
    'deployment_stage'?: VmStatusResponseDtoDeploymentStageEnum;
    /**
     * Phase the deployment is currently in
     * @type {string}
     * @memberof VmStatusResponseDto
     */
    'deployment_phase'?: VmStatusResponseDtoDeploymentPhaseEnum;
    /**
     * Ordered phase checklist for the running deployment, so the console can render steps without inferring them
     * @type {Array<DeploymentPhaseDto>}
     * @memberof VmStatusResponseDto
     */
    'deployment_phases'?: Array<DeploymentPhaseDto>;
    /**
     * Estimated seconds remaining for the deployment; null when it cannot be estimated
     * @type {number}
     * @memberof VmStatusResponseDto
     */
    'deployment_eta_seconds'?: number | null;
    /**
     * Human-readable description of the current deployment step
     * @type {string}
     * @memberof VmStatusResponseDto
     */
    'deployment_message'?: string;
    /**
     * Whether data was retrieved from cache
     * @type {boolean}
     * @memberof VmStatusResponseDto
     */
    'cached': boolean;
    /**
     * Cache expiration timestamp
     * @type {string}
     * @memberof VmStatusResponseDto
     */
    'cache_expires_at'?: string;
}

export const VmStatusResponseDtoGuestDiskStateEnum = {
    Ok: 'ok',
    Stopped: 'stopped',
    AgentUnavailable: 'agent_unavailable'
} as const;

export type VmStatusResponseDtoGuestDiskStateEnum = typeof VmStatusResponseDtoGuestDiskStateEnum[keyof typeof VmStatusResponseDtoGuestDiskStateEnum];
export const VmStatusResponseDtoDeploymentStatusEnum = {
    Pending: 'pending',
    InProgress: 'in_progress',
    Completed: 'completed',
    Failed: 'failed',
    Cancelled: 'cancelled'
} as const;

export type VmStatusResponseDtoDeploymentStatusEnum = typeof VmStatusResponseDtoDeploymentStatusEnum[keyof typeof VmStatusResponseDtoDeploymentStatusEnum];
export const VmStatusResponseDtoDeploymentStageEnum = {
    Stage1: 'stage1',
    Stage2: 'stage2',
    Stage3: 'stage3'
} as const;

export type VmStatusResponseDtoDeploymentStageEnum = typeof VmStatusResponseDtoDeploymentStageEnum[keyof typeof VmStatusResponseDtoDeploymentStageEnum];
export const VmStatusResponseDtoDeploymentPhaseEnum = {
    Prepare: 'prepare',
    Clone: 'clone',
    Configure: 'configure',
    CloudInit: 'cloud_init',
    Boot: 'boot',
    GuestSetup: 'guest_setup',
    PostInstall: 'post_install',
    Finalize: 'finalize'
} as const;

export type VmStatusResponseDtoDeploymentPhaseEnum = typeof VmStatusResponseDtoDeploymentPhaseEnum[keyof typeof VmStatusResponseDtoDeploymentPhaseEnum];

/**
 * 
 * @export
 * @interface VmTemplateEntity
 */
export interface VmTemplateEntity {
    /**
     * 
     * @type {number}
     * @memberof VmTemplateEntity
     */
    'id': number;
    /**
     * Customer-facing image name, e.g. \"Ubuntu 24.04\".
     * @type {string}
     * @memberof VmTemplateEntity
     */
    'display_name': string;
    /**
     * Image family (linux | windows), when classified.
     * @type {string}
     * @memberof VmTemplateEntity
     */
    'os_family'?: string | null;
    /**
     * Staff-chosen icon for the image; absent when never set.
     * @type {string}
     * @memberof VmTemplateEntity
     */
    'icon_url'?: string | null;
    /**
     * Login the image ships with (e.g. root, ubuntu, Administrator) — what a customer needs to connect. Null when the image defines none.
     * @type {string}
     * @memberof VmTemplateEntity
     */
    'default_username'?: string | null;
}
/**
 * 
 * @export
 * @interface VncConsoleConnectionDto
 */
export interface VncConsoleConnectionDto {
    /**
     * Backend websocket path used by the noVNC client. Opaque: it names the console session and nothing about where the instance runs.
     * @type {string}
     * @memberof VncConsoleConnectionDto
     */
    'websocket_url': string;
    /**
     * Ephemeral VNC password for the proxied console session
     * @type {string}
     * @memberof VncConsoleConnectionDto
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface VncConsoleRequestDto
 */
export interface VncConsoleRequestDto {
    /**
     * Unique identifier of the VM for which to generate console access
     * @type {number}
     * @memberof VncConsoleRequestDto
     */
    'vm_id': number;
}
/**
 * 
 * @export
 * @interface VpcCreateDto
 */
export interface VpcCreateDto {
    /**
     * The name of the VPC
     * @type {string}
     * @memberof VpcCreateDto
     */
    'name': string;
    /**
     * The description of the VPC
     * @type {string}
     * @memberof VpcCreateDto
     */
    'description'?: string;
    /**
     * The DHCP subnet of the VPC
     * @type {string}
     * @memberof VpcCreateDto
     */
    'dhcp_subnet'?: string;
    /**
     * The ID of the cluster
     * @type {number}
     * @memberof VpcCreateDto
     */
    'cluster_id': number;
}
/**
 * 
 * @export
 * @interface VpcEntity
 */
export interface VpcEntity {
    /**
     * The ID of the VPC
     * @type {number}
     * @memberof VpcEntity
     */
    'id': number;
    /**
     * The client ID associated with the VPC
     * @type {number}
     * @memberof VpcEntity
     */
    'client_id': number;
    /**
     * The cluster ID associated with the VPC
     * @type {number}
     * @memberof VpcEntity
     */
    'cluster_id': number;
    /**
     * The name of the VPC
     * @type {string}
     * @memberof VpcEntity
     */
    'name': string;
    /**
     * The description of the VPC
     * @type {string}
     * @memberof VpcEntity
     */
    'description': string;
    /**
     * The DHCP subnet of the VPC
     * @type {string}
     * @memberof VpcEntity
     */
    'dhcp_subnet': string;
    /**
     * Whether this is a default VPC
     * @type {boolean}
     * @memberof VpcEntity
     */
    'default': boolean;
    /**
     * Number of active VPC participants
     * @type {number}
     * @memberof VpcEntity
     */
    'participants_count'?: number;
    /**
     * The creation date of the VPC
     * @type {string}
     * @memberof VpcEntity
     */
    'created_at': string;
    /**
     * The last update date of the VPC
     * @type {string}
     * @memberof VpcEntity
     */
    'updated_at': string;
    /**
     * The last update date of the VPC
     * @type {string}
     * @memberof VpcEntity
     */
    'deleted_at': string;
}
/**
 * 
 * @export
 * @interface VpcVmsDto
 */
export interface VpcVmsDto {
    /**
     * The unique identifier of the VPC-VM relationship
     * @type {number}
     * @memberof VpcVmsDto
     */
    'id': number;
    /**
     * The unique identifier of the VPC
     * @type {number}
     * @memberof VpcVmsDto
     */
    'vpcs_id': number;
    /**
     * The unique identifier of the VM
     * @type {number}
     * @memberof VpcVmsDto
     */
    'vm_id': number;
    /**
     * The bridge ID associated with the VM in the VPC
     * @type {number}
     * @memberof VpcVmsDto
     */
    'bridge_id': number;
    /**
     * The status of the VM in the VPC
     * @type {string}
     * @memberof VpcVmsDto
     */
    'status': VpcVmsDtoStatusEnum;
    /**
     * The creation date of the VPC-VM relationship
     * @type {string}
     * @memberof VpcVmsDto
     */
    'created_at': string;
    /**
     * The last update date of the VPC-VM relationship
     * @type {string}
     * @memberof VpcVmsDto
     */
    'updated_at': string;
    /**
     * The unique identifier of the VM in the VPC
     * @type {string}
     * @memberof VpcVmsDto
     */
    'puid': string;
    /**
     * The network interface of the VM in the VPC
     * @type {string}
     * @memberof VpcVmsDto
     */
    'interface': string;
    /**
     * The DHCP IP address assigned to the VM in the VPC
     * @type {string}
     * @memberof VpcVmsDto
     */
    'dhcp_ip': string;
    /**
     * The deletion date of the VPC-VM relationship
     * @type {string}
     * @memberof VpcVmsDto
     */
    'deleted_at': string;
    /**
     * VM that belongs to the VPC
     * @type {VmEntity}
     * @memberof VpcVmsDto
     */
    'vms': VmEntity;
    /**
     * VPC that the VM belongs to
     * @type {VpcEntity}
     * @memberof VpcVmsDto
     */
    'vpc': VpcEntity;
}

export const VpcVmsDtoStatusEnum = {
    Online: 'online',
    Offline: 'offline',
    Failed: 'failed'
} as const;

export type VpcVmsDtoStatusEnum = typeof VpcVmsDtoStatusEnum[keyof typeof VpcVmsDtoStatusEnum];

/**
 * 
 * @export
 * @interface VpcVmsEntity
 */
export interface VpcVmsEntity {
    /**
     * The unique identifier of the VPC-VM relationship
     * @type {number}
     * @memberof VpcVmsEntity
     */
    'id': number;
    /**
     * The unique identifier of the VPC
     * @type {number}
     * @memberof VpcVmsEntity
     */
    'vpcs_id': number;
    /**
     * The unique identifier of the VM
     * @type {number}
     * @memberof VpcVmsEntity
     */
    'vm_id': number;
    /**
     * The status of the VM in the VPC
     * @type {string}
     * @memberof VpcVmsEntity
     */
    'status': VpcVmsEntityStatusEnum;
    /**
     * The creation date of the VPC-VM relationship
     * @type {string}
     * @memberof VpcVmsEntity
     */
    'created_at': string;
    /**
     * The last update date of the VPC-VM relationship
     * @type {string}
     * @memberof VpcVmsEntity
     */
    'updated_at': string;
    /**
     * The DHCP IP address assigned to the VM in the VPC
     * @type {string}
     * @memberof VpcVmsEntity
     */
    'dhcp_ip': string;
    /**
     * The deletion date of the VPC-VM relationship
     * @type {string}
     * @memberof VpcVmsEntity
     */
    'deleted_at': string;
    /**
     * VPC that the VM belongs to
     * @type {VpcEntity}
     * @memberof VpcVmsEntity
     */
    'vpc': VpcEntity;
}

export const VpcVmsEntityStatusEnum = {
    Online: 'online',
    Offline: 'offline',
    Failed: 'failed'
} as const;

export type VpcVmsEntityStatusEnum = typeof VpcVmsEntityStatusEnum[keyof typeof VpcVmsEntityStatusEnum];

/**
 * 
 * @export
 * @interface VpnApplianceDto
 */
export interface VpnApplianceDto {
    /**
     * legacy or appliance
     * @type {string}
     * @memberof VpnApplianceDto
     */
    'generation': string;
    /**
     * 
     * @type {string}
     * @memberof VpnApplianceDto
     */
    'agent_version'?: string;
    /**
     * 
     * @type {string}
     * @memberof VpnApplianceDto
     */
    'latest_version'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VpnApplianceDto
     */
    'update_available': boolean;
    /**
     * Whether rebuilding this gateway would actually put it on the agent. False on a platform that has not been cut over, where a rebuild would reinstall the same previous-generation container.
     * @type {boolean}
     * @memberof VpnApplianceDto
     */
    'rebuild_required': boolean;
    /**
     * Whether this platform can install the agent at all yet. When false, no gateway here can carry a site connection and the console says so instead of offering a rebuild that would change nothing.
     * @type {boolean}
     * @memberof VpnApplianceDto
     */
    'platform_installs_agent': boolean;
    /**
     * 
     * @type {string}
     * @memberof VpnApplianceDto
     */
    'apply_state': string;
    /**
     * 
     * @type {string}
     * @memberof VpnApplianceDto
     */
    'applied_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof VpnApplianceDto
     */
    'last_seen_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof VpnApplianceDto
     */
    'last_apply_error'?: string;
    /**
     * 
     * @type {string}
     * @memberof VpnApplianceDto
     */
    'last_apply_error_code'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VpnApplianceDto
     */
    'agent_online': boolean;
}
/**
 * 
 * @export
 * @interface VpnApplianceUpgradeDto
 */
export interface VpnApplianceUpgradeDto {
    /**
     * 
     * @type {boolean}
     * @memberof VpnApplianceUpgradeDto
     */
    'success': boolean;
    /**
     * Whether the whole gateway was rebuilt rather than updated in place
     * @type {boolean}
     * @memberof VpnApplianceUpgradeDto
     */
    'rebuilt': boolean;
    /**
     * False when it was already up to date
     * @type {boolean}
     * @memberof VpnApplianceUpgradeDto
     */
    'updating'?: boolean;
    /**
     * The rebuild job, when this rebuilt the gateway
     * @type {string}
     * @memberof VpnApplianceUpgradeDto
     */
    'job_id'?: string;
    /**
     * English fallback prose; the console keys on `rebuilt`
     * @type {string}
     * @memberof VpnApplianceUpgradeDto
     */
    'message': string;
}
/**
 * Why the last attempt failed; translate it, and fall back to error_message
 * @export
 * @enum {string}
 */

export const VpnApplyFailureCode = {
    ApplianceRolledBack: 'VPN_APPLIANCE_ROLLED_BACK',
    ApplianceApplyFailed: 'VPN_APPLIANCE_APPLY_FAILED',
    ApplianceUnreachable: 'VPN_APPLIANCE_UNREACHABLE',
    GatewayBusy: 'VPN_GATEWAY_BUSY',
    PoolConflict: 'VPN_POOL_CONFLICT'
} as const;

export type VpnApplyFailureCode = typeof VpnApplyFailureCode[keyof typeof VpnApplyFailureCode];


/**
 * 
 * @export
 * @interface VpnConnectedUserDto
 */
export interface VpnConnectedUserDto {
    /**
     * Username of the connected VPN user
     * @type {string}
     * @memberof VpnConnectedUserDto
     */
    'username': string;
    /**
     * Real IP address of the connected user
     * @type {string}
     * @memberof VpnConnectedUserDto
     */
    'real_address': string;
    /**
     * Virtual IP address assigned to the user
     * @type {string}
     * @memberof VpnConnectedUserDto
     */
    'virtual_address': string;
    /**
     * Bytes received from the user
     * @type {number}
     * @memberof VpnConnectedUserDto
     */
    'bytes_received': number;
    /**
     * Bytes sent to the user
     * @type {number}
     * @memberof VpnConnectedUserDto
     */
    'bytes_sent': number;
    /**
     * Connection start time
     * @type {string}
     * @memberof VpnConnectedUserDto
     */
    'connected_since': string;
    /**
     * Last reference time for routing table entry
     * @type {string}
     * @memberof VpnConnectedUserDto
     */
    'last_ref': string;
    /**
     * Connection duration in seconds
     * @type {number}
     * @memberof VpnConnectedUserDto
     */
    'connection_duration': number;
    /**
     * Total traffic in bytes (received + sent)
     * @type {number}
     * @memberof VpnConnectedUserDto
     */
    'total_traffic': number;
}
/**
 * 
 * @export
 * @interface VpnConnectionProfileDto
 */
export interface VpnConnectionProfileDto {
    /**
     * OpenVPN connection profile content (.ovpn file)
     * @type {string}
     * @memberof VpnConnectionProfileDto
     */
    'profile': string;
    /**
     * Whether the profile was retrieved from cache
     * @type {boolean}
     * @memberof VpnConnectionProfileDto
     */
    'cached': boolean;
    /**
     * Cache expiration timestamp
     * @type {string}
     * @memberof VpnConnectionProfileDto
     */
    'cache_expires_at'?: string;
    /**
     * VPN Gateway ID
     * @type {string}
     * @memberof VpnConnectionProfileDto
     */
    'vpn_gateway_id': string;
    /**
     * VM ID
     * @type {number}
     * @memberof VpnConnectionProfileDto
     */
    'vm_id': number;
    /**
     * Public IP address of the VPN server
     * @type {string}
     * @memberof VpnConnectionProfileDto
     */
    'public_ip'?: string;
}
/**
 * in_place reconfigures the running gateway; rebuild reinstalls it and takes the VPN offline for a few minutes
 * @export
 * @enum {string}
 */

export const VpnGatewayApplyMode = {
    InPlace: 'in_place',
    Rebuild: 'rebuild'
} as const;

export type VpnGatewayApplyMode = typeof VpnGatewayApplyMode[keyof typeof VpnGatewayApplyMode];


/**
 * 
 * @export
 * @interface VpnGatewayApplyOperationDto
 */
export interface VpnGatewayApplyOperationDto {
    /**
     * The job carrying the apply
     * @type {string}
     * @memberof VpnGatewayApplyOperationDto
     */
    'job_id': string;
    /**
     * queued (waiting for a worker), waiting_for_gateway (sent, not picked up), applying (the gateway is reconfiguring), finalizing (the gateway answered), retrying (an attempt failed; another is scheduled), applied, failed
     * @type {VpnGatewayApplyPhase}
     * @memberof VpnGatewayApplyOperationDto
     */
    'phase': VpnGatewayApplyPhase;
    /**
     * When the platform accepted the request (ISO 8601)
     * @type {string}
     * @memberof VpnGatewayApplyOperationDto
     */
    'requested_at': string;
    /**
     * When the current phase began (ISO 8601)
     * @type {string}
     * @memberof VpnGatewayApplyOperationDto
     */
    'phase_started_at': string;
    /**
     * Attempts started so far, the running one included
     * @type {number}
     * @memberof VpnGatewayApplyOperationDto
     */
    'attempt': number;
    /**
     * How many attempts the apply gets before it fails
     * @type {number}
     * @memberof VpnGatewayApplyOperationDto
     */
    'max_attempts': number;
    /**
     * When the next attempt runs, while retrying (ISO 8601)
     * @type {string}
     * @memberof VpnGatewayApplyOperationDto
     */
    'next_attempt_at'?: string | null;
    /**
     * Why the last attempt failed; translate it, and fall back to error_message
     * @type {VpnApplyFailureCode}
     * @memberof VpnGatewayApplyOperationDto
     */
    'error_code'?: VpnApplyFailureCode | null;
    /**
     * English fallback prose for error_code
     * @type {string}
     * @memberof VpnGatewayApplyOperationDto
     */
    'error_message'?: string | null;
}


/**
 * queued (waiting for a worker), waiting_for_gateway (sent, not picked up), applying (the gateway is reconfiguring), finalizing (the gateway answered), retrying (an attempt failed; another is scheduled), applied, failed
 * @export
 * @enum {string}
 */

export const VpnGatewayApplyPhase = {
    Queued: 'queued',
    WaitingForGateway: 'waiting_for_gateway',
    Applying: 'applying',
    Finalizing: 'finalizing',
    Retrying: 'retrying',
    Applied: 'applied',
    Failed: 'failed'
} as const;

export type VpnGatewayApplyPhase = typeof VpnGatewayApplyPhase[keyof typeof VpnGatewayApplyPhase];


/**
 * 
 * @export
 * @interface VpnGatewayApplyResponseDto
 */
export interface VpnGatewayApplyResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof VpnGatewayApplyResponseDto
     */
    'success': boolean;
    /**
     * in_place reconfigures the running gateway; rebuild reinstalls the machine, taking the VPN offline for a few minutes
     * @type {VpnGatewayApplyMode}
     * @memberof VpnGatewayApplyResponseDto
     */
    'mode': VpnGatewayApplyMode;
    /**
     * The job carrying the change: an apply job, or the deployment of a rebuild
     * @type {string}
     * @memberof VpnGatewayApplyResponseDto
     */
    'job_id'?: string | null;
    /**
     * True when an apply already queued or running carries this change
     * @type {boolean}
     * @memberof VpnGatewayApplyResponseDto
     */
    'coalesced': boolean;
    /**
     * The apply as it now stands. Null when the change is carried by a deployment, whose progress is the instance status
     * @type {VpnGatewayApplyOperationDto}
     * @memberof VpnGatewayApplyResponseDto
     */
    'operation'?: VpnGatewayApplyOperationDto | null;
    /**
     * English fallback prose; the console keys on mode and operation
     * @type {string}
     * @memberof VpnGatewayApplyResponseDto
     */
    'message': string;
}


/**
 * 
 * @export
 * @interface VpnGatewayDetailsDto
 */
export interface VpnGatewayDetailsDto {
    /**
     * VPN Gateway ID
     * @type {string}
     * @memberof VpnGatewayDetailsDto
     */
    'id': string;
    /**
     * VM ID
     * @type {number}
     * @memberof VpnGatewayDetailsDto
     */
    'vm_id': number;
    /**
     * VPN Network
     * @type {string}
     * @memberof VpnGatewayDetailsDto
     */
    'vpn_network': string;
    /**
     * VPN Netmask
     * @type {string}
     * @memberof VpnGatewayDetailsDto
     */
    'vpn_netmask': string;
    /**
     * Push Route Network
     * @type {string}
     * @memberof VpnGatewayDetailsDto
     */
    'push_route_network': string;
    /**
     * Push Route Netmask
     * @type {string}
     * @memberof VpnGatewayDetailsDto
     */
    'push_route_netmask': string;
    /**
     * The address pool handed to people connecting with the VPN app, e.g. 10.8.0.0/24
     * @type {string}
     * @memberof VpnGatewayDetailsDto
     */
    'remote_access_pool'?: string | null;
    /**
     * Why the pool cannot be used as it is (it overlaps the private network or a connected site), as a code the console translates; null when it is fine. While set, applying is refused and the console asks for a new pool.
     * @type {SiteMessageDto}
     * @memberof VpnGatewayDetailsDto
     */
    'remote_access_pool_issue'?: SiteMessageDto | null;
    /**
     * VPN Protocol
     * @type {string}
     * @memberof VpnGatewayDetailsDto
     */
    'vpn_protocol': VpnGatewayDetailsDtoVpnProtocolEnum;
    /**
     * Changed flag indicating docker rebuild is necessary
     * @type {boolean}
     * @memberof VpnGatewayDetailsDto
     */
    'changed': boolean;
    /**
     * Default Gateway
     * @type {boolean}
     * @memberof VpnGatewayDetailsDto
     */
    'default_gateway': boolean;
    /**
     * Download code for accessing VPN connection profile
     * @type {string}
     * @memberof VpnGatewayDetailsDto
     */
    'download_code'?: string | null;
    /**
     * Download code expiration date
     * @type {string}
     * @memberof VpnGatewayDetailsDto
     */
    'download_code_expiry'?: string | null;
    /**
     * Allow duplicate common names (multiple clients/devices connecting with the same user)
     * @type {boolean}
     * @memberof VpnGatewayDetailsDto
     */
    'duplicate_cn': boolean;
    /**
     * Main Public IP Address
     * @type {string}
     * @memberof VpnGatewayDetailsDto
     */
    'public_ip'?: string | null;
    /**
     * Private IP Address
     * @type {string}
     * @memberof VpnGatewayDetailsDto
     */
    'private_ip'?: string | null;
    /**
     * Created At
     * @type {string}
     * @memberof VpnGatewayDetailsDto
     */
    'created_at'?: string;
    /**
     * Updated At
     * @type {string}
     * @memberof VpnGatewayDetailsDto
     */
    'updated_at'?: string;
    /**
     * Product Information
     * @type {GatewayProductInfoDto}
     * @memberof VpnGatewayDetailsDto
     */
    'product'?: GatewayProductInfoDto | null;
    /**
     * VM Information
     * @type {GatewayVmInfoDto}
     * @memberof VpnGatewayDetailsDto
     */
    'vm_info': GatewayVmInfoDto;
    /**
     * VPC Information
     * @type {GatewayVpcInfoDto}
     * @memberof VpnGatewayDetailsDto
     */
    'vpc_info'?: GatewayVpcInfoDto | null;
    /**
     * The sites this gateway connects, and how many its plan includes
     * @type {GatewaySiteToSiteDto}
     * @memberof VpnGatewayDetailsDto
     */
    'site_to_site': GatewaySiteToSiteDto;
}

export const VpnGatewayDetailsDtoVpnProtocolEnum = {
    Tcp: 'tcp',
    Udp: 'udp'
} as const;

export type VpnGatewayDetailsDtoVpnProtocolEnum = typeof VpnGatewayDetailsDtoVpnProtocolEnum[keyof typeof VpnGatewayDetailsDtoVpnProtocolEnum];

/**
 * 
 * @export
 * @interface VpnGatewayDto
 */
export interface VpnGatewayDto {
    /**
     * VPN Gateway ID
     * @type {string}
     * @memberof VpnGatewayDto
     */
    'id': string;
    /**
     * VM ID
     * @type {number}
     * @memberof VpnGatewayDto
     */
    'vm_id': number;
    /**
     * VPN Network
     * @type {string}
     * @memberof VpnGatewayDto
     */
    'vpn_network': string;
    /**
     * VPN Netmask
     * @type {string}
     * @memberof VpnGatewayDto
     */
    'vpn_netmask': string;
    /**
     * Push Route Network
     * @type {string}
     * @memberof VpnGatewayDto
     */
    'push_route_network': string;
    /**
     * Push Route Netmask
     * @type {string}
     * @memberof VpnGatewayDto
     */
    'push_route_netmask': string;
    /**
     * The address pool handed to people connecting with the VPN app, e.g. 10.8.0.0/24
     * @type {string}
     * @memberof VpnGatewayDto
     */
    'remote_access_pool'?: string | null;
    /**
     * Why the pool cannot be used as it is (it overlaps the private network or a connected site), as a code the console translates; null when it is fine. While set, applying is refused and the console asks for a new pool.
     * @type {SiteMessageDto}
     * @memberof VpnGatewayDto
     */
    'remote_access_pool_issue'?: SiteMessageDto | null;
    /**
     * VPN Protocol
     * @type {string}
     * @memberof VpnGatewayDto
     */
    'vpn_protocol': VpnGatewayDtoVpnProtocolEnum;
    /**
     * Changed flag indicating docker rebuild is necessary
     * @type {boolean}
     * @memberof VpnGatewayDto
     */
    'changed': boolean;
    /**
     * Default Gateway
     * @type {boolean}
     * @memberof VpnGatewayDto
     */
    'default_gateway': boolean;
    /**
     * Download code for accessing VPN connection profile
     * @type {string}
     * @memberof VpnGatewayDto
     */
    'download_code'?: string | null;
    /**
     * Download code expiration date
     * @type {string}
     * @memberof VpnGatewayDto
     */
    'download_code_expiry'?: string | null;
    /**
     * Allow duplicate common names (multiple clients/devices connecting with the same user)
     * @type {boolean}
     * @memberof VpnGatewayDto
     */
    'duplicate_cn': boolean;
    /**
     * TUN interface MTU size
     * @type {number}
     * @memberof VpnGatewayDto
     */
    'tun_mtu': number;
    /**
     * Main Public IP Address
     * @type {string}
     * @memberof VpnGatewayDto
     */
    'public_ip'?: string | null;
    /**
     * Created At
     * @type {string}
     * @memberof VpnGatewayDto
     */
    'created_at'?: string;
    /**
     * Updated At
     * @type {string}
     * @memberof VpnGatewayDto
     */
    'updated_at'?: string;
    /**
     * Product Information
     * @type {ProductInfoDto}
     * @memberof VpnGatewayDto
     */
    'product'?: ProductInfoDto | null;
}

export const VpnGatewayDtoVpnProtocolEnum = {
    Tcp: 'tcp',
    Udp: 'udp'
} as const;

export type VpnGatewayDtoVpnProtocolEnum = typeof VpnGatewayDtoVpnProtocolEnum[keyof typeof VpnGatewayDtoVpnProtocolEnum];

/**
 * 
 * @export
 * @interface VpnGatewayInfoDto
 */
export interface VpnGatewayInfoDto {
    /**
     * VPN Gateway ID
     * @type {string}
     * @memberof VpnGatewayInfoDto
     */
    'id': string;
    /**
     * VM ID
     * @type {number}
     * @memberof VpnGatewayInfoDto
     */
    'vm_id': number;
    /**
     * VPN Network
     * @type {string}
     * @memberof VpnGatewayInfoDto
     */
    'vpn_network': string;
    /**
     * VPN Netmask
     * @type {string}
     * @memberof VpnGatewayInfoDto
     */
    'vpn_netmask': string;
    /**
     * VPN Protocol
     * @type {string}
     * @memberof VpnGatewayInfoDto
     */
    'vpn_protocol': VpnGatewayInfoDtoVpnProtocolEnum;
    /**
     * Changed flag indicating docker rebuild is necessary
     * @type {boolean}
     * @memberof VpnGatewayInfoDto
     */
    'changed': boolean;
    /**
     * Default Gateway
     * @type {boolean}
     * @memberof VpnGatewayInfoDto
     */
    'default_gateway': boolean;
    /**
     * Main Public IP Address
     * @type {string}
     * @memberof VpnGatewayInfoDto
     */
    'public_ip'?: string | null;
    /**
     * VM Information
     * @type {VmInfoDto}
     * @memberof VpnGatewayInfoDto
     */
    'vms': VmInfoDto;
}

export const VpnGatewayInfoDtoVpnProtocolEnum = {
    Tcp: 'tcp',
    Udp: 'udp'
} as const;

export type VpnGatewayInfoDtoVpnProtocolEnum = typeof VpnGatewayInfoDtoVpnProtocolEnum[keyof typeof VpnGatewayInfoDtoVpnProtocolEnum];

/**
 * 
 * @export
 * @interface VpnGatewayWithConnectedUsersDto
 */
export interface VpnGatewayWithConnectedUsersDto {
    /**
     * VPN Gateway ID
     * @type {string}
     * @memberof VpnGatewayWithConnectedUsersDto
     */
    'id': string;
    /**
     * VM ID
     * @type {number}
     * @memberof VpnGatewayWithConnectedUsersDto
     */
    'vm_id': number;
    /**
     * VPN Network
     * @type {string}
     * @memberof VpnGatewayWithConnectedUsersDto
     */
    'vpn_network': string;
    /**
     * VPN Netmask
     * @type {string}
     * @memberof VpnGatewayWithConnectedUsersDto
     */
    'vpn_netmask': string;
    /**
     * Push Route Network
     * @type {string}
     * @memberof VpnGatewayWithConnectedUsersDto
     */
    'push_route_network': string;
    /**
     * Push Route Netmask
     * @type {string}
     * @memberof VpnGatewayWithConnectedUsersDto
     */
    'push_route_netmask': string;
    /**
     * The address pool handed to people connecting with the VPN app, e.g. 10.8.0.0/24
     * @type {string}
     * @memberof VpnGatewayWithConnectedUsersDto
     */
    'remote_access_pool'?: string | null;
    /**
     * Why the pool cannot be used as it is (it overlaps the private network or a connected site), as a code the console translates; null when it is fine. While set, applying is refused and the console asks for a new pool.
     * @type {SiteMessageDto}
     * @memberof VpnGatewayWithConnectedUsersDto
     */
    'remote_access_pool_issue'?: SiteMessageDto | null;
    /**
     * VPN Protocol
     * @type {string}
     * @memberof VpnGatewayWithConnectedUsersDto
     */
    'vpn_protocol': VpnGatewayWithConnectedUsersDtoVpnProtocolEnum;
    /**
     * Changed flag indicating docker rebuild is necessary
     * @type {boolean}
     * @memberof VpnGatewayWithConnectedUsersDto
     */
    'changed': boolean;
    /**
     * Default Gateway
     * @type {boolean}
     * @memberof VpnGatewayWithConnectedUsersDto
     */
    'default_gateway': boolean;
    /**
     * Download code for accessing VPN connection profile
     * @type {string}
     * @memberof VpnGatewayWithConnectedUsersDto
     */
    'download_code'?: string | null;
    /**
     * Download code expiration date
     * @type {string}
     * @memberof VpnGatewayWithConnectedUsersDto
     */
    'download_code_expiry'?: string | null;
    /**
     * Allow duplicate common names (multiple clients/devices connecting with the same user)
     * @type {boolean}
     * @memberof VpnGatewayWithConnectedUsersDto
     */
    'duplicate_cn': boolean;
    /**
     * Main Public IP Address
     * @type {string}
     * @memberof VpnGatewayWithConnectedUsersDto
     */
    'public_ip'?: string | null;
    /**
     * Private IP Address
     * @type {string}
     * @memberof VpnGatewayWithConnectedUsersDto
     */
    'private_ip'?: string | null;
    /**
     * Created At
     * @type {string}
     * @memberof VpnGatewayWithConnectedUsersDto
     */
    'created_at'?: string;
    /**
     * Updated At
     * @type {string}
     * @memberof VpnGatewayWithConnectedUsersDto
     */
    'updated_at'?: string;
    /**
     * Product Information
     * @type {GatewayProductInfoDto}
     * @memberof VpnGatewayWithConnectedUsersDto
     */
    'product'?: GatewayProductInfoDto | null;
    /**
     * VM Information
     * @type {GatewayVmInfoDto}
     * @memberof VpnGatewayWithConnectedUsersDto
     */
    'vm_info': GatewayVmInfoDto;
    /**
     * VPC Information
     * @type {GatewayVpcInfoDto}
     * @memberof VpnGatewayWithConnectedUsersDto
     */
    'vpc_info'?: GatewayVpcInfoDto | null;
    /**
     * The sites this gateway connects, and how many its plan includes
     * @type {GatewaySiteToSiteDto}
     * @memberof VpnGatewayWithConnectedUsersDto
     */
    'site_to_site': GatewaySiteToSiteDto;
    /**
     * List of currently connected VPN users
     * @type {Array<VpnConnectedUserDto>}
     * @memberof VpnGatewayWithConnectedUsersDto
     */
    'connected_users': Array<VpnConnectedUserDto>;
    /**
     * Total number of connected users
     * @type {number}
     * @memberof VpnGatewayWithConnectedUsersDto
     */
    'total_connected_users': number;
    /**
     * Whether the connected users data was retrieved from cache
     * @type {boolean}
     * @memberof VpnGatewayWithConnectedUsersDto
     */
    'cached': boolean;
    /**
     * Cache expiration timestamp
     * @type {string}
     * @memberof VpnGatewayWithConnectedUsersDto
     */
    'cache_expires_at'?: string;
    /**
     * Last updated timestamp for connected users data
     * @type {string}
     * @memberof VpnGatewayWithConnectedUsersDto
     */
    'last_updated': string;
}

export const VpnGatewayWithConnectedUsersDtoVpnProtocolEnum = {
    Tcp: 'tcp',
    Udp: 'udp'
} as const;

export type VpnGatewayWithConnectedUsersDtoVpnProtocolEnum = typeof VpnGatewayWithConnectedUsersDtoVpnProtocolEnum[keyof typeof VpnGatewayWithConnectedUsersDtoVpnProtocolEnum];

/**
 * 
 * @export
 * @interface VpnGatewayWithVmDto
 */
export interface VpnGatewayWithVmDto {
    /**
     * VPN Gateway ID
     * @type {string}
     * @memberof VpnGatewayWithVmDto
     */
    'id': string;
    /**
     * VM ID
     * @type {number}
     * @memberof VpnGatewayWithVmDto
     */
    'vm_id': number;
    /**
     * VPN Network
     * @type {string}
     * @memberof VpnGatewayWithVmDto
     */
    'vpn_network': string;
    /**
     * VPN Netmask
     * @type {string}
     * @memberof VpnGatewayWithVmDto
     */
    'vpn_netmask': string;
    /**
     * Push Route Network
     * @type {string}
     * @memberof VpnGatewayWithVmDto
     */
    'push_route_network': string;
    /**
     * Push Route Netmask
     * @type {string}
     * @memberof VpnGatewayWithVmDto
     */
    'push_route_netmask': string;
    /**
     * The address pool handed to people connecting with the VPN app, e.g. 10.8.0.0/24
     * @type {string}
     * @memberof VpnGatewayWithVmDto
     */
    'remote_access_pool'?: string | null;
    /**
     * Why the pool cannot be used as it is (it overlaps the private network or a connected site), as a code the console translates; null when it is fine. While set, applying is refused and the console asks for a new pool.
     * @type {SiteMessageDto}
     * @memberof VpnGatewayWithVmDto
     */
    'remote_access_pool_issue'?: SiteMessageDto | null;
    /**
     * VPN Protocol
     * @type {string}
     * @memberof VpnGatewayWithVmDto
     */
    'vpn_protocol': VpnGatewayWithVmDtoVpnProtocolEnum;
    /**
     * Changed flag indicating docker rebuild is necessary
     * @type {boolean}
     * @memberof VpnGatewayWithVmDto
     */
    'changed': boolean;
    /**
     * Default Gateway
     * @type {boolean}
     * @memberof VpnGatewayWithVmDto
     */
    'default_gateway': boolean;
    /**
     * Allow duplicate common names (multiple clients/devices connecting with the same user)
     * @type {boolean}
     * @memberof VpnGatewayWithVmDto
     */
    'duplicate_cn': boolean;
    /**
     * TUN interface MTU size
     * @type {number}
     * @memberof VpnGatewayWithVmDto
     */
    'tun_mtu': number;
    /**
     * Download code for accessing VPN connection profile
     * @type {string}
     * @memberof VpnGatewayWithVmDto
     */
    'download_code'?: string | null;
    /**
     * Download code expiration date
     * @type {string}
     * @memberof VpnGatewayWithVmDto
     */
    'download_code_expiry'?: string | null;
    /**
     * Main Public IP Address
     * @type {string}
     * @memberof VpnGatewayWithVmDto
     */
    'public_ip'?: string | null;
    /**
     * Created At
     * @type {string}
     * @memberof VpnGatewayWithVmDto
     */
    'created_at'?: string;
    /**
     * Updated At
     * @type {string}
     * @memberof VpnGatewayWithVmDto
     */
    'updated_at'?: string;
    /**
     * VM Information
     * @type {VmInfoDto}
     * @memberof VpnGatewayWithVmDto
     */
    'vms': VmInfoDto;
    /**
     * Product Information
     * @type {ProductInfoDto}
     * @memberof VpnGatewayWithVmDto
     */
    'product'?: ProductInfoDto | null;
    /**
     * legacy (the previous container) or appliance (runs the agent)
     * @type {string}
     * @memberof VpnGatewayWithVmDto
     */
    'generation': VpnGatewayWithVmDtoGenerationEnum;
    /**
     * The agent version this gateway reported, if it runs one
     * @type {string}
     * @memberof VpnGatewayWithVmDto
     */
    'appliance_version'?: string | null;
    /**
     * Whether a newer agent is available for it
     * @type {boolean}
     * @memberof VpnGatewayWithVmDto
     */
    'update_available': boolean;
    /**
     * idle, queued, applying or failed
     * @type {string}
     * @memberof VpnGatewayWithVmDto
     */
    'apply_state': string;
    /**
     * in_place reconfigures the running gateway; rebuild reinstalls it and takes the VPN offline for a few minutes
     * @type {VpnGatewayApplyMode}
     * @memberof VpnGatewayWithVmDto
     */
    'apply_mode': VpnGatewayApplyMode;
    /**
     * The apply in flight, if any
     * @type {VpnGatewayApplyOperationDto}
     * @memberof VpnGatewayWithVmDto
     */
    'apply_operation'?: VpnGatewayApplyOperationDto | null;
    /**
     * Why the last apply failed, or why the one in flight is retrying
     * @type {VpnApplyFailureCode}
     * @memberof VpnGatewayWithVmDto
     */
    'last_apply_error_code'?: VpnApplyFailureCode | null;
    /**
     * English fallback prose for last_apply_error_code
     * @type {string}
     * @memberof VpnGatewayWithVmDto
     */
    'last_apply_error'?: string | null;
    /**
     * When the gateway last applied its configuration
     * @type {string}
     * @memberof VpnGatewayWithVmDto
     */
    'applied_at'?: string | null;
    /**
     * How many sites this gateway connects
     * @type {number}
     * @memberof VpnGatewayWithVmDto
     */
    'site_connections_count': number;
    /**
     * How many its plan includes
     * @type {number}
     * @memberof VpnGatewayWithVmDto
     */
    'included_site_connections': number;
}

export const VpnGatewayWithVmDtoVpnProtocolEnum = {
    Tcp: 'tcp',
    Udp: 'udp'
} as const;

export type VpnGatewayWithVmDtoVpnProtocolEnum = typeof VpnGatewayWithVmDtoVpnProtocolEnum[keyof typeof VpnGatewayWithVmDtoVpnProtocolEnum];
export const VpnGatewayWithVmDtoGenerationEnum = {
    Legacy: 'legacy',
    Appliance: 'appliance'
} as const;

export type VpnGatewayWithVmDtoGenerationEnum = typeof VpnGatewayWithVmDtoGenerationEnum[keyof typeof VpnGatewayWithVmDtoGenerationEnum];

/**
 * 
 * @export
 * @interface VpnUserDto
 */
export interface VpnUserDto {
    /**
     * VPN User ID
     * @type {string}
     * @memberof VpnUserDto
     */
    'id': string;
    /**
     * VPN Gateway ID
     * @type {string}
     * @memberof VpnUserDto
     */
    'vpn_gateway_id': string;
    /**
     * Username
     * @type {string}
     * @memberof VpnUserDto
     */
    'username': string;
    /**
     * Email
     * @type {string}
     * @memberof VpnUserDto
     */
    'email': string;
    /**
     * Status
     * @type {string}
     * @memberof VpnUserDto
     */
    'status': VpnUserDtoStatusEnum;
    /**
     * Created At
     * @type {string}
     * @memberof VpnUserDto
     */
    'created_at'?: string;
    /**
     * Updated At
     * @type {string}
     * @memberof VpnUserDto
     */
    'updated_at'?: string;
}

export const VpnUserDtoStatusEnum = {
    Active: 'active',
    Inactive: 'inactive'
} as const;

export type VpnUserDtoStatusEnum = typeof VpnUserDtoStatusEnum[keyof typeof VpnUserDtoStatusEnum];

/**
 * 
 * @export
 * @interface VpnUserWithGatewayDto
 */
export interface VpnUserWithGatewayDto {
    /**
     * VPN User ID
     * @type {string}
     * @memberof VpnUserWithGatewayDto
     */
    'id': string;
    /**
     * VPN Gateway ID
     * @type {string}
     * @memberof VpnUserWithGatewayDto
     */
    'vpn_gateway_id': string;
    /**
     * Username
     * @type {string}
     * @memberof VpnUserWithGatewayDto
     */
    'username': string;
    /**
     * Email
     * @type {string}
     * @memberof VpnUserWithGatewayDto
     */
    'email': string;
    /**
     * Status
     * @type {string}
     * @memberof VpnUserWithGatewayDto
     */
    'status': VpnUserWithGatewayDtoStatusEnum;
    /**
     * Created At
     * @type {string}
     * @memberof VpnUserWithGatewayDto
     */
    'created_at'?: string;
    /**
     * Updated At
     * @type {string}
     * @memberof VpnUserWithGatewayDto
     */
    'updated_at'?: string;
    /**
     * VPN Gateway Information
     * @type {VpnGatewayInfoDto}
     * @memberof VpnUserWithGatewayDto
     */
    'vpn_gateway': VpnGatewayInfoDto;
}

export const VpnUserWithGatewayDtoStatusEnum = {
    Active: 'active',
    Inactive: 'inactive'
} as const;

export type VpnUserWithGatewayDtoStatusEnum = typeof VpnUserWithGatewayDtoStatusEnum[keyof typeof VpnUserWithGatewayDtoStatusEnum];

/**
 * 
 * @export
 * @interface WebsocketTokenDto
 */
export interface WebsocketTokenDto {
    /**
     * Short-lived JWT used only for Socket.IO authentication
     * @type {string}
     * @memberof WebsocketTokenDto
     */
    'accessToken': string;
    /**
     * WebSocket token expiration as a Unix timestamp in seconds
     * @type {number}
     * @memberof WebsocketTokenDto
     */
    'accessTokenExpiry': number;
}
/**
 * 
 * @export
 * @interface WithdrawalAttachmentDto
 */
export interface WithdrawalAttachmentDto {
    /**
     * 
     * @type {string}
     * @memberof WithdrawalAttachmentDto
     */
    'id': string;
    /**
     * Sanitized original filename, for display only.
     * @type {string}
     * @memberof WithdrawalAttachmentDto
     */
    'filename': string;
    /**
     * Server-verified MIME type of the stored file.
     * @type {string}
     * @memberof WithdrawalAttachmentDto
     */
    'content_type': string;
    /**
     * 
     * @type {number}
     * @memberof WithdrawalAttachmentDto
     */
    'size_bytes': number;
    /**
     * 
     * @type {string}
     * @memberof WithdrawalAttachmentDto
     */
    'created_at': string;
}
/**
 * 
 * @export
 * @interface WithdrawalDto
 */
export interface WithdrawalDto {
    /**
     * 
     * @type {string}
     * @memberof WithdrawalDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof WithdrawalDto
     */
    'amount_micro_cents': string;
    /**
     * 
     * @type {string}
     * @memberof WithdrawalDto
     */
    'status': WithdrawalDtoStatusEnum;
    /**
     * 
     * @type {object}
     * @memberof WithdrawalDto
     */
    'payout_details': object;
    /**
     * 
     * @type {string}
     * @memberof WithdrawalDto
     */
    'requested_at': string;
    /**
     * 
     * @type {string}
     * @memberof WithdrawalDto
     */
    'processed_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WithdrawalDto
     */
    'admin_note'?: string | null;
    /**
     * 
     * @type {Array<WithdrawalAttachmentDto>}
     * @memberof WithdrawalDto
     */
    'attachments': Array<WithdrawalAttachmentDto>;
}

export const WithdrawalDtoStatusEnum = {
    Pending: 'PENDING',
    Paid: 'PAID',
    Cancelled: 'CANCELLED'
} as const;

export type WithdrawalDtoStatusEnum = typeof WithdrawalDtoStatusEnum[keyof typeof WithdrawalDtoStatusEnum];

/**
 * 
 * @export
 * @interface WorstInstanceDto
 */
export interface WorstInstanceDto {
    /**
     * 
     * @type {number}
     * @memberof WorstInstanceDto
     */
    'vm_id': number;
    /**
     * 
     * @type {string}
     * @memberof WorstInstanceDto
     */
    'name': string | null;
    /**
     * 
     * @type {number}
     * @memberof WorstInstanceDto
     */
    'score': number | null;
    /**
     * 
     * @type {string}
     * @memberof WorstInstanceDto
     */
    'grade': string | null;
    /**
     * 
     * @type {number}
     * @memberof WorstInstanceDto
     */
    'open_critical': number;
    /**
     * 
     * @type {number}
     * @memberof WorstInstanceDto
     */
    'open_high': number;
}

/**
 * MwApi - axios parameter creator
 * @export
 */
export const MwApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Cancel an upload
         * @param {string} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        abortClientImageUpload: async (imageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('abortClientImageUpload', 'imageId', imageId)
            const localVarPath = `/images/{imageId}/upload/abort`
                .replace(`{${"imageId"}}`, encodeURIComponent(String(imageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a DNS record to a zone
         * @param {string} id Domain record UUID
         * @param {CreateRecordDto} createRecordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDnsRecord: async (id: string, createRecordDto: CreateRecordDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addDnsRecord', 'id', id)
            // verify required parameter 'createRecordDto' is not null or undefined
            assertParamExists('addDnsRecord', 'createRecordDto', createRecordDto)
            const localVarPath = `/dns/zones/{id}/records`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRecordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a new rule to the firewall. Rules can be created using: • **Macros**: Predefined service configurations (e.g., HTTP, HTTPS, SSH) • **Manual configuration**: Specify protocol, ports, and other parameters  **Important**: Use either macros OR manual configuration, not both.
         * @summary Add firewall rule
         * @param {any} firewallId Unique identifier of the firewall
         * @param {AddFirewallRuleDto} addFirewallRuleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFirewallRule: async (firewallId: any, addFirewallRuleDto: AddFirewallRuleDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firewallId' is not null or undefined
            assertParamExists('addFirewallRule', 'firewallId', firewallId)
            // verify required parameter 'addFirewallRuleDto' is not null or undefined
            assertParamExists('addFirewallRule', 'addFirewallRuleDto', addFirewallRuleDto)
            const localVarPath = `/firewalls/{firewallId}/rules`
                .replace(`{${"firewallId"}}`, encodeURIComponent(String(firewallId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addFirewallRuleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a VM to a VPC for the authenticated client.
         * @summary Add VM to VPC
         * @param {AddVmToVpcDto} addVmToVpcDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addVmToVpc: async (addVmToVpcDto: AddVmToVpcDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addVmToVpcDto' is not null or undefined
            assertParamExists('addVmToVpc', 'addVmToVpcDto', addVmToVpcDto)
            const localVarPath = `/vpc/vm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addVmToVpcDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a user to a VPN Gateway
         * @param {string} id VPN Gateway ID
         * @param {AddVpnUserDto} addVpnUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addVpnUser: async (id: string, addVpnUserDto: AddVpnUserDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addVpnUser', 'id', id)
            // verify required parameter 'addVpnUserDto' is not null or undefined
            assertParamExists('addVpnUser', 'addVpnUserDto', addVpnUserDto)
            const localVarPath = `/vpn-gateway/{id}/users`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addVpnUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allowance: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('allowance', 'id', id)
            const localVarPath = `/billing/subscriptions/{id}/trial-allowance`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Apply a VPN gateway\'s pending changes
         * @param {string} id VPN Gateway ID
         * @param {ApplyChangesDto} applyChangesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyChanges: async (id: string, applyChangesDto: ApplyChangesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('applyChanges', 'id', id)
            // verify required parameter 'applyChangesDto' is not null or undefined
            assertParamExists('applyChanges', 'applyChangesDto', applyChangesDto)
            const localVarPath = `/vpn-gateway/{id}/apply-changes`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applyChangesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mounts the ISO as a CD-ROM and makes it the first boot device. The instance’s power state is preserved.
         * @summary Attach an ISO to an instance
         * @param {string} imageId 
         * @param {number} vmId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachClientImage: async (imageId: string, vmId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('attachClientImage', 'imageId', imageId)
            // verify required parameter 'vmId' is not null or undefined
            assertParamExists('attachClientImage', 'vmId', vmId)
            const localVarPath = `/images/{imageId}/attach/{vmId}`
                .replace(`{${"imageId"}}`, encodeURIComponent(String(imageId)))
                .replace(`{${"vmId"}}`, encodeURIComponent(String(vmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Apply a resize: change billing rate, generate temporary credit on downgrade, reconcile infrastructure
         * @param {number} vmId Instance (VM) id
         * @param {ResizeTargetDto} resizeTargetDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingApplyResize: async (vmId: number, resizeTargetDto: ResizeTargetDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmId' is not null or undefined
            assertParamExists('billingApplyResize', 'vmId', vmId)
            // verify required parameter 'resizeTargetDto' is not null or undefined
            assertParamExists('billingApplyResize', 'resizeTargetDto', resizeTargetDto)
            const localVarPath = `/billing/instances/{vmId}/resize`
                .replace(`{${"vmId"}}`, encodeURIComponent(String(vmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resizeTargetDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Voids an OPEN top-up invoice of this subscription at the payment provider. Only TOPUP invoices can be cancelled here — renewal and debt invoices are obligations, and checkout, reschedule, move, transfer and conversion invoices belong to the operation that raised them. Refused with 409 when the provider already reports the invoice paid. A payment that clears at the bank after the cancellation is still credited to the balance.
         * @summary Cancel an unpaid top-up invoice
         * @param {string} id Subscription UUID
         * @param {string} externalId Provider invoice id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingCancelTopupInvoice: async (id: string, externalId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('billingCancelTopupInvoice', 'id', id)
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('billingCancelTopupInvoice', 'externalId', externalId)
            const localVarPath = `/billing/subscriptions/{id}/invoices/{externalId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"externalId"}}`, encodeURIComponent(String(externalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Booleans only — used by checkout to avoid offering an IP type the datacenter has none of. Inventory counts are intentionally never exposed. Public.
         * @summary Whether IPv4/IPv6 can be allocated in a datacenter
         * @param {number} datacenterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingCatalogIpAvailability: async (datacenterId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datacenterId' is not null or undefined
            assertParamExists('billingCatalogIpAvailability', 'datacenterId', datacenterId)
            const localVarPath = `/billing/catalog/ip-availability`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (datacenterId !== undefined) {
                localVarQueryParameter['datacenter_id'] = datacenterId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Customer-facing location list for the configurator: name, region, flag asset, whether placement is currently possible, and whether each IP family can be allocated. Public.  This is deliberately NOT `GET /datacenters`, which is authenticated and answers with the datacenter entity including its clusters — hypervisor topology that has no business on a public surface.
         * @summary List the locations the checkout can deploy into
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingCatalogLocations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/billing/catalog/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a priced line-item breakdown for the given offering + addons + OS + disks + term. Applies free quotas (IPv4/IPv6) and OS filters. Public — the order endpoint requires auth.  Pass `compare_term` to price the same configuration on a second term and receive it as `comparison`, which is how the checkout shows what committing saves without issuing a second request.
         * @summary Simulate price for a checkout configuration
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingCatalogSimulate: async (body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('billingCatalogSimulate', 'body', body)
            const localVarPath = `/billing/catalog/simulate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the full visible catalog: offerings, addons, billing terms and rates currently in effect. Public.
         * @summary Get billing catalog snapshot
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingCatalogSnapshot: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/billing/catalog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export the period ledger as CSV
         * @param {string} id Subscription UUID
         * @param {string} [from] ISO date-time
         * @param {string} [to] ISO date-time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingExportSubscriptionLedgerCsv: async (id: string, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('billingExportSubscriptionLedgerCsv', 'id', id)
            const localVarPath = `/billing/subscriptions/{id}/ledger.csv`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Computes the next cycle-close renewal exactly as the close will (committed resources × term cap hours, minus the recurring coupon) and how much of it the current available balance already covers. Available balance is applied to the renewal at invoice issuance (RENEWAL_CREDIT_APPLIED), and balance that lands AFTER issuance settles the open renewal invoice once it covers it in full — so prepaying is a top-up tagged RENEWAL_PREPAY for the suggested amount. When the renewal invoice is already open, open_renewal_invoice.shortfall_cents is the top-up that settles it.
         * @summary Preview the next renewal for prepayment (\"Antecipar renovação\")
         * @param {string} id Subscription UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingGetRenewalPreview: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('billingGetRenewalPreview', 'id', id)
            const localVarPath = `/billing/subscriptions/{id}/renewal-preview`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Current instance configuration, available plans/addons and balance for the resize wizard
         * @param {number} vmId Instance (VM) id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingGetResizeContext: async (vmId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmId' is not null or undefined
            assertParamExists('billingGetResizeContext', 'vmId', vmId)
            const localVarPath = `/billing/instances/{vmId}/resize`
                .replace(`{${"vmId"}}`, encodeURIComponent(String(vmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a single subscription with balance and active resources
         * @param {string} id Subscription UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingGetSubscription: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('billingGetSubscription', 'id', id)
            const localVarPath = `/billing/subscriptions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the pending cancellation request for a subscription, if any
         * @param {string} id Subscription UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingGetSubscriptionCancellation: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('billingGetSubscriptionCancellation', 'id', id)
            const localVarPath = `/billing/subscriptions/{id}/cancellation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Newest first: what was removed, how long it was on the subscription, what it was billed in total and the temporary credit its removal returned, as the ledger recorded it. A service moved to another subscription is not listed — it is still billed, there.
         * @summary Services this subscription billed and no longer does
         * @param {string} id Subscription UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingGetSubscriptionEndedResources: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('billingGetSubscriptionEndedResources', 'id', id)
            const localVarPath = `/billing/subscriptions/{id}/resources/ended`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Invoices generated for a subscription, with payment events
         * @param {string} id Subscription UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingGetSubscriptionInvoices: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('billingGetSubscriptionInvoices', 'id', id)
            const localVarPath = `/billing/subscriptions/{id}/invoices`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Every credit and debit applied to the subscription, newest first. Each entry carries its bucket, reason, and reference. Use `cursor` for the next page.
         * @summary Paginated balance-ledger statement (full audit trail) for a subscription
         * @param {string} id Subscription UUID
         * @param {number} [limit] 
         * @param {string} [cursor] 
         * @param {BillingGetSubscriptionLedgerBucketEnum} [bucket] 
         * @param {BillingGetSubscriptionLedgerReasonEnum} [reason] 
         * @param {string} [from] ISO date-time
         * @param {string} [to] ISO date-time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingGetSubscriptionLedger: async (id: string, limit?: number, cursor?: string, bucket?: BillingGetSubscriptionLedgerBucketEnum, reason?: BillingGetSubscriptionLedgerReasonEnum, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('billingGetSubscriptionLedger', 'id', id)
            const localVarPath = `/billing/subscriptions/{id}/ledger`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (bucket !== undefined) {
                localVarQueryParameter['bucket'] = bucket;
            }

            if (reason !== undefined) {
                localVarQueryParameter['reason'] = reason;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Usage and credit forecast (estimates, not payment deadlines)
         * @param {string} id Subscription UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingGetSubscriptionProjection: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('billingGetSubscriptionProjection', 'id', id)
            const localVarPath = `/billing/subscriptions/{id}/projection`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Active resources with hourly rate and commitment-cap progress
         * @param {string} id Subscription UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingGetSubscriptionResources: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('billingGetSubscriptionResources', 'id', id)
            const localVarPath = `/billing/subscriptions/{id}/resources`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Opening and closing usable balance for the window and the signed total of every ledger reason in between. Closing always equals opening + net change.
         * @summary Period reconciliation: opening/closing usable balance + totals by reason
         * @param {string} id Subscription UUID
         * @param {string} [from] ISO date-time
         * @param {string} [to] ISO date-time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingGetSubscriptionStatementSummary: async (id: string, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('billingGetSubscriptionStatementSummary', 'id', id)
            const localVarPath = `/billing/subscriptions/{id}/statement-summary`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Suspension/resume history for a subscription
         * @param {string} id Subscription UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingGetSubscriptionSuspensions: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('billingGetSubscriptionSuspensions', 'id', id)
            const localVarPath = `/billing/subscriptions/{id}/suspensions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Daily spend and per-kind breakdown sourced from the metering hypertable. Defaults to the current cycle when no range is given.
         * @summary Hourly consumption history aggregated by day and resource kind
         * @param {string} id Subscription UUID
         * @param {string} [from] ISO date-time
         * @param {string} [to] ISO date-time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingGetSubscriptionUsage: async (id: string, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('billingGetSubscriptionUsage', 'id', id)
            const localVarPath = `/billing/subscriptions/{id}/usage`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Drill-down audit view: every billed hour with the exact resources, rates, seconds and cap status that made up the charge. Defaults to the current cycle.
         * @summary Hourly consumption with the per-resource line items composing each hour
         * @param {string} id Subscription UUID
         * @param {string} [from] ISO date-time
         * @param {string} [to] ISO date-time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingGetSubscriptionUsageHourly: async (id: string, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('billingGetSubscriptionUsageHourly', 'id', id)
            const localVarPath = `/billing/subscriptions/{id}/usage-hourly`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Open invoices first, then settled ones newest-first. Pass `status` (comma-separated: OPEN,PAID,CANCELLED,REFUNDED) to filter — e.g. `status=OPEN` for outstanding invoices only. To pay an OPEN invoice, SSO the user into WHMCS at `viewinvoice.php?id=<external_id>` via `GET /whmcs/sso`.
         * @summary List provider invoices across every subscription of the account
         * @param {string} [status] Comma-separated invoice statuses to include. Defaults to all.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingListAccountInvoices: async (status?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/billing/subscriptions/account/invoices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Defaults to active and suspended subscriptions. Pass `status` (comma-separated) to override, e.g. `status=inactive` to review parked subscriptions or `status=active,suspended,inactive` for everything but cancelled.
         * @summary List subscriptions with balance for the authenticated user
         * @param {string} [status] Comma-separated subscription statuses to include. Defaults to active,suspended.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingListSubscriptions: async (status?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/billing/subscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Only CREDIT_TOPUP coupons are accepted. The discount lowers the payable invoice amount; when the invoice is paid the full nominal top-up (paid + coupon grant) is credited to balance_available as two ledger entries with distinct reasons (RECHARGE, TOPUP_COUPON_CREDIT) for cash-vs-subsidy auditing.
         * @summary Preview a one-time top-up coupon for a subscription recharge
         * @param {string} id Subscription UUID
         * @param {TopupCouponPreviewBodyDto} topupCouponPreviewBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingPreviewTopupCoupon: async (id: string, topupCouponPreviewBodyDto: TopupCouponPreviewBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('billingPreviewTopupCoupon', 'id', id)
            // verify required parameter 'topupCouponPreviewBodyDto' is not null or undefined
            assertParamExists('billingPreviewTopupCoupon', 'topupCouponPreviewBodyDto', topupCouponPreviewBodyDto)
            const localVarPath = `/billing/subscriptions/{id}/topup/coupon/preview`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(topupCouponPreviewBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Price a resize and report impact, removed items and flag violations (no changes applied)
         * @param {number} vmId Instance (VM) id
         * @param {ResizeTargetDto} resizeTargetDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingQuoteResize: async (vmId: number, resizeTargetDto: ResizeTargetDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmId' is not null or undefined
            assertParamExists('billingQuoteResize', 'vmId', vmId)
            // verify required parameter 'resizeTargetDto' is not null or undefined
            assertParamExists('billingQuoteResize', 'resizeTargetDto', resizeTargetDto)
            const localVarPath = `/billing/instances/{vmId}/resize/quote`
                .replace(`{${"vmId"}}`, encodeURIComponent(String(vmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resizeTargetDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Stops recurring billing at the end of the current cycle: no renewal invoice is issued, and every instance and VPN gateway under the subscription is terminated when the cycle closes (immediately for ON_DEMAND subscriptions, which have no cycle). The request can be withdrawn at any time before execution. The exit survey is required in FULL — both the reason and the free-text answer to the follow-up question that reason raises.
         * @summary Schedule the subscription for cancellation at the end of the current cycle
         * @param {string} id Subscription UUID
         * @param {RequestCancellationBodyDto} requestCancellationBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingRequestSubscriptionCancellation: async (id: string, requestCancellationBodyDto: RequestCancellationBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('billingRequestSubscriptionCancellation', 'id', id)
            // verify required parameter 'requestCancellationBodyDto' is not null or undefined
            assertParamExists('billingRequestSubscriptionCancellation', 'requestCancellationBodyDto', requestCancellationBodyDto)
            const localVarPath = `/billing/subscriptions/{id}/cancellation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestCancellationBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Runs the same settlement the platform runs on every credit landing and hourly: when the available balance covers an open renewal invoice in full, the commitment is funded from the balance and the invoice is cancelled (never marked paid — the cash already arrived on the top-up). Nothing is applied when the balance falls short; the response then names the shortfall.
         * @summary Settle the open renewal invoice from the subscription balance now
         * @param {string} id Subscription UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingSettleRenewalFromBalance: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('billingSettleRenewalFromBalance', 'id', id)
            const localVarPath = `/billing/subscriptions/{id}/renewal-invoice/settle-from-balance`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generates a WHMCS invoice for the requested amount. The invoice URL is returned so the client can open it in a new tab. When paid, the reconciler credits balance_available.
         * @summary Create a top-up invoice (WHMCS) to add credits to a subscription
         * @param {string} id Subscription UUID
         * @param {TopupBodyDto} topupBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingTopupSubscription: async (id: string, topupBodyDto: TopupBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('billingTopupSubscription', 'id', id)
            // verify required parameter 'topupBodyDto' is not null or undefined
            assertParamExists('billingTopupSubscription', 'topupBodyDto', topupBodyDto)
            const localVarPath = `/billing/subscriptions/{id}/topup`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(topupBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets or clears the user-facing display name used to identify the subscription across the console.
         * @summary Update subscription settings (display name)
         * @param {string} id Subscription UUID
         * @param {UpdateSubscriptionDto} updateSubscriptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingUpdateSubscription: async (id: string, updateSubscriptionDto: UpdateSubscriptionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('billingUpdateSubscription', 'id', id)
            // verify required parameter 'updateSubscriptionDto' is not null or undefined
            assertParamExists('billingUpdateSubscription', 'updateSubscriptionDto', updateSubscriptionDto)
            const localVarPath = `/billing/subscriptions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSubscriptionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Only possible while the request is still pending — once the cycle has closed and the services were terminated, the cancellation is final.
         * @summary Withdraw the pending cancellation request (renewal resumes)
         * @param {string} id Subscription UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingWithdrawSubscriptionCancellation: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('billingWithdrawSubscriptionCancellation', 'id', id)
            const localVarPath = `/billing/subscriptions/{id}/cancellation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update multiple firewall rules in a single request. Accepts the same fields as the single rule update endpoint for each rule.
         * @summary Bulk update firewall rules
         * @param {any} firewallId Unique identifier of the firewall
         * @param {BulkUpdateFirewallRulesDto} bulkUpdateFirewallRulesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateFirewallRules: async (firewallId: any, bulkUpdateFirewallRulesDto: BulkUpdateFirewallRulesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firewallId' is not null or undefined
            assertParamExists('bulkUpdateFirewallRules', 'firewallId', firewallId)
            // verify required parameter 'bulkUpdateFirewallRulesDto' is not null or undefined
            assertParamExists('bulkUpdateFirewallRules', 'bulkUpdateFirewallRulesDto', bulkUpdateFirewallRulesDto)
            const localVarPath = `/firewalls/{firewallId}/rules`
                .replace(`{${"firewallId"}}`, encodeURIComponent(String(firewallId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkUpdateFirewallRulesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *              Check if the QEMU guest agent is running and responding in the VM.                          **Use cases:**             - Verify guest agent is installed before attempting operations             - Monitor guest agent health             - Troubleshoot guest agent connectivity issues                          **Note:** This endpoint returns a 200 status code even if the agent             is not running. Check the \'is_running\' field in the response to             determine the actual agent status.         
         * @summary Check QEMU guest agent status
         * @param {number} vmId ID of the VM
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAgentStatus: async (vmId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmId' is not null or undefined
            assertParamExists('checkAgentStatus', 'vmId', vmId)
            const localVarPath = `/vm/{vm_id}/qemu-agent/status`
                .replace(`{${"vm_id"}}`, encodeURIComponent(String(vmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check if a domain NS records point to our nameservers
         * @param {string} id Domain record UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkDnsZoneHealth: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('checkDnsZoneHealth', 'id', id)
            const localVarPath = `/dns/zones/{id}/health`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Identifier-first signup helper: lets the registration form detect an existing account before collecting the rest of the details, so the user can be routed to login. Fails open (returns exists=false) on lookup errors — the final register still guards with 409.
         * @summary Check whether an email already has an account
         * @param {CheckEmailDto} checkEmailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkRegistrationEmail: async (checkEmailDto: CheckEmailDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checkEmailDto' is not null or undefined
            assertParamExists('checkRegistrationEmail', 'checkEmailDto', checkEmailDto)
            const localVarPath = `/whmcs/register/check-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkEmailDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns whether the VM is eligible for backups and the number of backup slots available
         * @summary Check VM backup eligibility
         * @param {any} vmId VM ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkVmBackupEligibility: async (vmId: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmId' is not null or undefined
            assertParamExists('checkVmBackupEligibility', 'vmId', vmId)
            const localVarPath = `/backups/vm/{vmId}/eligibility`
                .replace(`{${"vmId"}}`, encodeURIComponent(String(vmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * In production this is invoked by the payment-reconciler when the InvoiceProvider reports the linked invoice as paid. Kept here so the end-to-end checkout flow is exercisable manually.
         * @summary Confirm a checkout v2 order (admin / test path)
         * @param {string} id Order ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutV2ConfirmOrder: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('checkoutV2ConfirmOrder', 'id', id)
            const localVarPath = `/checkout/v2/orders/{id}/confirm`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Re-runs the price simulation server-side and returns one of three outcomes: • **provisioned** — existing subscription had enough balance for the prorata (its cost to the end of the current cycle); resource attached immediately. • **pending_payment** — invoice created in WHMCS, resource provisioned on payment. A new COMMITTED subscription is billed the full term. A new ON_DEMAND subscription invoices initial_credit_cents (defaulting to the catalog initial minimum), credited entirely to available balance for hourly usage without a renewal cycle. An add to an existing COMMITTED subscription whose balance is short is billed the prorata NET of that balance (`balanceAppliedCents`), which is drawn when the invoice is paid — never below the minimum recharge, the difference (`minimumRechargeCreditCents`) staying as credit. • **requires_topup** — existing subscription lacks balance; no order created.   Client should POST /billing/subscriptions/:id/topup for the shortfall, then retry.
         * @summary Create a checkout v2 order
         * @param {CreateOrderDto} createOrderDto 
         * @param {string} [idempotencyKey] A unique, client-generated string (8–255 chars of [A-Za-z0-9._:-]; a UUID is ideal) that makes this call safe to send twice. A retry carrying the same key replays the first answer instead of placing a second order, and comes back with &#x60;Idempotency-Replayed: true&#x60;.  The key covers the request BODY as well: reusing one for a different configuration is refused with a 409 rather than silently answered with the old order. Mint a new key whenever what is being bought changes.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutV2CreateOrder: async (createOrderDto: CreateOrderDto, idempotencyKey?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createOrderDto' is not null or undefined
            assertParamExists('checkoutV2CreateOrder', 'createOrderDto', createOrderDto)
            const localVarPath = `/checkout/v2/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (idempotencyKey != null) {
                localVarHeaderParameter['Idempotency-Key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Backs the checkout \"waiting for payment\" panel: safe to poll, never advances the order. Pass `refresh=true` on an explicit \"I already paid\" click to ask the invoice provider out of band of the reconciler tick — that leg is rate-limited per invoice, and `checked_provider` reports whether it actually ran.
         * @summary Where a placed order stands (payment + provisioning)
         * @param {string} id Order ID (UUID)
         * @param {boolean} [refresh] Ask the invoice provider about the linked invoice before answering (rate-limited per invoice).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutV2GetOrderPaymentState: async (id: string, refresh?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('checkoutV2GetOrderPaymentState', 'id', id)
            const localVarPath = `/checkout/v2/orders/{id}/payment-state`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (refresh !== undefined) {
                localVarQueryParameter['refresh'] = refresh;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns subscriptions for the authenticated account with their current balance so the checkout wizard can let the customer pick a target subscription or start a new one.
         * @summary List active subscriptions available for adding a new resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutV2ListSubscriptions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/checkout/v2/subscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the gross cycle total of the service being ordered, the recurring discount its coupon takes off, and the payable amount. A coupon is bound to the SERVICE the order creates and discounts that service on every renewal; a service added to the subscription later is billed at list price. Fixed-value coupons come off the service total, never off a product price.
         * @summary Preview a recurring coupon for the service being ordered
         * @param {CheckoutCouponPreviewBodyDto} checkoutCouponPreviewBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutV2PreviewCoupon: async (checkoutCouponPreviewBodyDto: CheckoutCouponPreviewBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checkoutCouponPreviewBodyDto' is not null or undefined
            assertParamExists('checkoutV2PreviewCoupon', 'checkoutCouponPreviewBodyDto', checkoutCouponPreviewBodyDto)
            const localVarPath = `/checkout/v2/coupons/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkoutCouponPreviewBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Apply firewall configuration and rules to the specified VMs. This asynchronous operation: • Applies all firewall rules to the target VMs • Updates firewall policies on the VMs • Automatically removes firewall rules from VMs no longer assigned • Returns a job ID for tracking the operation progress  **Note**: Changes are not applied to VMs until this endpoint is called.
         * @summary Commit firewall rules to VMs
         * @param {any} firewallId Unique identifier of the firewall
         * @param {CommitFirewallDto} commitFirewallDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitFirewall: async (firewallId: any, commitFirewallDto: CommitFirewallDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firewallId' is not null or undefined
            assertParamExists('commitFirewall', 'firewallId', firewallId)
            // verify required parameter 'commitFirewallDto' is not null or undefined
            assertParamExists('commitFirewall', 'commitFirewallDto', commitFirewallDto)
            const localVarPath = `/firewalls/{firewallId}/commit`
                .replace(`{${"firewallId"}}`, encodeURIComponent(String(firewallId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commitFirewallDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Seals the upload and starts checking and preparing the image. Returns the id of the job to follow.
         * @summary Finish an upload
         * @param {string} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeClientImageUpload: async (imageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('completeClientImageUpload', 'imageId', imageId)
            const localVarPath = `/images/{imageId}/upload/complete`
                .replace(`{${"imageId"}}`, encodeURIComponent(String(imageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the plaintext token once — it cannot be retrieved later.
         * @summary Create an API token
         * @param {CreateApiTokenDto} createApiTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApiToken: async (createApiTokenDto: CreateApiTokenDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createApiTokenDto' is not null or undefined
            assertParamExists('createApiToken', 'createApiTokenDto', createApiTokenDto)
            const localVarPath = `/api-tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createApiTokenDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new DNS zone
         * @param {CreateZoneDto} createZoneDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDnsZone: async (createZoneDto: CreateZoneDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createZoneDto' is not null or undefined
            assertParamExists('createDnsZone', 'createZoneDto', createZoneDto)
            const localVarPath = `/dns/zones`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createZoneDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new firewall configuration with default policies. The firewall will be created with the specified input and output policies.
         * @summary Create a new firewall
         * @param {CreateFirewallDto} createFirewallDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFirewall: async (createFirewallDto: CreateFirewallDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFirewallDto' is not null or undefined
            assertParamExists('createFirewall', 'createFirewallDto', createFirewallDto)
            const localVarPath = `/firewalls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFirewallDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new backup schedule for a VM or updates an existing one
         * @summary Create or update a backup schedule
         * @param {CreateBackupScheduleDto} createBackupScheduleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSchedule: async (createBackupScheduleDto: CreateBackupScheduleDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createBackupScheduleDto' is not null or undefined
            assertParamExists('createSchedule', 'createBackupScheduleDto', createBackupScheduleDto)
            const localVarPath = `/backups/schedules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBackupScheduleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Accept a risk, with a justification and an expiry date
         * @param {CreateSecurityExceptionDto} createSecurityExceptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSecurityException: async (createSecurityExceptionDto: CreateSecurityExceptionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSecurityExceptionDto' is not null or undefined
            assertParamExists('createSecurityException', 'createSecurityExceptionDto', createSecurityExceptionDto)
            const localVarPath = `/security/exceptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSecurityExceptionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Connect another site to this gateway
         * @param {string} gatewayId 
         * @param {SiteConnectionRequestDto} siteConnectionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSiteConnection: async (gatewayId: string, siteConnectionRequestDto: SiteConnectionRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gatewayId' is not null or undefined
            assertParamExists('createSiteConnection', 'gatewayId', gatewayId)
            // verify required parameter 'siteConnectionRequestDto' is not null or undefined
            assertParamExists('createSiteConnection', 'siteConnectionRequestDto', siteConnectionRequestDto)
            const localVarPath = `/vpn-gateway/{gatewayId}/site-to-site`
                .replace(`{${"gatewayId"}}`, encodeURIComponent(String(gatewayId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(siteConnectionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new snapshot for the VM. Snapshots expire after 30 days. You can optionally include RAM state for a complete running state snapshot.
         * @summary Create a new snapshot
         * @param {number} vmId VM ID
         * @param {CreateSnapshotDto} createSnapshotDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSnapshot: async (vmId: number, createSnapshotDto: CreateSnapshotDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmId' is not null or undefined
            assertParamExists('createSnapshot', 'vmId', vmId)
            // verify required parameter 'createSnapshotDto' is not null or undefined
            assertParamExists('createSnapshot', 'createSnapshotDto', createSnapshotDto)
            const localVarPath = `/snapshots/vm/{vmId}`
                .replace(`{${"vmId"}}`, encodeURIComponent(String(vmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSnapshotDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a Single Sign-On (SSO) token for the authenticated user.
         * @summary Create SSO Token
         * @param {string} [path] Optional path parameter to customize SSO token creation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSsoToken: async (path?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/whmcs/sso`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new VPC for the authenticated client.
         * @summary Create a new VPC
         * @param {VpcCreateDto} vpcCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVpc: async (vpcCreateDto: VpcCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vpcCreateDto' is not null or undefined
            assertParamExists('createVpc', 'vpcCreateDto', vpcCreateDto)
            const localVarPath = `/vpc`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vpcCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new VPN Gateway
         * @param {CreateVpnGatewayDto} createVpnGatewayDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVpnGateway: async (createVpnGatewayDto: CreateVpnGatewayDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createVpnGatewayDto' is not null or undefined
            assertParamExists('createVpnGateway', 'createVpnGatewayDto', createVpnGatewayDto)
            const localVarPath = `/vpn-gateway`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createVpnGatewayDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mint a short-lived token that can be used only to authenticate Socket.IO connections.
         * @summary Create WebSocket token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWebsocketToken: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/whmcs/socket-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a backup
         * @summary Delete a backup
         * @param {number} backupId Backup ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBackup: async (backupId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'backupId' is not null or undefined
            assertParamExists('deleteBackup', 'backupId', backupId)
            const localVarPath = `/backups/{backupId}`
                .replace(`{${"backupId"}}`, encodeURIComponent(String(backupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes the artifact, every hypervisor copy of it, and ejects it from any instance booting it. Instances already built from it are unaffected.
         * @summary Delete an image
         * @param {string} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClientImage: async (imageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('deleteClientImage', 'imageId', imageId)
            const localVarPath = `/images/{imageId}`
                .replace(`{${"imageId"}}`, encodeURIComponent(String(imageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a DNS record from a zone
         * @param {string} id Domain record UUID
         * @param {DeleteRecordDto} deleteRecordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDnsRecord: async (id: string, deleteRecordDto: DeleteRecordDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteDnsRecord', 'id', id)
            // verify required parameter 'deleteRecordDto' is not null or undefined
            assertParamExists('deleteDnsRecord', 'deleteRecordDto', deleteRecordDto)
            const localVarPath = `/dns/zones/{id}/records`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteRecordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a DNS zone and all its records
         * @param {string} id Domain record UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDnsZone: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteDnsZone', 'id', id)
            const localVarPath = `/dns/zones/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Asynchronously delete a firewall and clean up all associated resources. This operation: • Removes firewall rules from all assigned VMs • Sets VM firewall policies to ALLOW • Deletes the firewall configuration • Returns a job ID for tracking the asynchronous operation
         * @summary Delete firewall
         * @param {any} firewallId Unique identifier of the firewall to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFirewall: async (firewallId: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firewallId' is not null or undefined
            assertParamExists('deleteFirewall', 'firewallId', firewallId)
            const localVarPath = `/firewalls/{firewallId}`
                .replace(`{${"firewallId"}}`, encodeURIComponent(String(firewallId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permanently delete a firewall rule.
         * @summary Delete firewall rule
         * @param {string} ruleId Unique identifier of the rule to delete
         * @param {any} firewallId Unique identifier of the firewall
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFirewallRule: async (ruleId: string, firewallId: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('deleteFirewallRule', 'ruleId', ruleId)
            // verify required parameter 'firewallId' is not null or undefined
            assertParamExists('deleteFirewallRule', 'firewallId', firewallId)
            const localVarPath = `/firewalls/{firewallId}/rules/{ruleId}`
                .replace(`{${"ruleId"}}`, encodeURIComponent(String(ruleId)))
                .replace(`{${"firewallId"}}`, encodeURIComponent(String(firewallId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove an attachment from one of my PENDING withdrawals
         * @param {string} id 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMyWithdrawalAttachment: async (id: string, attachmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteMyWithdrawalAttachment', 'id', id)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('deleteMyWithdrawalAttachment', 'attachmentId', attachmentId)
            const localVarPath = `/affiliates/withdrawals/{id}/attachments/{attachmentId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a backup schedule (soft delete)
         * @summary Delete a backup schedule
         * @param {number} scheduleId Schedule ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSchedule: async (scheduleId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scheduleId' is not null or undefined
            assertParamExists('deleteSchedule', 'scheduleId', scheduleId)
            const localVarPath = `/backups/schedules/{scheduleId}`
                .replace(`{${"scheduleId"}}`, encodeURIComponent(String(scheduleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disconnect a site
         * @param {string} gatewayId 
         * @param {string} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSiteConnection: async (gatewayId: string, connectionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gatewayId' is not null or undefined
            assertParamExists('deleteSiteConnection', 'gatewayId', gatewayId)
            // verify required parameter 'connectionId' is not null or undefined
            assertParamExists('deleteSiteConnection', 'connectionId', connectionId)
            const localVarPath = `/vpn-gateway/{gatewayId}/site-to-site/{connectionId}`
                .replace(`{${"gatewayId"}}`, encodeURIComponent(String(gatewayId)))
                .replace(`{${"connectionId"}}`, encodeURIComponent(String(connectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a specific snapshot. Validates that the snapshot belongs to a VM owned by the authenticated user.
         * @summary Delete a snapshot
         * @param {string} snapshotId Snapshot ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSnapshot: async (snapshotId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'snapshotId' is not null or undefined
            assertParamExists('deleteSnapshot', 'snapshotId', snapshotId)
            const localVarPath = `/snapshots/{snapshotId}`
                .replace(`{${"snapshotId"}}`, encodeURIComponent(String(snapshotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Terminate a VM instance, release its IP assignments, soft-delete the VM record, and stop future billing for linked resources.
         * @summary Delete VM
         * @param {any} vmId ID of the VM to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVm: async (vmId: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmId' is not null or undefined
            assertParamExists('deleteVm', 'vmId', vmId)
            const localVarPath = `/vm/{vm_id}`
                .replace(`{${"vm_id"}}`, encodeURIComponent(String(vmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a VPC by its ID.
         * @summary Delete a VPC
         * @param {number} vpcId ID of the VPC to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVpc: async (vpcId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vpcId' is not null or undefined
            assertParamExists('deleteVpc', 'vpcId', vpcId)
            const localVarPath = `/vpc/{vpc_id}`
                .replace(`{${"vpc_id"}}`, encodeURIComponent(String(vpcId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a VPN user
         * @param {string} id VPN User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVpnUser: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteVpnUser', 'id', id)
            const localVarPath = `/vpn-gateway/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Rebuilds the instance from a disk image the customer uploaded. The instance keeps its addresses and its plan; everything on its disk is replaced. Refused when the plan’s disk is smaller than the image needs — a reinstall cannot grow a disk, so it must be resized first.
         * @summary Reinstall an instance from one of my images
         * @param {string} imageId ID of the customer image
         * @param {any} vmId ID of the instance to rebuild
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deployVmFromClientImage: async (imageId: string, vmId: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('deployVmFromClientImage', 'imageId', imageId)
            // verify required parameter 'vmId' is not null or undefined
            assertParamExists('deployVmFromClientImage', 'vmId', vmId)
            const localVarPath = `/vm/{vm_id}/deploy/image/{image_id}`
                .replace(`{${"image_id"}}`, encodeURIComponent(String(imageId)))
                .replace(`{${"vm_id"}}`, encodeURIComponent(String(vmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deploy a VM from a template.
         * @summary Deploy VM from template
         * @param {number} templateId ID of the template to deploy from
         * @param {any} vmId ID of the VM to deploy
         * @param {DeployVmDto} [deployVmDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deployVmFromTemplate: async (templateId: number, vmId: any, deployVmDto?: DeployVmDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('deployVmFromTemplate', 'templateId', templateId)
            // verify required parameter 'vmId' is not null or undefined
            assertParamExists('deployVmFromTemplate', 'vmId', vmId)
            const localVarPath = `/vm/{vm_id}/deploy/{template_id}`
                .replace(`{${"template_id"}}`, encodeURIComponent(String(templateId)))
                .replace(`{${"vm_id"}}`, encodeURIComponent(String(vmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deployVmDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Eject an ISO
         * @param {string} imageId 
         * @param {number} vmId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detachClientImage: async (imageId: string, vmId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('detachClientImage', 'imageId', imageId)
            // verify required parameter 'vmId' is not null or undefined
            assertParamExists('detachClientImage', 'vmId', vmId)
            const localVarPath = `/images/{imageId}/attach/{vmId}`
                .replace(`{${"imageId"}}`, encodeURIComponent(String(imageId)))
                .replace(`{${"vmId"}}`, encodeURIComponent(String(vmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download an attachment on one of my withdrawals
         * @param {string} id 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadMyWithdrawalAttachment: async (id: string, attachmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('downloadMyWithdrawalAttachment', 'id', id)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('downloadMyWithdrawalAttachment', 'attachmentId', attachmentId)
            const localVarPath = `/affiliates/withdrawals/{id}/attachments/{attachmentId}/download`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download the configuration for the other end
         * @param {string} gatewayId 
         * @param {string} connectionId 
         * @param {string} vendor 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSiteConnectionConfig: async (gatewayId: string, connectionId: string, vendor: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gatewayId' is not null or undefined
            assertParamExists('downloadSiteConnectionConfig', 'gatewayId', gatewayId)
            // verify required parameter 'connectionId' is not null or undefined
            assertParamExists('downloadSiteConnectionConfig', 'connectionId', connectionId)
            // verify required parameter 'vendor' is not null or undefined
            assertParamExists('downloadSiteConnectionConfig', 'vendor', vendor)
            const localVarPath = `/vpn-gateway/{gatewayId}/site-to-site/{connectionId}/config`
                .replace(`{${"gatewayId"}}`, encodeURIComponent(String(gatewayId)))
                .replace(`{${"connectionId"}}`, encodeURIComponent(String(connectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (vendor !== undefined) {
                localVarQueryParameter['vendor'] = vendor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validates an admin-issued SSO code and returns access and refresh tokens for the client portal.
         * @summary Exchange a single-use SSO code for session tokens
         * @param {ExchangeSsoDto} exchangeSsoDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeSso: async (exchangeSsoDto: ExchangeSsoDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exchangeSsoDto' is not null or undefined
            assertParamExists('exchangeSso', 'exchangeSsoDto', exchangeSsoDto)
            const localVarPath = `/whmcs/sso/exchange`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exchangeSsoDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Queues a backup job for the specified VM. The backup will be executed asynchronously.
         * @summary Execute a manual backup for a VM
         * @param {any} vmId VM ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeBackup: async (vmId: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmId' is not null or undefined
            assertParamExists('executeBackup', 'vmId', vmId)
            const localVarPath = `/backups/vm/{vmId}/execute`
                .replace(`{${"vmId"}}`, encodeURIComponent(String(vmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate a download code for VPN connection profile access
         * @param {string} id VPN Gateway ID
         * @param {GenerateDownloadCodeDto} generateDownloadCodeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDownloadCode: async (id: string, generateDownloadCodeDto: GenerateDownloadCodeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('generateDownloadCode', 'id', id)
            // verify required parameter 'generateDownloadCodeDto' is not null or undefined
            assertParamExists('generateDownloadCode', 'generateDownloadCodeDto', generateDownloadCodeDto)
            const localVarPath = `/vpn-gateway/{id}/generate-download-code`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateDownloadCodeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all datacenters
         * @param {boolean} [includeHidden] Whether to include hidden datacenters (default: false)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDatacenters: async (includeHidden?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/datacenters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeHidden !== undefined) {
                localVarQueryParameter['includeHidden'] = includeHidden;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of all VPCs for the authenticated client.
         * @summary Get all VPCs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllVpcs: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/vpc`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all VPN Gateways for the logged-in client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllVpnGateways: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/vpn-gateway`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all VPN users from all VPN gateways for the logged-in client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllVpnUsers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/vpn-gateway/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary What this gateway is running
         * @param {string} id VPN Gateway ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppliance: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAppliance', 'id', id)
            const localVarPath = `/vpn-gateway/{id}/appliance`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Operator instructions for the AI assistant system prompt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssistantInstructions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ai/assistant-instructions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a list of available templates based on the current VM product. Respects soft deletes.
         * @summary List available templates for VM
         * @param {number} vmId ID of the VM to get templates for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableTemplates: async (vmId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmId' is not null or undefined
            assertParamExists('getAvailableTemplates', 'vmId', vmId)
            const localVarPath = `/vm/{vm_id}/templates`
                .replace(`{${"vm_id"}}`, encodeURIComponent(String(vmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the current backup progress for a VM by parsing hypervisor task logs
         * @summary Get backup progress for a VM
         * @param {any} vmId VM ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBackupProgress: async (vmId: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmId' is not null or undefined
            assertParamExists('getBackupProgress', 'vmId', vmId)
            const localVarPath = `/backups/vm/{vm_id}/backup-progress`
                .replace(`{${"vm_id"}}`, encodeURIComponent(String(vmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get one image
         * @param {string} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientImage: async (imageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('getClientImage', 'imageId', imageId)
            const localVarPath = `/images/{imageId}`
                .replace(`{${"imageId"}}`, encodeURIComponent(String(imageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The document exactly as the guest will receive it, with the format, the size limit and any problems found in it. Re-checked on every read.
         * @summary Read this image’s cloud-init user data
         * @param {string} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientImageCloudInit: async (imageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('getClientImageCloudInit', 'imageId', imageId)
            const localVarPath = `/images/{imageId}/cloud-init`
                .replace(`{${"imageId"}}`, encodeURIComponent(String(imageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Storage allowance and current usage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientImageQuota: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/images/quota`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Each instance is reported with whether its disk is large enough. A reinstall cannot grow a disk, so an instance that does not fit must be resized first.
         * @summary Instances this image can be used on
         * @param {string} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientImageTargets: async (imageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('getClientImageTargets', 'imageId', imageId)
            const localVarPath = `/images/{imageId}/targets`
                .replace(`{${"imageId"}}`, encodeURIComponent(String(imageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a specific cluster by its ID.
         * @summary Get Cluster by ID
         * @param {number} id Cluster ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClusterById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getClusterById', 'id', id)
            const localVarPath = `/cluster/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of all clusters.
         * @summary List Clusters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClusters: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/cluster`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get clusters by datacenter ID
         * @param {number} id Datacenter ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClustersByDatacenterId: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getClustersByDatacenterId', 'id', id)
            const localVarPath = `/datacenters/{id}/clusters`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get VPN connection profile using download code (public endpoint)
         * @param {string} downloadCode Download code for accessing VPN connection profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectionProfileByDownloadCode: async (downloadCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'downloadCode' is not null or undefined
            assertParamExists('getConnectionProfileByDownloadCode', 'downloadCode', downloadCode)
            const localVarPath = `/public/vpn-gateway/download/{downloadCode}`
                .replace(`{${"downloadCode"}}`, encodeURIComponent(String(downloadCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *        Generate a VNC ticket for a VM the authenticated user owns and return       WebSocket connection details for the proxied noVNC console viewer.       Call this on every connect or reconnect — it is idempotent and always       returns a fresh VNC ticket.        The returned `websocket_url` contains an opaque session token used by the       backend proxy. Open the console page at `/console/<vm_id>` and let the       viewer call this endpoint directly using the existing browser session.     
         * @summary Get VM console connection details
         * @param {VncConsoleRequestDto} vncConsoleRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsoleAccess: async (vncConsoleRequestDto: VncConsoleRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vncConsoleRequestDto' is not null or undefined
            assertParamExists('getConsoleAccess', 'vncConsoleRequestDto', vncConsoleRequestDto)
            const localVarPath = `/console/access`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vncConsoleRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fleet vitals, billing runway, backup coverage, security posture and a ranked list of what needs attention. Replaces the fan-out the console used to perform (one status call per instance, one projection per subscription), which did not survive contact with large accounts.  Sections fail independently: anything that could not be read is named in `degraded[]` rather than returned as zeroes, so a partial answer is never rendered as an all-clear.
         * @summary Everything the console home screen renders, in one read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardOverview: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/dashboard/overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a datacenter by ID
         * @param {number} id Datacenter ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatacenterById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDatacenterById', 'id', id)
            const localVarPath = `/datacenters/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check if the VM is eligible for snapshot operations and get quota information
         * @summary Check snapshot eligibility
         * @param {number} vmId VM ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEligibility: async (vmId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmId' is not null or undefined
            assertParamExists('getEligibility', 'vmId', vmId)
            const localVarPath = `/snapshots/vm/{vmId}/eligibility`
                .replace(`{${"vmId"}}`, encodeURIComponent(String(vmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Backs the Discover page. Showing it records nothing.
         * @summary Every tip, with adoption and state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureDiscoveryCatalog: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/feature-discovery/catalog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Ranked tips the account does not use yet, launches first. Empty while a deck was shown to this person in the last 20 hours, on any device.
         * @summary Tips for this sign-in
         * @param {Array<string>} [exclude] Tip codes this console cannot offer (a feature disabled in this deployment). Comma-separated or repeated.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureDiscoveryDeck: async (exclude?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/feature-discovery/next`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (exclude) {
                localVarQueryParameter['exclude'] = exclude;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get detailed information about a specific firewall including its configuration, rules, and assigned VMs.
         * @summary Get firewall by ID
         * @param {any} firewallId Unique identifier of the firewall
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirewall: async (firewallId: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firewallId' is not null or undefined
            assertParamExists('getFirewall', 'firewallId', firewallId)
            const localVarPath = `/firewalls/{firewallId}`
                .replace(`{${"firewallId"}}`, encodeURIComponent(String(firewallId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the firewall assigned to a specific VM along with its rules.
         * @summary Get firewall for VM
         * @param {any} vmId Unique identifier of the VM
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirewallForVm: async (vmId: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmId' is not null or undefined
            assertParamExists('getFirewallForVm', 'vmId', vmId)
            const localVarPath = `/firewalls/vm/{vmId}`
                .replace(`{${"vmId"}}`, encodeURIComponent(String(vmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Track the progress of any asynchronous job by ID
         * @summary Get job status
         * @param {string} jobId Job ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobStatus: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('getJobStatus', 'jobId', jobId)
            const localVarPath = `/jobs/{jobId}`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Affiliate overview for the current account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyAffiliate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/affiliates/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get notifications with pagination
         * @param {number} [page] Page number
         * @param {number} [limit] Number of items per page
         * @param {boolean} [unreadOnly] Return only unread notifications. &#x60;total&#x60;/&#x60;totalPages&#x60; then describe the unread set, so the \&quot;Unread\&quot; filter can paginate without holes.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications: async (page?: number, limit?: number, unreadOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (unreadOnly !== undefined) {
                localVarQueryParameter['unread_only'] = unreadOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the current restore progress for a VM by parsing hypervisor task logs
         * @summary Get restore progress for a VM
         * @param {any} vmId VM ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRestoreProgress: async (vmId: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmId' is not null or undefined
            assertParamExists('getRestoreProgress', 'vmId', vmId)
            const localVarPath = `/backups/vm/{vm_id}/restore-progress`
                .replace(`{${"vm_id"}}`, encodeURIComponent(String(vmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary One finding with its evidence, advice and timeline
         * @param {string} findingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSecurityFinding: async (findingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'findingId' is not null or undefined
            assertParamExists('getSecurityFinding', 'findingId', findingId)
            const localVarPath = `/security/findings/{findingId}`
                .replace(`{${"findingId"}}`, encodeURIComponent(String(findingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Security posture across every instance on the account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSecurityOverview: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/security/overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Daily security score history
         * @param {number} [days] 
         * @param {number} [vmId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSecurityScoreHistory: async (days?: number, vmId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/security/score-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }

            if (vmId !== undefined) {
                localVarQueryParameter['vm_id'] = vmId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Scanning and notification preferences for the account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSecuritySettings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/security/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary One connection, with what the other end needs
         * @param {string} gatewayId 
         * @param {string} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteConnection: async (gatewayId: string, connectionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gatewayId' is not null or undefined
            assertParamExists('getSiteConnection', 'gatewayId', gatewayId)
            // verify required parameter 'connectionId' is not null or undefined
            assertParamExists('getSiteConnection', 'connectionId', connectionId)
            const localVarPath = `/vpn-gateway/{gatewayId}/site-to-site/{connectionId}`
                .replace(`{${"gatewayId"}}`, encodeURIComponent(String(gatewayId)))
                .replace(`{${"connectionId"}}`, encodeURIComponent(String(connectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Which configurations can be generated
         * @param {string} gatewayId 
         * @param {string} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteConnectionConfigOptions: async (gatewayId: string, connectionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gatewayId' is not null or undefined
            assertParamExists('getSiteConnectionConfigOptions', 'gatewayId', gatewayId)
            // verify required parameter 'connectionId' is not null or undefined
            assertParamExists('getSiteConnectionConfigOptions', 'connectionId', connectionId)
            const localVarPath = `/vpn-gateway/{gatewayId}/site-to-site/{connectionId}/config-options`
                .replace(`{${"gatewayId"}}`, encodeURIComponent(String(gatewayId)))
                .replace(`{${"connectionId"}}`, encodeURIComponent(String(connectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary What has happened to this connection
         * @param {string} gatewayId 
         * @param {string} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteConnectionEvents: async (gatewayId: string, connectionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gatewayId' is not null or undefined
            assertParamExists('getSiteConnectionEvents', 'gatewayId', gatewayId)
            // verify required parameter 'connectionId' is not null or undefined
            assertParamExists('getSiteConnectionEvents', 'connectionId', connectionId)
            const localVarPath = `/vpn-gateway/{gatewayId}/site-to-site/{connectionId}/events`
                .replace(`{${"gatewayId"}}`, encodeURIComponent(String(gatewayId)))
                .replace(`{${"connectionId"}}`, encodeURIComponent(String(connectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the status of a VM operation task.
         * @summary Get Task Status
         * @param {string} taskId ID of the task to check
         * @param {any} vmId ID of the VM
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskStatus: async (taskId: string, vmId: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('getTaskStatus', 'taskId', taskId)
            // verify required parameter 'vmId' is not null or undefined
            assertParamExists('getTaskStatus', 'vmId', vmId)
            const localVarPath = `/vm/{vm_id}/task/{task_id}`
                .replace(`{${"task_id"}}`, encodeURIComponent(String(taskId)))
                .replace(`{${"vm_id"}}`, encodeURIComponent(String(vmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the details of the authenticated user.
         * @summary Get User Details
         * @param {boolean} [fresh] Ask WHMCS now instead of answering from the cached profile (used by the page that shows the profile back to its owner).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDetails: async (fresh?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/whmcs/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fresh !== undefined) {
                localVarQueryParameter['fresh'] = fresh;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Transferred data volume (inbound/outbound, all interfaces) aggregated in time buckets for the selected period, plus the public outbound usage of the current billing window.
         * @summary Get VM Bandwidth Usage
         * @param {GetVmBandwidthPeriodEnum} period Period for bandwidth usage data
         * @param {any} vmId ID of the VM
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVmBandwidth: async (period: GetVmBandwidthPeriodEnum, vmId: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'period' is not null or undefined
            assertParamExists('getVmBandwidth', 'period', period)
            // verify required parameter 'vmId' is not null or undefined
            assertParamExists('getVmBandwidth', 'vmId', vmId)
            const localVarPath = `/vm/{vm_id}/bandwidth`
                .replace(`{${"vm_id"}}`, encodeURIComponent(String(vmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a VM by its ID.
         * @summary Get VM by ID
         * @param {any} vmId ID of the VM
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVmById: async (vmId: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmId' is not null or undefined
            assertParamExists('getVmById', 'vmId', vmId)
            const localVarPath = `/vm/{vm_id}`
                .replace(`{${"vm_id"}}`, encodeURIComponent(String(vmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the current disk interface type, NIC model, and OS type for a VM.
         * @summary Get current VM hardware configuration
         * @param {number} vmId VM ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVmHardwareConfig: async (vmId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmId' is not null or undefined
            assertParamExists('getVmHardwareConfig', 'vmId', vmId)
            const localVarPath = `/vm-hardware/{vmId}`
                .replace(`{${"vmId"}}`, encodeURIComponent(String(vmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns available disk interface types, NIC models, and OS types/versions.
         * @summary Get hardware configuration options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVmHardwareOptions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/vm-hardware/options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve historical metrics data for a VM with caching. Returns CPU, memory, disk, and network usage over time.
         * @summary Get VM Metrics
         * @param {GetVmMetricsTimeframeEnum} timeframe Timeframe for metrics data
         * @param {any} vmId ID of the VM
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVmMetrics: async (timeframe: GetVmMetricsTimeframeEnum, vmId: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'timeframe' is not null or undefined
            assertParamExists('getVmMetrics', 'timeframe', timeframe)
            // verify required parameter 'vmId' is not null or undefined
            assertParamExists('getVmMetrics', 'vmId', vmId)
            const localVarPath = `/vm/{vm_id}/metrics`
                .replace(`{${"vm_id"}}`, encodeURIComponent(String(vmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (timeframe !== undefined) {
                localVarQueryParameter['timeframe'] = timeframe;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * What the removal returns to the subscription (temporary credit on a commitment, nothing on on-demand), how much, until when, what the subscription will hold afterwards, and anything that would make the deletion be refused. Computed by the same code that performs the removal; changes nothing.
         * @summary Preview what deleting a VM does to its billing
         * @param {any} vmId ID of the VM
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVmRemovalPreview: async (vmId: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmId' is not null or undefined
            assertParamExists('getVmRemovalPreview', 'vmId', vmId)
            const localVarPath = `/vm/{vm_id}/billing/removal-preview`
                .replace(`{${"vm_id"}}`, encodeURIComponent(String(vmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Security posture of one instance
         * @param {number} vmId Instance id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVmSecurityPosture: async (vmId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmId' is not null or undefined
            assertParamExists('getVmSecurityPosture', 'vmId', vmId)
            const localVarPath = `/vm/{vmId}/security`
                .replace(`{${"vmId"}}`, encodeURIComponent(String(vmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the current status of a VM from the hypervisor with caching and deployment information.
         * @summary Get VM Status
         * @param {string} vmId ID of the VM
         * @param {boolean} [fresh] Bypass the cached status and read the live state (used by user-invoked refreshes).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVmStatus: async (vmId: string, fresh?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmId' is not null or undefined
            assertParamExists('getVmStatus', 'vmId', vmId)
            const localVarPath = `/vm/{vm_id}/status`
                .replace(`{${"vm_id"}}`, encodeURIComponent(String(vmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fresh !== undefined) {
                localVarQueryParameter['fresh'] = fresh;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of all VMs for the authenticated client.
         * @summary List VMs
         * @param {string} [id] ID of the VM
         * @param {string} [clusterId] Cluster ID of the server
         * @param {GetVmsProductCategoryTypeEnum} [productCategoryType] Service type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVms: async (id?: string, clusterId?: string, productCategoryType?: GetVmsProductCategoryTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/vm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['cluster_id'] = clusterId;
            }

            if (productCategoryType !== undefined) {
                localVarQueryParameter['product_category_type'] = productCategoryType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all VMs from a VPC.
         * @summary Retrieve VMs by VPC ID
         * @param {any} vpcId ID of the VPC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVpcVms: async (vpcId: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vpcId' is not null or undefined
            assertParamExists('getVpcVms', 'vpcId', vpcId)
            const localVarPath = `/vpc/{vpc_id}/vms`
                .replace(`{${"vpc_id"}}`, encodeURIComponent(String(vpcId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get VPN connection profile (.ovpn file) for a VPN Gateway
         * @param {string} id VPN Gateway ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVpnConnectionProfile: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getVpnConnectionProfile', 'id', id)
            const localVarPath = `/vpn-gateway/{id}/connection-profile`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a VPN Gateway by VM ID
         * @param {number} vmId VM ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVpnGatewayByVmId: async (vmId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmId' is not null or undefined
            assertParamExists('getVpnGatewayByVmId', 'vmId', vmId)
            const localVarPath = `/vpn-gateway/vm/{vmId}`
                .replace(`{${"vmId"}}`, encodeURIComponent(String(vmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get VPN Gateway details with connected users information
         * @param {string} id VPN Gateway ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVpnGatewayDetails: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getVpnGatewayDetails', 'id', id)
            const localVarPath = `/vpn-gateway/{id}/details`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get VPN Gateway details using download code (public endpoint)
         * @param {string} downloadCode Download code for accessing VPN Gateway details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVpnGatewayDetailsByDownloadCode: async (downloadCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'downloadCode' is not null or undefined
            assertParamExists('getVpnGatewayDetailsByDownloadCode', 'downloadCode', downloadCode)
            const localVarPath = `/public/vpn-gateway/details/{downloadCode}`
                .replace(`{${"downloadCode"}}`, encodeURIComponent(String(downloadCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all users for a VPN Gateway
         * @param {string} id VPN Gateway ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVpnUsers: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getVpnUsers', 'id', id)
            const localVarPath = `/vpn-gateway/{id}/users`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Clones the origin VM into the destination VM using either the current state or an existing backup. Destination disk must be >= origin disk, and the required backup/vm storages must be available.
         * @summary Initiate a VM clone operation
         * @param {InitiateCloneDto} initiateCloneDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateVmClone: async (initiateCloneDto: InitiateCloneDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'initiateCloneDto' is not null or undefined
            assertParamExists('initiateVmClone', 'initiateCloneDto', initiateCloneDto)
            const localVarPath = `/vm-clone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(initiateCloneDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Paginated, searchable history of actions taken on your account — from the web console, from your API tokens, by the AI assistant, by our support team on your behalf, and by automated platform processes. Each entry records who acted, from which IP address, what was affected and whether it succeeded.
         * @summary List account activity
         * @param {number} [page] Page number (1-based).
         * @param {number} [pageSize] Entries per page.
         * @param {string} [search] Free-text search across the actor, the affected resource, the action and the IP address.
         * @param {ListAccountActivityActorKindEnum} [actorKind] Restrict to one kind of actor — &#x60;CONSOLE&#x60; for the web panel, &#x60;API_TOKEN&#x60; for your API credentials, &#x60;MCP&#x60; for AI assistant actions, &#x60;SUPPORT&#x60; for actions taken by our staff, &#x60;SYSTEM&#x60; for automated platform actions.
         * @param {ListAccountActivityCategoryEnum} [category] Restrict to one area of the product.
         * @param {string} [action] Exact action key, e.g. &#x60;instance.delete&#x60;. Takes precedence over &#x60;category&#x60;.
         * @param {string} [targetType] Restrict to one resource type, e.g. &#x60;instance&#x60;.
         * @param {string} [targetId] Restrict to one resource id — the history of a single instance, zone or firewall.
         * @param {ListAccountActivityOutcomeEnum} [outcome] 
         * @param {string} [from] Only entries at or after this instant (ISO 8601).
         * @param {string} [to] Only entries at or before this instant (ISO 8601).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccountActivity: async (page?: number, pageSize?: number, search?: string, actorKind?: ListAccountActivityActorKindEnum, category?: ListAccountActivityCategoryEnum, action?: string, targetType?: string, targetId?: string, outcome?: ListAccountActivityOutcomeEnum, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (actorKind !== undefined) {
                localVarQueryParameter['actorKind'] = actorKind;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (action !== undefined) {
                localVarQueryParameter['action'] = action;
            }

            if (targetType !== undefined) {
                localVarQueryParameter['targetType'] = targetType;
            }

            if (targetId !== undefined) {
                localVarQueryParameter['targetId'] = targetId;
            }

            if (outcome !== undefined) {
                localVarQueryParameter['outcome'] = outcome;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List grantable scopes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApiTokenScopes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api-tokens/scopes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List my API tokens
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApiTokens: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api-tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all backups for VMs owned by the authenticated user
         * @summary List all backups for the authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBackups: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/backups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all backups for the specified VM
         * @summary List backups for a specific VM
         * @param {any} vmId VM ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBackupsByVm: async (vmId: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmId' is not null or undefined
            assertParamExists('listBackupsByVm', 'vmId', vmId)
            const localVarPath = `/backups/vm/{vmId}`
                .replace(`{${"vmId"}}`, encodeURIComponent(String(vmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Every ISO and disk image on the authenticated account.
         * @summary List my images
         * @param {ListClientImagesKindEnum} [kind] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listClientImages: async (kind?: ListClientImagesKindEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/images`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (kind !== undefined) {
                localVarQueryParameter['kind'] = kind;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all DNS records for a zone
         * @param {string} id Domain record UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDnsRecords: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('listDnsRecords', 'id', id)
            const localVarPath = `/dns/zones/{id}/records`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List DNS zones for the authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDnsZones: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/dns/zones`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all available firewall macros with descriptions. Macros are predefined service configurations that can be used when creating firewall rules (e.g., HTTP, HTTPS, SSH).
         * @summary List firewall macros
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFirewallMacros: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/firewalls/macros`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a paginated list of all firewalls. Supports filtering by name, enable status, and search query.
         * @summary List all firewalls
         * @param {string} [name] Filter by firewall name
         * @param {boolean} [enable] Filter by enabled status
         * @param {string} [search] Search term for name or description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFirewalls: async (name?: string, enable?: boolean, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/firewalls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (enable !== undefined) {
                localVarQueryParameter['enable'] = enable;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List jobs created by the authenticated user, filterable by status, with pagination
         * @summary List jobs by status
         * @param {ListJobsStatusEnum} [status] &#x60;active&#x60; is a shorthand for pending + in_progress — what the console badge counts. Filtering by a single status cannot express it, and two round trips would report two moments in time.
         * @param {number} [page] Page number (1-based)
         * @param {number} [pageSize] Items per page (max 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listJobs: async (status?: ListJobsStatusEnum, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List my referrals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyAffiliateReferrals: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/affiliates/referrals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List my withdrawals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyAffiliateWithdrawals: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/affiliates/withdrawals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List attachments on one of my withdrawals
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyWithdrawalAttachments: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('listMyWithdrawalAttachments', 'id', id)
            const localVarPath = `/affiliates/withdrawals/{id}/attachments`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all IP addresses owned by the authenticated user with their reverse DNS state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRdnsIps: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rdns/ips`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all backup schedules for VMs owned by the authenticated user
         * @summary List all backup schedules for the authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSchedules: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/backups/schedules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Risk exceptions on the account
         * @param {boolean} [includeInactive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSecurityExceptions: async (includeInactive?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/security/exceptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeInactive !== undefined) {
                localVarQueryParameter['include_inactive'] = includeInactive;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Findings across the account, ordered by risk
         * @param {number} [vmId] 
         * @param {ListSecurityFindingsSeverityEnum} [severity] 
         * @param {ListSecurityFindingsStatusEnum} [status] 
         * @param {string} [category] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSecurityFindings: async (vmId?: number, severity?: ListSecurityFindingsSeverityEnum, status?: ListSecurityFindingsStatusEnum, category?: string, search?: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/security/findings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (vmId !== undefined) {
                localVarQueryParameter['vm_id'] = vmId;
            }

            if (severity !== undefined) {
                localVarQueryParameter['severity'] = severity;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * A hundred instances with the same ten problems is a thousand rows saying the same thing. Collapsed, each row is one fix that resolves every instance it lists.
         * @summary Open findings collapsed by rule, worst first
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSecurityFindingsByRule: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/security/findings/by-rule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The browsable counterpart to the overview, which returns only the worst five. Ordered by open criticals, then highs, then score — the list is meant to be worked from the top, not browsed alphabetically.
         * @summary Posture per instance, worst first
         * @param {string} [search] 
         * @param {string} [state] 
         * @param {any} [pageSize] 
         * @param {any} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSecurityInstances: async (search?: string, state?: string, pageSize?: any, page?: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/security/instances`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (pageSize !== undefined) {
                for (const [key, value] of Object.entries(pageSize)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (page !== undefined) {
                for (const [key, value] of Object.entries(page)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Every site connected to this gateway
         * @param {string} gatewayId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSiteConnections: async (gatewayId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gatewayId' is not null or undefined
            assertParamExists('listSiteConnections', 'gatewayId', gatewayId)
            const localVarPath = `/vpn-gateway/{gatewayId}/site-to-site`
                .replace(`{${"gatewayId"}}`, encodeURIComponent(String(gatewayId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all snapshots for a specific VM with quota information
         * @summary List all snapshots for a VM
         * @param {number} vmId VM ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSnapshots: async (vmId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmId' is not null or undefined
            assertParamExists('listSnapshots', 'vmId', vmId)
            const localVarPath = `/snapshots/vm/{vmId}`
                .replace(`{${"vmId"}}`, encodeURIComponent(String(vmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Scan history for one instance
         * @param {number} vmId Instance id
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVmSecurityScans: async (vmId: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmId' is not null or undefined
            assertParamExists('listVmSecurityScans', 'vmId', vmId)
            const localVarPath = `/vm/{vmId}/security/scans`
                .replace(`{${"vmId"}}`, encodeURIComponent(String(vmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Attack surface observed on one instance
         * @param {number} vmId Instance id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVmSecurityServices: async (vmId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmId' is not null or undefined
            assertParamExists('listVmSecurityServices', 'vmId', vmId)
            const localVarPath = `/vm/{vmId}/security/services`
                .replace(`{${"vmId"}}`, encodeURIComponent(String(vmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authenticate a user with email and password.
         * @summary Login
         * @param {LoginDto} loginDto Client login data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (loginDto: LoginDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginDto' is not null or undefined
            assertParamExists('login', 'loginDto', loginDto)
            const localVarPath = `/whmcs/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Logout the authenticated user.
         * @summary Logout
         * @param {LogoutDto} logoutDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (logoutDto: LogoutDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'logoutDto' is not null or undefined
            assertParamExists('logout', 'logoutDto', logoutDto)
            const localVarPath = `/whmcs/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logoutDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Clears the whole unread badge in one call. The console cannot do this by id list: it only holds the pages it has loaded, and older unread rows would stay unread forever.
         * @summary Mark every notification of the client as read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAllAsRead: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/notifications/mark-all-as-read`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark notifications as read in batch
         * @param {MarkNotificationsReadDto} markNotificationsReadDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsRead: async (markNotificationsReadDto: MarkNotificationsReadDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'markNotificationsReadDto' is not null or undefined
            assertParamExists('markAsRead', 'markNotificationsReadDto', markNotificationsReadDto)
            const localVarPath = `/notifications/mark-as-read`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markNotificationsReadDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mine: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/billing/trials/mine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offer: async (code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('offer', 'code', code)
            const localVarPath = `/billing/trials/offers/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Perform an operation (start, stop, reboot) on a VM and return a task ID for tracking.
         * @summary Perform VM Operation
         * @param {any} vmId ID of the VM to operate on
         * @param {VmOperationRequestDto} vmOperationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        performVmOperation: async (vmId: any, vmOperationRequestDto: VmOperationRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmId' is not null or undefined
            assertParamExists('performVmOperation', 'vmId', vmId)
            // verify required parameter 'vmOperationRequestDto' is not null or undefined
            assertParamExists('performVmOperation', 'vmOperationRequestDto', vmOperationRequestDto)
            const localVarPath = `/vm/{vm_id}/operation`
                .replace(`{${"vm_id"}}`, encodeURIComponent(String(vmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vmOperationRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * `shown` once a card has been on screen; `snoozed` for \"Not now\" (7 days); `dismissed` for \"Don\'t show again\"; `acted` when the call to action was followed. A support session is never recorded.
         * @summary Record what happened to a tip
         * @param {string} code 
         * @param {DiscoveryEventDto} discoveryEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordFeatureDiscoveryEvent: async (code: string, discoveryEventDto: DiscoveryEventDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('recordFeatureDiscoveryEvent', 'code', code)
            // verify required parameter 'discoveryEventDto' is not null or undefined
            assertParamExists('recordFeatureDiscoveryEvent', 'discoveryEventDto', discoveryEventDto)
            const localVarPath = `/feature-discovery/{code}/events`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(discoveryEventDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Refresh the access and refresh tokens.
         * @summary Refresh Tokens
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshTokens: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/whmcs/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new client in WHMCS.
         * @summary Register a new client
         * @param {AddClientDto} addClientDto Client registration data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register: async (addClientDto: AddClientDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addClientDto' is not null or undefined
            assertParamExists('register', 'addClientDto', addClientDto)
            const localVarPath = `/whmcs/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addClientDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Register a device for push notifications using FCM.
         * @summary Register FCM Device
         * @param {RegisterDeviceDto} registerDeviceDto Device registration details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerFcmDevice: async (registerDeviceDto: RegisterDeviceDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerDeviceDto' is not null or undefined
            assertParamExists('registerFcmDevice', 'registerDeviceDto', registerDeviceDto)
            const localVarPath = `/push-notifications/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerDeviceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reinstall a VPN Gateway by performing full reinstallation
         * @param {string} id VPN Gateway ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reinstallVpnGateway: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('reinstallVpnGateway', 'id', id)
            const localVarPath = `/vpn-gateway/{id}/reinstall`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resets the expiry to a full retention window from now.
         * @summary Extend an image’s retention
         * @param {string} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renewClientImage: async (imageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('renewClientImage', 'imageId', imageId)
            const localVarPath = `/images/{imageId}/renew`
                .replace(`{${"imageId"}}`, encodeURIComponent(String(imageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} code 
         * @param {string} totalMicroCents Catalog simulation total for the selected configuration, in micro-cents.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renewal: async (code: string, totalMicroCents: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('renewal', 'code', code)
            // verify required parameter 'totalMicroCents' is not null or undefined
            assertParamExists('renewal', 'totalMicroCents', totalMicroCents)
            const localVarPath = `/billing/trials/offers/{code}/renewal`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (totalMicroCents !== undefined) {
                localVarQueryParameter['total_micro_cents'] = totalMicroCents;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request a withdrawal
         * @param {RequestWithdrawalDto} requestWithdrawalDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAffiliateWithdrawal: async (requestWithdrawalDto: RequestWithdrawalDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestWithdrawalDto' is not null or undefined
            assertParamExists('requestAffiliateWithdrawal', 'requestWithdrawalDto', requestWithdrawalDto)
            const localVarPath = `/affiliates/withdrawals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestWithdrawalDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Triggers WHMCS\'s native password-reset email (ResetPassword API). Always returns success regardless of whether the email exists, to avoid account enumeration.
         * @summary Request a password reset email
         * @param {ResetPasswordRequestDto} resetPasswordRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordReset: async (resetPasswordRequestDto: ResetPasswordRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetPasswordRequestDto' is not null or undefined
            assertParamExists('requestPasswordReset', 'resetPasswordRequestDto', resetPasswordRequestDto)
            const localVarPath = `/whmcs/password/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sends a new 6-digit code to the email associated with the challenge. Limited to 3 resends per challenge.
         * @summary Resend two-factor verification code
         * @param {ResendTwoFactorDto} resendTwoFactorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendTwoFactor: async (resendTwoFactorDto: ResendTwoFactorDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resendTwoFactorDto' is not null or undefined
            assertParamExists('resendTwoFactor', 'resendTwoFactorDto', resendTwoFactorDto)
            const localVarPath = `/whmcs/login/resend-two-factor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resendTwoFactorDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reset the reverse DNS (PTR) record for an IPv4 address to the default platform value
         * @param {number} id IPv4 address record id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetIpv4Rdns: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('resetIpv4Rdns', 'id', id)
            const localVarPath = `/rdns/ipv4/{id}/reset`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reset the reverse DNS (PTR) record for an IPv6 address to the default platform value
         * @param {number} id IPv6 address record id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetIpv6Rdns: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('resetIpv6Rdns', 'id', id)
            const localVarPath = `/rdns/ipv6/{id}/reset`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *              Reset a user\'s password inside the VM using the QEMU guest agent.                          **Requirements:**             - QEMU guest agent must be installed and running in the VM             - The user must exist in the VM\'s operating system             - Password must be at least 8 characters long                          **Common use cases:**             - Reset root password when locked out             - Change user passwords without SSH access             - Automated password rotation         
         * @summary Reset user password
         * @param {number} vmId ID of the VM
         * @param {QemuAgentResetPasswordRequestDto} qemuAgentResetPasswordRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetUserPassword: async (vmId: number, qemuAgentResetPasswordRequestDto: QemuAgentResetPasswordRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmId' is not null or undefined
            assertParamExists('resetUserPassword', 'vmId', vmId)
            // verify required parameter 'qemuAgentResetPasswordRequestDto' is not null or undefined
            assertParamExists('resetUserPassword', 'qemuAgentResetPasswordRequestDto', qemuAgentResetPasswordRequestDto)
            const localVarPath = `/vm/{vm_id}/qemu-agent/reset-password`
                .replace(`{${"vm_id"}}`, encodeURIComponent(String(vmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(qemuAgentResetPasswordRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Initiates a restore operation to restore a VM from a backup. The VM will be overwritten with the backup data. This operation is asynchronous and returns a task ID for tracking.
         * @summary Restore a VM from a backup
         * @param {number} backupId Backup ID to restore from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreBackup: async (backupId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'backupId' is not null or undefined
            assertParamExists('restoreBackup', 'backupId', backupId)
            const localVarPath = `/backups/{backupId}/restore`
                .replace(`{${"backupId"}}`, encodeURIComponent(String(backupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Restore the VM to a previous snapshot state. WARNING: All snapshots newer than the target snapshot will be deleted.
         * @summary Restore VM from a snapshot
         * @param {number} vmId VM ID
         * @param {RestoreSnapshotDto} restoreSnapshotDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreSnapshot: async (vmId: number, restoreSnapshotDto: RestoreSnapshotDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmId' is not null or undefined
            assertParamExists('restoreSnapshot', 'vmId', vmId)
            // verify required parameter 'restoreSnapshotDto' is not null or undefined
            assertParamExists('restoreSnapshot', 'restoreSnapshotDto', restoreSnapshotDto)
            const localVarPath = `/snapshots/vm/{vmId}/restore`
                .replace(`{${"vmId"}}`, encodeURIComponent(String(vmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(restoreSnapshotDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reports which parts have not arrived and returns fresh URLs for them. Safe to call at any point during an upload.
         * @summary Resume an upload
         * @param {string} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeClientImageUpload: async (imageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('resumeClientImageUpload', 'imageId', imageId)
            const localVarPath = `/images/{imageId}/upload`
                .replace(`{${"imageId"}}`, encodeURIComponent(String(imageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Show the key for this connection
         * @param {string} gatewayId 
         * @param {string} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revealSiteConnectionSecret: async (gatewayId: string, connectionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gatewayId' is not null or undefined
            assertParamExists('revealSiteConnectionSecret', 'gatewayId', gatewayId)
            // verify required parameter 'connectionId' is not null or undefined
            assertParamExists('revealSiteConnectionSecret', 'connectionId', connectionId)
            const localVarPath = `/vpn-gateway/{gatewayId}/site-to-site/{connectionId}/secret/reveal`
                .replace(`{${"gatewayId"}}`, encodeURIComponent(String(gatewayId)))
                .replace(`{${"connectionId"}}`, encodeURIComponent(String(connectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Revoke an API token
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeApiToken: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('revokeApiToken', 'id', id)
            const localVarPath = `/api-tokens/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Revoke an exception; its findings return to open immediately
         * @param {string} exceptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeSecurityException: async (exceptionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exceptionId' is not null or undefined
            assertParamExists('revokeSecurityException', 'exceptionId', exceptionId)
            const localVarPath = `/security/exceptions/{exceptionId}`
                .replace(`{${"exceptionId"}}`, encodeURIComponent(String(exceptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Revokes the token and issues a replacement with the same name and scopes.
         * @summary Roll an API token
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rollApiToken: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rollApiToken', 'id', id)
            const localVarPath = `/api-tokens/{id}/roll`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace the key for this connection
         * @param {string} gatewayId 
         * @param {string} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rotateSiteConnectionSecret: async (gatewayId: string, connectionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gatewayId' is not null or undefined
            assertParamExists('rotateSiteConnectionSecret', 'gatewayId', gatewayId)
            // verify required parameter 'connectionId' is not null or undefined
            assertParamExists('rotateSiteConnectionSecret', 'connectionId', connectionId)
            const localVarPath = `/vpn-gateway/{gatewayId}/site-to-site/{connectionId}/secret/rotate`
                .replace(`{${"gatewayId"}}`, encodeURIComponent(String(gatewayId)))
                .replace(`{${"connectionId"}}`, encodeURIComponent(String(connectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Turn a connection off or back on
         * @param {string} gatewayId 
         * @param {string} connectionId 
         * @param {SiteConnectionEnabledRequestDto} siteConnectionEnabledRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSiteConnectionEnabled: async (gatewayId: string, connectionId: string, siteConnectionEnabledRequestDto: SiteConnectionEnabledRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gatewayId' is not null or undefined
            assertParamExists('setSiteConnectionEnabled', 'gatewayId', gatewayId)
            // verify required parameter 'connectionId' is not null or undefined
            assertParamExists('setSiteConnectionEnabled', 'connectionId', connectionId)
            // verify required parameter 'siteConnectionEnabledRequestDto' is not null or undefined
            assertParamExists('setSiteConnectionEnabled', 'siteConnectionEnabledRequestDto', siteConnectionEnabledRequestDto)
            const localVarPath = `/vpn-gateway/{gatewayId}/site-to-site/{connectionId}/enabled`
                .replace(`{${"gatewayId"}}`, encodeURIComponent(String(gatewayId)))
                .replace(`{${"connectionId"}}`, encodeURIComponent(String(connectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(siteConnectionEnabledRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates the WHMCS client from the address + password step of a social signup, links the identity and signs the user in.
         * @summary Complete social registration
         * @param {CompleteSocialRegistrationDto} completeSocialRegistrationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        socialCompleteRegistration: async (completeSocialRegistrationDto: CompleteSocialRegistrationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'completeSocialRegistrationDto' is not null or undefined
            assertParamExists('socialCompleteRegistration', 'completeSocialRegistrationDto', completeSocialRegistrationDto)
            const localVarPath = `/whmcs/social/complete-registration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeSocialRegistrationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Exchanges the single-use handoff code from the callback for the login result (token + client).
         * @summary Exchange social handoff code
         * @param {SocialHandoffExchangeDto} socialHandoffExchangeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        socialHandoffExchange: async (socialHandoffExchangeDto: SocialHandoffExchangeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'socialHandoffExchangeDto' is not null or undefined
            assertParamExists('socialHandoffExchange', 'socialHandoffExchangeDto', socialHandoffExchangeDto)
            const localVarPath = `/whmcs/social/handoff/exchange`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(socialHandoffExchangeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Provider redirect target. Processes the result and 302-redirects to the frontend callback page with a single-use handoff code, a registration ticket, a selection token, or an error.
         * @summary Social login callback
         * @param {string} provider 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        socialLoginCallback: async (provider: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'provider' is not null or undefined
            assertParamExists('socialLoginCallback', 'provider', provider)
            const localVarPath = `/whmcs/social/{provider}/callback`
                .replace(`{${"provider"}}`, encodeURIComponent(String(provider)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Redirects the browser to the social provider authorization endpoint.
         * @summary Start social login
         * @param {string} provider 
         * @param {string} deviceId 
         * @param {string} [redirect] 
         * @param {SocialLoginStartDisplayEnum} [display] popup relays to the browser opener; native returns through the fixed app URI and requires S256 proof.
         * @param {string} [nativeState] Native installation-generated state (43 base64url characters).
         * @param {string} [codeChallenge] S256 challenge generated on the native installation.
         * @param {SocialLoginStartCodeChallengeMethodEnum} [codeChallengeMethod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        socialLoginStart: async (provider: string, deviceId: string, redirect?: string, display?: SocialLoginStartDisplayEnum, nativeState?: string, codeChallenge?: string, codeChallengeMethod?: SocialLoginStartCodeChallengeMethodEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'provider' is not null or undefined
            assertParamExists('socialLoginStart', 'provider', provider)
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('socialLoginStart', 'deviceId', deviceId)
            const localVarPath = `/whmcs/social/{provider}/start`
                .replace(`{${"provider"}}`, encodeURIComponent(String(provider)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (deviceId !== undefined) {
                localVarQueryParameter['deviceId'] = deviceId;
            }

            if (redirect !== undefined) {
                localVarQueryParameter['redirect'] = redirect;
            }

            if (display !== undefined) {
                localVarQueryParameter['display'] = display;
            }

            if (nativeState !== undefined) {
                localVarQueryParameter['nativeState'] = nativeState;
            }

            if (codeChallenge !== undefined) {
                localVarQueryParameter['codeChallenge'] = codeChallenge;
            }

            if (codeChallengeMethod !== undefined) {
                localVarQueryParameter['codeChallengeMethod'] = codeChallengeMethod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Redeem a native social callback with S256 proof
         * @param {NativeSocialExchangeDto} nativeSocialExchangeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        socialNativeExchange: async (nativeSocialExchangeDto: NativeSocialExchangeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nativeSocialExchangeDto' is not null or undefined
            assertParamExists('socialNativeExchange', 'nativeSocialExchangeDto', nativeSocialExchangeDto)
            const localVarPath = `/whmcs/social/native/exchange`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(nativeSocialExchangeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Complete a social multi-account login
         * @param {SelectSocialAccountDto} selectSocialAccountDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        socialSelectAccount: async (selectSocialAccountDto: SelectSocialAccountDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'selectSocialAccountDto' is not null or undefined
            assertParamExists('socialSelectAccount', 'selectSocialAccountDto', selectSocialAccountDto)
            const localVarPath = `/whmcs/social/select-account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(selectSocialAccountDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List accounts for a social multi-account login
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        socialSelectionAccounts: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('socialSelectionAccounts', 'token', token)
            const localVarPath = `/whmcs/social/selection/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reserves storage and returns one presigned URL per part. Upload the parts directly, then call the complete endpoint.
         * @summary Start an upload
         * @param {StartClientImageUploadDto} startClientImageUploadDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startClientImageUpload: async (startClientImageUploadDto: StartClientImageUploadDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startClientImageUploadDto' is not null or undefined
            assertParamExists('startClientImageUpload', 'startClientImageUploadDto', startClientImageUploadDto)
            const localVarPath = `/images`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startClientImageUploadDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start a scan of one instance now
         * @param {number} vmId Instance id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startVmSecurityScan: async (vmId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmId' is not null or undefined
            assertParamExists('startVmSecurityScan', 'vmId', vmId)
            const localVarPath = `/vm/{vmId}/security/scans`
                .replace(`{${"vmId"}}`, encodeURIComponent(String(vmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Records a rating (with optional comment/reasons and a context snapshot). Re-rating the same subject updates the prior entry.
         * @summary Submit feedback
         * @param {SubmitFeedbackDto} submitFeedbackDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitFeedback: async (submitFeedbackDto: SubmitFeedbackDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'submitFeedbackDto' is not null or undefined
            assertParamExists('submitFeedback', 'submitFeedbackDto', submitFeedbackDto)
            const localVarPath = `/feedback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submitFeedbackDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Rename an image or change its hardware profile
         * @param {string} imageId 
         * @param {UpdateClientImageDto} updateClientImageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientImage: async (imageId: string, updateClientImageDto: UpdateClientImageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('updateClientImage', 'imageId', imageId)
            // verify required parameter 'updateClientImageDto' is not null or undefined
            assertParamExists('updateClientImage', 'updateClientImageDto', updateClientImageDto)
            const localVarPath = `/images/{imageId}`
                .replace(`{${"imageId"}}`, encodeURIComponent(String(imageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateClientImageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Applies to the NEXT deploy or reinstall from this image; running instances are untouched. Refused with the list of problems when the document has errors, and refused entirely unless the image is marked as having cloud-init installed. Send null to remove it.
         * @summary Set or clear this image’s cloud-init user data
         * @param {string} imageId 
         * @param {UpdateClientImageCloudInitDto} updateClientImageCloudInitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientImageCloudInit: async (imageId: string, updateClientImageCloudInitDto: UpdateClientImageCloudInitDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('updateClientImageCloudInit', 'imageId', imageId)
            // verify required parameter 'updateClientImageCloudInitDto' is not null or undefined
            assertParamExists('updateClientImageCloudInit', 'updateClientImageCloudInitDto', updateClientImageCloudInitDto)
            const localVarPath = `/images/{imageId}/cloud-init`
                .replace(`{${"imageId"}}`, encodeURIComponent(String(imageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateClientImageCloudInitDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update firewall configuration including name, description, enable status, or default policies (policy_in/policy_out). Only fields provided in the request body will be updated.
         * @summary Update firewall
         * @param {any} firewallId Unique identifier of the firewall
         * @param {UpdateFirewallDto} updateFirewallDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFirewall: async (firewallId: any, updateFirewallDto: UpdateFirewallDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firewallId' is not null or undefined
            assertParamExists('updateFirewall', 'firewallId', firewallId)
            // verify required parameter 'updateFirewallDto' is not null or undefined
            assertParamExists('updateFirewall', 'updateFirewallDto', updateFirewallDto)
            const localVarPath = `/firewalls/{firewallId}`
                .replace(`{${"firewallId"}}`, encodeURIComponent(String(firewallId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFirewallDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing firewall rule. Any information omitted from the payload will be cleared (set to null/empty) on the record.
         * @summary Update firewall rule
         * @param {string} ruleId Unique identifier of the rule to update
         * @param {any} firewallId Unique identifier of the firewall
         * @param {UpdateFirewallRuleDto} updateFirewallRuleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFirewallRule: async (ruleId: string, firewallId: any, updateFirewallRuleDto: UpdateFirewallRuleDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('updateFirewallRule', 'ruleId', ruleId)
            // verify required parameter 'firewallId' is not null or undefined
            assertParamExists('updateFirewallRule', 'firewallId', firewallId)
            // verify required parameter 'updateFirewallRuleDto' is not null or undefined
            assertParamExists('updateFirewallRule', 'updateFirewallRuleDto', updateFirewallRuleDto)
            const localVarPath = `/firewalls/{firewallId}/rules/{ruleId}`
                .replace(`{${"ruleId"}}`, encodeURIComponent(String(ruleId)))
                .replace(`{${"firewallId"}}`, encodeURIComponent(String(firewallId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFirewallRuleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the reverse DNS (PTR) record for an IPv4 address
         * @param {number} id IPv4 address record id
         * @param {UpdateRdnsDto} updateRdnsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIpv4Rdns: async (id: number, updateRdnsDto: UpdateRdnsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateIpv4Rdns', 'id', id)
            // verify required parameter 'updateRdnsDto' is not null or undefined
            assertParamExists('updateIpv4Rdns', 'updateRdnsDto', updateRdnsDto)
            const localVarPath = `/rdns/ipv4/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRdnsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the reverse DNS (PTR) record for an IPv6 address
         * @param {number} id IPv6 address record id
         * @param {UpdateRdnsDto} updateRdnsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIpv6Rdns: async (id: number, updateRdnsDto: UpdateRdnsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateIpv6Rdns', 'id', id)
            // verify required parameter 'updateRdnsDto' is not null or undefined
            assertParamExists('updateIpv6Rdns', 'updateRdnsDto', updateRdnsDto)
            const localVarPath = `/rdns/ipv6/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRdnsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Turn scanning on or off for the account, or change notifications
         * @param {UpdateSecuritySettingsDto} updateSecuritySettingsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSecuritySettings: async (updateSecuritySettingsDto: UpdateSecuritySettingsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateSecuritySettingsDto' is not null or undefined
            assertParamExists('updateSecuritySettings', 'updateSecuritySettingsDto', updateSecuritySettingsDto)
            const localVarPath = `/security/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSecuritySettingsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change a connection
         * @param {string} gatewayId 
         * @param {string} connectionId 
         * @param {SiteConnectionRequestDto} siteConnectionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSiteConnection: async (gatewayId: string, connectionId: string, siteConnectionRequestDto: SiteConnectionRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gatewayId' is not null or undefined
            assertParamExists('updateSiteConnection', 'gatewayId', gatewayId)
            // verify required parameter 'connectionId' is not null or undefined
            assertParamExists('updateSiteConnection', 'connectionId', connectionId)
            // verify required parameter 'siteConnectionRequestDto' is not null or undefined
            assertParamExists('updateSiteConnection', 'siteConnectionRequestDto', siteConnectionRequestDto)
            const localVarPath = `/vpn-gateway/{gatewayId}/site-to-site/{connectionId}`
                .replace(`{${"gatewayId"}}`, encodeURIComponent(String(gatewayId)))
                .replace(`{${"connectionId"}}`, encodeURIComponent(String(connectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(siteConnectionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the name and/or description of a VM.
         * @summary Update VM name and description
         * @param {any} vmId ID of the VM
         * @param {UpdateVmDto} updateVmDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVm: async (vmId: any, updateVmDto: UpdateVmDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmId' is not null or undefined
            assertParamExists('updateVm', 'vmId', vmId)
            // verify required parameter 'updateVmDto' is not null or undefined
            assertParamExists('updateVm', 'updateVmDto', updateVmDto)
            const localVarPath = `/vm/{vm_id}`
                .replace(`{${"vm_id"}}`, encodeURIComponent(String(vmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVmDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change disk interface type, NIC model, and/or OS type for all devices on the VM. Changing the disk interface type requires the VM to be powered off.
         * @summary Update VM hardware configuration
         * @param {number} vmId VM ID
         * @param {UpdateVmHardwareDto} updateVmHardwareDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVmHardware: async (vmId: number, updateVmHardwareDto: UpdateVmHardwareDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmId' is not null or undefined
            assertParamExists('updateVmHardware', 'vmId', vmId)
            // verify required parameter 'updateVmHardwareDto' is not null or undefined
            assertParamExists('updateVmHardware', 'updateVmHardwareDto', updateVmHardwareDto)
            const localVarPath = `/vm-hardware/{vmId}`
                .replace(`{${"vmId"}}`, encodeURIComponent(String(vmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVmHardwareDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Turn scanning on or off for one instance, or change its schedule
         * @param {number} vmId Instance id
         * @param {UpdateVmSecuritySettingsDto} updateVmSecuritySettingsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVmSecuritySettings: async (vmId: number, updateVmSecuritySettingsDto: UpdateVmSecuritySettingsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmId' is not null or undefined
            assertParamExists('updateVmSecuritySettings', 'vmId', vmId)
            // verify required parameter 'updateVmSecuritySettingsDto' is not null or undefined
            assertParamExists('updateVmSecuritySettings', 'updateVmSecuritySettingsDto', updateVmSecuritySettingsDto)
            const localVarPath = `/vm/{vmId}/security`
                .replace(`{${"vmId"}}`, encodeURIComponent(String(vmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVmSecuritySettingsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update multiple VMs in a VPC. Empty array removes all VMs.
         * @summary Update VMs in a VPC
         * @param {UpdateVpcVmsDto} updateVpcVmsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVpcVms: async (updateVpcVmsDto: UpdateVpcVmsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateVpcVmsDto' is not null or undefined
            assertParamExists('updateVpcVms', 'updateVpcVmsDto', updateVpcVmsDto)
            const localVarPath = `/vpc/vms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVpcVmsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a VPN Gateway
         * @param {string} id VPN Gateway ID
         * @param {UpdateVpnGatewayDto} updateVpnGatewayDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVpnGateway: async (id: string, updateVpnGatewayDto: UpdateVpnGatewayDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateVpnGateway', 'id', id)
            // verify required parameter 'updateVpnGatewayDto' is not null or undefined
            assertParamExists('updateVpnGateway', 'updateVpnGatewayDto', updateVpnGatewayDto)
            const localVarPath = `/vpn-gateway/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVpnGatewayDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a VPN user
         * @param {string} id VPN User ID
         * @param {UpdateVpnUserDto} updateVpnUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVpnUser: async (id: string, updateVpnUserDto: UpdateVpnUserDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateVpnUser', 'id', id)
            // verify required parameter 'updateVpnUserDto' is not null or undefined
            assertParamExists('updateVpnUser', 'updateVpnUserDto', updateVpnUserDto)
            const localVarPath = `/vpn-gateway/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVpnUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update this gateway
         * @param {string} id VPN Gateway ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upgradeAppliance: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('upgradeAppliance', 'id', id)
            const localVarPath = `/vpn-gateway/{id}/appliance/upgrade`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Attach a payout-evidence file to one of my withdrawals
         * @param {string} id 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadMyWithdrawalAttachment: async (id: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('uploadMyWithdrawalAttachment', 'id', id)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadMyWithdrawalAttachment', 'file', file)
            const localVarPath = `/affiliates/withdrawals/{id}/attachments`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * What the editor calls while the customer types, so the problems appear beside the document rather than after a refused save.
         * @summary Check cloud-init user data without saving it
         * @param {string} imageId 
         * @param {ValidateClientImageCloudInitDto} validateClientImageCloudInitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateClientImageCloudInit: async (imageId: string, validateClientImageCloudInitDto: ValidateClientImageCloudInitDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('validateClientImageCloudInit', 'imageId', imageId)
            // verify required parameter 'validateClientImageCloudInitDto' is not null or undefined
            assertParamExists('validateClientImageCloudInit', 'validateClientImageCloudInitDto', validateClientImageCloudInitDto)
            const localVarPath = `/images/{imageId}/cloud-init/validate`
                .replace(`{${"imageId"}}`, encodeURIComponent(String(imageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validateClientImageCloudInitDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check a connection before creating it
         * @param {string} gatewayId 
         * @param {SiteConnectionRequestDto} siteConnectionRequestDto 
         * @param {string} [connectionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateSiteConnection: async (gatewayId: string, siteConnectionRequestDto: SiteConnectionRequestDto, connectionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gatewayId' is not null or undefined
            assertParamExists('validateSiteConnection', 'gatewayId', gatewayId)
            // verify required parameter 'siteConnectionRequestDto' is not null or undefined
            assertParamExists('validateSiteConnection', 'siteConnectionRequestDto', siteConnectionRequestDto)
            const localVarPath = `/vpn-gateway/{gatewayId}/site-to-site/validate`
                .replace(`{${"gatewayId"}}`, encodeURIComponent(String(gatewayId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (connectionId !== undefined) {
                localVarQueryParameter['connection_id'] = connectionId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(siteConnectionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check whether the origin → destination pair satisfies all clone requirements, including clone source selection and storage availability.
         * @summary Validate clone eligibility
         * @param {number} originVmId DB id of the origin (source) VM
         * @param {number} destinationVmId DB id of the destination VM
         * @param {ValidateVmCloneSourceTypeEnum} sourceType Whether to clone the current VM state or restore from an existing backup.
         * @param {number} [backupId] Existing backup ID to use when sourceType&#x3D;existing_backup.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateVmClone: async (originVmId: number, destinationVmId: number, sourceType: ValidateVmCloneSourceTypeEnum, backupId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'originVmId' is not null or undefined
            assertParamExists('validateVmClone', 'originVmId', originVmId)
            // verify required parameter 'destinationVmId' is not null or undefined
            assertParamExists('validateVmClone', 'destinationVmId', destinationVmId)
            // verify required parameter 'sourceType' is not null or undefined
            assertParamExists('validateVmClone', 'sourceType', sourceType)
            const localVarPath = `/vm-clone/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (originVmId !== undefined) {
                localVarQueryParameter['originVmId'] = originVmId;
            }

            if (destinationVmId !== undefined) {
                localVarQueryParameter['destinationVmId'] = destinationVmId;
            }

            if (sourceType !== undefined) {
                localVarQueryParameter['sourceType'] = sourceType;
            }

            if (backupId !== undefined) {
                localVarQueryParameter['backupId'] = backupId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Submits the 6-digit code sent to the user\'s email during login to complete authentication.
         * @summary Verify two-factor authentication code
         * @param {VerifyTwoFactorDto} verifyTwoFactorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyTwoFactor: async (verifyTwoFactorDto: VerifyTwoFactorDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyTwoFactorDto' is not null or undefined
            assertParamExists('verifyTwoFactor', 'verifyTwoFactorDto', verifyTwoFactorDto)
            const localVarPath = `/whmcs/login/verify-two-factor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyTwoFactorDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MwApi - functional programming interface
 * @export
 */
export const MwApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MwApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Cancel an upload
         * @param {string} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async abortClientImageUpload(imageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientImageOperationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.abortClientImageUpload(imageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.abortClientImageUpload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add a DNS record to a zone
         * @param {string} id Domain record UUID
         * @param {CreateRecordDto} createRecordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addDnsRecord(id: string, createRecordDto: CreateRecordDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addDnsRecord(id, createRecordDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.addDnsRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a new rule to the firewall. Rules can be created using: • **Macros**: Predefined service configurations (e.g., HTTP, HTTPS, SSH) • **Manual configuration**: Specify protocol, ports, and other parameters  **Important**: Use either macros OR manual configuration, not both.
         * @summary Add firewall rule
         * @param {any} firewallId Unique identifier of the firewall
         * @param {AddFirewallRuleDto} addFirewallRuleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addFirewallRule(firewallId: any, addFirewallRuleDto: AddFirewallRuleDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FirewallRuleEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addFirewallRule(firewallId, addFirewallRuleDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.addFirewallRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a VM to a VPC for the authenticated client.
         * @summary Add VM to VPC
         * @param {AddVmToVpcDto} addVmToVpcDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addVmToVpc(addVmToVpcDto: AddVmToVpcDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VpcVmsEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addVmToVpc(addVmToVpcDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.addVmToVpc']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add a user to a VPN Gateway
         * @param {string} id VPN Gateway ID
         * @param {AddVpnUserDto} addVpnUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addVpnUser(id: string, addVpnUserDto: AddVpnUserDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VpnUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addVpnUser(id, addVpnUserDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.addVpnUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allowance(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrialAllowanceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allowance(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.allowance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Apply a VPN gateway\'s pending changes
         * @param {string} id VPN Gateway ID
         * @param {ApplyChangesDto} applyChangesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyChanges(id: string, applyChangesDto: ApplyChangesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VpnGatewayApplyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyChanges(id, applyChangesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.applyChanges']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mounts the ISO as a CD-ROM and makes it the first boot device. The instance’s power state is preserved.
         * @summary Attach an ISO to an instance
         * @param {string} imageId 
         * @param {number} vmId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async attachClientImage(imageId: string, vmId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientImageOperationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.attachClientImage(imageId, vmId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.attachClientImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Apply a resize: change billing rate, generate temporary credit on downgrade, reconcile infrastructure
         * @param {number} vmId Instance (VM) id
         * @param {ResizeTargetDto} resizeTargetDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingApplyResize(vmId: number, resizeTargetDto: ResizeTargetDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResizeApplyResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingApplyResize(vmId, resizeTargetDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.billingApplyResize']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Voids an OPEN top-up invoice of this subscription at the payment provider. Only TOPUP invoices can be cancelled here — renewal and debt invoices are obligations, and checkout, reschedule, move, transfer and conversion invoices belong to the operation that raised them. Refused with 409 when the provider already reports the invoice paid. A payment that clears at the bank after the cancellation is still credited to the balance.
         * @summary Cancel an unpaid top-up invoice
         * @param {string} id Subscription UUID
         * @param {string} externalId Provider invoice id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingCancelTopupInvoice(id: string, externalId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingCancelTopupInvoice(id, externalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.billingCancelTopupInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Booleans only — used by checkout to avoid offering an IP type the datacenter has none of. Inventory counts are intentionally never exposed. Public.
         * @summary Whether IPv4/IPv6 can be allocated in a datacenter
         * @param {number} datacenterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingCatalogIpAvailability(datacenterId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IpAvailabilityDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingCatalogIpAvailability(datacenterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.billingCatalogIpAvailability']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Customer-facing location list for the configurator: name, region, flag asset, whether placement is currently possible, and whether each IP family can be allocated. Public.  This is deliberately NOT `GET /datacenters`, which is authenticated and answers with the datacenter entity including its clusters — hypervisor topology that has no business on a public surface.
         * @summary List the locations the checkout can deploy into
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingCatalogLocations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PublicLocationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingCatalogLocations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.billingCatalogLocations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a priced line-item breakdown for the given offering + addons + OS + disks + term. Applies free quotas (IPv4/IPv6) and OS filters. Public — the order endpoint requires auth.  Pass `compare_term` to price the same configuration on a second term and receive it as `comparison`, which is how the checkout shows what committing saves without issuing a second request.
         * @summary Simulate price for a checkout configuration
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingCatalogSimulate(body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingCatalogSimulate(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.billingCatalogSimulate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the full visible catalog: offerings, addons, billing terms and rates currently in effect. Public.
         * @summary Get billing catalog snapshot
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingCatalogSnapshot(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingCatalogSnapshot(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.billingCatalogSnapshot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export the period ledger as CSV
         * @param {string} id Subscription UUID
         * @param {string} [from] ISO date-time
         * @param {string} [to] ISO date-time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingExportSubscriptionLedgerCsv(id: string, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingExportSubscriptionLedgerCsv(id, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.billingExportSubscriptionLedgerCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Computes the next cycle-close renewal exactly as the close will (committed resources × term cap hours, minus the recurring coupon) and how much of it the current available balance already covers. Available balance is applied to the renewal at invoice issuance (RENEWAL_CREDIT_APPLIED), and balance that lands AFTER issuance settles the open renewal invoice once it covers it in full — so prepaying is a top-up tagged RENEWAL_PREPAY for the suggested amount. When the renewal invoice is already open, open_renewal_invoice.shortfall_cents is the top-up that settles it.
         * @summary Preview the next renewal for prepayment (\"Antecipar renovação\")
         * @param {string} id Subscription UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingGetRenewalPreview(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RenewalPreviewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingGetRenewalPreview(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.billingGetRenewalPreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Current instance configuration, available plans/addons and balance for the resize wizard
         * @param {number} vmId Instance (VM) id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingGetResizeContext(vmId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResizeContextDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingGetResizeContext(vmId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.billingGetResizeContext']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a single subscription with balance and active resources
         * @param {string} id Subscription UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingGetSubscription(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingGetSubscription(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.billingGetSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the pending cancellation request for a subscription, if any
         * @param {string} id Subscription UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingGetSubscriptionCancellation(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CancellationStateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingGetSubscriptionCancellation(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.billingGetSubscriptionCancellation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Newest first: what was removed, how long it was on the subscription, what it was billed in total and the temporary credit its removal returned, as the ledger recorded it. A service moved to another subscription is not listed — it is still billed, there.
         * @summary Services this subscription billed and no longer does
         * @param {string} id Subscription UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingGetSubscriptionEndedResources(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EndedResourcesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingGetSubscriptionEndedResources(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.billingGetSubscriptionEndedResources']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Invoices generated for a subscription, with payment events
         * @param {string} id Subscription UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingGetSubscriptionInvoices(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InvoiceDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingGetSubscriptionInvoices(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.billingGetSubscriptionInvoices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Every credit and debit applied to the subscription, newest first. Each entry carries its bucket, reason, and reference. Use `cursor` for the next page.
         * @summary Paginated balance-ledger statement (full audit trail) for a subscription
         * @param {string} id Subscription UUID
         * @param {number} [limit] 
         * @param {string} [cursor] 
         * @param {BillingGetSubscriptionLedgerBucketEnum} [bucket] 
         * @param {BillingGetSubscriptionLedgerReasonEnum} [reason] 
         * @param {string} [from] ISO date-time
         * @param {string} [to] ISO date-time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingGetSubscriptionLedger(id: string, limit?: number, cursor?: string, bucket?: BillingGetSubscriptionLedgerBucketEnum, reason?: BillingGetSubscriptionLedgerReasonEnum, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LedgerPageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingGetSubscriptionLedger(id, limit, cursor, bucket, reason, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.billingGetSubscriptionLedger']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Usage and credit forecast (estimates, not payment deadlines)
         * @param {string} id Subscription UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingGetSubscriptionProjection(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingGetSubscriptionProjection(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.billingGetSubscriptionProjection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Active resources with hourly rate and commitment-cap progress
         * @param {string} id Subscription UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingGetSubscriptionResources(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ResourceUsageDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingGetSubscriptionResources(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.billingGetSubscriptionResources']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Opening and closing usable balance for the window and the signed total of every ledger reason in between. Closing always equals opening + net change.
         * @summary Period reconciliation: opening/closing usable balance + totals by reason
         * @param {string} id Subscription UUID
         * @param {string} [from] ISO date-time
         * @param {string} [to] ISO date-time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingGetSubscriptionStatementSummary(id: string, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatementSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingGetSubscriptionStatementSummary(id, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.billingGetSubscriptionStatementSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Suspension/resume history for a subscription
         * @param {string} id Subscription UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingGetSubscriptionSuspensions(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SuspensionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingGetSubscriptionSuspensions(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.billingGetSubscriptionSuspensions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Daily spend and per-kind breakdown sourced from the metering hypertable. Defaults to the current cycle when no range is given.
         * @summary Hourly consumption history aggregated by day and resource kind
         * @param {string} id Subscription UUID
         * @param {string} [from] ISO date-time
         * @param {string} [to] ISO date-time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingGetSubscriptionUsage(id: string, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsageReportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingGetSubscriptionUsage(id, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.billingGetSubscriptionUsage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Drill-down audit view: every billed hour with the exact resources, rates, seconds and cap status that made up the charge. Defaults to the current cycle.
         * @summary Hourly consumption with the per-resource line items composing each hour
         * @param {string} id Subscription UUID
         * @param {string} [from] ISO date-time
         * @param {string} [to] ISO date-time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingGetSubscriptionUsageHourly(id: string, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsageHourlyReportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingGetSubscriptionUsageHourly(id, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.billingGetSubscriptionUsageHourly']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Open invoices first, then settled ones newest-first. Pass `status` (comma-separated: OPEN,PAID,CANCELLED,REFUNDED) to filter — e.g. `status=OPEN` for outstanding invoices only. To pay an OPEN invoice, SSO the user into WHMCS at `viewinvoice.php?id=<external_id>` via `GET /whmcs/sso`.
         * @summary List provider invoices across every subscription of the account
         * @param {string} [status] Comma-separated invoice statuses to include. Defaults to all.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingListAccountInvoices(status?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccountInvoiceDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingListAccountInvoices(status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.billingListAccountInvoices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Defaults to active and suspended subscriptions. Pass `status` (comma-separated) to override, e.g. `status=inactive` to review parked subscriptions or `status=active,suspended,inactive` for everything but cancelled.
         * @summary List subscriptions with balance for the authenticated user
         * @param {string} [status] Comma-separated subscription statuses to include. Defaults to active,suspended.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingListSubscriptions(status?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SubscriptionListItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingListSubscriptions(status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.billingListSubscriptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Only CREDIT_TOPUP coupons are accepted. The discount lowers the payable invoice amount; when the invoice is paid the full nominal top-up (paid + coupon grant) is credited to balance_available as two ledger entries with distinct reasons (RECHARGE, TOPUP_COUPON_CREDIT) for cash-vs-subsidy auditing.
         * @summary Preview a one-time top-up coupon for a subscription recharge
         * @param {string} id Subscription UUID
         * @param {TopupCouponPreviewBodyDto} topupCouponPreviewBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingPreviewTopupCoupon(id: string, topupCouponPreviewBodyDto: TopupCouponPreviewBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TopupCouponPreviewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingPreviewTopupCoupon(id, topupCouponPreviewBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.billingPreviewTopupCoupon']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Price a resize and report impact, removed items and flag violations (no changes applied)
         * @param {number} vmId Instance (VM) id
         * @param {ResizeTargetDto} resizeTargetDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingQuoteResize(vmId: number, resizeTargetDto: ResizeTargetDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResizeQuoteDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingQuoteResize(vmId, resizeTargetDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.billingQuoteResize']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Stops recurring billing at the end of the current cycle: no renewal invoice is issued, and every instance and VPN gateway under the subscription is terminated when the cycle closes (immediately for ON_DEMAND subscriptions, which have no cycle). The request can be withdrawn at any time before execution. The exit survey is required in FULL — both the reason and the free-text answer to the follow-up question that reason raises.
         * @summary Schedule the subscription for cancellation at the end of the current cycle
         * @param {string} id Subscription UUID
         * @param {RequestCancellationBodyDto} requestCancellationBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingRequestSubscriptionCancellation(id: string, requestCancellationBodyDto: RequestCancellationBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CancellationRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingRequestSubscriptionCancellation(id, requestCancellationBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.billingRequestSubscriptionCancellation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Runs the same settlement the platform runs on every credit landing and hourly: when the available balance covers an open renewal invoice in full, the commitment is funded from the balance and the invoice is cancelled (never marked paid — the cash already arrived on the top-up). Nothing is applied when the balance falls short; the response then names the shortfall.
         * @summary Settle the open renewal invoice from the subscription balance now
         * @param {string} id Subscription UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingSettleRenewalFromBalance(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RenewalCreditSettleResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingSettleRenewalFromBalance(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.billingSettleRenewalFromBalance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generates a WHMCS invoice for the requested amount. The invoice URL is returned so the client can open it in a new tab. When paid, the reconciler credits balance_available.
         * @summary Create a top-up invoice (WHMCS) to add credits to a subscription
         * @param {string} id Subscription UUID
         * @param {TopupBodyDto} topupBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingTopupSubscription(id: string, topupBodyDto: TopupBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingTopupSubscription(id, topupBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.billingTopupSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sets or clears the user-facing display name used to identify the subscription across the console.
         * @summary Update subscription settings (display name)
         * @param {string} id Subscription UUID
         * @param {UpdateSubscriptionDto} updateSubscriptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingUpdateSubscription(id: string, updateSubscriptionDto: UpdateSubscriptionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingUpdateSubscription(id, updateSubscriptionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.billingUpdateSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Only possible while the request is still pending — once the cycle has closed and the services were terminated, the cancellation is final.
         * @summary Withdraw the pending cancellation request (renewal resumes)
         * @param {string} id Subscription UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingWithdrawSubscriptionCancellation(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CancellationRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingWithdrawSubscriptionCancellation(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.billingWithdrawSubscriptionCancellation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update multiple firewall rules in a single request. Accepts the same fields as the single rule update endpoint for each rule.
         * @summary Bulk update firewall rules
         * @param {any} firewallId Unique identifier of the firewall
         * @param {BulkUpdateFirewallRulesDto} bulkUpdateFirewallRulesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUpdateFirewallRules(firewallId: any, bulkUpdateFirewallRulesDto: BulkUpdateFirewallRulesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FirewallRuleEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUpdateFirewallRules(firewallId, bulkUpdateFirewallRulesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.bulkUpdateFirewallRules']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *              Check if the QEMU guest agent is running and responding in the VM.                          **Use cases:**             - Verify guest agent is installed before attempting operations             - Monitor guest agent health             - Troubleshoot guest agent connectivity issues                          **Note:** This endpoint returns a 200 status code even if the agent             is not running. Check the \'is_running\' field in the response to             determine the actual agent status.         
         * @summary Check QEMU guest agent status
         * @param {number} vmId ID of the VM
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkAgentStatus(vmId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QemuAgentStatusResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkAgentStatus(vmId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.checkAgentStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Check if a domain NS records point to our nameservers
         * @param {string} id Domain record UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkDnsZoneHealth(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DnsHealthResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkDnsZoneHealth(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.checkDnsZoneHealth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Identifier-first signup helper: lets the registration form detect an existing account before collecting the rest of the details, so the user can be routed to login. Fails open (returns exists=false) on lookup errors — the final register still guards with 409.
         * @summary Check whether an email already has an account
         * @param {CheckEmailDto} checkEmailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkRegistrationEmail(checkEmailDto: CheckEmailDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckEmailResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkRegistrationEmail(checkEmailDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.checkRegistrationEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns whether the VM is eligible for backups and the number of backup slots available
         * @summary Check VM backup eligibility
         * @param {any} vmId VM ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkVmBackupEligibility(vmId: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckVmBackupEligibility200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkVmBackupEligibility(vmId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.checkVmBackupEligibility']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * In production this is invoked by the payment-reconciler when the InvoiceProvider reports the linked invoice as paid. Kept here so the end-to-end checkout flow is exercisable manually.
         * @summary Confirm a checkout v2 order (admin / test path)
         * @param {string} id Order ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkoutV2ConfirmOrder(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkoutV2ConfirmOrder(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.checkoutV2ConfirmOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Re-runs the price simulation server-side and returns one of three outcomes: • **provisioned** — existing subscription had enough balance for the prorata (its cost to the end of the current cycle); resource attached immediately. • **pending_payment** — invoice created in WHMCS, resource provisioned on payment. A new COMMITTED subscription is billed the full term. A new ON_DEMAND subscription invoices initial_credit_cents (defaulting to the catalog initial minimum), credited entirely to available balance for hourly usage without a renewal cycle. An add to an existing COMMITTED subscription whose balance is short is billed the prorata NET of that balance (`balanceAppliedCents`), which is drawn when the invoice is paid — never below the minimum recharge, the difference (`minimumRechargeCreditCents`) staying as credit. • **requires_topup** — existing subscription lacks balance; no order created.   Client should POST /billing/subscriptions/:id/topup for the shortfall, then retry.
         * @summary Create a checkout v2 order
         * @param {CreateOrderDto} createOrderDto 
         * @param {string} [idempotencyKey] A unique, client-generated string (8–255 chars of [A-Za-z0-9._:-]; a UUID is ideal) that makes this call safe to send twice. A retry carrying the same key replays the first answer instead of placing a second order, and comes back with &#x60;Idempotency-Replayed: true&#x60;.  The key covers the request BODY as well: reusing one for a different configuration is refused with a 409 rather than silently answered with the old order. Mint a new key whenever what is being bought changes.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkoutV2CreateOrder(createOrderDto: CreateOrderDto, idempotencyKey?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkoutV2CreateOrder(createOrderDto, idempotencyKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.checkoutV2CreateOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Backs the checkout \"waiting for payment\" panel: safe to poll, never advances the order. Pass `refresh=true` on an explicit \"I already paid\" click to ask the invoice provider out of band of the reconciler tick — that leg is rate-limited per invoice, and `checked_provider` reports whether it actually ran.
         * @summary Where a placed order stands (payment + provisioning)
         * @param {string} id Order ID (UUID)
         * @param {boolean} [refresh] Ask the invoice provider about the linked invoice before answering (rate-limited per invoice).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkoutV2GetOrderPaymentState(id: string, refresh?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderPaymentStateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkoutV2GetOrderPaymentState(id, refresh, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.checkoutV2GetOrderPaymentState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns subscriptions for the authenticated account with their current balance so the checkout wizard can let the customer pick a target subscription or start a new one.
         * @summary List active subscriptions available for adding a new resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkoutV2ListSubscriptions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkoutV2ListSubscriptions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.checkoutV2ListSubscriptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the gross cycle total of the service being ordered, the recurring discount its coupon takes off, and the payable amount. A coupon is bound to the SERVICE the order creates and discounts that service on every renewal; a service added to the subscription later is billed at list price. Fixed-value coupons come off the service total, never off a product price.
         * @summary Preview a recurring coupon for the service being ordered
         * @param {CheckoutCouponPreviewBodyDto} checkoutCouponPreviewBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkoutV2PreviewCoupon(checkoutCouponPreviewBodyDto: CheckoutCouponPreviewBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CouponPreviewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkoutV2PreviewCoupon(checkoutCouponPreviewBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.checkoutV2PreviewCoupon']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Apply firewall configuration and rules to the specified VMs. This asynchronous operation: • Applies all firewall rules to the target VMs • Updates firewall policies on the VMs • Automatically removes firewall rules from VMs no longer assigned • Returns a job ID for tracking the operation progress  **Note**: Changes are not applied to VMs until this endpoint is called.
         * @summary Commit firewall rules to VMs
         * @param {any} firewallId Unique identifier of the firewall
         * @param {CommitFirewallDto} commitFirewallDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commitFirewall(firewallId: any, commitFirewallDto: CommitFirewallDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommitFirewall201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commitFirewall(firewallId, commitFirewallDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.commitFirewall']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Seals the upload and starts checking and preparing the image. Returns the id of the job to follow.
         * @summary Finish an upload
         * @param {string} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeClientImageUpload(imageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientImageOperationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeClientImageUpload(imageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.completeClientImageUpload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the plaintext token once — it cannot be retrieved later.
         * @summary Create an API token
         * @param {CreateApiTokenDto} createApiTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createApiToken(createApiTokenDto: CreateApiTokenDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MintedApiTokenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createApiToken(createApiTokenDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.createApiToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new DNS zone
         * @param {CreateZoneDto} createZoneDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDnsZone(createZoneDto: CreateZoneDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DnsZoneDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDnsZone(createZoneDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.createDnsZone']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new firewall configuration with default policies. The firewall will be created with the specified input and output policies.
         * @summary Create a new firewall
         * @param {CreateFirewallDto} createFirewallDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFirewall(createFirewallDto: CreateFirewallDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FirewallEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFirewall(createFirewallDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.createFirewall']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new backup schedule for a VM or updates an existing one
         * @summary Create or update a backup schedule
         * @param {CreateBackupScheduleDto} createBackupScheduleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSchedule(createBackupScheduleDto: CreateBackupScheduleDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackupScheduleEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSchedule(createBackupScheduleDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.createSchedule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Accept a risk, with a justification and an expiry date
         * @param {CreateSecurityExceptionDto} createSecurityExceptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSecurityException(createSecurityExceptionDto: CreateSecurityExceptionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SecurityExceptionCreatedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSecurityException(createSecurityExceptionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.createSecurityException']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Connect another site to this gateway
         * @param {string} gatewayId 
         * @param {SiteConnectionRequestDto} siteConnectionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSiteConnection(gatewayId: string, siteConnectionRequestDto: SiteConnectionRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SiteConnectionMutationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSiteConnection(gatewayId, siteConnectionRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.createSiteConnection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new snapshot for the VM. Snapshots expire after 30 days. You can optionally include RAM state for a complete running state snapshot.
         * @summary Create a new snapshot
         * @param {number} vmId VM ID
         * @param {CreateSnapshotDto} createSnapshotDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSnapshot(vmId: number, createSnapshotDto: CreateSnapshotDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SnapshotOperationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSnapshot(vmId, createSnapshotDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.createSnapshot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a Single Sign-On (SSO) token for the authenticated user.
         * @summary Create SSO Token
         * @param {string} [path] Optional path parameter to customize SSO token creation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSsoToken(path?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateSsoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSsoToken(path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.createSsoToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new VPC for the authenticated client.
         * @summary Create a new VPC
         * @param {VpcCreateDto} vpcCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVpc(vpcCreateDto: VpcCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VpcEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createVpc(vpcCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.createVpc']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new VPN Gateway
         * @param {CreateVpnGatewayDto} createVpnGatewayDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVpnGateway(createVpnGatewayDto: CreateVpnGatewayDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VpnGatewayDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createVpnGateway(createVpnGatewayDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.createVpnGateway']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mint a short-lived token that can be used only to authenticate Socket.IO connections.
         * @summary Create WebSocket token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWebsocketToken(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebsocketTokenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWebsocketToken(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.createWebsocketToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes a backup
         * @summary Delete a backup
         * @param {number} backupId Backup ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBackup(backupId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteBackup200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBackup(backupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.deleteBackup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Removes the artifact, every hypervisor copy of it, and ejects it from any instance booting it. Instances already built from it are unaffected.
         * @summary Delete an image
         * @param {string} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteClientImage(imageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientImageOperationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteClientImage(imageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.deleteClientImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a DNS record from a zone
         * @param {string} id Domain record UUID
         * @param {DeleteRecordDto} deleteRecordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDnsRecord(id: string, deleteRecordDto: DeleteRecordDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDnsRecord(id, deleteRecordDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.deleteDnsRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a DNS zone and all its records
         * @param {string} id Domain record UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDnsZone(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDnsZone(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.deleteDnsZone']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Asynchronously delete a firewall and clean up all associated resources. This operation: • Removes firewall rules from all assigned VMs • Sets VM firewall policies to ALLOW • Deletes the firewall configuration • Returns a job ID for tracking the asynchronous operation
         * @summary Delete firewall
         * @param {any} firewallId Unique identifier of the firewall to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFirewall(firewallId: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteFirewall201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFirewall(firewallId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.deleteFirewall']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Permanently delete a firewall rule.
         * @summary Delete firewall rule
         * @param {string} ruleId Unique identifier of the rule to delete
         * @param {any} firewallId Unique identifier of the firewall
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFirewallRule(ruleId: string, firewallId: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFirewallRule(ruleId, firewallId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.deleteFirewallRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove an attachment from one of my PENDING withdrawals
         * @param {string} id 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMyWithdrawalAttachment(id: string, attachmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMyWithdrawalAttachment(id, attachmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.deleteMyWithdrawalAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes a backup schedule (soft delete)
         * @summary Delete a backup schedule
         * @param {number} scheduleId Schedule ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSchedule(scheduleId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteBackup200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSchedule(scheduleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.deleteSchedule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Disconnect a site
         * @param {string} gatewayId 
         * @param {string} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSiteConnection(gatewayId: string, connectionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SiteConnectionRemovedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSiteConnection(gatewayId, connectionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.deleteSiteConnection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a specific snapshot. Validates that the snapshot belongs to a VM owned by the authenticated user.
         * @summary Delete a snapshot
         * @param {string} snapshotId Snapshot ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSnapshot(snapshotId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SnapshotOperationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSnapshot(snapshotId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.deleteSnapshot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Terminate a VM instance, release its IP assignments, soft-delete the VM record, and stop future billing for linked resources.
         * @summary Delete VM
         * @param {any} vmId ID of the VM to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteVm(vmId: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TerminateServiceResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteVm(vmId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.deleteVm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a VPC by its ID.
         * @summary Delete a VPC
         * @param {number} vpcId ID of the VPC to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteVpc(vpcId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteVpc(vpcId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.deleteVpc']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a VPN user
         * @param {string} id VPN User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteVpnUser(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VpnUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteVpnUser(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.deleteVpnUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Rebuilds the instance from a disk image the customer uploaded. The instance keeps its addresses and its plan; everything on its disk is replaced. Refused when the plan’s disk is smaller than the image needs — a reinstall cannot grow a disk, so it must be resized first.
         * @summary Reinstall an instance from one of my images
         * @param {string} imageId ID of the customer image
         * @param {any} vmId ID of the instance to rebuild
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deployVmFromClientImage(imageId: string, vmId: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deployVmFromClientImage(imageId, vmId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.deployVmFromClientImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deploy a VM from a template.
         * @summary Deploy VM from template
         * @param {number} templateId ID of the template to deploy from
         * @param {any} vmId ID of the VM to deploy
         * @param {DeployVmDto} [deployVmDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deployVmFromTemplate(templateId: number, vmId: any, deployVmDto?: DeployVmDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deployVmFromTemplate(templateId, vmId, deployVmDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.deployVmFromTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Eject an ISO
         * @param {string} imageId 
         * @param {number} vmId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async detachClientImage(imageId: string, vmId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientImageOperationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.detachClientImage(imageId, vmId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.detachClientImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download an attachment on one of my withdrawals
         * @param {string} id 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadMyWithdrawalAttachment(id: string, attachmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadMyWithdrawalAttachment(id, attachmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.downloadMyWithdrawalAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download the configuration for the other end
         * @param {string} gatewayId 
         * @param {string} connectionId 
         * @param {string} vendor 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadSiteConnectionConfig(gatewayId: string, connectionId: string, vendor: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VendorConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadSiteConnectionConfig(gatewayId, connectionId, vendor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.downloadSiteConnectionConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validates an admin-issued SSO code and returns access and refresh tokens for the client portal.
         * @summary Exchange a single-use SSO code for session tokens
         * @param {ExchangeSsoDto} exchangeSsoDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exchangeSso(exchangeSsoDto: ExchangeSsoDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exchangeSso(exchangeSsoDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.exchangeSso']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Queues a backup job for the specified VM. The backup will be executed asynchronously.
         * @summary Execute a manual backup for a VM
         * @param {any} vmId VM ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executeBackup(vmId: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExecuteBackup200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executeBackup(vmId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.executeBackup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Generate a download code for VPN connection profile access
         * @param {string} id VPN Gateway ID
         * @param {GenerateDownloadCodeDto} generateDownloadCodeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateDownloadCode(id: string, generateDownloadCodeDto: GenerateDownloadCodeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DownloadCodeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateDownloadCode(id, generateDownloadCodeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.generateDownloadCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all datacenters
         * @param {boolean} [includeHidden] Whether to include hidden datacenters (default: false)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDatacenters(includeHidden?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DatacenterEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllDatacenters(includeHidden, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getAllDatacenters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a list of all VPCs for the authenticated client.
         * @summary Get all VPCs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllVpcs(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VpcEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllVpcs(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getAllVpcs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all VPN Gateways for the logged-in client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllVpnGateways(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VpnGatewayWithVmDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllVpnGateways(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getAllVpnGateways']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all VPN users from all VPN gateways for the logged-in client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllVpnUsers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VpnUserWithGatewayDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllVpnUsers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getAllVpnUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary What this gateway is running
         * @param {string} id VPN Gateway ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppliance(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VpnApplianceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppliance(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getAppliance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Operator instructions for the AI assistant system prompt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssistantInstructions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssistantInstructionsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssistantInstructions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getAssistantInstructions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a list of available templates based on the current VM product. Respects soft deletes.
         * @summary List available templates for VM
         * @param {number} vmId ID of the VM to get templates for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableTemplates(vmId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TemplateDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableTemplates(vmId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getAvailableTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the current backup progress for a VM by parsing hypervisor task logs
         * @summary Get backup progress for a VM
         * @param {any} vmId VM ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBackupProgress(vmId: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBackupProgress(vmId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getBackupProgress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get one image
         * @param {string} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientImage(imageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientImageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientImage(imageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getClientImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The document exactly as the guest will receive it, with the format, the size limit and any problems found in it. Re-checked on every read.
         * @summary Read this image’s cloud-init user data
         * @param {string} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientImageCloudInit(imageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientImageCloudInitDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientImageCloudInit(imageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getClientImageCloudInit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Storage allowance and current usage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientImageQuota(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientImageQuotaDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientImageQuota(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getClientImageQuota']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Each instance is reported with whether its disk is large enough. A reinstall cannot grow a disk, so an instance that does not fit must be resized first.
         * @summary Instances this image can be used on
         * @param {string} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientImageTargets(imageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AttachTargetsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientImageTargets(imageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getClientImageTargets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a specific cluster by its ID.
         * @summary Get Cluster by ID
         * @param {number} id Cluster ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClusterById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClusterEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClusterById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getClusterById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a list of all clusters.
         * @summary List Clusters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClusters(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClusterEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClusters(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getClusters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get clusters by datacenter ID
         * @param {number} id Datacenter ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClustersByDatacenterId(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClusterEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClustersByDatacenterId(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getClustersByDatacenterId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get VPN connection profile using download code (public endpoint)
         * @param {string} downloadCode Download code for accessing VPN connection profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConnectionProfileByDownloadCode(downloadCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DownloadCodeConnectionProfileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConnectionProfileByDownloadCode(downloadCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getConnectionProfileByDownloadCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *        Generate a VNC ticket for a VM the authenticated user owns and return       WebSocket connection details for the proxied noVNC console viewer.       Call this on every connect or reconnect — it is idempotent and always       returns a fresh VNC ticket.        The returned `websocket_url` contains an opaque session token used by the       backend proxy. Open the console page at `/console/<vm_id>` and let the       viewer call this endpoint directly using the existing browser session.     
         * @summary Get VM console connection details
         * @param {VncConsoleRequestDto} vncConsoleRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConsoleAccess(vncConsoleRequestDto: VncConsoleRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VncConsoleConnectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConsoleAccess(vncConsoleRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getConsoleAccess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fleet vitals, billing runway, backup coverage, security posture and a ranked list of what needs attention. Replaces the fan-out the console used to perform (one status call per instance, one projection per subscription), which did not survive contact with large accounts.  Sections fail independently: anything that could not be read is named in `degraded[]` rather than returned as zeroes, so a partial answer is never rendered as an all-clear.
         * @summary Everything the console home screen renders, in one read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardOverview(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardOverviewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardOverview(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getDashboardOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a datacenter by ID
         * @param {number} id Datacenter ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDatacenterById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatacenterEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatacenterById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getDatacenterById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Check if the VM is eligible for snapshot operations and get quota information
         * @summary Check snapshot eligibility
         * @param {number} vmId VM ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEligibility(vmId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEligibility200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEligibility(vmId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getEligibility']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Backs the Discover page. Showing it records nothing.
         * @summary Every tip, with adoption and state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeatureDiscoveryCatalog(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiscoveryCatalogDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeatureDiscoveryCatalog(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getFeatureDiscoveryCatalog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Ranked tips the account does not use yet, launches first. Empty while a deck was shown to this person in the last 20 hours, on any device.
         * @summary Tips for this sign-in
         * @param {Array<string>} [exclude] Tip codes this console cannot offer (a feature disabled in this deployment). Comma-separated or repeated.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeatureDiscoveryDeck(exclude?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiscoveryDeckDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeatureDiscoveryDeck(exclude, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getFeatureDiscoveryDeck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get detailed information about a specific firewall including its configuration, rules, and assigned VMs.
         * @summary Get firewall by ID
         * @param {any} firewallId Unique identifier of the firewall
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFirewall(firewallId: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FirewallEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFirewall(firewallId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getFirewall']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the firewall assigned to a specific VM along with its rules.
         * @summary Get firewall for VM
         * @param {any} vmId Unique identifier of the VM
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFirewallForVm(vmId: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FirewallEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFirewallForVm(vmId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getFirewallForVm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Track the progress of any asynchronous job by ID
         * @summary Get job status
         * @param {string} jobId Job ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobStatus(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobStatus(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getJobStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Affiliate overview for the current account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyAffiliate(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AffiliateMeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyAffiliate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getMyAffiliate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get notifications with pagination
         * @param {number} [page] Page number
         * @param {number} [limit] Number of items per page
         * @param {boolean} [unreadOnly] Return only unread notifications. &#x60;total&#x60;/&#x60;totalPages&#x60; then describe the unread set, so the \&quot;Unread\&quot; filter can paginate without holes.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotifications(page?: number, limit?: number, unreadOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotifications(page, limit, unreadOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the current restore progress for a VM by parsing hypervisor task logs
         * @summary Get restore progress for a VM
         * @param {any} vmId VM ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRestoreProgress(vmId: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRestoreProgress(vmId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getRestoreProgress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary One finding with its evidence, advice and timeline
         * @param {string} findingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSecurityFinding(findingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SecurityFindingDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSecurityFinding(findingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getSecurityFinding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Security posture across every instance on the account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSecurityOverview(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SecurityOverviewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSecurityOverview(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getSecurityOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Daily security score history
         * @param {number} [days] 
         * @param {number} [vmId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSecurityScoreHistory(days?: number, vmId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SecurityScoreHistoryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSecurityScoreHistory(days, vmId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getSecurityScoreHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Scanning and notification preferences for the account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSecuritySettings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SecuritySettingsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSecuritySettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getSecuritySettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary One connection, with what the other end needs
         * @param {string} gatewayId 
         * @param {string} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSiteConnection(gatewayId: string, connectionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SiteConnectionDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSiteConnection(gatewayId, connectionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getSiteConnection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Which configurations can be generated
         * @param {string} gatewayId 
         * @param {string} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSiteConnectionConfigOptions(gatewayId: string, connectionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VendorConfigOptionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSiteConnectionConfigOptions(gatewayId, connectionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getSiteConnectionConfigOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary What has happened to this connection
         * @param {string} gatewayId 
         * @param {string} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSiteConnectionEvents(gatewayId: string, connectionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SiteConnectionEventDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSiteConnectionEvents(gatewayId, connectionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getSiteConnectionEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the status of a VM operation task.
         * @summary Get Task Status
         * @param {string} taskId ID of the task to check
         * @param {any} vmId ID of the VM
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTaskStatus(taskId: string, vmId: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskStatusResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTaskStatus(taskId, vmId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getTaskStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the details of the authenticated user.
         * @summary Get User Details
         * @param {boolean} [fresh] Ask WHMCS now instead of answering from the cached profile (used by the page that shows the profile back to its owner).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserDetails(fresh?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserDetails(fresh, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getUserDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Transferred data volume (inbound/outbound, all interfaces) aggregated in time buckets for the selected period, plus the public outbound usage of the current billing window.
         * @summary Get VM Bandwidth Usage
         * @param {GetVmBandwidthPeriodEnum} period Period for bandwidth usage data
         * @param {any} vmId ID of the VM
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVmBandwidth(period: GetVmBandwidthPeriodEnum, vmId: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VmBandwidthResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVmBandwidth(period, vmId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getVmBandwidth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a VM by its ID.
         * @summary Get VM by ID
         * @param {any} vmId ID of the VM
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVmById(vmId: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VmEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVmById(vmId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getVmById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the current disk interface type, NIC model, and OS type for a VM.
         * @summary Get current VM hardware configuration
         * @param {number} vmId VM ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVmHardwareConfig(vmId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVmHardwareConfig200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVmHardwareConfig(vmId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getVmHardwareConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns available disk interface types, NIC models, and OS types/versions.
         * @summary Get hardware configuration options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVmHardwareOptions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HardwareOptionsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVmHardwareOptions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getVmHardwareOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve historical metrics data for a VM with caching. Returns CPU, memory, disk, and network usage over time.
         * @summary Get VM Metrics
         * @param {GetVmMetricsTimeframeEnum} timeframe Timeframe for metrics data
         * @param {any} vmId ID of the VM
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVmMetrics(timeframe: GetVmMetricsTimeframeEnum, vmId: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VmMetricsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVmMetrics(timeframe, vmId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getVmMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * What the removal returns to the subscription (temporary credit on a commitment, nothing on on-demand), how much, until when, what the subscription will hold afterwards, and anything that would make the deletion be refused. Computed by the same code that performs the removal; changes nothing.
         * @summary Preview what deleting a VM does to its billing
         * @param {any} vmId ID of the VM
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVmRemovalPreview(vmId: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VmRemovalPreviewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVmRemovalPreview(vmId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getVmRemovalPreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Security posture of one instance
         * @param {number} vmId Instance id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVmSecurityPosture(vmId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VmSecurityPostureDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVmSecurityPosture(vmId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getVmSecurityPosture']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the current status of a VM from the hypervisor with caching and deployment information.
         * @summary Get VM Status
         * @param {string} vmId ID of the VM
         * @param {boolean} [fresh] Bypass the cached status and read the live state (used by user-invoked refreshes).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVmStatus(vmId: string, fresh?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VmStatusResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVmStatus(vmId, fresh, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getVmStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a list of all VMs for the authenticated client.
         * @summary List VMs
         * @param {string} [id] ID of the VM
         * @param {string} [clusterId] Cluster ID of the server
         * @param {GetVmsProductCategoryTypeEnum} [productCategoryType] Service type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVms(id?: string, clusterId?: string, productCategoryType?: GetVmsProductCategoryTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VmEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVms(id, clusterId, productCategoryType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getVms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve all VMs from a VPC.
         * @summary Retrieve VMs by VPC ID
         * @param {any} vpcId ID of the VPC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVpcVms(vpcId: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VpcVmsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVpcVms(vpcId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getVpcVms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get VPN connection profile (.ovpn file) for a VPN Gateway
         * @param {string} id VPN Gateway ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVpnConnectionProfile(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VpnConnectionProfileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVpnConnectionProfile(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getVpnConnectionProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a VPN Gateway by VM ID
         * @param {number} vmId VM ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVpnGatewayByVmId(vmId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VpnGatewayDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVpnGatewayByVmId(vmId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getVpnGatewayByVmId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get VPN Gateway details with connected users information
         * @param {string} id VPN Gateway ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVpnGatewayDetails(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VpnGatewayWithConnectedUsersDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVpnGatewayDetails(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getVpnGatewayDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get VPN Gateway details using download code (public endpoint)
         * @param {string} downloadCode Download code for accessing VPN Gateway details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVpnGatewayDetailsByDownloadCode(downloadCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VpnGatewayDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVpnGatewayDetailsByDownloadCode(downloadCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getVpnGatewayDetailsByDownloadCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all users for a VPN Gateway
         * @param {string} id VPN Gateway ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVpnUsers(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VpnUserDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVpnUsers(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.getVpnUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Clones the origin VM into the destination VM using either the current state or an existing backup. Destination disk must be >= origin disk, and the required backup/vm storages must be available.
         * @summary Initiate a VM clone operation
         * @param {InitiateCloneDto} initiateCloneDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initiateVmClone(initiateCloneDto: InitiateCloneDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CloneInitiatedResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initiateVmClone(initiateCloneDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.initiateVmClone']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Paginated, searchable history of actions taken on your account — from the web console, from your API tokens, by the AI assistant, by our support team on your behalf, and by automated platform processes. Each entry records who acted, from which IP address, what was affected and whether it succeeded.
         * @summary List account activity
         * @param {number} [page] Page number (1-based).
         * @param {number} [pageSize] Entries per page.
         * @param {string} [search] Free-text search across the actor, the affected resource, the action and the IP address.
         * @param {ListAccountActivityActorKindEnum} [actorKind] Restrict to one kind of actor — &#x60;CONSOLE&#x60; for the web panel, &#x60;API_TOKEN&#x60; for your API credentials, &#x60;MCP&#x60; for AI assistant actions, &#x60;SUPPORT&#x60; for actions taken by our staff, &#x60;SYSTEM&#x60; for automated platform actions.
         * @param {ListAccountActivityCategoryEnum} [category] Restrict to one area of the product.
         * @param {string} [action] Exact action key, e.g. &#x60;instance.delete&#x60;. Takes precedence over &#x60;category&#x60;.
         * @param {string} [targetType] Restrict to one resource type, e.g. &#x60;instance&#x60;.
         * @param {string} [targetId] Restrict to one resource id — the history of a single instance, zone or firewall.
         * @param {ListAccountActivityOutcomeEnum} [outcome] 
         * @param {string} [from] Only entries at or after this instant (ISO 8601).
         * @param {string} [to] Only entries at or before this instant (ISO 8601).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAccountActivity(page?: number, pageSize?: number, search?: string, actorKind?: ListAccountActivityActorKindEnum, category?: ListAccountActivityCategoryEnum, action?: string, targetType?: string, targetId?: string, outcome?: ListAccountActivityOutcomeEnum, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientActivityListResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAccountActivity(page, pageSize, search, actorKind, category, action, targetType, targetId, outcome, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.listAccountActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List grantable scopes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listApiTokenScopes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiScopeOptionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listApiTokenScopes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.listApiTokenScopes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List my API tokens
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listApiTokens(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiTokenSummaryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listApiTokens(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.listApiTokens']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all backups for VMs owned by the authenticated user
         * @summary List all backups for the authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBackups(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BackupEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBackups(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.listBackups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all backups for the specified VM
         * @summary List backups for a specific VM
         * @param {any} vmId VM ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBackupsByVm(vmId: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BackupEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBackupsByVm(vmId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.listBackupsByVm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Every ISO and disk image on the authenticated account.
         * @summary List my images
         * @param {ListClientImagesKindEnum} [kind] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listClientImages(kind?: ListClientImagesKindEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClientImageDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listClientImages(kind, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.listClientImages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all DNS records for a zone
         * @param {string} id Domain record UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDnsRecords(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DnsRRsetDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDnsRecords(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.listDnsRecords']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List DNS zones for the authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDnsZones(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DnsZoneDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDnsZones(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.listDnsZones']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all available firewall macros with descriptions. Macros are predefined service configurations that can be used when creating firewall rules (e.g., HTTP, HTTPS, SSH).
         * @summary List firewall macros
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFirewallMacros(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FirewallMacroResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFirewallMacros(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.listFirewallMacros']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a paginated list of all firewalls. Supports filtering by name, enable status, and search query.
         * @summary List all firewalls
         * @param {string} [name] Filter by firewall name
         * @param {boolean} [enable] Filter by enabled status
         * @param {string} [search] Search term for name or description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFirewalls(name?: string, enable?: boolean, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FirewallEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFirewalls(name, enable, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.listFirewalls']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List jobs created by the authenticated user, filterable by status, with pagination
         * @summary List jobs by status
         * @param {ListJobsStatusEnum} [status] &#x60;active&#x60; is a shorthand for pending + in_progress — what the console badge counts. Filtering by a single status cannot express it, and two round trips would report two moments in time.
         * @param {number} [page] Page number (1-based)
         * @param {number} [pageSize] Items per page (max 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listJobs(status?: ListJobsStatusEnum, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobsPageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listJobs(status, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.listJobs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List my referrals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMyAffiliateReferrals(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AffiliateReferralDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMyAffiliateReferrals(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.listMyAffiliateReferrals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List my withdrawals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMyAffiliateWithdrawals(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WithdrawalDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMyAffiliateWithdrawals(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.listMyAffiliateWithdrawals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List attachments on one of my withdrawals
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMyWithdrawalAttachments(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WithdrawalAttachmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMyWithdrawalAttachments(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.listMyWithdrawalAttachments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all IP addresses owned by the authenticated user with their reverse DNS state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRdnsIps(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IpRdnsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRdnsIps(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.listRdnsIps']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all backup schedules for VMs owned by the authenticated user
         * @summary List all backup schedules for the authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSchedules(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BackupScheduleEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSchedules(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.listSchedules']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Risk exceptions on the account
         * @param {boolean} [includeInactive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSecurityExceptions(includeInactive?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SecurityExceptionListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSecurityExceptions(includeInactive, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.listSecurityExceptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Findings across the account, ordered by risk
         * @param {number} [vmId] 
         * @param {ListSecurityFindingsSeverityEnum} [severity] 
         * @param {ListSecurityFindingsStatusEnum} [status] 
         * @param {string} [category] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSecurityFindings(vmId?: number, severity?: ListSecurityFindingsSeverityEnum, status?: ListSecurityFindingsStatusEnum, category?: string, search?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SecurityFindingListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSecurityFindings(vmId, severity, status, category, search, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.listSecurityFindings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * A hundred instances with the same ten problems is a thousand rows saying the same thing. Collapsed, each row is one fix that resolves every instance it lists.
         * @summary Open findings collapsed by rule, worst first
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSecurityFindingsByRule(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SecurityRuleGroupDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSecurityFindingsByRule(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.listSecurityFindingsByRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The browsable counterpart to the overview, which returns only the worst five. Ordered by open criticals, then highs, then score — the list is meant to be worked from the top, not browsed alphabetically.
         * @summary Posture per instance, worst first
         * @param {string} [search] 
         * @param {string} [state] 
         * @param {any} [pageSize] 
         * @param {any} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSecurityInstances(search?: string, state?: string, pageSize?: any, page?: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSecurityInstances(search, state, pageSize, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.listSecurityInstances']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Every site connected to this gateway
         * @param {string} gatewayId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSiteConnections(gatewayId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SiteConnectionListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSiteConnections(gatewayId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.listSiteConnections']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve all snapshots for a specific VM with quota information
         * @summary List all snapshots for a VM
         * @param {number} vmId VM ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSnapshots(vmId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SnapshotListResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSnapshots(vmId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.listSnapshots']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Scan history for one instance
         * @param {number} vmId Instance id
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listVmSecurityScans(vmId: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SecurityScanListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listVmSecurityScans(vmId, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.listVmSecurityScans']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Attack surface observed on one instance
         * @param {number} vmId Instance id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listVmSecurityServices(vmId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SecurityServiceListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listVmSecurityServices(vmId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.listVmSecurityServices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authenticate a user with email and password.
         * @summary Login
         * @param {LoginDto} loginDto Client login data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(loginDto: LoginDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Login200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(loginDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.login']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Logout the authenticated user.
         * @summary Logout
         * @param {LogoutDto} logoutDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(logoutDto: LogoutDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(logoutDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.logout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Clears the whole unread badge in one call. The console cannot do this by id list: it only holds the pages it has loaded, and older unread rows would stay unread forever.
         * @summary Mark every notification of the client as read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markAllAsRead(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarkNotificationsReadResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markAllAsRead(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.markAllAsRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mark notifications as read in batch
         * @param {MarkNotificationsReadDto} markNotificationsReadDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markAsRead(markNotificationsReadDto: MarkNotificationsReadDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarkNotificationsReadResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markAsRead(markNotificationsReadDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.markAsRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mine(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicTrialDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mine(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.mine']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async offer(code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicTrialDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.offer(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.offer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Perform an operation (start, stop, reboot) on a VM and return a task ID for tracking.
         * @summary Perform VM Operation
         * @param {any} vmId ID of the VM to operate on
         * @param {VmOperationRequestDto} vmOperationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async performVmOperation(vmId: any, vmOperationRequestDto: VmOperationRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VmOperationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.performVmOperation(vmId, vmOperationRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.performVmOperation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * `shown` once a card has been on screen; `snoozed` for \"Not now\" (7 days); `dismissed` for \"Don\'t show again\"; `acted` when the call to action was followed. A support session is never recorded.
         * @summary Record what happened to a tip
         * @param {string} code 
         * @param {DiscoveryEventDto} discoveryEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recordFeatureDiscoveryEvent(code: string, discoveryEventDto: DiscoveryEventDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiscoveryEventResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recordFeatureDiscoveryEvent(code, discoveryEventDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.recordFeatureDiscoveryEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Refresh the access and refresh tokens.
         * @summary Refresh Tokens
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshTokens(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshTokens(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.refreshTokens']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new client in WHMCS.
         * @summary Register a new client
         * @param {AddClientDto} addClientDto Client registration data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async register(addClientDto: AddClientDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddClientResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.register(addClientDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.register']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Register a device for push notifications using FCM.
         * @summary Register FCM Device
         * @param {RegisterDeviceDto} registerDeviceDto Device registration details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerFcmDevice(registerDeviceDto: RegisterDeviceDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegisterDeviceResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerFcmDevice(registerDeviceDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.registerFcmDevice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reinstall a VPN Gateway by performing full reinstallation
         * @param {string} id VPN Gateway ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reinstallVpnGateway(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VpnGatewayApplyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reinstallVpnGateway(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.reinstallVpnGateway']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Resets the expiry to a full retention window from now.
         * @summary Extend an image’s retention
         * @param {string} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async renewClientImage(imageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientImageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.renewClientImage(imageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.renewClientImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} code 
         * @param {string} totalMicroCents Catalog simulation total for the selected configuration, in micro-cents.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async renewal(code: string, totalMicroCents: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrialRenewalDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.renewal(code, totalMicroCents, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.renewal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Request a withdrawal
         * @param {RequestWithdrawalDto} requestWithdrawalDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestAffiliateWithdrawal(requestWithdrawalDto: RequestWithdrawalDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WithdrawalDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestAffiliateWithdrawal(requestWithdrawalDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.requestAffiliateWithdrawal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Triggers WHMCS\'s native password-reset email (ResetPassword API). Always returns success regardless of whether the email exists, to avoid account enumeration.
         * @summary Request a password reset email
         * @param {ResetPasswordRequestDto} resetPasswordRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestPasswordReset(resetPasswordRequestDto: ResetPasswordRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResetPasswordResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestPasswordReset(resetPasswordRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.requestPasswordReset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sends a new 6-digit code to the email associated with the challenge. Limited to 3 resends per challenge.
         * @summary Resend two-factor verification code
         * @param {ResendTwoFactorDto} resendTwoFactorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendTwoFactor(resendTwoFactorDto: ResendTwoFactorDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendTwoFactor(resendTwoFactorDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.resendTwoFactor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reset the reverse DNS (PTR) record for an IPv4 address to the default platform value
         * @param {number} id IPv4 address record id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetIpv4Rdns(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IpRdnsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetIpv4Rdns(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.resetIpv4Rdns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reset the reverse DNS (PTR) record for an IPv6 address to the default platform value
         * @param {number} id IPv6 address record id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetIpv6Rdns(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IpRdnsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetIpv6Rdns(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.resetIpv6Rdns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *              Reset a user\'s password inside the VM using the QEMU guest agent.                          **Requirements:**             - QEMU guest agent must be installed and running in the VM             - The user must exist in the VM\'s operating system             - Password must be at least 8 characters long                          **Common use cases:**             - Reset root password when locked out             - Change user passwords without SSH access             - Automated password rotation         
         * @summary Reset user password
         * @param {number} vmId ID of the VM
         * @param {QemuAgentResetPasswordRequestDto} qemuAgentResetPasswordRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetUserPassword(vmId: number, qemuAgentResetPasswordRequestDto: QemuAgentResetPasswordRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QemuAgentResetPasswordResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetUserPassword(vmId, qemuAgentResetPasswordRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.resetUserPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Initiates a restore operation to restore a VM from a backup. The VM will be overwritten with the backup data. This operation is asynchronous and returns a task ID for tracking.
         * @summary Restore a VM from a backup
         * @param {number} backupId Backup ID to restore from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreBackup(backupId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RestoreBackupResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreBackup(backupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.restoreBackup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Restore the VM to a previous snapshot state. WARNING: All snapshots newer than the target snapshot will be deleted.
         * @summary Restore VM from a snapshot
         * @param {number} vmId VM ID
         * @param {RestoreSnapshotDto} restoreSnapshotDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreSnapshot(vmId: number, restoreSnapshotDto: RestoreSnapshotDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SnapshotOperationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreSnapshot(vmId, restoreSnapshotDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.restoreSnapshot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reports which parts have not arrived and returns fresh URLs for them. Safe to call at any point during an upload.
         * @summary Resume an upload
         * @param {string} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resumeClientImageUpload(imageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResumeTicketDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resumeClientImageUpload(imageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.resumeClientImageUpload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Show the key for this connection
         * @param {string} gatewayId 
         * @param {string} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revealSiteConnectionSecret(gatewayId: string, connectionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SiteSecretDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revealSiteConnectionSecret(gatewayId, connectionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.revealSiteConnectionSecret']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Revoke an API token
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeApiToken(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeApiToken(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.revokeApiToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Revoke an exception; its findings return to open immediately
         * @param {string} exceptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeSecurityException(exceptionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeSecurityException(exceptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.revokeSecurityException']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Revokes the token and issues a replacement with the same name and scopes.
         * @summary Roll an API token
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rollApiToken(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MintedApiTokenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rollApiToken(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.rollApiToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Replace the key for this connection
         * @param {string} gatewayId 
         * @param {string} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rotateSiteConnectionSecret(gatewayId: string, connectionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SiteSecretDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rotateSiteConnectionSecret(gatewayId, connectionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.rotateSiteConnectionSecret']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Turn a connection off or back on
         * @param {string} gatewayId 
         * @param {string} connectionId 
         * @param {SiteConnectionEnabledRequestDto} siteConnectionEnabledRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setSiteConnectionEnabled(gatewayId: string, connectionId: string, siteConnectionEnabledRequestDto: SiteConnectionEnabledRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SiteConnectionMutationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setSiteConnectionEnabled(gatewayId, connectionId, siteConnectionEnabledRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.setSiteConnectionEnabled']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates the WHMCS client from the address + password step of a social signup, links the identity and signs the user in.
         * @summary Complete social registration
         * @param {CompleteSocialRegistrationDto} completeSocialRegistrationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async socialCompleteRegistration(completeSocialRegistrationDto: CompleteSocialRegistrationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.socialCompleteRegistration(completeSocialRegistrationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.socialCompleteRegistration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Exchanges the single-use handoff code from the callback for the login result (token + client).
         * @summary Exchange social handoff code
         * @param {SocialHandoffExchangeDto} socialHandoffExchangeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async socialHandoffExchange(socialHandoffExchangeDto: SocialHandoffExchangeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.socialHandoffExchange(socialHandoffExchangeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.socialHandoffExchange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Provider redirect target. Processes the result and 302-redirects to the frontend callback page with a single-use handoff code, a registration ticket, a selection token, or an error.
         * @summary Social login callback
         * @param {string} provider 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async socialLoginCallback(provider: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.socialLoginCallback(provider, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.socialLoginCallback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Redirects the browser to the social provider authorization endpoint.
         * @summary Start social login
         * @param {string} provider 
         * @param {string} deviceId 
         * @param {string} [redirect] 
         * @param {SocialLoginStartDisplayEnum} [display] popup relays to the browser opener; native returns through the fixed app URI and requires S256 proof.
         * @param {string} [nativeState] Native installation-generated state (43 base64url characters).
         * @param {string} [codeChallenge] S256 challenge generated on the native installation.
         * @param {SocialLoginStartCodeChallengeMethodEnum} [codeChallengeMethod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async socialLoginStart(provider: string, deviceId: string, redirect?: string, display?: SocialLoginStartDisplayEnum, nativeState?: string, codeChallenge?: string, codeChallengeMethod?: SocialLoginStartCodeChallengeMethodEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.socialLoginStart(provider, deviceId, redirect, display, nativeState, codeChallenge, codeChallengeMethod, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.socialLoginStart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Redeem a native social callback with S256 proof
         * @param {NativeSocialExchangeDto} nativeSocialExchangeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async socialNativeExchange(nativeSocialExchangeDto: NativeSocialExchangeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NativeSocialResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.socialNativeExchange(nativeSocialExchangeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.socialNativeExchange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Complete a social multi-account login
         * @param {SelectSocialAccountDto} selectSocialAccountDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async socialSelectAccount(selectSocialAccountDto: SelectSocialAccountDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.socialSelectAccount(selectSocialAccountDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.socialSelectAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List accounts for a social multi-account login
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async socialSelectionAccounts(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LoginAccountOptionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.socialSelectionAccounts(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.socialSelectionAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reserves storage and returns one presigned URL per part. Upload the parts directly, then call the complete endpoint.
         * @summary Start an upload
         * @param {StartClientImageUploadDto} startClientImageUploadDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startClientImageUpload(startClientImageUploadDto: StartClientImageUploadDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadTicketDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startClientImageUpload(startClientImageUploadDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.startClientImageUpload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Start a scan of one instance now
         * @param {number} vmId Instance id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startVmSecurityScan(vmId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SecurityScanStartedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startVmSecurityScan(vmId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.startVmSecurityScan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Records a rating (with optional comment/reasons and a context snapshot). Re-rating the same subject updates the prior entry.
         * @summary Submit feedback
         * @param {SubmitFeedbackDto} submitFeedbackDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitFeedback(submitFeedbackDto: SubmitFeedbackDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmitFeedbackResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitFeedback(submitFeedbackDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.submitFeedback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Rename an image or change its hardware profile
         * @param {string} imageId 
         * @param {UpdateClientImageDto} updateClientImageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateClientImage(imageId: string, updateClientImageDto: UpdateClientImageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientImageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateClientImage(imageId, updateClientImageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.updateClientImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Applies to the NEXT deploy or reinstall from this image; running instances are untouched. Refused with the list of problems when the document has errors, and refused entirely unless the image is marked as having cloud-init installed. Send null to remove it.
         * @summary Set or clear this image’s cloud-init user data
         * @param {string} imageId 
         * @param {UpdateClientImageCloudInitDto} updateClientImageCloudInitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateClientImageCloudInit(imageId: string, updateClientImageCloudInitDto: UpdateClientImageCloudInitDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientImageCloudInitDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateClientImageCloudInit(imageId, updateClientImageCloudInitDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.updateClientImageCloudInit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update firewall configuration including name, description, enable status, or default policies (policy_in/policy_out). Only fields provided in the request body will be updated.
         * @summary Update firewall
         * @param {any} firewallId Unique identifier of the firewall
         * @param {UpdateFirewallDto} updateFirewallDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFirewall(firewallId: any, updateFirewallDto: UpdateFirewallDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FirewallEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFirewall(firewallId, updateFirewallDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.updateFirewall']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing firewall rule. Any information omitted from the payload will be cleared (set to null/empty) on the record.
         * @summary Update firewall rule
         * @param {string} ruleId Unique identifier of the rule to update
         * @param {any} firewallId Unique identifier of the firewall
         * @param {UpdateFirewallRuleDto} updateFirewallRuleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFirewallRule(ruleId: string, firewallId: any, updateFirewallRuleDto: UpdateFirewallRuleDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FirewallRuleEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFirewallRule(ruleId, firewallId, updateFirewallRuleDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.updateFirewallRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update the reverse DNS (PTR) record for an IPv4 address
         * @param {number} id IPv4 address record id
         * @param {UpdateRdnsDto} updateRdnsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateIpv4Rdns(id: number, updateRdnsDto: UpdateRdnsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IpRdnsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateIpv4Rdns(id, updateRdnsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.updateIpv4Rdns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update the reverse DNS (PTR) record for an IPv6 address
         * @param {number} id IPv6 address record id
         * @param {UpdateRdnsDto} updateRdnsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateIpv6Rdns(id: number, updateRdnsDto: UpdateRdnsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IpRdnsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateIpv6Rdns(id, updateRdnsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.updateIpv6Rdns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Turn scanning on or off for the account, or change notifications
         * @param {UpdateSecuritySettingsDto} updateSecuritySettingsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSecuritySettings(updateSecuritySettingsDto: UpdateSecuritySettingsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SecuritySettingsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSecuritySettings(updateSecuritySettingsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.updateSecuritySettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Change a connection
         * @param {string} gatewayId 
         * @param {string} connectionId 
         * @param {SiteConnectionRequestDto} siteConnectionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSiteConnection(gatewayId: string, connectionId: string, siteConnectionRequestDto: SiteConnectionRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SiteConnectionMutationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSiteConnection(gatewayId, connectionId, siteConnectionRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.updateSiteConnection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the name and/or description of a VM.
         * @summary Update VM name and description
         * @param {any} vmId ID of the VM
         * @param {UpdateVmDto} updateVmDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVm(vmId: any, updateVmDto: UpdateVmDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VmEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVm(vmId, updateVmDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.updateVm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change disk interface type, NIC model, and/or OS type for all devices on the VM. Changing the disk interface type requires the VM to be powered off.
         * @summary Update VM hardware configuration
         * @param {number} vmId VM ID
         * @param {UpdateVmHardwareDto} updateVmHardwareDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVmHardware(vmId: number, updateVmHardwareDto: UpdateVmHardwareDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateVmHardware200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVmHardware(vmId, updateVmHardwareDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.updateVmHardware']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Turn scanning on or off for one instance, or change its schedule
         * @param {number} vmId Instance id
         * @param {UpdateVmSecuritySettingsDto} updateVmSecuritySettingsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVmSecuritySettings(vmId: number, updateVmSecuritySettingsDto: UpdateVmSecuritySettingsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVmSecuritySettings(vmId, updateVmSecuritySettingsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.updateVmSecuritySettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update multiple VMs in a VPC. Empty array removes all VMs.
         * @summary Update VMs in a VPC
         * @param {UpdateVpcVmsDto} updateVpcVmsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVpcVms(updateVpcVmsDto: UpdateVpcVmsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VpcVmsEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVpcVms(updateVpcVmsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.updateVpcVms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a VPN Gateway
         * @param {string} id VPN Gateway ID
         * @param {UpdateVpnGatewayDto} updateVpnGatewayDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVpnGateway(id: string, updateVpnGatewayDto: UpdateVpnGatewayDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VpnGatewayDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVpnGateway(id, updateVpnGatewayDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.updateVpnGateway']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a VPN user
         * @param {string} id VPN User ID
         * @param {UpdateVpnUserDto} updateVpnUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVpnUser(id: string, updateVpnUserDto: UpdateVpnUserDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VpnUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVpnUser(id, updateVpnUserDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.updateVpnUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update this gateway
         * @param {string} id VPN Gateway ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upgradeAppliance(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VpnApplianceUpgradeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upgradeAppliance(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.upgradeAppliance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Attach a payout-evidence file to one of my withdrawals
         * @param {string} id 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadMyWithdrawalAttachment(id: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WithdrawalAttachmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadMyWithdrawalAttachment(id, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.uploadMyWithdrawalAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * What the editor calls while the customer types, so the problems appear beside the document rather than after a refused save.
         * @summary Check cloud-init user data without saving it
         * @param {string} imageId 
         * @param {ValidateClientImageCloudInitDto} validateClientImageCloudInitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateClientImageCloudInit(imageId: string, validateClientImageCloudInitDto: ValidateClientImageCloudInitDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientImageCloudInitValidationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateClientImageCloudInit(imageId, validateClientImageCloudInitDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.validateClientImageCloudInit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Check a connection before creating it
         * @param {string} gatewayId 
         * @param {SiteConnectionRequestDto} siteConnectionRequestDto 
         * @param {string} [connectionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateSiteConnection(gatewayId: string, siteConnectionRequestDto: SiteConnectionRequestDto, connectionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SiteValidationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateSiteConnection(gatewayId, siteConnectionRequestDto, connectionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.validateSiteConnection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Check whether the origin → destination pair satisfies all clone requirements, including clone source selection and storage availability.
         * @summary Validate clone eligibility
         * @param {number} originVmId DB id of the origin (source) VM
         * @param {number} destinationVmId DB id of the destination VM
         * @param {ValidateVmCloneSourceTypeEnum} sourceType Whether to clone the current VM state or restore from an existing backup.
         * @param {number} [backupId] Existing backup ID to use when sourceType&#x3D;existing_backup.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateVmClone(originVmId: number, destinationVmId: number, sourceType: ValidateVmCloneSourceTypeEnum, backupId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CloneValidationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateVmClone(originVmId, destinationVmId, sourceType, backupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.validateVmClone']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Submits the 6-digit code sent to the user\'s email during login to complete authentication.
         * @summary Verify two-factor authentication code
         * @param {VerifyTwoFactorDto} verifyTwoFactorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyTwoFactor(verifyTwoFactorDto: VerifyTwoFactorDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyTwoFactor(verifyTwoFactorDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MwApi.verifyTwoFactor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MwApi - factory interface
 * @export
 */
export const MwApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MwApiFp(configuration)
    return {
        /**
         * 
         * @summary Cancel an upload
         * @param {string} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        abortClientImageUpload(imageId: string, options?: RawAxiosRequestConfig): AxiosPromise<ClientImageOperationDto> {
            return localVarFp.abortClientImageUpload(imageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a DNS record to a zone
         * @param {string} id Domain record UUID
         * @param {CreateRecordDto} createRecordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDnsRecord(id: string, createRecordDto: CreateRecordDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addDnsRecord(id, createRecordDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a new rule to the firewall. Rules can be created using: • **Macros**: Predefined service configurations (e.g., HTTP, HTTPS, SSH) • **Manual configuration**: Specify protocol, ports, and other parameters  **Important**: Use either macros OR manual configuration, not both.
         * @summary Add firewall rule
         * @param {any} firewallId Unique identifier of the firewall
         * @param {AddFirewallRuleDto} addFirewallRuleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFirewallRule(firewallId: any, addFirewallRuleDto: AddFirewallRuleDto, options?: RawAxiosRequestConfig): AxiosPromise<FirewallRuleEntity> {
            return localVarFp.addFirewallRule(firewallId, addFirewallRuleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a VM to a VPC for the authenticated client.
         * @summary Add VM to VPC
         * @param {AddVmToVpcDto} addVmToVpcDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addVmToVpc(addVmToVpcDto: AddVmToVpcDto, options?: RawAxiosRequestConfig): AxiosPromise<VpcVmsEntity> {
            return localVarFp.addVmToVpc(addVmToVpcDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a user to a VPN Gateway
         * @param {string} id VPN Gateway ID
         * @param {AddVpnUserDto} addVpnUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addVpnUser(id: string, addVpnUserDto: AddVpnUserDto, options?: RawAxiosRequestConfig): AxiosPromise<VpnUserDto> {
            return localVarFp.addVpnUser(id, addVpnUserDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allowance(id: string, options?: RawAxiosRequestConfig): AxiosPromise<TrialAllowanceDto> {
            return localVarFp.allowance(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Apply a VPN gateway\'s pending changes
         * @param {string} id VPN Gateway ID
         * @param {ApplyChangesDto} applyChangesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyChanges(id: string, applyChangesDto: ApplyChangesDto, options?: RawAxiosRequestConfig): AxiosPromise<VpnGatewayApplyResponseDto> {
            return localVarFp.applyChanges(id, applyChangesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Mounts the ISO as a CD-ROM and makes it the first boot device. The instance’s power state is preserved.
         * @summary Attach an ISO to an instance
         * @param {string} imageId 
         * @param {number} vmId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachClientImage(imageId: string, vmId: number, options?: RawAxiosRequestConfig): AxiosPromise<ClientImageOperationDto> {
            return localVarFp.attachClientImage(imageId, vmId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Apply a resize: change billing rate, generate temporary credit on downgrade, reconcile infrastructure
         * @param {number} vmId Instance (VM) id
         * @param {ResizeTargetDto} resizeTargetDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingApplyResize(vmId: number, resizeTargetDto: ResizeTargetDto, options?: RawAxiosRequestConfig): AxiosPromise<ResizeApplyResultDto> {
            return localVarFp.billingApplyResize(vmId, resizeTargetDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Voids an OPEN top-up invoice of this subscription at the payment provider. Only TOPUP invoices can be cancelled here — renewal and debt invoices are obligations, and checkout, reschedule, move, transfer and conversion invoices belong to the operation that raised them. Refused with 409 when the provider already reports the invoice paid. A payment that clears at the bank after the cancellation is still credited to the balance.
         * @summary Cancel an unpaid top-up invoice
         * @param {string} id Subscription UUID
         * @param {string} externalId Provider invoice id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingCancelTopupInvoice(id: string, externalId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.billingCancelTopupInvoice(id, externalId, options).then((request) => request(axios, basePath));
        },
        /**
         * Booleans only — used by checkout to avoid offering an IP type the datacenter has none of. Inventory counts are intentionally never exposed. Public.
         * @summary Whether IPv4/IPv6 can be allocated in a datacenter
         * @param {number} datacenterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingCatalogIpAvailability(datacenterId: number, options?: RawAxiosRequestConfig): AxiosPromise<IpAvailabilityDto> {
            return localVarFp.billingCatalogIpAvailability(datacenterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Customer-facing location list for the configurator: name, region, flag asset, whether placement is currently possible, and whether each IP family can be allocated. Public.  This is deliberately NOT `GET /datacenters`, which is authenticated and answers with the datacenter entity including its clusters — hypervisor topology that has no business on a public surface.
         * @summary List the locations the checkout can deploy into
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingCatalogLocations(options?: RawAxiosRequestConfig): AxiosPromise<Array<PublicLocationDto>> {
            return localVarFp.billingCatalogLocations(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a priced line-item breakdown for the given offering + addons + OS + disks + term. Applies free quotas (IPv4/IPv6) and OS filters. Public — the order endpoint requires auth.  Pass `compare_term` to price the same configuration on a second term and receive it as `comparison`, which is how the checkout shows what committing saves without issuing a second request.
         * @summary Simulate price for a checkout configuration
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingCatalogSimulate(body: object, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.billingCatalogSimulate(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the full visible catalog: offerings, addons, billing terms and rates currently in effect. Public.
         * @summary Get billing catalog snapshot
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingCatalogSnapshot(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.billingCatalogSnapshot(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export the period ledger as CSV
         * @param {string} id Subscription UUID
         * @param {string} [from] ISO date-time
         * @param {string} [to] ISO date-time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingExportSubscriptionLedgerCsv(id: string, from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.billingExportSubscriptionLedgerCsv(id, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * Computes the next cycle-close renewal exactly as the close will (committed resources × term cap hours, minus the recurring coupon) and how much of it the current available balance already covers. Available balance is applied to the renewal at invoice issuance (RENEWAL_CREDIT_APPLIED), and balance that lands AFTER issuance settles the open renewal invoice once it covers it in full — so prepaying is a top-up tagged RENEWAL_PREPAY for the suggested amount. When the renewal invoice is already open, open_renewal_invoice.shortfall_cents is the top-up that settles it.
         * @summary Preview the next renewal for prepayment (\"Antecipar renovação\")
         * @param {string} id Subscription UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingGetRenewalPreview(id: string, options?: RawAxiosRequestConfig): AxiosPromise<RenewalPreviewDto> {
            return localVarFp.billingGetRenewalPreview(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Current instance configuration, available plans/addons and balance for the resize wizard
         * @param {number} vmId Instance (VM) id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingGetResizeContext(vmId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResizeContextDto> {
            return localVarFp.billingGetResizeContext(vmId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a single subscription with balance and active resources
         * @param {string} id Subscription UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingGetSubscription(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.billingGetSubscription(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the pending cancellation request for a subscription, if any
         * @param {string} id Subscription UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingGetSubscriptionCancellation(id: string, options?: RawAxiosRequestConfig): AxiosPromise<CancellationStateDto> {
            return localVarFp.billingGetSubscriptionCancellation(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Newest first: what was removed, how long it was on the subscription, what it was billed in total and the temporary credit its removal returned, as the ledger recorded it. A service moved to another subscription is not listed — it is still billed, there.
         * @summary Services this subscription billed and no longer does
         * @param {string} id Subscription UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingGetSubscriptionEndedResources(id: string, options?: RawAxiosRequestConfig): AxiosPromise<EndedResourcesDto> {
            return localVarFp.billingGetSubscriptionEndedResources(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Invoices generated for a subscription, with payment events
         * @param {string} id Subscription UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingGetSubscriptionInvoices(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<InvoiceDto>> {
            return localVarFp.billingGetSubscriptionInvoices(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Every credit and debit applied to the subscription, newest first. Each entry carries its bucket, reason, and reference. Use `cursor` for the next page.
         * @summary Paginated balance-ledger statement (full audit trail) for a subscription
         * @param {string} id Subscription UUID
         * @param {number} [limit] 
         * @param {string} [cursor] 
         * @param {BillingGetSubscriptionLedgerBucketEnum} [bucket] 
         * @param {BillingGetSubscriptionLedgerReasonEnum} [reason] 
         * @param {string} [from] ISO date-time
         * @param {string} [to] ISO date-time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingGetSubscriptionLedger(id: string, limit?: number, cursor?: string, bucket?: BillingGetSubscriptionLedgerBucketEnum, reason?: BillingGetSubscriptionLedgerReasonEnum, from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<LedgerPageDto> {
            return localVarFp.billingGetSubscriptionLedger(id, limit, cursor, bucket, reason, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Usage and credit forecast (estimates, not payment deadlines)
         * @param {string} id Subscription UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingGetSubscriptionProjection(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ProjectionDto> {
            return localVarFp.billingGetSubscriptionProjection(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Active resources with hourly rate and commitment-cap progress
         * @param {string} id Subscription UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingGetSubscriptionResources(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ResourceUsageDto>> {
            return localVarFp.billingGetSubscriptionResources(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Opening and closing usable balance for the window and the signed total of every ledger reason in between. Closing always equals opening + net change.
         * @summary Period reconciliation: opening/closing usable balance + totals by reason
         * @param {string} id Subscription UUID
         * @param {string} [from] ISO date-time
         * @param {string} [to] ISO date-time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingGetSubscriptionStatementSummary(id: string, from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<StatementSummaryDto> {
            return localVarFp.billingGetSubscriptionStatementSummary(id, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Suspension/resume history for a subscription
         * @param {string} id Subscription UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingGetSubscriptionSuspensions(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<SuspensionDto>> {
            return localVarFp.billingGetSubscriptionSuspensions(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Daily spend and per-kind breakdown sourced from the metering hypertable. Defaults to the current cycle when no range is given.
         * @summary Hourly consumption history aggregated by day and resource kind
         * @param {string} id Subscription UUID
         * @param {string} [from] ISO date-time
         * @param {string} [to] ISO date-time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingGetSubscriptionUsage(id: string, from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<UsageReportDto> {
            return localVarFp.billingGetSubscriptionUsage(id, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * Drill-down audit view: every billed hour with the exact resources, rates, seconds and cap status that made up the charge. Defaults to the current cycle.
         * @summary Hourly consumption with the per-resource line items composing each hour
         * @param {string} id Subscription UUID
         * @param {string} [from] ISO date-time
         * @param {string} [to] ISO date-time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingGetSubscriptionUsageHourly(id: string, from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<UsageHourlyReportDto> {
            return localVarFp.billingGetSubscriptionUsageHourly(id, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * Open invoices first, then settled ones newest-first. Pass `status` (comma-separated: OPEN,PAID,CANCELLED,REFUNDED) to filter — e.g. `status=OPEN` for outstanding invoices only. To pay an OPEN invoice, SSO the user into WHMCS at `viewinvoice.php?id=<external_id>` via `GET /whmcs/sso`.
         * @summary List provider invoices across every subscription of the account
         * @param {string} [status] Comma-separated invoice statuses to include. Defaults to all.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingListAccountInvoices(status?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<AccountInvoiceDto>> {
            return localVarFp.billingListAccountInvoices(status, options).then((request) => request(axios, basePath));
        },
        /**
         * Defaults to active and suspended subscriptions. Pass `status` (comma-separated) to override, e.g. `status=inactive` to review parked subscriptions or `status=active,suspended,inactive` for everything but cancelled.
         * @summary List subscriptions with balance for the authenticated user
         * @param {string} [status] Comma-separated subscription statuses to include. Defaults to active,suspended.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingListSubscriptions(status?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<SubscriptionListItemDto>> {
            return localVarFp.billingListSubscriptions(status, options).then((request) => request(axios, basePath));
        },
        /**
         * Only CREDIT_TOPUP coupons are accepted. The discount lowers the payable invoice amount; when the invoice is paid the full nominal top-up (paid + coupon grant) is credited to balance_available as two ledger entries with distinct reasons (RECHARGE, TOPUP_COUPON_CREDIT) for cash-vs-subsidy auditing.
         * @summary Preview a one-time top-up coupon for a subscription recharge
         * @param {string} id Subscription UUID
         * @param {TopupCouponPreviewBodyDto} topupCouponPreviewBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingPreviewTopupCoupon(id: string, topupCouponPreviewBodyDto: TopupCouponPreviewBodyDto, options?: RawAxiosRequestConfig): AxiosPromise<TopupCouponPreviewDto> {
            return localVarFp.billingPreviewTopupCoupon(id, topupCouponPreviewBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Price a resize and report impact, removed items and flag violations (no changes applied)
         * @param {number} vmId Instance (VM) id
         * @param {ResizeTargetDto} resizeTargetDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingQuoteResize(vmId: number, resizeTargetDto: ResizeTargetDto, options?: RawAxiosRequestConfig): AxiosPromise<ResizeQuoteDto> {
            return localVarFp.billingQuoteResize(vmId, resizeTargetDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Stops recurring billing at the end of the current cycle: no renewal invoice is issued, and every instance and VPN gateway under the subscription is terminated when the cycle closes (immediately for ON_DEMAND subscriptions, which have no cycle). The request can be withdrawn at any time before execution. The exit survey is required in FULL — both the reason and the free-text answer to the follow-up question that reason raises.
         * @summary Schedule the subscription for cancellation at the end of the current cycle
         * @param {string} id Subscription UUID
         * @param {RequestCancellationBodyDto} requestCancellationBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingRequestSubscriptionCancellation(id: string, requestCancellationBodyDto: RequestCancellationBodyDto, options?: RawAxiosRequestConfig): AxiosPromise<CancellationRequestDto> {
            return localVarFp.billingRequestSubscriptionCancellation(id, requestCancellationBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Runs the same settlement the platform runs on every credit landing and hourly: when the available balance covers an open renewal invoice in full, the commitment is funded from the balance and the invoice is cancelled (never marked paid — the cash already arrived on the top-up). Nothing is applied when the balance falls short; the response then names the shortfall.
         * @summary Settle the open renewal invoice from the subscription balance now
         * @param {string} id Subscription UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingSettleRenewalFromBalance(id: string, options?: RawAxiosRequestConfig): AxiosPromise<RenewalCreditSettleResultDto> {
            return localVarFp.billingSettleRenewalFromBalance(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Generates a WHMCS invoice for the requested amount. The invoice URL is returned so the client can open it in a new tab. When paid, the reconciler credits balance_available.
         * @summary Create a top-up invoice (WHMCS) to add credits to a subscription
         * @param {string} id Subscription UUID
         * @param {TopupBodyDto} topupBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingTopupSubscription(id: string, topupBodyDto: TopupBodyDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.billingTopupSubscription(id, topupBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Sets or clears the user-facing display name used to identify the subscription across the console.
         * @summary Update subscription settings (display name)
         * @param {string} id Subscription UUID
         * @param {UpdateSubscriptionDto} updateSubscriptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingUpdateSubscription(id: string, updateSubscriptionDto: UpdateSubscriptionDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.billingUpdateSubscription(id, updateSubscriptionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Only possible while the request is still pending — once the cycle has closed and the services were terminated, the cancellation is final.
         * @summary Withdraw the pending cancellation request (renewal resumes)
         * @param {string} id Subscription UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingWithdrawSubscriptionCancellation(id: string, options?: RawAxiosRequestConfig): AxiosPromise<CancellationRequestDto> {
            return localVarFp.billingWithdrawSubscriptionCancellation(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update multiple firewall rules in a single request. Accepts the same fields as the single rule update endpoint for each rule.
         * @summary Bulk update firewall rules
         * @param {any} firewallId Unique identifier of the firewall
         * @param {BulkUpdateFirewallRulesDto} bulkUpdateFirewallRulesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateFirewallRules(firewallId: any, bulkUpdateFirewallRulesDto: BulkUpdateFirewallRulesDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<FirewallRuleEntity>> {
            return localVarFp.bulkUpdateFirewallRules(firewallId, bulkUpdateFirewallRulesDto, options).then((request) => request(axios, basePath));
        },
        /**
         *              Check if the QEMU guest agent is running and responding in the VM.                          **Use cases:**             - Verify guest agent is installed before attempting operations             - Monitor guest agent health             - Troubleshoot guest agent connectivity issues                          **Note:** This endpoint returns a 200 status code even if the agent             is not running. Check the \'is_running\' field in the response to             determine the actual agent status.         
         * @summary Check QEMU guest agent status
         * @param {number} vmId ID of the VM
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAgentStatus(vmId: number, options?: RawAxiosRequestConfig): AxiosPromise<QemuAgentStatusResponseDto> {
            return localVarFp.checkAgentStatus(vmId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check if a domain NS records point to our nameservers
         * @param {string} id Domain record UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkDnsZoneHealth(id: string, options?: RawAxiosRequestConfig): AxiosPromise<DnsHealthResponseDto> {
            return localVarFp.checkDnsZoneHealth(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Identifier-first signup helper: lets the registration form detect an existing account before collecting the rest of the details, so the user can be routed to login. Fails open (returns exists=false) on lookup errors — the final register still guards with 409.
         * @summary Check whether an email already has an account
         * @param {CheckEmailDto} checkEmailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkRegistrationEmail(checkEmailDto: CheckEmailDto, options?: RawAxiosRequestConfig): AxiosPromise<CheckEmailResponseDto> {
            return localVarFp.checkRegistrationEmail(checkEmailDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns whether the VM is eligible for backups and the number of backup slots available
         * @summary Check VM backup eligibility
         * @param {any} vmId VM ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkVmBackupEligibility(vmId: any, options?: RawAxiosRequestConfig): AxiosPromise<CheckVmBackupEligibility200Response> {
            return localVarFp.checkVmBackupEligibility(vmId, options).then((request) => request(axios, basePath));
        },
        /**
         * In production this is invoked by the payment-reconciler when the InvoiceProvider reports the linked invoice as paid. Kept here so the end-to-end checkout flow is exercisable manually.
         * @summary Confirm a checkout v2 order (admin / test path)
         * @param {string} id Order ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutV2ConfirmOrder(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.checkoutV2ConfirmOrder(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Re-runs the price simulation server-side and returns one of three outcomes: • **provisioned** — existing subscription had enough balance for the prorata (its cost to the end of the current cycle); resource attached immediately. • **pending_payment** — invoice created in WHMCS, resource provisioned on payment. A new COMMITTED subscription is billed the full term. A new ON_DEMAND subscription invoices initial_credit_cents (defaulting to the catalog initial minimum), credited entirely to available balance for hourly usage without a renewal cycle. An add to an existing COMMITTED subscription whose balance is short is billed the prorata NET of that balance (`balanceAppliedCents`), which is drawn when the invoice is paid — never below the minimum recharge, the difference (`minimumRechargeCreditCents`) staying as credit. • **requires_topup** — existing subscription lacks balance; no order created.   Client should POST /billing/subscriptions/:id/topup for the shortfall, then retry.
         * @summary Create a checkout v2 order
         * @param {CreateOrderDto} createOrderDto 
         * @param {string} [idempotencyKey] A unique, client-generated string (8–255 chars of [A-Za-z0-9._:-]; a UUID is ideal) that makes this call safe to send twice. A retry carrying the same key replays the first answer instead of placing a second order, and comes back with &#x60;Idempotency-Replayed: true&#x60;.  The key covers the request BODY as well: reusing one for a different configuration is refused with a 409 rather than silently answered with the old order. Mint a new key whenever what is being bought changes.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutV2CreateOrder(createOrderDto: CreateOrderDto, idempotencyKey?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.checkoutV2CreateOrder(createOrderDto, idempotencyKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Backs the checkout \"waiting for payment\" panel: safe to poll, never advances the order. Pass `refresh=true` on an explicit \"I already paid\" click to ask the invoice provider out of band of the reconciler tick — that leg is rate-limited per invoice, and `checked_provider` reports whether it actually ran.
         * @summary Where a placed order stands (payment + provisioning)
         * @param {string} id Order ID (UUID)
         * @param {boolean} [refresh] Ask the invoice provider about the linked invoice before answering (rate-limited per invoice).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutV2GetOrderPaymentState(id: string, refresh?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<OrderPaymentStateDto> {
            return localVarFp.checkoutV2GetOrderPaymentState(id, refresh, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns subscriptions for the authenticated account with their current balance so the checkout wizard can let the customer pick a target subscription or start a new one.
         * @summary List active subscriptions available for adding a new resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutV2ListSubscriptions(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.checkoutV2ListSubscriptions(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the gross cycle total of the service being ordered, the recurring discount its coupon takes off, and the payable amount. A coupon is bound to the SERVICE the order creates and discounts that service on every renewal; a service added to the subscription later is billed at list price. Fixed-value coupons come off the service total, never off a product price.
         * @summary Preview a recurring coupon for the service being ordered
         * @param {CheckoutCouponPreviewBodyDto} checkoutCouponPreviewBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutV2PreviewCoupon(checkoutCouponPreviewBodyDto: CheckoutCouponPreviewBodyDto, options?: RawAxiosRequestConfig): AxiosPromise<CouponPreviewDto> {
            return localVarFp.checkoutV2PreviewCoupon(checkoutCouponPreviewBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Apply firewall configuration and rules to the specified VMs. This asynchronous operation: • Applies all firewall rules to the target VMs • Updates firewall policies on the VMs • Automatically removes firewall rules from VMs no longer assigned • Returns a job ID for tracking the operation progress  **Note**: Changes are not applied to VMs until this endpoint is called.
         * @summary Commit firewall rules to VMs
         * @param {any} firewallId Unique identifier of the firewall
         * @param {CommitFirewallDto} commitFirewallDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitFirewall(firewallId: any, commitFirewallDto: CommitFirewallDto, options?: RawAxiosRequestConfig): AxiosPromise<CommitFirewall201Response> {
            return localVarFp.commitFirewall(firewallId, commitFirewallDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Seals the upload and starts checking and preparing the image. Returns the id of the job to follow.
         * @summary Finish an upload
         * @param {string} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeClientImageUpload(imageId: string, options?: RawAxiosRequestConfig): AxiosPromise<ClientImageOperationDto> {
            return localVarFp.completeClientImageUpload(imageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the plaintext token once — it cannot be retrieved later.
         * @summary Create an API token
         * @param {CreateApiTokenDto} createApiTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApiToken(createApiTokenDto: CreateApiTokenDto, options?: RawAxiosRequestConfig): AxiosPromise<MintedApiTokenDto> {
            return localVarFp.createApiToken(createApiTokenDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new DNS zone
         * @param {CreateZoneDto} createZoneDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDnsZone(createZoneDto: CreateZoneDto, options?: RawAxiosRequestConfig): AxiosPromise<DnsZoneDto> {
            return localVarFp.createDnsZone(createZoneDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new firewall configuration with default policies. The firewall will be created with the specified input and output policies.
         * @summary Create a new firewall
         * @param {CreateFirewallDto} createFirewallDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFirewall(createFirewallDto: CreateFirewallDto, options?: RawAxiosRequestConfig): AxiosPromise<FirewallEntity> {
            return localVarFp.createFirewall(createFirewallDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new backup schedule for a VM or updates an existing one
         * @summary Create or update a backup schedule
         * @param {CreateBackupScheduleDto} createBackupScheduleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSchedule(createBackupScheduleDto: CreateBackupScheduleDto, options?: RawAxiosRequestConfig): AxiosPromise<BackupScheduleEntity> {
            return localVarFp.createSchedule(createBackupScheduleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Accept a risk, with a justification and an expiry date
         * @param {CreateSecurityExceptionDto} createSecurityExceptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSecurityException(createSecurityExceptionDto: CreateSecurityExceptionDto, options?: RawAxiosRequestConfig): AxiosPromise<SecurityExceptionCreatedDto> {
            return localVarFp.createSecurityException(createSecurityExceptionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Connect another site to this gateway
         * @param {string} gatewayId 
         * @param {SiteConnectionRequestDto} siteConnectionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSiteConnection(gatewayId: string, siteConnectionRequestDto: SiteConnectionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SiteConnectionMutationDto> {
            return localVarFp.createSiteConnection(gatewayId, siteConnectionRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new snapshot for the VM. Snapshots expire after 30 days. You can optionally include RAM state for a complete running state snapshot.
         * @summary Create a new snapshot
         * @param {number} vmId VM ID
         * @param {CreateSnapshotDto} createSnapshotDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSnapshot(vmId: number, createSnapshotDto: CreateSnapshotDto, options?: RawAxiosRequestConfig): AxiosPromise<SnapshotOperationResponseDto> {
            return localVarFp.createSnapshot(vmId, createSnapshotDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a Single Sign-On (SSO) token for the authenticated user.
         * @summary Create SSO Token
         * @param {string} [path] Optional path parameter to customize SSO token creation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSsoToken(path?: string, options?: RawAxiosRequestConfig): AxiosPromise<CreateSsoDto> {
            return localVarFp.createSsoToken(path, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new VPC for the authenticated client.
         * @summary Create a new VPC
         * @param {VpcCreateDto} vpcCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVpc(vpcCreateDto: VpcCreateDto, options?: RawAxiosRequestConfig): AxiosPromise<VpcEntity> {
            return localVarFp.createVpc(vpcCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new VPN Gateway
         * @param {CreateVpnGatewayDto} createVpnGatewayDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVpnGateway(createVpnGatewayDto: CreateVpnGatewayDto, options?: RawAxiosRequestConfig): AxiosPromise<VpnGatewayDto> {
            return localVarFp.createVpnGateway(createVpnGatewayDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Mint a short-lived token that can be used only to authenticate Socket.IO connections.
         * @summary Create WebSocket token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWebsocketToken(options?: RawAxiosRequestConfig): AxiosPromise<WebsocketTokenDto> {
            return localVarFp.createWebsocketToken(options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a backup
         * @summary Delete a backup
         * @param {number} backupId Backup ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBackup(backupId: number, options?: RawAxiosRequestConfig): AxiosPromise<DeleteBackup200Response> {
            return localVarFp.deleteBackup(backupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Removes the artifact, every hypervisor copy of it, and ejects it from any instance booting it. Instances already built from it are unaffected.
         * @summary Delete an image
         * @param {string} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClientImage(imageId: string, options?: RawAxiosRequestConfig): AxiosPromise<ClientImageOperationDto> {
            return localVarFp.deleteClientImage(imageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a DNS record from a zone
         * @param {string} id Domain record UUID
         * @param {DeleteRecordDto} deleteRecordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDnsRecord(id: string, deleteRecordDto: DeleteRecordDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteDnsRecord(id, deleteRecordDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a DNS zone and all its records
         * @param {string} id Domain record UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDnsZone(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteDnsZone(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Asynchronously delete a firewall and clean up all associated resources. This operation: • Removes firewall rules from all assigned VMs • Sets VM firewall policies to ALLOW • Deletes the firewall configuration • Returns a job ID for tracking the asynchronous operation
         * @summary Delete firewall
         * @param {any} firewallId Unique identifier of the firewall to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFirewall(firewallId: any, options?: RawAxiosRequestConfig): AxiosPromise<DeleteFirewall201Response> {
            return localVarFp.deleteFirewall(firewallId, options).then((request) => request(axios, basePath));
        },
        /**
         * Permanently delete a firewall rule.
         * @summary Delete firewall rule
         * @param {string} ruleId Unique identifier of the rule to delete
         * @param {any} firewallId Unique identifier of the firewall
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFirewallRule(ruleId: string, firewallId: any, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteFirewallRule(ruleId, firewallId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove an attachment from one of my PENDING withdrawals
         * @param {string} id 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMyWithdrawalAttachment(id: string, attachmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteMyWithdrawalAttachment(id, attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a backup schedule (soft delete)
         * @summary Delete a backup schedule
         * @param {number} scheduleId Schedule ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSchedule(scheduleId: number, options?: RawAxiosRequestConfig): AxiosPromise<DeleteBackup200Response> {
            return localVarFp.deleteSchedule(scheduleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Disconnect a site
         * @param {string} gatewayId 
         * @param {string} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSiteConnection(gatewayId: string, connectionId: string, options?: RawAxiosRequestConfig): AxiosPromise<SiteConnectionRemovedDto> {
            return localVarFp.deleteSiteConnection(gatewayId, connectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a specific snapshot. Validates that the snapshot belongs to a VM owned by the authenticated user.
         * @summary Delete a snapshot
         * @param {string} snapshotId Snapshot ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSnapshot(snapshotId: string, options?: RawAxiosRequestConfig): AxiosPromise<SnapshotOperationResponseDto> {
            return localVarFp.deleteSnapshot(snapshotId, options).then((request) => request(axios, basePath));
        },
        /**
         * Terminate a VM instance, release its IP assignments, soft-delete the VM record, and stop future billing for linked resources.
         * @summary Delete VM
         * @param {any} vmId ID of the VM to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVm(vmId: any, options?: RawAxiosRequestConfig): AxiosPromise<TerminateServiceResponseDto> {
            return localVarFp.deleteVm(vmId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a VPC by its ID.
         * @summary Delete a VPC
         * @param {number} vpcId ID of the VPC to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVpc(vpcId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteVpc(vpcId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a VPN user
         * @param {string} id VPN User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVpnUser(id: string, options?: RawAxiosRequestConfig): AxiosPromise<VpnUserDto> {
            return localVarFp.deleteVpnUser(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Rebuilds the instance from a disk image the customer uploaded. The instance keeps its addresses and its plan; everything on its disk is replaced. Refused when the plan’s disk is smaller than the image needs — a reinstall cannot grow a disk, so it must be resized first.
         * @summary Reinstall an instance from one of my images
         * @param {string} imageId ID of the customer image
         * @param {any} vmId ID of the instance to rebuild
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deployVmFromClientImage(imageId: string, vmId: any, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deployVmFromClientImage(imageId, vmId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deploy a VM from a template.
         * @summary Deploy VM from template
         * @param {number} templateId ID of the template to deploy from
         * @param {any} vmId ID of the VM to deploy
         * @param {DeployVmDto} [deployVmDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deployVmFromTemplate(templateId: number, vmId: any, deployVmDto?: DeployVmDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deployVmFromTemplate(templateId, vmId, deployVmDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Eject an ISO
         * @param {string} imageId 
         * @param {number} vmId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detachClientImage(imageId: string, vmId: number, options?: RawAxiosRequestConfig): AxiosPromise<ClientImageOperationDto> {
            return localVarFp.detachClientImage(imageId, vmId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download an attachment on one of my withdrawals
         * @param {string} id 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadMyWithdrawalAttachment(id: string, attachmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.downloadMyWithdrawalAttachment(id, attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download the configuration for the other end
         * @param {string} gatewayId 
         * @param {string} connectionId 
         * @param {string} vendor 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSiteConnectionConfig(gatewayId: string, connectionId: string, vendor: string, options?: RawAxiosRequestConfig): AxiosPromise<VendorConfigDto> {
            return localVarFp.downloadSiteConnectionConfig(gatewayId, connectionId, vendor, options).then((request) => request(axios, basePath));
        },
        /**
         * Validates an admin-issued SSO code and returns access and refresh tokens for the client portal.
         * @summary Exchange a single-use SSO code for session tokens
         * @param {ExchangeSsoDto} exchangeSsoDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeSso(exchangeSsoDto: ExchangeSsoDto, options?: RawAxiosRequestConfig): AxiosPromise<TokenDto> {
            return localVarFp.exchangeSso(exchangeSsoDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Queues a backup job for the specified VM. The backup will be executed asynchronously.
         * @summary Execute a manual backup for a VM
         * @param {any} vmId VM ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeBackup(vmId: any, options?: RawAxiosRequestConfig): AxiosPromise<ExecuteBackup200Response> {
            return localVarFp.executeBackup(vmId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate a download code for VPN connection profile access
         * @param {string} id VPN Gateway ID
         * @param {GenerateDownloadCodeDto} generateDownloadCodeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDownloadCode(id: string, generateDownloadCodeDto: GenerateDownloadCodeDto, options?: RawAxiosRequestConfig): AxiosPromise<DownloadCodeDto> {
            return localVarFp.generateDownloadCode(id, generateDownloadCodeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all datacenters
         * @param {boolean} [includeHidden] Whether to include hidden datacenters (default: false)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDatacenters(includeHidden?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<DatacenterEntity>> {
            return localVarFp.getAllDatacenters(includeHidden, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of all VPCs for the authenticated client.
         * @summary Get all VPCs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllVpcs(options?: RawAxiosRequestConfig): AxiosPromise<Array<VpcEntity>> {
            return localVarFp.getAllVpcs(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all VPN Gateways for the logged-in client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllVpnGateways(options?: RawAxiosRequestConfig): AxiosPromise<Array<VpnGatewayWithVmDto>> {
            return localVarFp.getAllVpnGateways(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all VPN users from all VPN gateways for the logged-in client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllVpnUsers(options?: RawAxiosRequestConfig): AxiosPromise<Array<VpnUserWithGatewayDto>> {
            return localVarFp.getAllVpnUsers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary What this gateway is running
         * @param {string} id VPN Gateway ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppliance(id: string, options?: RawAxiosRequestConfig): AxiosPromise<VpnApplianceDto> {
            return localVarFp.getAppliance(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Operator instructions for the AI assistant system prompt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssistantInstructions(options?: RawAxiosRequestConfig): AxiosPromise<AssistantInstructionsDto> {
            return localVarFp.getAssistantInstructions(options).then((request) => request(axios, basePath));
        },
        /**
         * Get a list of available templates based on the current VM product. Respects soft deletes.
         * @summary List available templates for VM
         * @param {number} vmId ID of the VM to get templates for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableTemplates(vmId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<TemplateDto>> {
            return localVarFp.getAvailableTemplates(vmId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the current backup progress for a VM by parsing hypervisor task logs
         * @summary Get backup progress for a VM
         * @param {any} vmId VM ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBackupProgress(vmId: any, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getBackupProgress(vmId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get one image
         * @param {string} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientImage(imageId: string, options?: RawAxiosRequestConfig): AxiosPromise<ClientImageDto> {
            return localVarFp.getClientImage(imageId, options).then((request) => request(axios, basePath));
        },
        /**
         * The document exactly as the guest will receive it, with the format, the size limit and any problems found in it. Re-checked on every read.
         * @summary Read this image’s cloud-init user data
         * @param {string} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientImageCloudInit(imageId: string, options?: RawAxiosRequestConfig): AxiosPromise<ClientImageCloudInitDto> {
            return localVarFp.getClientImageCloudInit(imageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Storage allowance and current usage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientImageQuota(options?: RawAxiosRequestConfig): AxiosPromise<ClientImageQuotaDto> {
            return localVarFp.getClientImageQuota(options).then((request) => request(axios, basePath));
        },
        /**
         * Each instance is reported with whether its disk is large enough. A reinstall cannot grow a disk, so an instance that does not fit must be resized first.
         * @summary Instances this image can be used on
         * @param {string} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientImageTargets(imageId: string, options?: RawAxiosRequestConfig): AxiosPromise<AttachTargetsDto> {
            return localVarFp.getClientImageTargets(imageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a specific cluster by its ID.
         * @summary Get Cluster by ID
         * @param {number} id Cluster ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClusterById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ClusterEntity> {
            return localVarFp.getClusterById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of all clusters.
         * @summary List Clusters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClusters(options?: RawAxiosRequestConfig): AxiosPromise<Array<ClusterEntity>> {
            return localVarFp.getClusters(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get clusters by datacenter ID
         * @param {number} id Datacenter ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClustersByDatacenterId(id: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ClusterEntity>> {
            return localVarFp.getClustersByDatacenterId(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get VPN connection profile using download code (public endpoint)
         * @param {string} downloadCode Download code for accessing VPN connection profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectionProfileByDownloadCode(downloadCode: string, options?: RawAxiosRequestConfig): AxiosPromise<DownloadCodeConnectionProfileDto> {
            return localVarFp.getConnectionProfileByDownloadCode(downloadCode, options).then((request) => request(axios, basePath));
        },
        /**
         *        Generate a VNC ticket for a VM the authenticated user owns and return       WebSocket connection details for the proxied noVNC console viewer.       Call this on every connect or reconnect — it is idempotent and always       returns a fresh VNC ticket.        The returned `websocket_url` contains an opaque session token used by the       backend proxy. Open the console page at `/console/<vm_id>` and let the       viewer call this endpoint directly using the existing browser session.     
         * @summary Get VM console connection details
         * @param {VncConsoleRequestDto} vncConsoleRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsoleAccess(vncConsoleRequestDto: VncConsoleRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<VncConsoleConnectionDto> {
            return localVarFp.getConsoleAccess(vncConsoleRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Fleet vitals, billing runway, backup coverage, security posture and a ranked list of what needs attention. Replaces the fan-out the console used to perform (one status call per instance, one projection per subscription), which did not survive contact with large accounts.  Sections fail independently: anything that could not be read is named in `degraded[]` rather than returned as zeroes, so a partial answer is never rendered as an all-clear.
         * @summary Everything the console home screen renders, in one read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardOverview(options?: RawAxiosRequestConfig): AxiosPromise<DashboardOverviewDto> {
            return localVarFp.getDashboardOverview(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a datacenter by ID
         * @param {number} id Datacenter ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatacenterById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<DatacenterEntity> {
            return localVarFp.getDatacenterById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Check if the VM is eligible for snapshot operations and get quota information
         * @summary Check snapshot eligibility
         * @param {number} vmId VM ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEligibility(vmId: number, options?: RawAxiosRequestConfig): AxiosPromise<GetEligibility200Response> {
            return localVarFp.getEligibility(vmId, options).then((request) => request(axios, basePath));
        },
        /**
         * Backs the Discover page. Showing it records nothing.
         * @summary Every tip, with adoption and state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureDiscoveryCatalog(options?: RawAxiosRequestConfig): AxiosPromise<DiscoveryCatalogDto> {
            return localVarFp.getFeatureDiscoveryCatalog(options).then((request) => request(axios, basePath));
        },
        /**
         * Ranked tips the account does not use yet, launches first. Empty while a deck was shown to this person in the last 20 hours, on any device.
         * @summary Tips for this sign-in
         * @param {Array<string>} [exclude] Tip codes this console cannot offer (a feature disabled in this deployment). Comma-separated or repeated.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureDiscoveryDeck(exclude?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<DiscoveryDeckDto> {
            return localVarFp.getFeatureDiscoveryDeck(exclude, options).then((request) => request(axios, basePath));
        },
        /**
         * Get detailed information about a specific firewall including its configuration, rules, and assigned VMs.
         * @summary Get firewall by ID
         * @param {any} firewallId Unique identifier of the firewall
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirewall(firewallId: any, options?: RawAxiosRequestConfig): AxiosPromise<FirewallEntity> {
            return localVarFp.getFirewall(firewallId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the firewall assigned to a specific VM along with its rules.
         * @summary Get firewall for VM
         * @param {any} vmId Unique identifier of the VM
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirewallForVm(vmId: any, options?: RawAxiosRequestConfig): AxiosPromise<FirewallEntity> {
            return localVarFp.getFirewallForVm(vmId, options).then((request) => request(axios, basePath));
        },
        /**
         * Track the progress of any asynchronous job by ID
         * @summary Get job status
         * @param {string} jobId Job ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobStatus(jobId: string, options?: RawAxiosRequestConfig): AxiosPromise<JobDto> {
            return localVarFp.getJobStatus(jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Affiliate overview for the current account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyAffiliate(options?: RawAxiosRequestConfig): AxiosPromise<AffiliateMeDto> {
            return localVarFp.getMyAffiliate(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get notifications with pagination
         * @param {number} [page] Page number
         * @param {number} [limit] Number of items per page
         * @param {boolean} [unreadOnly] Return only unread notifications. &#x60;total&#x60;/&#x60;totalPages&#x60; then describe the unread set, so the \&quot;Unread\&quot; filter can paginate without holes.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications(page?: number, limit?: number, unreadOnly?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<NotificationsResponseDto> {
            return localVarFp.getNotifications(page, limit, unreadOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the current restore progress for a VM by parsing hypervisor task logs
         * @summary Get restore progress for a VM
         * @param {any} vmId VM ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRestoreProgress(vmId: any, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getRestoreProgress(vmId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary One finding with its evidence, advice and timeline
         * @param {string} findingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSecurityFinding(findingId: string, options?: RawAxiosRequestConfig): AxiosPromise<SecurityFindingDetailDto> {
            return localVarFp.getSecurityFinding(findingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Security posture across every instance on the account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSecurityOverview(options?: RawAxiosRequestConfig): AxiosPromise<SecurityOverviewDto> {
            return localVarFp.getSecurityOverview(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Daily security score history
         * @param {number} [days] 
         * @param {number} [vmId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSecurityScoreHistory(days?: number, vmId?: number, options?: RawAxiosRequestConfig): AxiosPromise<SecurityScoreHistoryDto> {
            return localVarFp.getSecurityScoreHistory(days, vmId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Scanning and notification preferences for the account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSecuritySettings(options?: RawAxiosRequestConfig): AxiosPromise<SecuritySettingsDto> {
            return localVarFp.getSecuritySettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary One connection, with what the other end needs
         * @param {string} gatewayId 
         * @param {string} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteConnection(gatewayId: string, connectionId: string, options?: RawAxiosRequestConfig): AxiosPromise<SiteConnectionDetailDto> {
            return localVarFp.getSiteConnection(gatewayId, connectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Which configurations can be generated
         * @param {string} gatewayId 
         * @param {string} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteConnectionConfigOptions(gatewayId: string, connectionId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<VendorConfigOptionDto>> {
            return localVarFp.getSiteConnectionConfigOptions(gatewayId, connectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary What has happened to this connection
         * @param {string} gatewayId 
         * @param {string} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteConnectionEvents(gatewayId: string, connectionId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<SiteConnectionEventDto>> {
            return localVarFp.getSiteConnectionEvents(gatewayId, connectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the status of a VM operation task.
         * @summary Get Task Status
         * @param {string} taskId ID of the task to check
         * @param {any} vmId ID of the VM
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskStatus(taskId: string, vmId: any, options?: RawAxiosRequestConfig): AxiosPromise<TaskStatusResponseDto> {
            return localVarFp.getTaskStatus(taskId, vmId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the details of the authenticated user.
         * @summary Get User Details
         * @param {boolean} [fresh] Ask WHMCS now instead of answering from the cached profile (used by the page that shows the profile back to its owner).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDetails(fresh?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<ClientDetailsDto> {
            return localVarFp.getUserDetails(fresh, options).then((request) => request(axios, basePath));
        },
        /**
         * Transferred data volume (inbound/outbound, all interfaces) aggregated in time buckets for the selected period, plus the public outbound usage of the current billing window.
         * @summary Get VM Bandwidth Usage
         * @param {GetVmBandwidthPeriodEnum} period Period for bandwidth usage data
         * @param {any} vmId ID of the VM
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVmBandwidth(period: GetVmBandwidthPeriodEnum, vmId: any, options?: RawAxiosRequestConfig): AxiosPromise<VmBandwidthResponseDto> {
            return localVarFp.getVmBandwidth(period, vmId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a VM by its ID.
         * @summary Get VM by ID
         * @param {any} vmId ID of the VM
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVmById(vmId: any, options?: RawAxiosRequestConfig): AxiosPromise<VmEntity> {
            return localVarFp.getVmById(vmId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the current disk interface type, NIC model, and OS type for a VM.
         * @summary Get current VM hardware configuration
         * @param {number} vmId VM ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVmHardwareConfig(vmId: number, options?: RawAxiosRequestConfig): AxiosPromise<GetVmHardwareConfig200Response> {
            return localVarFp.getVmHardwareConfig(vmId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns available disk interface types, NIC models, and OS types/versions.
         * @summary Get hardware configuration options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVmHardwareOptions(options?: RawAxiosRequestConfig): AxiosPromise<HardwareOptionsResponseDto> {
            return localVarFp.getVmHardwareOptions(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve historical metrics data for a VM with caching. Returns CPU, memory, disk, and network usage over time.
         * @summary Get VM Metrics
         * @param {GetVmMetricsTimeframeEnum} timeframe Timeframe for metrics data
         * @param {any} vmId ID of the VM
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVmMetrics(timeframe: GetVmMetricsTimeframeEnum, vmId: any, options?: RawAxiosRequestConfig): AxiosPromise<VmMetricsResponseDto> {
            return localVarFp.getVmMetrics(timeframe, vmId, options).then((request) => request(axios, basePath));
        },
        /**
         * What the removal returns to the subscription (temporary credit on a commitment, nothing on on-demand), how much, until when, what the subscription will hold afterwards, and anything that would make the deletion be refused. Computed by the same code that performs the removal; changes nothing.
         * @summary Preview what deleting a VM does to its billing
         * @param {any} vmId ID of the VM
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVmRemovalPreview(vmId: any, options?: RawAxiosRequestConfig): AxiosPromise<VmRemovalPreviewDto> {
            return localVarFp.getVmRemovalPreview(vmId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Security posture of one instance
         * @param {number} vmId Instance id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVmSecurityPosture(vmId: number, options?: RawAxiosRequestConfig): AxiosPromise<VmSecurityPostureDto> {
            return localVarFp.getVmSecurityPosture(vmId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the current status of a VM from the hypervisor with caching and deployment information.
         * @summary Get VM Status
         * @param {string} vmId ID of the VM
         * @param {boolean} [fresh] Bypass the cached status and read the live state (used by user-invoked refreshes).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVmStatus(vmId: string, fresh?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<VmStatusResponseDto> {
            return localVarFp.getVmStatus(vmId, fresh, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of all VMs for the authenticated client.
         * @summary List VMs
         * @param {string} [id] ID of the VM
         * @param {string} [clusterId] Cluster ID of the server
         * @param {GetVmsProductCategoryTypeEnum} [productCategoryType] Service type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVms(id?: string, clusterId?: string, productCategoryType?: GetVmsProductCategoryTypeEnum, options?: RawAxiosRequestConfig): AxiosPromise<Array<VmEntity>> {
            return localVarFp.getVms(id, clusterId, productCategoryType, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all VMs from a VPC.
         * @summary Retrieve VMs by VPC ID
         * @param {any} vpcId ID of the VPC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVpcVms(vpcId: any, options?: RawAxiosRequestConfig): AxiosPromise<Array<VpcVmsDto>> {
            return localVarFp.getVpcVms(vpcId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get VPN connection profile (.ovpn file) for a VPN Gateway
         * @param {string} id VPN Gateway ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVpnConnectionProfile(id: string, options?: RawAxiosRequestConfig): AxiosPromise<VpnConnectionProfileDto> {
            return localVarFp.getVpnConnectionProfile(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a VPN Gateway by VM ID
         * @param {number} vmId VM ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVpnGatewayByVmId(vmId: number, options?: RawAxiosRequestConfig): AxiosPromise<VpnGatewayDto> {
            return localVarFp.getVpnGatewayByVmId(vmId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get VPN Gateway details with connected users information
         * @param {string} id VPN Gateway ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVpnGatewayDetails(id: string, options?: RawAxiosRequestConfig): AxiosPromise<VpnGatewayWithConnectedUsersDto> {
            return localVarFp.getVpnGatewayDetails(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get VPN Gateway details using download code (public endpoint)
         * @param {string} downloadCode Download code for accessing VPN Gateway details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVpnGatewayDetailsByDownloadCode(downloadCode: string, options?: RawAxiosRequestConfig): AxiosPromise<VpnGatewayDetailsDto> {
            return localVarFp.getVpnGatewayDetailsByDownloadCode(downloadCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all users for a VPN Gateway
         * @param {string} id VPN Gateway ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVpnUsers(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<VpnUserDto>> {
            return localVarFp.getVpnUsers(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Clones the origin VM into the destination VM using either the current state or an existing backup. Destination disk must be >= origin disk, and the required backup/vm storages must be available.
         * @summary Initiate a VM clone operation
         * @param {InitiateCloneDto} initiateCloneDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateVmClone(initiateCloneDto: InitiateCloneDto, options?: RawAxiosRequestConfig): AxiosPromise<CloneInitiatedResponseDto> {
            return localVarFp.initiateVmClone(initiateCloneDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Paginated, searchable history of actions taken on your account — from the web console, from your API tokens, by the AI assistant, by our support team on your behalf, and by automated platform processes. Each entry records who acted, from which IP address, what was affected and whether it succeeded.
         * @summary List account activity
         * @param {number} [page] Page number (1-based).
         * @param {number} [pageSize] Entries per page.
         * @param {string} [search] Free-text search across the actor, the affected resource, the action and the IP address.
         * @param {ListAccountActivityActorKindEnum} [actorKind] Restrict to one kind of actor — &#x60;CONSOLE&#x60; for the web panel, &#x60;API_TOKEN&#x60; for your API credentials, &#x60;MCP&#x60; for AI assistant actions, &#x60;SUPPORT&#x60; for actions taken by our staff, &#x60;SYSTEM&#x60; for automated platform actions.
         * @param {ListAccountActivityCategoryEnum} [category] Restrict to one area of the product.
         * @param {string} [action] Exact action key, e.g. &#x60;instance.delete&#x60;. Takes precedence over &#x60;category&#x60;.
         * @param {string} [targetType] Restrict to one resource type, e.g. &#x60;instance&#x60;.
         * @param {string} [targetId] Restrict to one resource id — the history of a single instance, zone or firewall.
         * @param {ListAccountActivityOutcomeEnum} [outcome] 
         * @param {string} [from] Only entries at or after this instant (ISO 8601).
         * @param {string} [to] Only entries at or before this instant (ISO 8601).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccountActivity(page?: number, pageSize?: number, search?: string, actorKind?: ListAccountActivityActorKindEnum, category?: ListAccountActivityCategoryEnum, action?: string, targetType?: string, targetId?: string, outcome?: ListAccountActivityOutcomeEnum, from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<ClientActivityListResponseDto> {
            return localVarFp.listAccountActivity(page, pageSize, search, actorKind, category, action, targetType, targetId, outcome, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List grantable scopes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApiTokenScopes(options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiScopeOptionDto>> {
            return localVarFp.listApiTokenScopes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List my API tokens
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApiTokens(options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiTokenSummaryDto>> {
            return localVarFp.listApiTokens(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all backups for VMs owned by the authenticated user
         * @summary List all backups for the authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBackups(options?: RawAxiosRequestConfig): AxiosPromise<Array<BackupEntity>> {
            return localVarFp.listBackups(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all backups for the specified VM
         * @summary List backups for a specific VM
         * @param {any} vmId VM ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBackupsByVm(vmId: any, options?: RawAxiosRequestConfig): AxiosPromise<Array<BackupEntity>> {
            return localVarFp.listBackupsByVm(vmId, options).then((request) => request(axios, basePath));
        },
        /**
         * Every ISO and disk image on the authenticated account.
         * @summary List my images
         * @param {ListClientImagesKindEnum} [kind] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listClientImages(kind?: ListClientImagesKindEnum, options?: RawAxiosRequestConfig): AxiosPromise<Array<ClientImageDto>> {
            return localVarFp.listClientImages(kind, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all DNS records for a zone
         * @param {string} id Domain record UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDnsRecords(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DnsRRsetDto>> {
            return localVarFp.listDnsRecords(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List DNS zones for the authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDnsZones(options?: RawAxiosRequestConfig): AxiosPromise<Array<DnsZoneDto>> {
            return localVarFp.listDnsZones(options).then((request) => request(axios, basePath));
        },
        /**
         * Get all available firewall macros with descriptions. Macros are predefined service configurations that can be used when creating firewall rules (e.g., HTTP, HTTPS, SSH).
         * @summary List firewall macros
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFirewallMacros(options?: RawAxiosRequestConfig): AxiosPromise<Array<FirewallMacroResponseDto>> {
            return localVarFp.listFirewallMacros(options).then((request) => request(axios, basePath));
        },
        /**
         * Get a paginated list of all firewalls. Supports filtering by name, enable status, and search query.
         * @summary List all firewalls
         * @param {string} [name] Filter by firewall name
         * @param {boolean} [enable] Filter by enabled status
         * @param {string} [search] Search term for name or description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFirewalls(name?: string, enable?: boolean, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<FirewallEntity>> {
            return localVarFp.listFirewalls(name, enable, search, options).then((request) => request(axios, basePath));
        },
        /**
         * List jobs created by the authenticated user, filterable by status, with pagination
         * @summary List jobs by status
         * @param {ListJobsStatusEnum} [status] &#x60;active&#x60; is a shorthand for pending + in_progress — what the console badge counts. Filtering by a single status cannot express it, and two round trips would report two moments in time.
         * @param {number} [page] Page number (1-based)
         * @param {number} [pageSize] Items per page (max 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listJobs(status?: ListJobsStatusEnum, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<JobsPageDto> {
            return localVarFp.listJobs(status, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List my referrals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyAffiliateReferrals(options?: RawAxiosRequestConfig): AxiosPromise<Array<AffiliateReferralDto>> {
            return localVarFp.listMyAffiliateReferrals(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List my withdrawals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyAffiliateWithdrawals(options?: RawAxiosRequestConfig): AxiosPromise<Array<WithdrawalDto>> {
            return localVarFp.listMyAffiliateWithdrawals(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List attachments on one of my withdrawals
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyWithdrawalAttachments(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<WithdrawalAttachmentDto>> {
            return localVarFp.listMyWithdrawalAttachments(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all IP addresses owned by the authenticated user with their reverse DNS state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRdnsIps(options?: RawAxiosRequestConfig): AxiosPromise<Array<IpRdnsDto>> {
            return localVarFp.listRdnsIps(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all backup schedules for VMs owned by the authenticated user
         * @summary List all backup schedules for the authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSchedules(options?: RawAxiosRequestConfig): AxiosPromise<Array<BackupScheduleEntity>> {
            return localVarFp.listSchedules(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Risk exceptions on the account
         * @param {boolean} [includeInactive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSecurityExceptions(includeInactive?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<SecurityExceptionListDto> {
            return localVarFp.listSecurityExceptions(includeInactive, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Findings across the account, ordered by risk
         * @param {number} [vmId] 
         * @param {ListSecurityFindingsSeverityEnum} [severity] 
         * @param {ListSecurityFindingsStatusEnum} [status] 
         * @param {string} [category] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSecurityFindings(vmId?: number, severity?: ListSecurityFindingsSeverityEnum, status?: ListSecurityFindingsStatusEnum, category?: string, search?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<SecurityFindingListDto> {
            return localVarFp.listSecurityFindings(vmId, severity, status, category, search, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * A hundred instances with the same ten problems is a thousand rows saying the same thing. Collapsed, each row is one fix that resolves every instance it lists.
         * @summary Open findings collapsed by rule, worst first
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSecurityFindingsByRule(options?: RawAxiosRequestConfig): AxiosPromise<Array<SecurityRuleGroupDto>> {
            return localVarFp.listSecurityFindingsByRule(options).then((request) => request(axios, basePath));
        },
        /**
         * The browsable counterpart to the overview, which returns only the worst five. Ordered by open criticals, then highs, then score — the list is meant to be worked from the top, not browsed alphabetically.
         * @summary Posture per instance, worst first
         * @param {string} [search] 
         * @param {string} [state] 
         * @param {any} [pageSize] 
         * @param {any} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSecurityInstances(search?: string, state?: string, pageSize?: any, page?: any, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.listSecurityInstances(search, state, pageSize, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Every site connected to this gateway
         * @param {string} gatewayId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSiteConnections(gatewayId: string, options?: RawAxiosRequestConfig): AxiosPromise<SiteConnectionListDto> {
            return localVarFp.listSiteConnections(gatewayId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all snapshots for a specific VM with quota information
         * @summary List all snapshots for a VM
         * @param {number} vmId VM ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSnapshots(vmId: number, options?: RawAxiosRequestConfig): AxiosPromise<SnapshotListResponseDto> {
            return localVarFp.listSnapshots(vmId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Scan history for one instance
         * @param {number} vmId Instance id
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVmSecurityScans(vmId: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<SecurityScanListDto> {
            return localVarFp.listVmSecurityScans(vmId, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Attack surface observed on one instance
         * @param {number} vmId Instance id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVmSecurityServices(vmId: number, options?: RawAxiosRequestConfig): AxiosPromise<SecurityServiceListDto> {
            return localVarFp.listVmSecurityServices(vmId, options).then((request) => request(axios, basePath));
        },
        /**
         * Authenticate a user with email and password.
         * @summary Login
         * @param {LoginDto} loginDto Client login data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(loginDto: LoginDto, options?: RawAxiosRequestConfig): AxiosPromise<Login200Response> {
            return localVarFp.login(loginDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Logout the authenticated user.
         * @summary Logout
         * @param {LogoutDto} logoutDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(logoutDto: LogoutDto, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.logout(logoutDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Clears the whole unread badge in one call. The console cannot do this by id list: it only holds the pages it has loaded, and older unread rows would stay unread forever.
         * @summary Mark every notification of the client as read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAllAsRead(options?: RawAxiosRequestConfig): AxiosPromise<MarkNotificationsReadResponseDto> {
            return localVarFp.markAllAsRead(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark notifications as read in batch
         * @param {MarkNotificationsReadDto} markNotificationsReadDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsRead(markNotificationsReadDto: MarkNotificationsReadDto, options?: RawAxiosRequestConfig): AxiosPromise<MarkNotificationsReadResponseDto> {
            return localVarFp.markAsRead(markNotificationsReadDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mine(options?: RawAxiosRequestConfig): AxiosPromise<PublicTrialDto> {
            return localVarFp.mine(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offer(code: string, options?: RawAxiosRequestConfig): AxiosPromise<PublicTrialDto> {
            return localVarFp.offer(code, options).then((request) => request(axios, basePath));
        },
        /**
         * Perform an operation (start, stop, reboot) on a VM and return a task ID for tracking.
         * @summary Perform VM Operation
         * @param {any} vmId ID of the VM to operate on
         * @param {VmOperationRequestDto} vmOperationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        performVmOperation(vmId: any, vmOperationRequestDto: VmOperationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<VmOperationResponseDto> {
            return localVarFp.performVmOperation(vmId, vmOperationRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * `shown` once a card has been on screen; `snoozed` for \"Not now\" (7 days); `dismissed` for \"Don\'t show again\"; `acted` when the call to action was followed. A support session is never recorded.
         * @summary Record what happened to a tip
         * @param {string} code 
         * @param {DiscoveryEventDto} discoveryEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordFeatureDiscoveryEvent(code: string, discoveryEventDto: DiscoveryEventDto, options?: RawAxiosRequestConfig): AxiosPromise<DiscoveryEventResultDto> {
            return localVarFp.recordFeatureDiscoveryEvent(code, discoveryEventDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Refresh the access and refresh tokens.
         * @summary Refresh Tokens
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshTokens(options?: RawAxiosRequestConfig): AxiosPromise<TokenDto> {
            return localVarFp.refreshTokens(options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new client in WHMCS.
         * @summary Register a new client
         * @param {AddClientDto} addClientDto Client registration data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register(addClientDto: AddClientDto, options?: RawAxiosRequestConfig): AxiosPromise<AddClientResponseDto> {
            return localVarFp.register(addClientDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Register a device for push notifications using FCM.
         * @summary Register FCM Device
         * @param {RegisterDeviceDto} registerDeviceDto Device registration details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerFcmDevice(registerDeviceDto: RegisterDeviceDto, options?: RawAxiosRequestConfig): AxiosPromise<RegisterDeviceResponseDto> {
            return localVarFp.registerFcmDevice(registerDeviceDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reinstall a VPN Gateway by performing full reinstallation
         * @param {string} id VPN Gateway ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reinstallVpnGateway(id: string, options?: RawAxiosRequestConfig): AxiosPromise<VpnGatewayApplyResponseDto> {
            return localVarFp.reinstallVpnGateway(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Resets the expiry to a full retention window from now.
         * @summary Extend an image’s retention
         * @param {string} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renewClientImage(imageId: string, options?: RawAxiosRequestConfig): AxiosPromise<ClientImageDto> {
            return localVarFp.renewClientImage(imageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} code 
         * @param {string} totalMicroCents Catalog simulation total for the selected configuration, in micro-cents.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renewal(code: string, totalMicroCents: string, options?: RawAxiosRequestConfig): AxiosPromise<TrialRenewalDto> {
            return localVarFp.renewal(code, totalMicroCents, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request a withdrawal
         * @param {RequestWithdrawalDto} requestWithdrawalDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAffiliateWithdrawal(requestWithdrawalDto: RequestWithdrawalDto, options?: RawAxiosRequestConfig): AxiosPromise<WithdrawalDto> {
            return localVarFp.requestAffiliateWithdrawal(requestWithdrawalDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Triggers WHMCS\'s native password-reset email (ResetPassword API). Always returns success regardless of whether the email exists, to avoid account enumeration.
         * @summary Request a password reset email
         * @param {ResetPasswordRequestDto} resetPasswordRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordReset(resetPasswordRequestDto: ResetPasswordRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ResetPasswordResponseDto> {
            return localVarFp.requestPasswordReset(resetPasswordRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Sends a new 6-digit code to the email associated with the challenge. Limited to 3 resends per challenge.
         * @summary Resend two-factor verification code
         * @param {ResendTwoFactorDto} resendTwoFactorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendTwoFactor(resendTwoFactorDto: ResendTwoFactorDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resendTwoFactor(resendTwoFactorDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reset the reverse DNS (PTR) record for an IPv4 address to the default platform value
         * @param {number} id IPv4 address record id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetIpv4Rdns(id: number, options?: RawAxiosRequestConfig): AxiosPromise<IpRdnsDto> {
            return localVarFp.resetIpv4Rdns(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reset the reverse DNS (PTR) record for an IPv6 address to the default platform value
         * @param {number} id IPv6 address record id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetIpv6Rdns(id: number, options?: RawAxiosRequestConfig): AxiosPromise<IpRdnsDto> {
            return localVarFp.resetIpv6Rdns(id, options).then((request) => request(axios, basePath));
        },
        /**
         *              Reset a user\'s password inside the VM using the QEMU guest agent.                          **Requirements:**             - QEMU guest agent must be installed and running in the VM             - The user must exist in the VM\'s operating system             - Password must be at least 8 characters long                          **Common use cases:**             - Reset root password when locked out             - Change user passwords without SSH access             - Automated password rotation         
         * @summary Reset user password
         * @param {number} vmId ID of the VM
         * @param {QemuAgentResetPasswordRequestDto} qemuAgentResetPasswordRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetUserPassword(vmId: number, qemuAgentResetPasswordRequestDto: QemuAgentResetPasswordRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<QemuAgentResetPasswordResponseDto> {
            return localVarFp.resetUserPassword(vmId, qemuAgentResetPasswordRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Initiates a restore operation to restore a VM from a backup. The VM will be overwritten with the backup data. This operation is asynchronous and returns a task ID for tracking.
         * @summary Restore a VM from a backup
         * @param {number} backupId Backup ID to restore from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreBackup(backupId: number, options?: RawAxiosRequestConfig): AxiosPromise<RestoreBackupResponseDto> {
            return localVarFp.restoreBackup(backupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Restore the VM to a previous snapshot state. WARNING: All snapshots newer than the target snapshot will be deleted.
         * @summary Restore VM from a snapshot
         * @param {number} vmId VM ID
         * @param {RestoreSnapshotDto} restoreSnapshotDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreSnapshot(vmId: number, restoreSnapshotDto: RestoreSnapshotDto, options?: RawAxiosRequestConfig): AxiosPromise<SnapshotOperationResponseDto> {
            return localVarFp.restoreSnapshot(vmId, restoreSnapshotDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Reports which parts have not arrived and returns fresh URLs for them. Safe to call at any point during an upload.
         * @summary Resume an upload
         * @param {string} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeClientImageUpload(imageId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResumeTicketDto> {
            return localVarFp.resumeClientImageUpload(imageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Show the key for this connection
         * @param {string} gatewayId 
         * @param {string} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revealSiteConnectionSecret(gatewayId: string, connectionId: string, options?: RawAxiosRequestConfig): AxiosPromise<SiteSecretDto> {
            return localVarFp.revealSiteConnectionSecret(gatewayId, connectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Revoke an API token
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeApiToken(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.revokeApiToken(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Revoke an exception; its findings return to open immediately
         * @param {string} exceptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeSecurityException(exceptionId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.revokeSecurityException(exceptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Revokes the token and issues a replacement with the same name and scopes.
         * @summary Roll an API token
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rollApiToken(id: string, options?: RawAxiosRequestConfig): AxiosPromise<MintedApiTokenDto> {
            return localVarFp.rollApiToken(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace the key for this connection
         * @param {string} gatewayId 
         * @param {string} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rotateSiteConnectionSecret(gatewayId: string, connectionId: string, options?: RawAxiosRequestConfig): AxiosPromise<SiteSecretDto> {
            return localVarFp.rotateSiteConnectionSecret(gatewayId, connectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Turn a connection off or back on
         * @param {string} gatewayId 
         * @param {string} connectionId 
         * @param {SiteConnectionEnabledRequestDto} siteConnectionEnabledRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSiteConnectionEnabled(gatewayId: string, connectionId: string, siteConnectionEnabledRequestDto: SiteConnectionEnabledRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SiteConnectionMutationDto> {
            return localVarFp.setSiteConnectionEnabled(gatewayId, connectionId, siteConnectionEnabledRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates the WHMCS client from the address + password step of a social signup, links the identity and signs the user in.
         * @summary Complete social registration
         * @param {CompleteSocialRegistrationDto} completeSocialRegistrationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        socialCompleteRegistration(completeSocialRegistrationDto: CompleteSocialRegistrationDto, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponseDto> {
            return localVarFp.socialCompleteRegistration(completeSocialRegistrationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Exchanges the single-use handoff code from the callback for the login result (token + client).
         * @summary Exchange social handoff code
         * @param {SocialHandoffExchangeDto} socialHandoffExchangeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        socialHandoffExchange(socialHandoffExchangeDto: SocialHandoffExchangeDto, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponseDto> {
            return localVarFp.socialHandoffExchange(socialHandoffExchangeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Provider redirect target. Processes the result and 302-redirects to the frontend callback page with a single-use handoff code, a registration ticket, a selection token, or an error.
         * @summary Social login callback
         * @param {string} provider 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        socialLoginCallback(provider: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.socialLoginCallback(provider, options).then((request) => request(axios, basePath));
        },
        /**
         * Redirects the browser to the social provider authorization endpoint.
         * @summary Start social login
         * @param {string} provider 
         * @param {string} deviceId 
         * @param {string} [redirect] 
         * @param {SocialLoginStartDisplayEnum} [display] popup relays to the browser opener; native returns through the fixed app URI and requires S256 proof.
         * @param {string} [nativeState] Native installation-generated state (43 base64url characters).
         * @param {string} [codeChallenge] S256 challenge generated on the native installation.
         * @param {SocialLoginStartCodeChallengeMethodEnum} [codeChallengeMethod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        socialLoginStart(provider: string, deviceId: string, redirect?: string, display?: SocialLoginStartDisplayEnum, nativeState?: string, codeChallenge?: string, codeChallengeMethod?: SocialLoginStartCodeChallengeMethodEnum, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.socialLoginStart(provider, deviceId, redirect, display, nativeState, codeChallenge, codeChallengeMethod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Redeem a native social callback with S256 proof
         * @param {NativeSocialExchangeDto} nativeSocialExchangeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        socialNativeExchange(nativeSocialExchangeDto: NativeSocialExchangeDto, options?: RawAxiosRequestConfig): AxiosPromise<NativeSocialResultDto> {
            return localVarFp.socialNativeExchange(nativeSocialExchangeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Complete a social multi-account login
         * @param {SelectSocialAccountDto} selectSocialAccountDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        socialSelectAccount(selectSocialAccountDto: SelectSocialAccountDto, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponseDto> {
            return localVarFp.socialSelectAccount(selectSocialAccountDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List accounts for a social multi-account login
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        socialSelectionAccounts(token: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<LoginAccountOptionDto>> {
            return localVarFp.socialSelectionAccounts(token, options).then((request) => request(axios, basePath));
        },
        /**
         * Reserves storage and returns one presigned URL per part. Upload the parts directly, then call the complete endpoint.
         * @summary Start an upload
         * @param {StartClientImageUploadDto} startClientImageUploadDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startClientImageUpload(startClientImageUploadDto: StartClientImageUploadDto, options?: RawAxiosRequestConfig): AxiosPromise<UploadTicketDto> {
            return localVarFp.startClientImageUpload(startClientImageUploadDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start a scan of one instance now
         * @param {number} vmId Instance id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startVmSecurityScan(vmId: number, options?: RawAxiosRequestConfig): AxiosPromise<SecurityScanStartedDto> {
            return localVarFp.startVmSecurityScan(vmId, options).then((request) => request(axios, basePath));
        },
        /**
         * Records a rating (with optional comment/reasons and a context snapshot). Re-rating the same subject updates the prior entry.
         * @summary Submit feedback
         * @param {SubmitFeedbackDto} submitFeedbackDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitFeedback(submitFeedbackDto: SubmitFeedbackDto, options?: RawAxiosRequestConfig): AxiosPromise<SubmitFeedbackResultDto> {
            return localVarFp.submitFeedback(submitFeedbackDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Rename an image or change its hardware profile
         * @param {string} imageId 
         * @param {UpdateClientImageDto} updateClientImageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientImage(imageId: string, updateClientImageDto: UpdateClientImageDto, options?: RawAxiosRequestConfig): AxiosPromise<ClientImageDto> {
            return localVarFp.updateClientImage(imageId, updateClientImageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Applies to the NEXT deploy or reinstall from this image; running instances are untouched. Refused with the list of problems when the document has errors, and refused entirely unless the image is marked as having cloud-init installed. Send null to remove it.
         * @summary Set or clear this image’s cloud-init user data
         * @param {string} imageId 
         * @param {UpdateClientImageCloudInitDto} updateClientImageCloudInitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientImageCloudInit(imageId: string, updateClientImageCloudInitDto: UpdateClientImageCloudInitDto, options?: RawAxiosRequestConfig): AxiosPromise<ClientImageCloudInitDto> {
            return localVarFp.updateClientImageCloudInit(imageId, updateClientImageCloudInitDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Update firewall configuration including name, description, enable status, or default policies (policy_in/policy_out). Only fields provided in the request body will be updated.
         * @summary Update firewall
         * @param {any} firewallId Unique identifier of the firewall
         * @param {UpdateFirewallDto} updateFirewallDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFirewall(firewallId: any, updateFirewallDto: UpdateFirewallDto, options?: RawAxiosRequestConfig): AxiosPromise<FirewallEntity> {
            return localVarFp.updateFirewall(firewallId, updateFirewallDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing firewall rule. Any information omitted from the payload will be cleared (set to null/empty) on the record.
         * @summary Update firewall rule
         * @param {string} ruleId Unique identifier of the rule to update
         * @param {any} firewallId Unique identifier of the firewall
         * @param {UpdateFirewallRuleDto} updateFirewallRuleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFirewallRule(ruleId: string, firewallId: any, updateFirewallRuleDto: UpdateFirewallRuleDto, options?: RawAxiosRequestConfig): AxiosPromise<FirewallRuleEntity> {
            return localVarFp.updateFirewallRule(ruleId, firewallId, updateFirewallRuleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the reverse DNS (PTR) record for an IPv4 address
         * @param {number} id IPv4 address record id
         * @param {UpdateRdnsDto} updateRdnsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIpv4Rdns(id: number, updateRdnsDto: UpdateRdnsDto, options?: RawAxiosRequestConfig): AxiosPromise<IpRdnsDto> {
            return localVarFp.updateIpv4Rdns(id, updateRdnsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the reverse DNS (PTR) record for an IPv6 address
         * @param {number} id IPv6 address record id
         * @param {UpdateRdnsDto} updateRdnsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIpv6Rdns(id: number, updateRdnsDto: UpdateRdnsDto, options?: RawAxiosRequestConfig): AxiosPromise<IpRdnsDto> {
            return localVarFp.updateIpv6Rdns(id, updateRdnsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Turn scanning on or off for the account, or change notifications
         * @param {UpdateSecuritySettingsDto} updateSecuritySettingsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSecuritySettings(updateSecuritySettingsDto: UpdateSecuritySettingsDto, options?: RawAxiosRequestConfig): AxiosPromise<SecuritySettingsDto> {
            return localVarFp.updateSecuritySettings(updateSecuritySettingsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change a connection
         * @param {string} gatewayId 
         * @param {string} connectionId 
         * @param {SiteConnectionRequestDto} siteConnectionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSiteConnection(gatewayId: string, connectionId: string, siteConnectionRequestDto: SiteConnectionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SiteConnectionMutationDto> {
            return localVarFp.updateSiteConnection(gatewayId, connectionId, siteConnectionRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the name and/or description of a VM.
         * @summary Update VM name and description
         * @param {any} vmId ID of the VM
         * @param {UpdateVmDto} updateVmDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVm(vmId: any, updateVmDto: UpdateVmDto, options?: RawAxiosRequestConfig): AxiosPromise<VmEntity> {
            return localVarFp.updateVm(vmId, updateVmDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Change disk interface type, NIC model, and/or OS type for all devices on the VM. Changing the disk interface type requires the VM to be powered off.
         * @summary Update VM hardware configuration
         * @param {number} vmId VM ID
         * @param {UpdateVmHardwareDto} updateVmHardwareDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVmHardware(vmId: number, updateVmHardwareDto: UpdateVmHardwareDto, options?: RawAxiosRequestConfig): AxiosPromise<UpdateVmHardware200Response> {
            return localVarFp.updateVmHardware(vmId, updateVmHardwareDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Turn scanning on or off for one instance, or change its schedule
         * @param {number} vmId Instance id
         * @param {UpdateVmSecuritySettingsDto} updateVmSecuritySettingsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVmSecuritySettings(vmId: number, updateVmSecuritySettingsDto: UpdateVmSecuritySettingsDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateVmSecuritySettings(vmId, updateVmSecuritySettingsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Update multiple VMs in a VPC. Empty array removes all VMs.
         * @summary Update VMs in a VPC
         * @param {UpdateVpcVmsDto} updateVpcVmsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVpcVms(updateVpcVmsDto: UpdateVpcVmsDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<VpcVmsEntity>> {
            return localVarFp.updateVpcVms(updateVpcVmsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a VPN Gateway
         * @param {string} id VPN Gateway ID
         * @param {UpdateVpnGatewayDto} updateVpnGatewayDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVpnGateway(id: string, updateVpnGatewayDto: UpdateVpnGatewayDto, options?: RawAxiosRequestConfig): AxiosPromise<VpnGatewayDto> {
            return localVarFp.updateVpnGateway(id, updateVpnGatewayDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a VPN user
         * @param {string} id VPN User ID
         * @param {UpdateVpnUserDto} updateVpnUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVpnUser(id: string, updateVpnUserDto: UpdateVpnUserDto, options?: RawAxiosRequestConfig): AxiosPromise<VpnUserDto> {
            return localVarFp.updateVpnUser(id, updateVpnUserDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update this gateway
         * @param {string} id VPN Gateway ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upgradeAppliance(id: string, options?: RawAxiosRequestConfig): AxiosPromise<VpnApplianceUpgradeDto> {
            return localVarFp.upgradeAppliance(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Attach a payout-evidence file to one of my withdrawals
         * @param {string} id 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadMyWithdrawalAttachment(id: string, file: File, options?: RawAxiosRequestConfig): AxiosPromise<WithdrawalAttachmentDto> {
            return localVarFp.uploadMyWithdrawalAttachment(id, file, options).then((request) => request(axios, basePath));
        },
        /**
         * What the editor calls while the customer types, so the problems appear beside the document rather than after a refused save.
         * @summary Check cloud-init user data without saving it
         * @param {string} imageId 
         * @param {ValidateClientImageCloudInitDto} validateClientImageCloudInitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateClientImageCloudInit(imageId: string, validateClientImageCloudInitDto: ValidateClientImageCloudInitDto, options?: RawAxiosRequestConfig): AxiosPromise<ClientImageCloudInitValidationDto> {
            return localVarFp.validateClientImageCloudInit(imageId, validateClientImageCloudInitDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check a connection before creating it
         * @param {string} gatewayId 
         * @param {SiteConnectionRequestDto} siteConnectionRequestDto 
         * @param {string} [connectionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateSiteConnection(gatewayId: string, siteConnectionRequestDto: SiteConnectionRequestDto, connectionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<SiteValidationDto> {
            return localVarFp.validateSiteConnection(gatewayId, siteConnectionRequestDto, connectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Check whether the origin → destination pair satisfies all clone requirements, including clone source selection and storage availability.
         * @summary Validate clone eligibility
         * @param {number} originVmId DB id of the origin (source) VM
         * @param {number} destinationVmId DB id of the destination VM
         * @param {ValidateVmCloneSourceTypeEnum} sourceType Whether to clone the current VM state or restore from an existing backup.
         * @param {number} [backupId] Existing backup ID to use when sourceType&#x3D;existing_backup.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateVmClone(originVmId: number, destinationVmId: number, sourceType: ValidateVmCloneSourceTypeEnum, backupId?: number, options?: RawAxiosRequestConfig): AxiosPromise<CloneValidationResponseDto> {
            return localVarFp.validateVmClone(originVmId, destinationVmId, sourceType, backupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Submits the 6-digit code sent to the user\'s email during login to complete authentication.
         * @summary Verify two-factor authentication code
         * @param {VerifyTwoFactorDto} verifyTwoFactorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyTwoFactor(verifyTwoFactorDto: VerifyTwoFactorDto, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponseDto> {
            return localVarFp.verifyTwoFactor(verifyTwoFactorDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MwApi - object-oriented interface
 * @export
 * @class MwApi
 * @extends {BaseAPI}
 */
export class MwApi extends BaseAPI {
    /**
     * 
     * @summary Cancel an upload
     * @param {string} imageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public abortClientImageUpload(imageId: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).abortClientImageUpload(imageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a DNS record to a zone
     * @param {string} id Domain record UUID
     * @param {CreateRecordDto} createRecordDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public addDnsRecord(id: string, createRecordDto: CreateRecordDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).addDnsRecord(id, createRecordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a new rule to the firewall. Rules can be created using: • **Macros**: Predefined service configurations (e.g., HTTP, HTTPS, SSH) • **Manual configuration**: Specify protocol, ports, and other parameters  **Important**: Use either macros OR manual configuration, not both.
     * @summary Add firewall rule
     * @param {any} firewallId Unique identifier of the firewall
     * @param {AddFirewallRuleDto} addFirewallRuleDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public addFirewallRule(firewallId: any, addFirewallRuleDto: AddFirewallRuleDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).addFirewallRule(firewallId, addFirewallRuleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a VM to a VPC for the authenticated client.
     * @summary Add VM to VPC
     * @param {AddVmToVpcDto} addVmToVpcDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public addVmToVpc(addVmToVpcDto: AddVmToVpcDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).addVmToVpc(addVmToVpcDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a user to a VPN Gateway
     * @param {string} id VPN Gateway ID
     * @param {AddVpnUserDto} addVpnUserDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public addVpnUser(id: string, addVpnUserDto: AddVpnUserDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).addVpnUser(id, addVpnUserDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public allowance(id: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).allowance(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Apply a VPN gateway\'s pending changes
     * @param {string} id VPN Gateway ID
     * @param {ApplyChangesDto} applyChangesDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public applyChanges(id: string, applyChangesDto: ApplyChangesDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).applyChanges(id, applyChangesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mounts the ISO as a CD-ROM and makes it the first boot device. The instance’s power state is preserved.
     * @summary Attach an ISO to an instance
     * @param {string} imageId 
     * @param {number} vmId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public attachClientImage(imageId: string, vmId: number, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).attachClientImage(imageId, vmId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Apply a resize: change billing rate, generate temporary credit on downgrade, reconcile infrastructure
     * @param {number} vmId Instance (VM) id
     * @param {ResizeTargetDto} resizeTargetDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public billingApplyResize(vmId: number, resizeTargetDto: ResizeTargetDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).billingApplyResize(vmId, resizeTargetDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Voids an OPEN top-up invoice of this subscription at the payment provider. Only TOPUP invoices can be cancelled here — renewal and debt invoices are obligations, and checkout, reschedule, move, transfer and conversion invoices belong to the operation that raised them. Refused with 409 when the provider already reports the invoice paid. A payment that clears at the bank after the cancellation is still credited to the balance.
     * @summary Cancel an unpaid top-up invoice
     * @param {string} id Subscription UUID
     * @param {string} externalId Provider invoice id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public billingCancelTopupInvoice(id: string, externalId: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).billingCancelTopupInvoice(id, externalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Booleans only — used by checkout to avoid offering an IP type the datacenter has none of. Inventory counts are intentionally never exposed. Public.
     * @summary Whether IPv4/IPv6 can be allocated in a datacenter
     * @param {number} datacenterId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public billingCatalogIpAvailability(datacenterId: number, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).billingCatalogIpAvailability(datacenterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Customer-facing location list for the configurator: name, region, flag asset, whether placement is currently possible, and whether each IP family can be allocated. Public.  This is deliberately NOT `GET /datacenters`, which is authenticated and answers with the datacenter entity including its clusters — hypervisor topology that has no business on a public surface.
     * @summary List the locations the checkout can deploy into
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public billingCatalogLocations(options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).billingCatalogLocations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a priced line-item breakdown for the given offering + addons + OS + disks + term. Applies free quotas (IPv4/IPv6) and OS filters. Public — the order endpoint requires auth.  Pass `compare_term` to price the same configuration on a second term and receive it as `comparison`, which is how the checkout shows what committing saves without issuing a second request.
     * @summary Simulate price for a checkout configuration
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public billingCatalogSimulate(body: object, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).billingCatalogSimulate(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the full visible catalog: offerings, addons, billing terms and rates currently in effect. Public.
     * @summary Get billing catalog snapshot
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public billingCatalogSnapshot(options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).billingCatalogSnapshot(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export the period ledger as CSV
     * @param {string} id Subscription UUID
     * @param {string} [from] ISO date-time
     * @param {string} [to] ISO date-time
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public billingExportSubscriptionLedgerCsv(id: string, from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).billingExportSubscriptionLedgerCsv(id, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Computes the next cycle-close renewal exactly as the close will (committed resources × term cap hours, minus the recurring coupon) and how much of it the current available balance already covers. Available balance is applied to the renewal at invoice issuance (RENEWAL_CREDIT_APPLIED), and balance that lands AFTER issuance settles the open renewal invoice once it covers it in full — so prepaying is a top-up tagged RENEWAL_PREPAY for the suggested amount. When the renewal invoice is already open, open_renewal_invoice.shortfall_cents is the top-up that settles it.
     * @summary Preview the next renewal for prepayment (\"Antecipar renovação\")
     * @param {string} id Subscription UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public billingGetRenewalPreview(id: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).billingGetRenewalPreview(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Current instance configuration, available plans/addons and balance for the resize wizard
     * @param {number} vmId Instance (VM) id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public billingGetResizeContext(vmId: number, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).billingGetResizeContext(vmId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a single subscription with balance and active resources
     * @param {string} id Subscription UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public billingGetSubscription(id: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).billingGetSubscription(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the pending cancellation request for a subscription, if any
     * @param {string} id Subscription UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public billingGetSubscriptionCancellation(id: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).billingGetSubscriptionCancellation(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Newest first: what was removed, how long it was on the subscription, what it was billed in total and the temporary credit its removal returned, as the ledger recorded it. A service moved to another subscription is not listed — it is still billed, there.
     * @summary Services this subscription billed and no longer does
     * @param {string} id Subscription UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public billingGetSubscriptionEndedResources(id: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).billingGetSubscriptionEndedResources(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Invoices generated for a subscription, with payment events
     * @param {string} id Subscription UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public billingGetSubscriptionInvoices(id: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).billingGetSubscriptionInvoices(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Every credit and debit applied to the subscription, newest first. Each entry carries its bucket, reason, and reference. Use `cursor` for the next page.
     * @summary Paginated balance-ledger statement (full audit trail) for a subscription
     * @param {string} id Subscription UUID
     * @param {number} [limit] 
     * @param {string} [cursor] 
     * @param {BillingGetSubscriptionLedgerBucketEnum} [bucket] 
     * @param {BillingGetSubscriptionLedgerReasonEnum} [reason] 
     * @param {string} [from] ISO date-time
     * @param {string} [to] ISO date-time
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public billingGetSubscriptionLedger(id: string, limit?: number, cursor?: string, bucket?: BillingGetSubscriptionLedgerBucketEnum, reason?: BillingGetSubscriptionLedgerReasonEnum, from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).billingGetSubscriptionLedger(id, limit, cursor, bucket, reason, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Usage and credit forecast (estimates, not payment deadlines)
     * @param {string} id Subscription UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public billingGetSubscriptionProjection(id: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).billingGetSubscriptionProjection(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Active resources with hourly rate and commitment-cap progress
     * @param {string} id Subscription UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public billingGetSubscriptionResources(id: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).billingGetSubscriptionResources(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Opening and closing usable balance for the window and the signed total of every ledger reason in between. Closing always equals opening + net change.
     * @summary Period reconciliation: opening/closing usable balance + totals by reason
     * @param {string} id Subscription UUID
     * @param {string} [from] ISO date-time
     * @param {string} [to] ISO date-time
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public billingGetSubscriptionStatementSummary(id: string, from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).billingGetSubscriptionStatementSummary(id, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Suspension/resume history for a subscription
     * @param {string} id Subscription UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public billingGetSubscriptionSuspensions(id: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).billingGetSubscriptionSuspensions(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Daily spend and per-kind breakdown sourced from the metering hypertable. Defaults to the current cycle when no range is given.
     * @summary Hourly consumption history aggregated by day and resource kind
     * @param {string} id Subscription UUID
     * @param {string} [from] ISO date-time
     * @param {string} [to] ISO date-time
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public billingGetSubscriptionUsage(id: string, from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).billingGetSubscriptionUsage(id, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Drill-down audit view: every billed hour with the exact resources, rates, seconds and cap status that made up the charge. Defaults to the current cycle.
     * @summary Hourly consumption with the per-resource line items composing each hour
     * @param {string} id Subscription UUID
     * @param {string} [from] ISO date-time
     * @param {string} [to] ISO date-time
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public billingGetSubscriptionUsageHourly(id: string, from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).billingGetSubscriptionUsageHourly(id, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Open invoices first, then settled ones newest-first. Pass `status` (comma-separated: OPEN,PAID,CANCELLED,REFUNDED) to filter — e.g. `status=OPEN` for outstanding invoices only. To pay an OPEN invoice, SSO the user into WHMCS at `viewinvoice.php?id=<external_id>` via `GET /whmcs/sso`.
     * @summary List provider invoices across every subscription of the account
     * @param {string} [status] Comma-separated invoice statuses to include. Defaults to all.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public billingListAccountInvoices(status?: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).billingListAccountInvoices(status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Defaults to active and suspended subscriptions. Pass `status` (comma-separated) to override, e.g. `status=inactive` to review parked subscriptions or `status=active,suspended,inactive` for everything but cancelled.
     * @summary List subscriptions with balance for the authenticated user
     * @param {string} [status] Comma-separated subscription statuses to include. Defaults to active,suspended.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public billingListSubscriptions(status?: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).billingListSubscriptions(status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Only CREDIT_TOPUP coupons are accepted. The discount lowers the payable invoice amount; when the invoice is paid the full nominal top-up (paid + coupon grant) is credited to balance_available as two ledger entries with distinct reasons (RECHARGE, TOPUP_COUPON_CREDIT) for cash-vs-subsidy auditing.
     * @summary Preview a one-time top-up coupon for a subscription recharge
     * @param {string} id Subscription UUID
     * @param {TopupCouponPreviewBodyDto} topupCouponPreviewBodyDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public billingPreviewTopupCoupon(id: string, topupCouponPreviewBodyDto: TopupCouponPreviewBodyDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).billingPreviewTopupCoupon(id, topupCouponPreviewBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Price a resize and report impact, removed items and flag violations (no changes applied)
     * @param {number} vmId Instance (VM) id
     * @param {ResizeTargetDto} resizeTargetDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public billingQuoteResize(vmId: number, resizeTargetDto: ResizeTargetDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).billingQuoteResize(vmId, resizeTargetDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Stops recurring billing at the end of the current cycle: no renewal invoice is issued, and every instance and VPN gateway under the subscription is terminated when the cycle closes (immediately for ON_DEMAND subscriptions, which have no cycle). The request can be withdrawn at any time before execution. The exit survey is required in FULL — both the reason and the free-text answer to the follow-up question that reason raises.
     * @summary Schedule the subscription for cancellation at the end of the current cycle
     * @param {string} id Subscription UUID
     * @param {RequestCancellationBodyDto} requestCancellationBodyDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public billingRequestSubscriptionCancellation(id: string, requestCancellationBodyDto: RequestCancellationBodyDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).billingRequestSubscriptionCancellation(id, requestCancellationBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Runs the same settlement the platform runs on every credit landing and hourly: when the available balance covers an open renewal invoice in full, the commitment is funded from the balance and the invoice is cancelled (never marked paid — the cash already arrived on the top-up). Nothing is applied when the balance falls short; the response then names the shortfall.
     * @summary Settle the open renewal invoice from the subscription balance now
     * @param {string} id Subscription UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public billingSettleRenewalFromBalance(id: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).billingSettleRenewalFromBalance(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generates a WHMCS invoice for the requested amount. The invoice URL is returned so the client can open it in a new tab. When paid, the reconciler credits balance_available.
     * @summary Create a top-up invoice (WHMCS) to add credits to a subscription
     * @param {string} id Subscription UUID
     * @param {TopupBodyDto} topupBodyDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public billingTopupSubscription(id: string, topupBodyDto: TopupBodyDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).billingTopupSubscription(id, topupBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sets or clears the user-facing display name used to identify the subscription across the console.
     * @summary Update subscription settings (display name)
     * @param {string} id Subscription UUID
     * @param {UpdateSubscriptionDto} updateSubscriptionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public billingUpdateSubscription(id: string, updateSubscriptionDto: UpdateSubscriptionDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).billingUpdateSubscription(id, updateSubscriptionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Only possible while the request is still pending — once the cycle has closed and the services were terminated, the cancellation is final.
     * @summary Withdraw the pending cancellation request (renewal resumes)
     * @param {string} id Subscription UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public billingWithdrawSubscriptionCancellation(id: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).billingWithdrawSubscriptionCancellation(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update multiple firewall rules in a single request. Accepts the same fields as the single rule update endpoint for each rule.
     * @summary Bulk update firewall rules
     * @param {any} firewallId Unique identifier of the firewall
     * @param {BulkUpdateFirewallRulesDto} bulkUpdateFirewallRulesDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public bulkUpdateFirewallRules(firewallId: any, bulkUpdateFirewallRulesDto: BulkUpdateFirewallRulesDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).bulkUpdateFirewallRules(firewallId, bulkUpdateFirewallRulesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *              Check if the QEMU guest agent is running and responding in the VM.                          **Use cases:**             - Verify guest agent is installed before attempting operations             - Monitor guest agent health             - Troubleshoot guest agent connectivity issues                          **Note:** This endpoint returns a 200 status code even if the agent             is not running. Check the \'is_running\' field in the response to             determine the actual agent status.         
     * @summary Check QEMU guest agent status
     * @param {number} vmId ID of the VM
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public checkAgentStatus(vmId: number, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).checkAgentStatus(vmId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check if a domain NS records point to our nameservers
     * @param {string} id Domain record UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public checkDnsZoneHealth(id: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).checkDnsZoneHealth(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Identifier-first signup helper: lets the registration form detect an existing account before collecting the rest of the details, so the user can be routed to login. Fails open (returns exists=false) on lookup errors — the final register still guards with 409.
     * @summary Check whether an email already has an account
     * @param {CheckEmailDto} checkEmailDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public checkRegistrationEmail(checkEmailDto: CheckEmailDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).checkRegistrationEmail(checkEmailDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns whether the VM is eligible for backups and the number of backup slots available
     * @summary Check VM backup eligibility
     * @param {any} vmId VM ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public checkVmBackupEligibility(vmId: any, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).checkVmBackupEligibility(vmId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * In production this is invoked by the payment-reconciler when the InvoiceProvider reports the linked invoice as paid. Kept here so the end-to-end checkout flow is exercisable manually.
     * @summary Confirm a checkout v2 order (admin / test path)
     * @param {string} id Order ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public checkoutV2ConfirmOrder(id: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).checkoutV2ConfirmOrder(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Re-runs the price simulation server-side and returns one of three outcomes: • **provisioned** — existing subscription had enough balance for the prorata (its cost to the end of the current cycle); resource attached immediately. • **pending_payment** — invoice created in WHMCS, resource provisioned on payment. A new COMMITTED subscription is billed the full term. A new ON_DEMAND subscription invoices initial_credit_cents (defaulting to the catalog initial minimum), credited entirely to available balance for hourly usage without a renewal cycle. An add to an existing COMMITTED subscription whose balance is short is billed the prorata NET of that balance (`balanceAppliedCents`), which is drawn when the invoice is paid — never below the minimum recharge, the difference (`minimumRechargeCreditCents`) staying as credit. • **requires_topup** — existing subscription lacks balance; no order created.   Client should POST /billing/subscriptions/:id/topup for the shortfall, then retry.
     * @summary Create a checkout v2 order
     * @param {CreateOrderDto} createOrderDto 
     * @param {string} [idempotencyKey] A unique, client-generated string (8–255 chars of [A-Za-z0-9._:-]; a UUID is ideal) that makes this call safe to send twice. A retry carrying the same key replays the first answer instead of placing a second order, and comes back with &#x60;Idempotency-Replayed: true&#x60;.  The key covers the request BODY as well: reusing one for a different configuration is refused with a 409 rather than silently answered with the old order. Mint a new key whenever what is being bought changes.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public checkoutV2CreateOrder(createOrderDto: CreateOrderDto, idempotencyKey?: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).checkoutV2CreateOrder(createOrderDto, idempotencyKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Backs the checkout \"waiting for payment\" panel: safe to poll, never advances the order. Pass `refresh=true` on an explicit \"I already paid\" click to ask the invoice provider out of band of the reconciler tick — that leg is rate-limited per invoice, and `checked_provider` reports whether it actually ran.
     * @summary Where a placed order stands (payment + provisioning)
     * @param {string} id Order ID (UUID)
     * @param {boolean} [refresh] Ask the invoice provider about the linked invoice before answering (rate-limited per invoice).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public checkoutV2GetOrderPaymentState(id: string, refresh?: boolean, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).checkoutV2GetOrderPaymentState(id, refresh, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns subscriptions for the authenticated account with their current balance so the checkout wizard can let the customer pick a target subscription or start a new one.
     * @summary List active subscriptions available for adding a new resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public checkoutV2ListSubscriptions(options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).checkoutV2ListSubscriptions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the gross cycle total of the service being ordered, the recurring discount its coupon takes off, and the payable amount. A coupon is bound to the SERVICE the order creates and discounts that service on every renewal; a service added to the subscription later is billed at list price. Fixed-value coupons come off the service total, never off a product price.
     * @summary Preview a recurring coupon for the service being ordered
     * @param {CheckoutCouponPreviewBodyDto} checkoutCouponPreviewBodyDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public checkoutV2PreviewCoupon(checkoutCouponPreviewBodyDto: CheckoutCouponPreviewBodyDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).checkoutV2PreviewCoupon(checkoutCouponPreviewBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Apply firewall configuration and rules to the specified VMs. This asynchronous operation: • Applies all firewall rules to the target VMs • Updates firewall policies on the VMs • Automatically removes firewall rules from VMs no longer assigned • Returns a job ID for tracking the operation progress  **Note**: Changes are not applied to VMs until this endpoint is called.
     * @summary Commit firewall rules to VMs
     * @param {any} firewallId Unique identifier of the firewall
     * @param {CommitFirewallDto} commitFirewallDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public commitFirewall(firewallId: any, commitFirewallDto: CommitFirewallDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).commitFirewall(firewallId, commitFirewallDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Seals the upload and starts checking and preparing the image. Returns the id of the job to follow.
     * @summary Finish an upload
     * @param {string} imageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public completeClientImageUpload(imageId: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).completeClientImageUpload(imageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the plaintext token once — it cannot be retrieved later.
     * @summary Create an API token
     * @param {CreateApiTokenDto} createApiTokenDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public createApiToken(createApiTokenDto: CreateApiTokenDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).createApiToken(createApiTokenDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new DNS zone
     * @param {CreateZoneDto} createZoneDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public createDnsZone(createZoneDto: CreateZoneDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).createDnsZone(createZoneDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new firewall configuration with default policies. The firewall will be created with the specified input and output policies.
     * @summary Create a new firewall
     * @param {CreateFirewallDto} createFirewallDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public createFirewall(createFirewallDto: CreateFirewallDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).createFirewall(createFirewallDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new backup schedule for a VM or updates an existing one
     * @summary Create or update a backup schedule
     * @param {CreateBackupScheduleDto} createBackupScheduleDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public createSchedule(createBackupScheduleDto: CreateBackupScheduleDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).createSchedule(createBackupScheduleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Accept a risk, with a justification and an expiry date
     * @param {CreateSecurityExceptionDto} createSecurityExceptionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public createSecurityException(createSecurityExceptionDto: CreateSecurityExceptionDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).createSecurityException(createSecurityExceptionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Connect another site to this gateway
     * @param {string} gatewayId 
     * @param {SiteConnectionRequestDto} siteConnectionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public createSiteConnection(gatewayId: string, siteConnectionRequestDto: SiteConnectionRequestDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).createSiteConnection(gatewayId, siteConnectionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new snapshot for the VM. Snapshots expire after 30 days. You can optionally include RAM state for a complete running state snapshot.
     * @summary Create a new snapshot
     * @param {number} vmId VM ID
     * @param {CreateSnapshotDto} createSnapshotDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public createSnapshot(vmId: number, createSnapshotDto: CreateSnapshotDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).createSnapshot(vmId, createSnapshotDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a Single Sign-On (SSO) token for the authenticated user.
     * @summary Create SSO Token
     * @param {string} [path] Optional path parameter to customize SSO token creation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public createSsoToken(path?: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).createSsoToken(path, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new VPC for the authenticated client.
     * @summary Create a new VPC
     * @param {VpcCreateDto} vpcCreateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public createVpc(vpcCreateDto: VpcCreateDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).createVpc(vpcCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new VPN Gateway
     * @param {CreateVpnGatewayDto} createVpnGatewayDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public createVpnGateway(createVpnGatewayDto: CreateVpnGatewayDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).createVpnGateway(createVpnGatewayDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mint a short-lived token that can be used only to authenticate Socket.IO connections.
     * @summary Create WebSocket token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public createWebsocketToken(options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).createWebsocketToken(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a backup
     * @summary Delete a backup
     * @param {number} backupId Backup ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public deleteBackup(backupId: number, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).deleteBackup(backupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Removes the artifact, every hypervisor copy of it, and ejects it from any instance booting it. Instances already built from it are unaffected.
     * @summary Delete an image
     * @param {string} imageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public deleteClientImage(imageId: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).deleteClientImage(imageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a DNS record from a zone
     * @param {string} id Domain record UUID
     * @param {DeleteRecordDto} deleteRecordDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public deleteDnsRecord(id: string, deleteRecordDto: DeleteRecordDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).deleteDnsRecord(id, deleteRecordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a DNS zone and all its records
     * @param {string} id Domain record UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public deleteDnsZone(id: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).deleteDnsZone(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Asynchronously delete a firewall and clean up all associated resources. This operation: • Removes firewall rules from all assigned VMs • Sets VM firewall policies to ALLOW • Deletes the firewall configuration • Returns a job ID for tracking the asynchronous operation
     * @summary Delete firewall
     * @param {any} firewallId Unique identifier of the firewall to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public deleteFirewall(firewallId: any, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).deleteFirewall(firewallId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Permanently delete a firewall rule.
     * @summary Delete firewall rule
     * @param {string} ruleId Unique identifier of the rule to delete
     * @param {any} firewallId Unique identifier of the firewall
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public deleteFirewallRule(ruleId: string, firewallId: any, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).deleteFirewallRule(ruleId, firewallId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove an attachment from one of my PENDING withdrawals
     * @param {string} id 
     * @param {string} attachmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public deleteMyWithdrawalAttachment(id: string, attachmentId: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).deleteMyWithdrawalAttachment(id, attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a backup schedule (soft delete)
     * @summary Delete a backup schedule
     * @param {number} scheduleId Schedule ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public deleteSchedule(scheduleId: number, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).deleteSchedule(scheduleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Disconnect a site
     * @param {string} gatewayId 
     * @param {string} connectionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public deleteSiteConnection(gatewayId: string, connectionId: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).deleteSiteConnection(gatewayId, connectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a specific snapshot. Validates that the snapshot belongs to a VM owned by the authenticated user.
     * @summary Delete a snapshot
     * @param {string} snapshotId Snapshot ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public deleteSnapshot(snapshotId: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).deleteSnapshot(snapshotId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Terminate a VM instance, release its IP assignments, soft-delete the VM record, and stop future billing for linked resources.
     * @summary Delete VM
     * @param {any} vmId ID of the VM to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public deleteVm(vmId: any, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).deleteVm(vmId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a VPC by its ID.
     * @summary Delete a VPC
     * @param {number} vpcId ID of the VPC to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public deleteVpc(vpcId: number, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).deleteVpc(vpcId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a VPN user
     * @param {string} id VPN User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public deleteVpnUser(id: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).deleteVpnUser(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Rebuilds the instance from a disk image the customer uploaded. The instance keeps its addresses and its plan; everything on its disk is replaced. Refused when the plan’s disk is smaller than the image needs — a reinstall cannot grow a disk, so it must be resized first.
     * @summary Reinstall an instance from one of my images
     * @param {string} imageId ID of the customer image
     * @param {any} vmId ID of the instance to rebuild
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public deployVmFromClientImage(imageId: string, vmId: any, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).deployVmFromClientImage(imageId, vmId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deploy a VM from a template.
     * @summary Deploy VM from template
     * @param {number} templateId ID of the template to deploy from
     * @param {any} vmId ID of the VM to deploy
     * @param {DeployVmDto} [deployVmDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public deployVmFromTemplate(templateId: number, vmId: any, deployVmDto?: DeployVmDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).deployVmFromTemplate(templateId, vmId, deployVmDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Eject an ISO
     * @param {string} imageId 
     * @param {number} vmId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public detachClientImage(imageId: string, vmId: number, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).detachClientImage(imageId, vmId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download an attachment on one of my withdrawals
     * @param {string} id 
     * @param {string} attachmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public downloadMyWithdrawalAttachment(id: string, attachmentId: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).downloadMyWithdrawalAttachment(id, attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download the configuration for the other end
     * @param {string} gatewayId 
     * @param {string} connectionId 
     * @param {string} vendor 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public downloadSiteConnectionConfig(gatewayId: string, connectionId: string, vendor: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).downloadSiteConnectionConfig(gatewayId, connectionId, vendor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validates an admin-issued SSO code and returns access and refresh tokens for the client portal.
     * @summary Exchange a single-use SSO code for session tokens
     * @param {ExchangeSsoDto} exchangeSsoDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public exchangeSso(exchangeSsoDto: ExchangeSsoDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).exchangeSso(exchangeSsoDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Queues a backup job for the specified VM. The backup will be executed asynchronously.
     * @summary Execute a manual backup for a VM
     * @param {any} vmId VM ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public executeBackup(vmId: any, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).executeBackup(vmId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate a download code for VPN connection profile access
     * @param {string} id VPN Gateway ID
     * @param {GenerateDownloadCodeDto} generateDownloadCodeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public generateDownloadCode(id: string, generateDownloadCodeDto: GenerateDownloadCodeDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).generateDownloadCode(id, generateDownloadCodeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all datacenters
     * @param {boolean} [includeHidden] Whether to include hidden datacenters (default: false)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getAllDatacenters(includeHidden?: boolean, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getAllDatacenters(includeHidden, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of all VPCs for the authenticated client.
     * @summary Get all VPCs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getAllVpcs(options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getAllVpcs(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all VPN Gateways for the logged-in client
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getAllVpnGateways(options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getAllVpnGateways(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all VPN users from all VPN gateways for the logged-in client
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getAllVpnUsers(options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getAllVpnUsers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary What this gateway is running
     * @param {string} id VPN Gateway ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getAppliance(id: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getAppliance(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Operator instructions for the AI assistant system prompt
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getAssistantInstructions(options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getAssistantInstructions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a list of available templates based on the current VM product. Respects soft deletes.
     * @summary List available templates for VM
     * @param {number} vmId ID of the VM to get templates for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getAvailableTemplates(vmId: number, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getAvailableTemplates(vmId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the current backup progress for a VM by parsing hypervisor task logs
     * @summary Get backup progress for a VM
     * @param {any} vmId VM ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getBackupProgress(vmId: any, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getBackupProgress(vmId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get one image
     * @param {string} imageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getClientImage(imageId: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getClientImage(imageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The document exactly as the guest will receive it, with the format, the size limit and any problems found in it. Re-checked on every read.
     * @summary Read this image’s cloud-init user data
     * @param {string} imageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getClientImageCloudInit(imageId: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getClientImageCloudInit(imageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Storage allowance and current usage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getClientImageQuota(options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getClientImageQuota(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Each instance is reported with whether its disk is large enough. A reinstall cannot grow a disk, so an instance that does not fit must be resized first.
     * @summary Instances this image can be used on
     * @param {string} imageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getClientImageTargets(imageId: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getClientImageTargets(imageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a specific cluster by its ID.
     * @summary Get Cluster by ID
     * @param {number} id Cluster ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getClusterById(id: number, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getClusterById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of all clusters.
     * @summary List Clusters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getClusters(options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getClusters(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get clusters by datacenter ID
     * @param {number} id Datacenter ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getClustersByDatacenterId(id: number, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getClustersByDatacenterId(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get VPN connection profile using download code (public endpoint)
     * @param {string} downloadCode Download code for accessing VPN connection profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getConnectionProfileByDownloadCode(downloadCode: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getConnectionProfileByDownloadCode(downloadCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *        Generate a VNC ticket for a VM the authenticated user owns and return       WebSocket connection details for the proxied noVNC console viewer.       Call this on every connect or reconnect — it is idempotent and always       returns a fresh VNC ticket.        The returned `websocket_url` contains an opaque session token used by the       backend proxy. Open the console page at `/console/<vm_id>` and let the       viewer call this endpoint directly using the existing browser session.     
     * @summary Get VM console connection details
     * @param {VncConsoleRequestDto} vncConsoleRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getConsoleAccess(vncConsoleRequestDto: VncConsoleRequestDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getConsoleAccess(vncConsoleRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fleet vitals, billing runway, backup coverage, security posture and a ranked list of what needs attention. Replaces the fan-out the console used to perform (one status call per instance, one projection per subscription), which did not survive contact with large accounts.  Sections fail independently: anything that could not be read is named in `degraded[]` rather than returned as zeroes, so a partial answer is never rendered as an all-clear.
     * @summary Everything the console home screen renders, in one read
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getDashboardOverview(options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getDashboardOverview(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a datacenter by ID
     * @param {number} id Datacenter ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getDatacenterById(id: number, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getDatacenterById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check if the VM is eligible for snapshot operations and get quota information
     * @summary Check snapshot eligibility
     * @param {number} vmId VM ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getEligibility(vmId: number, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getEligibility(vmId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Backs the Discover page. Showing it records nothing.
     * @summary Every tip, with adoption and state
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getFeatureDiscoveryCatalog(options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getFeatureDiscoveryCatalog(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Ranked tips the account does not use yet, launches first. Empty while a deck was shown to this person in the last 20 hours, on any device.
     * @summary Tips for this sign-in
     * @param {Array<string>} [exclude] Tip codes this console cannot offer (a feature disabled in this deployment). Comma-separated or repeated.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getFeatureDiscoveryDeck(exclude?: Array<string>, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getFeatureDiscoveryDeck(exclude, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get detailed information about a specific firewall including its configuration, rules, and assigned VMs.
     * @summary Get firewall by ID
     * @param {any} firewallId Unique identifier of the firewall
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getFirewall(firewallId: any, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getFirewall(firewallId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the firewall assigned to a specific VM along with its rules.
     * @summary Get firewall for VM
     * @param {any} vmId Unique identifier of the VM
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getFirewallForVm(vmId: any, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getFirewallForVm(vmId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Track the progress of any asynchronous job by ID
     * @summary Get job status
     * @param {string} jobId Job ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getJobStatus(jobId: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getJobStatus(jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Affiliate overview for the current account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getMyAffiliate(options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getMyAffiliate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get notifications with pagination
     * @param {number} [page] Page number
     * @param {number} [limit] Number of items per page
     * @param {boolean} [unreadOnly] Return only unread notifications. &#x60;total&#x60;/&#x60;totalPages&#x60; then describe the unread set, so the \&quot;Unread\&quot; filter can paginate without holes.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getNotifications(page?: number, limit?: number, unreadOnly?: boolean, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getNotifications(page, limit, unreadOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the current restore progress for a VM by parsing hypervisor task logs
     * @summary Get restore progress for a VM
     * @param {any} vmId VM ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getRestoreProgress(vmId: any, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getRestoreProgress(vmId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary One finding with its evidence, advice and timeline
     * @param {string} findingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getSecurityFinding(findingId: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getSecurityFinding(findingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Security posture across every instance on the account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getSecurityOverview(options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getSecurityOverview(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Daily security score history
     * @param {number} [days] 
     * @param {number} [vmId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getSecurityScoreHistory(days?: number, vmId?: number, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getSecurityScoreHistory(days, vmId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Scanning and notification preferences for the account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getSecuritySettings(options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getSecuritySettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary One connection, with what the other end needs
     * @param {string} gatewayId 
     * @param {string} connectionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getSiteConnection(gatewayId: string, connectionId: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getSiteConnection(gatewayId, connectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Which configurations can be generated
     * @param {string} gatewayId 
     * @param {string} connectionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getSiteConnectionConfigOptions(gatewayId: string, connectionId: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getSiteConnectionConfigOptions(gatewayId, connectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary What has happened to this connection
     * @param {string} gatewayId 
     * @param {string} connectionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getSiteConnectionEvents(gatewayId: string, connectionId: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getSiteConnectionEvents(gatewayId, connectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the status of a VM operation task.
     * @summary Get Task Status
     * @param {string} taskId ID of the task to check
     * @param {any} vmId ID of the VM
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getTaskStatus(taskId: string, vmId: any, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getTaskStatus(taskId, vmId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the details of the authenticated user.
     * @summary Get User Details
     * @param {boolean} [fresh] Ask WHMCS now instead of answering from the cached profile (used by the page that shows the profile back to its owner).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getUserDetails(fresh?: boolean, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getUserDetails(fresh, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Transferred data volume (inbound/outbound, all interfaces) aggregated in time buckets for the selected period, plus the public outbound usage of the current billing window.
     * @summary Get VM Bandwidth Usage
     * @param {GetVmBandwidthPeriodEnum} period Period for bandwidth usage data
     * @param {any} vmId ID of the VM
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getVmBandwidth(period: GetVmBandwidthPeriodEnum, vmId: any, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getVmBandwidth(period, vmId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a VM by its ID.
     * @summary Get VM by ID
     * @param {any} vmId ID of the VM
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getVmById(vmId: any, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getVmById(vmId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the current disk interface type, NIC model, and OS type for a VM.
     * @summary Get current VM hardware configuration
     * @param {number} vmId VM ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getVmHardwareConfig(vmId: number, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getVmHardwareConfig(vmId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns available disk interface types, NIC models, and OS types/versions.
     * @summary Get hardware configuration options
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getVmHardwareOptions(options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getVmHardwareOptions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve historical metrics data for a VM with caching. Returns CPU, memory, disk, and network usage over time.
     * @summary Get VM Metrics
     * @param {GetVmMetricsTimeframeEnum} timeframe Timeframe for metrics data
     * @param {any} vmId ID of the VM
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getVmMetrics(timeframe: GetVmMetricsTimeframeEnum, vmId: any, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getVmMetrics(timeframe, vmId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * What the removal returns to the subscription (temporary credit on a commitment, nothing on on-demand), how much, until when, what the subscription will hold afterwards, and anything that would make the deletion be refused. Computed by the same code that performs the removal; changes nothing.
     * @summary Preview what deleting a VM does to its billing
     * @param {any} vmId ID of the VM
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getVmRemovalPreview(vmId: any, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getVmRemovalPreview(vmId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Security posture of one instance
     * @param {number} vmId Instance id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getVmSecurityPosture(vmId: number, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getVmSecurityPosture(vmId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the current status of a VM from the hypervisor with caching and deployment information.
     * @summary Get VM Status
     * @param {string} vmId ID of the VM
     * @param {boolean} [fresh] Bypass the cached status and read the live state (used by user-invoked refreshes).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getVmStatus(vmId: string, fresh?: boolean, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getVmStatus(vmId, fresh, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of all VMs for the authenticated client.
     * @summary List VMs
     * @param {string} [id] ID of the VM
     * @param {string} [clusterId] Cluster ID of the server
     * @param {GetVmsProductCategoryTypeEnum} [productCategoryType] Service type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getVms(id?: string, clusterId?: string, productCategoryType?: GetVmsProductCategoryTypeEnum, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getVms(id, clusterId, productCategoryType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve all VMs from a VPC.
     * @summary Retrieve VMs by VPC ID
     * @param {any} vpcId ID of the VPC
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getVpcVms(vpcId: any, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getVpcVms(vpcId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get VPN connection profile (.ovpn file) for a VPN Gateway
     * @param {string} id VPN Gateway ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getVpnConnectionProfile(id: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getVpnConnectionProfile(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a VPN Gateway by VM ID
     * @param {number} vmId VM ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getVpnGatewayByVmId(vmId: number, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getVpnGatewayByVmId(vmId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get VPN Gateway details with connected users information
     * @param {string} id VPN Gateway ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getVpnGatewayDetails(id: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getVpnGatewayDetails(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get VPN Gateway details using download code (public endpoint)
     * @param {string} downloadCode Download code for accessing VPN Gateway details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getVpnGatewayDetailsByDownloadCode(downloadCode: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getVpnGatewayDetailsByDownloadCode(downloadCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all users for a VPN Gateway
     * @param {string} id VPN Gateway ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public getVpnUsers(id: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).getVpnUsers(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Clones the origin VM into the destination VM using either the current state or an existing backup. Destination disk must be >= origin disk, and the required backup/vm storages must be available.
     * @summary Initiate a VM clone operation
     * @param {InitiateCloneDto} initiateCloneDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public initiateVmClone(initiateCloneDto: InitiateCloneDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).initiateVmClone(initiateCloneDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Paginated, searchable history of actions taken on your account — from the web console, from your API tokens, by the AI assistant, by our support team on your behalf, and by automated platform processes. Each entry records who acted, from which IP address, what was affected and whether it succeeded.
     * @summary List account activity
     * @param {number} [page] Page number (1-based).
     * @param {number} [pageSize] Entries per page.
     * @param {string} [search] Free-text search across the actor, the affected resource, the action and the IP address.
     * @param {ListAccountActivityActorKindEnum} [actorKind] Restrict to one kind of actor — &#x60;CONSOLE&#x60; for the web panel, &#x60;API_TOKEN&#x60; for your API credentials, &#x60;MCP&#x60; for AI assistant actions, &#x60;SUPPORT&#x60; for actions taken by our staff, &#x60;SYSTEM&#x60; for automated platform actions.
     * @param {ListAccountActivityCategoryEnum} [category] Restrict to one area of the product.
     * @param {string} [action] Exact action key, e.g. &#x60;instance.delete&#x60;. Takes precedence over &#x60;category&#x60;.
     * @param {string} [targetType] Restrict to one resource type, e.g. &#x60;instance&#x60;.
     * @param {string} [targetId] Restrict to one resource id — the history of a single instance, zone or firewall.
     * @param {ListAccountActivityOutcomeEnum} [outcome] 
     * @param {string} [from] Only entries at or after this instant (ISO 8601).
     * @param {string} [to] Only entries at or before this instant (ISO 8601).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public listAccountActivity(page?: number, pageSize?: number, search?: string, actorKind?: ListAccountActivityActorKindEnum, category?: ListAccountActivityCategoryEnum, action?: string, targetType?: string, targetId?: string, outcome?: ListAccountActivityOutcomeEnum, from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).listAccountActivity(page, pageSize, search, actorKind, category, action, targetType, targetId, outcome, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List grantable scopes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public listApiTokenScopes(options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).listApiTokenScopes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List my API tokens
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public listApiTokens(options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).listApiTokens(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all backups for VMs owned by the authenticated user
     * @summary List all backups for the authenticated user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public listBackups(options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).listBackups(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all backups for the specified VM
     * @summary List backups for a specific VM
     * @param {any} vmId VM ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public listBackupsByVm(vmId: any, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).listBackupsByVm(vmId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Every ISO and disk image on the authenticated account.
     * @summary List my images
     * @param {ListClientImagesKindEnum} [kind] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public listClientImages(kind?: ListClientImagesKindEnum, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).listClientImages(kind, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all DNS records for a zone
     * @param {string} id Domain record UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public listDnsRecords(id: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).listDnsRecords(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List DNS zones for the authenticated user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public listDnsZones(options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).listDnsZones(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all available firewall macros with descriptions. Macros are predefined service configurations that can be used when creating firewall rules (e.g., HTTP, HTTPS, SSH).
     * @summary List firewall macros
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public listFirewallMacros(options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).listFirewallMacros(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a paginated list of all firewalls. Supports filtering by name, enable status, and search query.
     * @summary List all firewalls
     * @param {string} [name] Filter by firewall name
     * @param {boolean} [enable] Filter by enabled status
     * @param {string} [search] Search term for name or description
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public listFirewalls(name?: string, enable?: boolean, search?: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).listFirewalls(name, enable, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List jobs created by the authenticated user, filterable by status, with pagination
     * @summary List jobs by status
     * @param {ListJobsStatusEnum} [status] &#x60;active&#x60; is a shorthand for pending + in_progress — what the console badge counts. Filtering by a single status cannot express it, and two round trips would report two moments in time.
     * @param {number} [page] Page number (1-based)
     * @param {number} [pageSize] Items per page (max 100)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public listJobs(status?: ListJobsStatusEnum, page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).listJobs(status, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List my referrals
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public listMyAffiliateReferrals(options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).listMyAffiliateReferrals(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List my withdrawals
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public listMyAffiliateWithdrawals(options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).listMyAffiliateWithdrawals(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List attachments on one of my withdrawals
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public listMyWithdrawalAttachments(id: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).listMyWithdrawalAttachments(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all IP addresses owned by the authenticated user with their reverse DNS state
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public listRdnsIps(options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).listRdnsIps(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all backup schedules for VMs owned by the authenticated user
     * @summary List all backup schedules for the authenticated user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public listSchedules(options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).listSchedules(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Risk exceptions on the account
     * @param {boolean} [includeInactive] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public listSecurityExceptions(includeInactive?: boolean, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).listSecurityExceptions(includeInactive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Findings across the account, ordered by risk
     * @param {number} [vmId] 
     * @param {ListSecurityFindingsSeverityEnum} [severity] 
     * @param {ListSecurityFindingsStatusEnum} [status] 
     * @param {string} [category] 
     * @param {string} [search] 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public listSecurityFindings(vmId?: number, severity?: ListSecurityFindingsSeverityEnum, status?: ListSecurityFindingsStatusEnum, category?: string, search?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).listSecurityFindings(vmId, severity, status, category, search, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * A hundred instances with the same ten problems is a thousand rows saying the same thing. Collapsed, each row is one fix that resolves every instance it lists.
     * @summary Open findings collapsed by rule, worst first
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public listSecurityFindingsByRule(options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).listSecurityFindingsByRule(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The browsable counterpart to the overview, which returns only the worst five. Ordered by open criticals, then highs, then score — the list is meant to be worked from the top, not browsed alphabetically.
     * @summary Posture per instance, worst first
     * @param {string} [search] 
     * @param {string} [state] 
     * @param {any} [pageSize] 
     * @param {any} [page] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public listSecurityInstances(search?: string, state?: string, pageSize?: any, page?: any, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).listSecurityInstances(search, state, pageSize, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Every site connected to this gateway
     * @param {string} gatewayId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public listSiteConnections(gatewayId: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).listSiteConnections(gatewayId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve all snapshots for a specific VM with quota information
     * @summary List all snapshots for a VM
     * @param {number} vmId VM ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public listSnapshots(vmId: number, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).listSnapshots(vmId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Scan history for one instance
     * @param {number} vmId Instance id
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public listVmSecurityScans(vmId: number, limit?: number, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).listVmSecurityScans(vmId, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Attack surface observed on one instance
     * @param {number} vmId Instance id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public listVmSecurityServices(vmId: number, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).listVmSecurityServices(vmId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Authenticate a user with email and password.
     * @summary Login
     * @param {LoginDto} loginDto Client login data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public login(loginDto: LoginDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).login(loginDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Logout the authenticated user.
     * @summary Logout
     * @param {LogoutDto} logoutDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public logout(logoutDto: LogoutDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).logout(logoutDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Clears the whole unread badge in one call. The console cannot do this by id list: it only holds the pages it has loaded, and older unread rows would stay unread forever.
     * @summary Mark every notification of the client as read
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public markAllAsRead(options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).markAllAsRead(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark notifications as read in batch
     * @param {MarkNotificationsReadDto} markNotificationsReadDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public markAsRead(markNotificationsReadDto: MarkNotificationsReadDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).markAsRead(markNotificationsReadDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public mine(options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).mine(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public offer(code: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).offer(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Perform an operation (start, stop, reboot) on a VM and return a task ID for tracking.
     * @summary Perform VM Operation
     * @param {any} vmId ID of the VM to operate on
     * @param {VmOperationRequestDto} vmOperationRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public performVmOperation(vmId: any, vmOperationRequestDto: VmOperationRequestDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).performVmOperation(vmId, vmOperationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * `shown` once a card has been on screen; `snoozed` for \"Not now\" (7 days); `dismissed` for \"Don\'t show again\"; `acted` when the call to action was followed. A support session is never recorded.
     * @summary Record what happened to a tip
     * @param {string} code 
     * @param {DiscoveryEventDto} discoveryEventDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public recordFeatureDiscoveryEvent(code: string, discoveryEventDto: DiscoveryEventDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).recordFeatureDiscoveryEvent(code, discoveryEventDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Refresh the access and refresh tokens.
     * @summary Refresh Tokens
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public refreshTokens(options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).refreshTokens(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new client in WHMCS.
     * @summary Register a new client
     * @param {AddClientDto} addClientDto Client registration data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public register(addClientDto: AddClientDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).register(addClientDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Register a device for push notifications using FCM.
     * @summary Register FCM Device
     * @param {RegisterDeviceDto} registerDeviceDto Device registration details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public registerFcmDevice(registerDeviceDto: RegisterDeviceDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).registerFcmDevice(registerDeviceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reinstall a VPN Gateway by performing full reinstallation
     * @param {string} id VPN Gateway ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public reinstallVpnGateway(id: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).reinstallVpnGateway(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resets the expiry to a full retention window from now.
     * @summary Extend an image’s retention
     * @param {string} imageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public renewClientImage(imageId: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).renewClientImage(imageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} code 
     * @param {string} totalMicroCents Catalog simulation total for the selected configuration, in micro-cents.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public renewal(code: string, totalMicroCents: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).renewal(code, totalMicroCents, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request a withdrawal
     * @param {RequestWithdrawalDto} requestWithdrawalDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public requestAffiliateWithdrawal(requestWithdrawalDto: RequestWithdrawalDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).requestAffiliateWithdrawal(requestWithdrawalDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Triggers WHMCS\'s native password-reset email (ResetPassword API). Always returns success regardless of whether the email exists, to avoid account enumeration.
     * @summary Request a password reset email
     * @param {ResetPasswordRequestDto} resetPasswordRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public requestPasswordReset(resetPasswordRequestDto: ResetPasswordRequestDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).requestPasswordReset(resetPasswordRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sends a new 6-digit code to the email associated with the challenge. Limited to 3 resends per challenge.
     * @summary Resend two-factor verification code
     * @param {ResendTwoFactorDto} resendTwoFactorDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public resendTwoFactor(resendTwoFactorDto: ResendTwoFactorDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).resendTwoFactor(resendTwoFactorDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reset the reverse DNS (PTR) record for an IPv4 address to the default platform value
     * @param {number} id IPv4 address record id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public resetIpv4Rdns(id: number, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).resetIpv4Rdns(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reset the reverse DNS (PTR) record for an IPv6 address to the default platform value
     * @param {number} id IPv6 address record id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public resetIpv6Rdns(id: number, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).resetIpv6Rdns(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *              Reset a user\'s password inside the VM using the QEMU guest agent.                          **Requirements:**             - QEMU guest agent must be installed and running in the VM             - The user must exist in the VM\'s operating system             - Password must be at least 8 characters long                          **Common use cases:**             - Reset root password when locked out             - Change user passwords without SSH access             - Automated password rotation         
     * @summary Reset user password
     * @param {number} vmId ID of the VM
     * @param {QemuAgentResetPasswordRequestDto} qemuAgentResetPasswordRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public resetUserPassword(vmId: number, qemuAgentResetPasswordRequestDto: QemuAgentResetPasswordRequestDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).resetUserPassword(vmId, qemuAgentResetPasswordRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Initiates a restore operation to restore a VM from a backup. The VM will be overwritten with the backup data. This operation is asynchronous and returns a task ID for tracking.
     * @summary Restore a VM from a backup
     * @param {number} backupId Backup ID to restore from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public restoreBackup(backupId: number, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).restoreBackup(backupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Restore the VM to a previous snapshot state. WARNING: All snapshots newer than the target snapshot will be deleted.
     * @summary Restore VM from a snapshot
     * @param {number} vmId VM ID
     * @param {RestoreSnapshotDto} restoreSnapshotDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public restoreSnapshot(vmId: number, restoreSnapshotDto: RestoreSnapshotDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).restoreSnapshot(vmId, restoreSnapshotDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reports which parts have not arrived and returns fresh URLs for them. Safe to call at any point during an upload.
     * @summary Resume an upload
     * @param {string} imageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public resumeClientImageUpload(imageId: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).resumeClientImageUpload(imageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Show the key for this connection
     * @param {string} gatewayId 
     * @param {string} connectionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public revealSiteConnectionSecret(gatewayId: string, connectionId: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).revealSiteConnectionSecret(gatewayId, connectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Revoke an API token
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public revokeApiToken(id: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).revokeApiToken(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Revoke an exception; its findings return to open immediately
     * @param {string} exceptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public revokeSecurityException(exceptionId: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).revokeSecurityException(exceptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Revokes the token and issues a replacement with the same name and scopes.
     * @summary Roll an API token
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public rollApiToken(id: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).rollApiToken(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace the key for this connection
     * @param {string} gatewayId 
     * @param {string} connectionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public rotateSiteConnectionSecret(gatewayId: string, connectionId: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).rotateSiteConnectionSecret(gatewayId, connectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Turn a connection off or back on
     * @param {string} gatewayId 
     * @param {string} connectionId 
     * @param {SiteConnectionEnabledRequestDto} siteConnectionEnabledRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public setSiteConnectionEnabled(gatewayId: string, connectionId: string, siteConnectionEnabledRequestDto: SiteConnectionEnabledRequestDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).setSiteConnectionEnabled(gatewayId, connectionId, siteConnectionEnabledRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates the WHMCS client from the address + password step of a social signup, links the identity and signs the user in.
     * @summary Complete social registration
     * @param {CompleteSocialRegistrationDto} completeSocialRegistrationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public socialCompleteRegistration(completeSocialRegistrationDto: CompleteSocialRegistrationDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).socialCompleteRegistration(completeSocialRegistrationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Exchanges the single-use handoff code from the callback for the login result (token + client).
     * @summary Exchange social handoff code
     * @param {SocialHandoffExchangeDto} socialHandoffExchangeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public socialHandoffExchange(socialHandoffExchangeDto: SocialHandoffExchangeDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).socialHandoffExchange(socialHandoffExchangeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Provider redirect target. Processes the result and 302-redirects to the frontend callback page with a single-use handoff code, a registration ticket, a selection token, or an error.
     * @summary Social login callback
     * @param {string} provider 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public socialLoginCallback(provider: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).socialLoginCallback(provider, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Redirects the browser to the social provider authorization endpoint.
     * @summary Start social login
     * @param {string} provider 
     * @param {string} deviceId 
     * @param {string} [redirect] 
     * @param {SocialLoginStartDisplayEnum} [display] popup relays to the browser opener; native returns through the fixed app URI and requires S256 proof.
     * @param {string} [nativeState] Native installation-generated state (43 base64url characters).
     * @param {string} [codeChallenge] S256 challenge generated on the native installation.
     * @param {SocialLoginStartCodeChallengeMethodEnum} [codeChallengeMethod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public socialLoginStart(provider: string, deviceId: string, redirect?: string, display?: SocialLoginStartDisplayEnum, nativeState?: string, codeChallenge?: string, codeChallengeMethod?: SocialLoginStartCodeChallengeMethodEnum, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).socialLoginStart(provider, deviceId, redirect, display, nativeState, codeChallenge, codeChallengeMethod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Redeem a native social callback with S256 proof
     * @param {NativeSocialExchangeDto} nativeSocialExchangeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public socialNativeExchange(nativeSocialExchangeDto: NativeSocialExchangeDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).socialNativeExchange(nativeSocialExchangeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Complete a social multi-account login
     * @param {SelectSocialAccountDto} selectSocialAccountDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public socialSelectAccount(selectSocialAccountDto: SelectSocialAccountDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).socialSelectAccount(selectSocialAccountDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List accounts for a social multi-account login
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public socialSelectionAccounts(token: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).socialSelectionAccounts(token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reserves storage and returns one presigned URL per part. Upload the parts directly, then call the complete endpoint.
     * @summary Start an upload
     * @param {StartClientImageUploadDto} startClientImageUploadDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public startClientImageUpload(startClientImageUploadDto: StartClientImageUploadDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).startClientImageUpload(startClientImageUploadDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start a scan of one instance now
     * @param {number} vmId Instance id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public startVmSecurityScan(vmId: number, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).startVmSecurityScan(vmId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Records a rating (with optional comment/reasons and a context snapshot). Re-rating the same subject updates the prior entry.
     * @summary Submit feedback
     * @param {SubmitFeedbackDto} submitFeedbackDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public submitFeedback(submitFeedbackDto: SubmitFeedbackDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).submitFeedback(submitFeedbackDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Rename an image or change its hardware profile
     * @param {string} imageId 
     * @param {UpdateClientImageDto} updateClientImageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public updateClientImage(imageId: string, updateClientImageDto: UpdateClientImageDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).updateClientImage(imageId, updateClientImageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Applies to the NEXT deploy or reinstall from this image; running instances are untouched. Refused with the list of problems when the document has errors, and refused entirely unless the image is marked as having cloud-init installed. Send null to remove it.
     * @summary Set or clear this image’s cloud-init user data
     * @param {string} imageId 
     * @param {UpdateClientImageCloudInitDto} updateClientImageCloudInitDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public updateClientImageCloudInit(imageId: string, updateClientImageCloudInitDto: UpdateClientImageCloudInitDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).updateClientImageCloudInit(imageId, updateClientImageCloudInitDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update firewall configuration including name, description, enable status, or default policies (policy_in/policy_out). Only fields provided in the request body will be updated.
     * @summary Update firewall
     * @param {any} firewallId Unique identifier of the firewall
     * @param {UpdateFirewallDto} updateFirewallDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public updateFirewall(firewallId: any, updateFirewallDto: UpdateFirewallDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).updateFirewall(firewallId, updateFirewallDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing firewall rule. Any information omitted from the payload will be cleared (set to null/empty) on the record.
     * @summary Update firewall rule
     * @param {string} ruleId Unique identifier of the rule to update
     * @param {any} firewallId Unique identifier of the firewall
     * @param {UpdateFirewallRuleDto} updateFirewallRuleDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public updateFirewallRule(ruleId: string, firewallId: any, updateFirewallRuleDto: UpdateFirewallRuleDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).updateFirewallRule(ruleId, firewallId, updateFirewallRuleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the reverse DNS (PTR) record for an IPv4 address
     * @param {number} id IPv4 address record id
     * @param {UpdateRdnsDto} updateRdnsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public updateIpv4Rdns(id: number, updateRdnsDto: UpdateRdnsDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).updateIpv4Rdns(id, updateRdnsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the reverse DNS (PTR) record for an IPv6 address
     * @param {number} id IPv6 address record id
     * @param {UpdateRdnsDto} updateRdnsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public updateIpv6Rdns(id: number, updateRdnsDto: UpdateRdnsDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).updateIpv6Rdns(id, updateRdnsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Turn scanning on or off for the account, or change notifications
     * @param {UpdateSecuritySettingsDto} updateSecuritySettingsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public updateSecuritySettings(updateSecuritySettingsDto: UpdateSecuritySettingsDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).updateSecuritySettings(updateSecuritySettingsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change a connection
     * @param {string} gatewayId 
     * @param {string} connectionId 
     * @param {SiteConnectionRequestDto} siteConnectionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public updateSiteConnection(gatewayId: string, connectionId: string, siteConnectionRequestDto: SiteConnectionRequestDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).updateSiteConnection(gatewayId, connectionId, siteConnectionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the name and/or description of a VM.
     * @summary Update VM name and description
     * @param {any} vmId ID of the VM
     * @param {UpdateVmDto} updateVmDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public updateVm(vmId: any, updateVmDto: UpdateVmDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).updateVm(vmId, updateVmDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change disk interface type, NIC model, and/or OS type for all devices on the VM. Changing the disk interface type requires the VM to be powered off.
     * @summary Update VM hardware configuration
     * @param {number} vmId VM ID
     * @param {UpdateVmHardwareDto} updateVmHardwareDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public updateVmHardware(vmId: number, updateVmHardwareDto: UpdateVmHardwareDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).updateVmHardware(vmId, updateVmHardwareDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Turn scanning on or off for one instance, or change its schedule
     * @param {number} vmId Instance id
     * @param {UpdateVmSecuritySettingsDto} updateVmSecuritySettingsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public updateVmSecuritySettings(vmId: number, updateVmSecuritySettingsDto: UpdateVmSecuritySettingsDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).updateVmSecuritySettings(vmId, updateVmSecuritySettingsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update multiple VMs in a VPC. Empty array removes all VMs.
     * @summary Update VMs in a VPC
     * @param {UpdateVpcVmsDto} updateVpcVmsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public updateVpcVms(updateVpcVmsDto: UpdateVpcVmsDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).updateVpcVms(updateVpcVmsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a VPN Gateway
     * @param {string} id VPN Gateway ID
     * @param {UpdateVpnGatewayDto} updateVpnGatewayDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public updateVpnGateway(id: string, updateVpnGatewayDto: UpdateVpnGatewayDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).updateVpnGateway(id, updateVpnGatewayDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a VPN user
     * @param {string} id VPN User ID
     * @param {UpdateVpnUserDto} updateVpnUserDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public updateVpnUser(id: string, updateVpnUserDto: UpdateVpnUserDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).updateVpnUser(id, updateVpnUserDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update this gateway
     * @param {string} id VPN Gateway ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public upgradeAppliance(id: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).upgradeAppliance(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Attach a payout-evidence file to one of my withdrawals
     * @param {string} id 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public uploadMyWithdrawalAttachment(id: string, file: File, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).uploadMyWithdrawalAttachment(id, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * What the editor calls while the customer types, so the problems appear beside the document rather than after a refused save.
     * @summary Check cloud-init user data without saving it
     * @param {string} imageId 
     * @param {ValidateClientImageCloudInitDto} validateClientImageCloudInitDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public validateClientImageCloudInit(imageId: string, validateClientImageCloudInitDto: ValidateClientImageCloudInitDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).validateClientImageCloudInit(imageId, validateClientImageCloudInitDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check a connection before creating it
     * @param {string} gatewayId 
     * @param {SiteConnectionRequestDto} siteConnectionRequestDto 
     * @param {string} [connectionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public validateSiteConnection(gatewayId: string, siteConnectionRequestDto: SiteConnectionRequestDto, connectionId?: string, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).validateSiteConnection(gatewayId, siteConnectionRequestDto, connectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check whether the origin → destination pair satisfies all clone requirements, including clone source selection and storage availability.
     * @summary Validate clone eligibility
     * @param {number} originVmId DB id of the origin (source) VM
     * @param {number} destinationVmId DB id of the destination VM
     * @param {ValidateVmCloneSourceTypeEnum} sourceType Whether to clone the current VM state or restore from an existing backup.
     * @param {number} [backupId] Existing backup ID to use when sourceType&#x3D;existing_backup.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public validateVmClone(originVmId: number, destinationVmId: number, sourceType: ValidateVmCloneSourceTypeEnum, backupId?: number, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).validateVmClone(originVmId, destinationVmId, sourceType, backupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Submits the 6-digit code sent to the user\'s email during login to complete authentication.
     * @summary Verify two-factor authentication code
     * @param {VerifyTwoFactorDto} verifyTwoFactorDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MwApi
     */
    public verifyTwoFactor(verifyTwoFactorDto: VerifyTwoFactorDto, options?: RawAxiosRequestConfig) {
        return MwApiFp(this.configuration).verifyTwoFactor(verifyTwoFactorDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const BillingGetSubscriptionLedgerBucketEnum = {
    Committed: 'COMMITTED',
    Available: 'AVAILABLE',
    Temporary: 'TEMPORARY',
    Negative: 'NEGATIVE'
} as const;
export type BillingGetSubscriptionLedgerBucketEnum = typeof BillingGetSubscriptionLedgerBucketEnum[keyof typeof BillingGetSubscriptionLedgerBucketEnum];
/**
 * @export
 */
export const BillingGetSubscriptionLedgerReasonEnum = {
    TrialGrant: 'TRIAL_GRANT',
    TrialWriteOff: 'TRIAL_WRITE_OFF',
    Usage: 'USAGE',
    Recharge: 'RECHARGE',
    InvoiceCarryover: 'INVOICE_CARRYOVER',
    Adjustment: 'ADJUSTMENT',
    Refund: 'REFUND',
    CommitmentPayment: 'COMMITMENT_PAYMENT',
    CouponDiscount: 'COUPON_DISCOUNT',
    TopupCouponCredit: 'TOPUP_COUPON_CREDIT',
    InternalTransferIn: 'INTERNAL_TRANSFER_IN',
    InternalTransferOut: 'INTERNAL_TRANSFER_OUT',
    TemporaryGrant: 'TEMPORARY_GRANT',
    TemporaryExpiry: 'TEMPORARY_EXPIRY',
    DebtSettlement: 'DEBT_SETTLEMENT',
    CommitmentExpiry: 'COMMITMENT_EXPIRY',
    RenewalCreditApplied: 'RENEWAL_CREDIT_APPLIED',
    PaymentReversal: 'PAYMENT_REVERSAL',
    CarryForward: 'CARRY_FORWARD',
    InternalCreditGrant: 'INTERNAL_CREDIT_GRANT'
} as const;
export type BillingGetSubscriptionLedgerReasonEnum = typeof BillingGetSubscriptionLedgerReasonEnum[keyof typeof BillingGetSubscriptionLedgerReasonEnum];
/**
 * @export
 */
export const GetVmBandwidthPeriodEnum = {
    CurrentCycle: 'current_cycle',
    Day: 'day',
    Week: 'week',
    Month: 'month',
    Year: 'year'
} as const;
export type GetVmBandwidthPeriodEnum = typeof GetVmBandwidthPeriodEnum[keyof typeof GetVmBandwidthPeriodEnum];
/**
 * @export
 */
export const GetVmMetricsTimeframeEnum = {
    Hour: 'hour',
    Day: 'day',
    Week: 'week',
    Month: 'month',
    Year: 'year'
} as const;
export type GetVmMetricsTimeframeEnum = typeof GetVmMetricsTimeframeEnum[keyof typeof GetVmMetricsTimeframeEnum];
/**
 * @export
 */
export const GetVmsProductCategoryTypeEnum = {
    Vm: 'vm',
    VpnGateway: 'vpn_gateway'
} as const;
export type GetVmsProductCategoryTypeEnum = typeof GetVmsProductCategoryTypeEnum[keyof typeof GetVmsProductCategoryTypeEnum];
/**
 * @export
 */
export const ListAccountActivityActorKindEnum = {
    Console: 'CONSOLE',
    ApiToken: 'API_TOKEN',
    Mcp: 'MCP',
    Support: 'SUPPORT',
    SupportBot: 'SUPPORT_BOT',
    System: 'SYSTEM'
} as const;
export type ListAccountActivityActorKindEnum = typeof ListAccountActivityActorKindEnum[keyof typeof ListAccountActivityActorKindEnum];
/**
 * @export
 */
export const ListAccountActivityCategoryEnum = {
    Instance: 'instance',
    Network: 'network',
    Dns: 'dns',
    Storage: 'storage',
    Billing: 'billing',
    Security: 'security',
    Account: 'account'
} as const;
export type ListAccountActivityCategoryEnum = typeof ListAccountActivityCategoryEnum[keyof typeof ListAccountActivityCategoryEnum];
/**
 * @export
 */
export const ListAccountActivityOutcomeEnum = {
    Success: 'success',
    Failure: 'failure',
    Denied: 'denied'
} as const;
export type ListAccountActivityOutcomeEnum = typeof ListAccountActivityOutcomeEnum[keyof typeof ListAccountActivityOutcomeEnum];
/**
 * @export
 */
export const ListClientImagesKindEnum = {
    DiskImage: 'disk_image',
    Iso: 'iso'
} as const;
export type ListClientImagesKindEnum = typeof ListClientImagesKindEnum[keyof typeof ListClientImagesKindEnum];
/**
 * @export
 */
export const ListJobsStatusEnum = {
    Pending: 'pending',
    InProgress: 'in_progress',
    Completed: 'completed',
    Failed: 'failed',
    Cancelled: 'cancelled',
    Active: 'active'
} as const;
export type ListJobsStatusEnum = typeof ListJobsStatusEnum[keyof typeof ListJobsStatusEnum];
/**
 * @export
 */
export const ListSecurityFindingsSeverityEnum = {
    Critical: 'critical',
    High: 'high',
    Medium: 'medium',
    Low: 'low',
    Info: 'info'
} as const;
export type ListSecurityFindingsSeverityEnum = typeof ListSecurityFindingsSeverityEnum[keyof typeof ListSecurityFindingsSeverityEnum];
/**
 * @export
 */
export const ListSecurityFindingsStatusEnum = {
    Open: 'open',
    Resolved: 'resolved',
    Excepted: 'excepted',
    FalsePositive: 'false_positive'
} as const;
export type ListSecurityFindingsStatusEnum = typeof ListSecurityFindingsStatusEnum[keyof typeof ListSecurityFindingsStatusEnum];
/**
 * @export
 */
export const SocialLoginStartDisplayEnum = {
    Popup: 'popup',
    Native: 'native'
} as const;
export type SocialLoginStartDisplayEnum = typeof SocialLoginStartDisplayEnum[keyof typeof SocialLoginStartDisplayEnum];
/**
 * @export
 */
export const SocialLoginStartCodeChallengeMethodEnum = {
    S256: 'S256'
} as const;
export type SocialLoginStartCodeChallengeMethodEnum = typeof SocialLoginStartCodeChallengeMethodEnum[keyof typeof SocialLoginStartCodeChallengeMethodEnum];
/**
 * @export
 */
export const ValidateVmCloneSourceTypeEnum = {
    CurrentState: 'current_state',
    ExistingBackup: 'existing_backup'
} as const;
export type ValidateVmCloneSourceTypeEnum = typeof ValidateVmCloneSourceTypeEnum[keyof typeof ValidateVmCloneSourceTypeEnum];


